import type {
  ActivateWorkforceInvitationCommand,
  ApplyCanonicalCoachLifecycleCommand,
  ApprovalListView,
  ApprovalRequestListReadModel,
  ApprovalRequestReadModel,
  ApprovalSummaryReadModel,
  AssignCoachServiceRequest,
  AssumeServiceDutyCommand,
  BindWorkforceInvitationWechatCommand,
  BindWorkforceInvitationWechatResult,
  BusinessAuditTimelineReadModel,
  CancelApprovalCommand,
  CancelKioskProductReservationCommand,
  CancelWorkforceInvitationCommand,
  CancelWorkforceInvitationResult,
  CanonicalCoachLifecycleAction,
  CanonicalCoachLifecyclePreview,
  CanonicalCoachLifecycleResult,
  CanonicalCoachOnboardingResult,
  CanonicalCoachProfileMaintenanceResult,
  CashShiftCashMovementListReadModel,
  CashShiftCashMovementRecord,
  CashShiftHandoverPreviewReadModel,
  CashShiftHandoverReceiveResult,
  CashShiftHandoverSubmissionResult,
  CashShiftHandoverWorkflowReadModel,
  CashShiftRecord,
  CheckoutSplitPlanReadModel,
  ClosePurchaseOrderShortRequest,
  CoachAssignableServiceOption,
  CoachConfigurationImportResult,
  CoachConfigurationSnapshot,
  CoachMonthlyCommissionReadModel,
  CoachProfile,
  CoachProfileAccountOnboardingRequest,
  CoachProfileAccountOnboardingResult,
  CoachQueueActionRequest,
  CoachRuntimeQueueReadModel,
  CoachRuntimeReadModel,
  CoachRuntimeServiceReadModel,
  CoachRuntimeShiftReadModel,
  CoachServiceAssignmentOperatorResult,
  CoachServiceAssignmentPreview,
  CoachServiceAssignmentPreviewRequest,
  CoachServiceReplacementOperatorResult,
  CoachServiceReplacementPreviewReadModel,
  CoachServiceStopRequest,
  CoachServiceStopRequestList,
  CoachSessionStopCompletedService,
  CoachSessionStopPreview,
  CoachSessionStopResult,
  CoachSummaryRow,
  CombinedCheckoutManualPaymentMethod,
  CombinedCheckoutReadModel,
  CompleteTableCleaningWorkItemCommand,
  CompleteWorkforcePhoneChangeCommand,
  CompleteWorkforceWechatRebindCommand,
  ConfirmMemberRechargeReconciliationRequest,
  ConfirmWorkforceInvitationIdentityCommand,
  ConfirmWorkforceInvitationIdentityResult,
  ConnectivityReadModel,
  CreateCanonicalCoachOnboardingCommand,
  CreateCombinedCheckoutRequest,
  CreateCustomerReservationRequest,
  CreateGroupBuyDailyReconciliationApprovalCommand,
  CreateGroupBuyReconciliationResolutionApprovalCommand,
  CreateInventoryOperationApprovalCommand,
  CreateKioskPairingResult,
  CreateManualReviewResolutionApprovalCommand,
  CreateMemberBalanceRefundApprovalCommand,
  CreateMemberRequest,
  CreateOrderCashRefundApprovalCommand,
  CreatePaidOrderItemReturnApprovalCommand,
  CreatePurchaseOrderApprovalCommand,
  CreateSupportAccessGrantRequest,
  CreateWorkforceInvitationCommand,
  CreateWorkforcePasswordResetCommand,
  CreateWorkforcePhoneChangeCommand,
  CreateWorkforceWechatRebindCommand,
  CustomerGroupBuyRequestReadModel,
  CustomerRentalCandidate,
  CustomerRentalCreateRequest,
  CustomerRentalExceptionDecisionRequest,
  CustomerRentalExceptionReportRequest,
  CustomerRentalOperationResult,
  CustomerRentalRecord,
  CustomerRentalReturnRequest,
  CustomerReservationCalendarDay,
  CustomerReservationHistoryPage,
  CustomerReservationMutationResult,
  CustomerReservationReadModel,
  CustomerReservationTransitionRequest,
  CustomerReservationWorkspace,
  CustomerReservationWorkspaceItem,
  CustomerReservationWorkspacePage,
  CustomerStorageCreateRequest,
  CustomerStorageExceptionDecisionRequest,
  CustomerStorageExceptionReportRequest,
  CustomerStorageOperationResult,
  CustomerStoragePickupRequest,
  CustomerStorageRecord,
  CustomerStorageSourceCandidate,
  DecideApprovalCommand,
  DeliverKioskProductReservationReceipt,
  DeviceIncidentManualResolutionRequest,
  DeviceIncidentManualResolutionResult,
  DeviceIncidentStatusReadModel,
  DiagnosticBundleReadModel,
  DisableCanonicalWorkforceAccountCommand,
  DisableCanonicalWorkforceAccountResult,
  ExecutePaidOrderItemReturnCommand,
  FrontdeskConfirmCleaningRequest,
  FrontdeskOpenSessionRequest,
  FrontdeskOperatingFactReadModelList,
  FrontdeskPricingOptionsReadModel,
  FrontdeskReleaseTableRequest,
  FrontdeskTableCloseoutReceipt,
  GroupBuyChannelRecord,
  GroupBuyChannelUpsertRequest,
  GroupBuyDailyReconciliationPreview,
  GroupBuyFulfillmentRecord,
  GroupBuyOnlineRedemptionCapability,
  GroupBuyOnlineRedemptionRecord,
  GroupBuyPackageRecord,
  GroupBuyPackageUpsertRequest,
  GroupBuyReconciliationResolutionPreview,
  GroupBuyReconciliationResolutionSourceListReadModel,
  GroupBuyReconciliationSignoffPackage,
  GroupBuyReconciliationSummary,
  InspectWorkforceInvitationCommand,
  InspectWorkforceInvitationResult,
  InventoryCountProgressReadModel,
  InventoryLotWorkspace,
  InventoryMovementReadModel,
  InventoryOperationApprovalPreviewReadModel,
  InventoryProductRecord,
  KioskProductReservationReadModel,
  KioskProductReservationTransitionCommand,
  ManualReviewItem,
  ManualReviewListFilter,
  ManualReviewListReadModel,
  ManualReviewResolutionPreviewReadModel,
  ManualReviewSummaryReadModel,
  MemberBalanceRefundApprovalPreviewReadModel,
  MemberCreateAck,
  MemberCreatePending,
  MemberCrmProfileReadModel,
  MemberDashboard,
  MemberDebitState,
  MemberFundTransactionReadModel,
  MemberLifecycleReadModel,
  MemberPrepaidSessionOpenPreview,
  MemberPrepaidSessionOpenPreviewRequest,
  MemberPrepaidSessionOpenRequest,
  MemberProfileUpdateAck,
  MemberProfileUpdatePending,
  MemberReadModel,
  MemberReceivableRetryRequest,
  MemberReceivableRetryResult,
  MemberRechargeReconciliationPreview,
  MemberRechargeReconciliationPreviewRequest,
  MemberRechargeReconciliationResult,
  MemberRechargeRecord,
  MemberRechargeRequest,
  MemberRecord,
  MemberRefundRequest,
  MemberRefundStatusResult,
  MemberSensitiveProfile,
  MemberSpendPreviewResult,
  OfficialPaymentOperatorResultV1,
  OfficialPaymentStartRequestV1,
  OperatingConfigurationApplyRequest,
  OperatingConfigurationApplyResult,
  OperatingConfigurationBundle,
  OperatingConfigurationPreviewRequest,
  OperatingConfigurationPreviewResult,
  OperatorIdentity,
  OperatorSessionReadModel,
  OrderCashRefundApprovalPreviewReadModel,
  OrderDetail,
  OrderHistoryReadModel,
  OrderItemRecord,
  OrderItemSaleReturnOperatorResult,
  OrderItemSaleReturnRequest,
  OrderStrongReportFilter,
  OrderStrongReportReadModel,
  OwnerBusinessSummaryReadModel,
  PaidOrderItemReturnApprovalPreviewReadModel,
  PaidOrderReturnCandidateListReadModel,
  PaidSaleReturnOriginalPayment,
  PayCheckoutSplitShareRequest,
  PaymentMethod,
  PaymentRecord,
  PreviewCashShiftHandoverRequest,
  PreviewCoachServiceReplacementRequest,
  PreviewGroupBuyDailyReconciliationRequest,
  PreviewGroupBuyReconciliationResolutionRequest,
  PreviewInventoryOperationApprovalRequest,
  PreviewManualReviewResolutionRequest,
  PreviewMemberBalanceRefundApprovalRequest,
  PreviewOrderCashRefundApprovalRequest,
  PreviewPaidOrderItemReturnApprovalRequest,
  PreviewPurchaseOrderApprovalRequest,
  PreviewSupplierBatchPaymentRequest,
  ProductCatalogImportResult,
  ProductCatalogPreviewResult,
  ProductSaleBarcodeLookupResult,
  ProductSaleCatalogItem,
  ProductUnitConversionRecord,
  ProductUnitConversionUpsertRequest,
  PurchaseOrderApprovalPreviewReadModel,
  PurchaseOrderDraftRecord,
  PurchaseOrderDraftUpsertRequest,
  PurchaseOrderReceivingWorkspace,
  PurchaseOrderShortCloseWriteResult,
  PurchasePayableReconciliationWriteResult,
  PurchasePayableWorkspace,
  PurchaseReceiptWriteResult,
  PurchaseReturnWorkspace,
  PurchaseReturnWriteResult,
  ReceiptReprintResult,
  ReceiveCashShiftHandoverCommand,
  RechargePlanRecord,
  RechargePlanUpsertRequest,
  ReconcilePurchasePayableRequest,
  ReconciliationSummaryReadModel,
  RecordCashShiftCashMovementCommand,
  RecordGroupBuyFulfillmentRequest,
  RecordPurchaseReceiptRequest,
  RecordPurchaseReturnRequest,
  RecordSupplierBatchPaymentRequest,
  RecordSupplierCreditRequest,
  RecordSupplierPaymentRequest,
  RecordSupplierRefundRequest,
  ReissueWorkforceInvitationCommand,
  ReleaseServiceDutyCommand,
  ReplaceCoachServiceRequest,
  RequestCoachServiceStopRequest,
  RequestWorkforcePhoneChangeNewPhoneOtpCommand,
  ResumeGroupBuyOnlineRedemptionRequest,
  RetryApprovalExecutionCommand,
  ReverseSupplierPaymentRequest,
  RevokeSupportAccessGrantRequest,
  SaveCheckoutSplitPlanRequest,
  SeatCustomerReservationRequest,
  ServiceDutyReadModel,
  ServiceRequestHistoryPage,
  ServiceRequestReadModel,
  ServiceRequestTransferOptionsReadModel,
  ServiceRequestTransferReceipt,
  ServiceRoutingConfigurationReadModel,
  ServiceWorkItemListReadModel,
  SessionStartAdjustmentCommand,
  SessionStartAdjustmentPreview,
  StartGroupBuyOnlineRedemptionRequest,
  StoreAcknowledgeClosingLegacyCommand,
  StoreClosingAction,
  StoreClosingReadiness,
  StoreCompleteClosingCommand,
  StoreOpenCommand,
  StoreOpeningReadiness,
  StoreOperatingDayRecord,
  StorePackageOrderItemAddResult,
  StorePackageOrderItemReturnResult,
  StorePackageRecord,
  StorePackageUpsertRequest,
  StoreStartClosingCommand,
  SubmitCashShiftHandoverCommand,
  SupplierBatchPaymentPreview,
  SupplierBatchPaymentWriteResult,
  SupplierCreditSettlementWorkspace,
  SupplierCreditWriteResult,
  SupplierPaymentReversalWriteResult,
  SupplierPaymentWriteResult,
  SupplierRecord,
  SupplierRefundWriteResult,
  SupplierSettlementLedgerDirectory,
  SupplierSettlementLedgerExportReadModel,
  SupplierSettlementLedgerPage,
  SupplierSettlementLedgerQuery,
  SupplierUpsertRequest,
  SupportAccessMutationResult,
  SupportAccessWorkspace,
  SystemStatusReadModel,
  TableCleaningWorkItemCompletionReceipt,
  TableKioskManagementReadModel,
  TableSnapshot,
  TransferServiceRequestCommand,
  UpdateCanonicalCoachProfileCommand,
  UpdateMemberRequest,
  UpdateServiceRoutingConfigurationCommand,
  UpsertCanonicalWorkforceEmploymentCommand,
  UpsertCanonicalWorkforceEmploymentResult,
  VerifyWorkforceInvitationOtpCommand,
  VerifyWorkforceInvitationOtpResult,
  VerifyWorkforcePhoneChangeNewPhoneOtpCommand,
  VerifyWorkforcePhoneChangeNewPhoneOtpResult,
  VersionInfo,
  WalletDefinitionRecord,
  WalletDefinitionUpsertRequest,
  WalletDisplayGroupRecord,
  WalletDisplayGroupUpsertRequest,
  WalletPaymentRuleRecord,
  WalletPaymentRuleUpsertRequest,
  WalletPaymentTargetOption,
  WorkforceDirectoryPage,
  WorkforceInvitationActivationResult,
  WorkforceInvitationAdminReadModel,
  WorkforceInvitationIssueResult,
  WorkforceMigrationConflictPage,
  WorkforceMigrationConflictStatus,
  WorkforceMutationPending,
  WorkforceOffboardingPreview,
  WorkforcePayrollOperationCommand,
  WorkforcePayrollOperationResult,
  WorkforcePayrollWorkspace,
  WorkforcePersonDetail,
  WorkforcePhoneChangeIssueResult,
  WorkforcePhoneChangeNewPhoneOtpResult,
  WorkforcePhoneChangeResult,
  WorkforcePrincipalContext,
  WorkforceWechatRebindIssueResult,
  WorkforceWechatRebindResult,
} from "@billiard/contracts";
import {
  COACH_RUNTIME_SESSION_QUERY_KEY,
  canonicalCoachLifecycleResultMatchesCommand,
  canonicalCoachOnboardingInvitationIdempotencyKey,
  canonicalCoachProfileMaintenanceResultMatchesCommand,
  canonicalMemberCreateCommand,
  coachConfigurationSnapshotsEqual,
  coachSummaryTotals,
  isActiveServiceRequestReadModelList,
  isApplyCanonicalCoachLifecycleCommand,
  isApprovalListView,
  isApprovalRequestListReadModel,
  isApprovalRequestReadModel,
  isApprovalSummaryReadModel,
  isAssumeServiceDutyCommand,
  isBindWorkforceInvitationWechatResult,
  isBusinessAuditTimelineReadModel,
  isCancelApprovalCommand,
  isCancelWorkforceInvitationCommand,
  isCancelWorkforceInvitationResult,
  isCanonicalCoachLifecyclePreview,
  isCanonicalCoachLifecycleResult,
  isCanonicalCoachOnboardingResult,
  isCanonicalCoachProfileMaintenanceResult,
  isCashShiftCashMovementListReadModel,
  isCashShiftCashMovementRecord,
  isCashShiftHandoverPreviewReadModel,
  isCashShiftHandoverReceiveResult,
  isCashShiftHandoverSubmissionResult,
  isCashShiftHandoverWorkflowReadModel,
  isCashShiftRecord,
  isCashShiftRecordList,
  isCheckoutSplitPlanReadModel,
  isClosePurchaseOrderShortRequest,
  isCoachAssignableServiceOptionList,
  isCoachConfigurationImportResult,
  isCoachConfigurationSnapshot,
  isCoachMonthlyCommissionReadModelList,
  isCoachProfileList,
  isCoachRuntimeQueueReadModel,
  isCoachRuntimeReadModel,
  isCoachRuntimeServiceReadModel,
  isCoachRuntimeShiftReadModel,
  isCoachServiceAssignmentOperatorResult,
  isCoachServiceAssignmentPreview,
  isCoachServiceReplacementOperatorResult,
  isCoachServiceReplacementPreviewReadModel,
  isCoachServiceStopRequest,
  isCoachServiceStopRequestList,
  isCoachSessionStopPreview,
  isCoachSessionStopResult,
  isCoachSummaryRow,
  isCombinedCheckoutReadModel,
  isCompleteTableCleaningWorkItemCommand,
  isCompleteWorkforcePhoneChangeCommand,
  isCompleteWorkforceWechatRebindCommand,
  isConfirmWorkforceInvitationIdentityResult,
  isConnectivityReadModel,
  isCreateCanonicalCoachOnboardingCommand,
  isCreateCombinedCheckoutRequest,
  isCreateCustomerReservationRequest,
  isCreateGroupBuyDailyReconciliationApprovalCommand,
  isCreateGroupBuyReconciliationResolutionApprovalCommand,
  isCreateInventoryOperationApprovalCommand,
  isCreateKioskPairingResult,
  isCreateManualReviewResolutionApprovalCommand,
  isCreateMemberBalanceRefundApprovalCommand,
  isCreateOrderCashRefundApprovalCommand,
  isCreatePaidOrderItemReturnApprovalCommand,
  isCreatePurchaseOrderApprovalCommand,
  isCreateWorkforceInvitationCommand,
  isCreateWorkforcePasswordResetCommand,
  isCreateWorkforcePhoneChangeCommand,
  isCreateWorkforceWechatRebindCommand,
  isCustomerGroupBuyRequestReadModel,
  isCustomerRentalCandidateList,
  isCustomerRentalCreateRequest,
  isCustomerRentalExceptionDecisionRequest,
  isCustomerRentalExceptionReportRequest,
  isCustomerRentalOperationResult,
  isCustomerRentalRecord,
  isCustomerRentalReturnRequest,
  isCustomerReservationCalendarDay,
  isCustomerReservationHistoryPage,
  isCustomerReservationMutationResult,
  isCustomerReservationTransitionRequest,
  isCustomerReservationWorkspace,
  isCustomerReservationWorkspacePage,
  isCustomerStorageCreateRequest,
  isCustomerStorageExceptionDecisionRequest,
  isCustomerStorageExceptionReportRequest,
  isCustomerStorageOperationResult,
  isCustomerStoragePickupRequest,
  isCustomerStorageRecord,
  isCustomerStorageSourceCandidateList,
  isDecideApprovalCommand,
  isDeliverKioskProductReservationReceipt,
  isDeviceIncidentManualResolutionRequest,
  isDeviceIncidentManualResolutionResult,
  isDeviceIncidentStatusReadModel,
  isDiagnosticBundleReadModel,
  isDisableCanonicalWorkforceAccountCommand,
  isDisableCanonicalWorkforceAccountResult,
  isExecutePaidOrderItemReturnCommand,
  isFrontdeskOpenSessionRequest,
  isFrontdeskOperatingFactReadModelList,
  isFrontdeskPricingOptionsReadModel,
  isFrontdeskTableCloseoutReceiptForRequest,
  isGroupBuyDailyReconciliationPreview,
  isGroupBuyFulfillmentRecord,
  isGroupBuyOnlineRedemptionRecord,
  isGroupBuyReconciliationInternalReferenceId,
  isGroupBuyReconciliationResolutionPreview,
  isGroupBuyReconciliationResolutionSourceListReadModel,
  isGroupBuyReconciliationSignoffPackage,
  isGroupBuyReconciliationSummary,
  isInspectWorkforceInvitationResult,
  isInventoryCountProgressReadModel,
  isInventoryLotWorkspace,
  isInventoryMovementReadModelList,
  isInventoryOperationApprovalPreviewReadModel,
  isInventoryProductRecord,
  isInventoryProductRecordList,
  isKioskProductReservationReadModel,
  isManualReviewItem,
  isManualReviewListReadModel,
  isManualReviewResolutionPreviewReadModel,
  isManualReviewSummaryReadModel,
  isMemberBalanceRefundApprovalPreviewReadModel,
  isMemberCreateAck,
  isMemberCreatePending,
  isMemberCrmProfileReadModel,
  isMemberDashboard,
  isMemberDebitState,
  isMemberFundTransactionReadModelList,
  isMemberLifecycleReadModel,
  isMemberPrepaidSessionOpenPreview,
  isMemberPrepaidSessionOpenRequest,
  isMemberProfileUpdateAck,
  isMemberProfileUpdatePending,
  isMemberReadModel,
  isMemberReadModelList,
  isMemberReceivableRetryResult,
  isMemberRechargeReconciliationPreview,
  isMemberRechargeReconciliationPreviewRequest,
  isMemberRechargeReconciliationResult,
  isMemberRechargeRecordList,
  isMemberSensitiveProfile,
  isMemberSpendPreviewResult,
  isOfficialPaymentOperatorResultV1,
  isOperatingConfigurationApplyResult,
  isOperatingConfigurationBundle,
  isOperatingConfigurationPreviewResult,
  isOperatorSessionReadModel,
  isOrderCashRefundApprovalPreviewReadModel,
  isOrderDetail,
  isOrderDetailReadModel,
  isOrderHistoryReadModelList,
  isOrderItemSaleReturnOperatorResult,
  isOrderStrongReportReadModel,
  isOwnerBusinessSummaryReadModel,
  isPaidOrderItemReturnApprovalPreviewReadModel,
  isPaidOrderReturnCandidateListReadModel,
  isPayCheckoutSplitShareRequest,
  isPreviewGroupBuyDailyReconciliationRequest,
  isPreviewGroupBuyReconciliationResolutionRequest,
  isPreviewInventoryOperationApprovalRequest,
  isPreviewManualReviewResolutionRequest,
  isPreviewMemberBalanceRefundApprovalRequest,
  isPreviewOrderCashRefundApprovalRequest,
  isPreviewPaidOrderItemReturnApprovalRequest,
  isPreviewPurchaseOrderApprovalRequest,
  isPreviewSupplierBatchPaymentRequest,
  isProductCatalogPreviewResult,
  isProductSaleBarcodeLookupResult,
  isProductSaleCatalogItemList,
  isProductUnitConversionRecord,
  isProductUnitConversionRecordList,
  isProductUnitConversionUpsertRequest,
  isPurchaseOrderApprovalPreviewReadModel,
  isPurchaseOrderDraftRecord,
  isPurchaseOrderDraftRecordList,
  isPurchaseOrderDraftUpsertRequest,
  isPurchaseOrderReceivingWorkspace,
  isPurchaseOrderReceivingWorkspaceList,
  isPurchaseOrderShortCloseWriteResult,
  isPurchasePayableReconciliationRecord,
  isPurchasePayableWorkspace,
  isPurchaseReceiptNumber,
  isPurchaseReceiptWriteResult,
  isPurchaseReturnWorkspace,
  isPurchaseReturnWriteResult,
  isReceiptReprintResult,
  isRechargePlanRecordList,
  isReconcilePurchasePayableRequest,
  isReconciliationSummaryReadModel,
  isRecordGroupBuyFulfillmentRequest,
  isRecordPurchaseReceiptRequest,
  isRecordPurchaseReturnRequest,
  isRecordSupplierBatchPaymentRequest,
  isRecordSupplierCreditRequest,
  isRecordSupplierPaymentRequest,
  isRecordSupplierRefundRequest,
  isReissueWorkforceInvitationCommand,
  isReleaseServiceDutyCommand,
  isRequestWorkforcePhoneChangeNewPhoneOtpCommand,
  isResumeGroupBuyOnlineRedemptionRequest,
  isRetryApprovalExecutionCommand,
  isReverseSupplierPaymentRequest,
  isSaveCheckoutSplitPlanRequest,
  isServiceDutyReadModel,
  isServiceRequestHistoryPage,
  isServiceRequestReadModelList,
  isServiceRequestTransferOptionsReadModel,
  isServiceRequestTransferReceipt,
  isServiceRoutingConfigurationReadModel,
  isServiceWorkItemListReadModel,
  isSessionStartAdjustmentCommand,
  isSessionStartAdjustmentPreview,
  isStartGroupBuyOnlineRedemptionRequest,
  isStoreClosingReadiness,
  isStoreOpeningReadiness,
  isStoreOperatingDayRecord,
  isStorePackageOrderItem,
  isStorePackageOrderItemReturnRecord,
  isStorePackageRecord,
  isSupplierBatchPaymentPreview,
  isSupplierBatchPaymentRecord,
  isSupplierCreditRecord,
  isSupplierCreditSettlementWorkspace,
  isSupplierPaymentRecord,
  isSupplierPaymentReversalRecord,
  isSupplierRecord,
  isSupplierRecordList,
  isSupplierRefundRecord,
  isSupplierSettlementLedgerDirectory,
  isSupplierSettlementLedgerExportReadModel,
  isSupplierSettlementLedgerPage,
  isSupportAccessMutationResult,
  isSupportAccessWorkspace,
  isSystemStatusReadModel,
  isTableCleaningWorkItemCompletionReceiptForCommand,
  isTableKioskManagementReadModelList,
  isTableSnapshot,
  isTableSnapshotList,
  isTransferServiceRequestCommand,
  isUpdateCanonicalCoachProfileCommand,
  isUpdateServiceRoutingConfigurationCommand,
  isUpsertCanonicalWorkforceEmploymentResult,
  isVerifyWorkforceInvitationOtpResult,
  isVerifyWorkforcePhoneChangeNewPhoneOtpCommand,
  isVerifyWorkforcePhoneChangeNewPhoneOtpResult,
  isWalletDefinitionRecordList,
  isWalletDisplayGroupRecordList,
  isWalletPaymentRuleRecordList,
  isWalletPaymentTargetOptionList,
  isWorkforceDirectoryPage,
  isWorkforceInvitationActivationResult,
  isWorkforceInvitationAdminReadModel,
  isWorkforceInvitationIssueResult,
  isWorkforceMigrationConflictPage,
  isWorkforceMutationPending,
  isWorkforceOffboardingPreview,
  isWorkforcePayrollOperationResult,
  isWorkforcePayrollWorkspace,
  isWorkforcePersonDetail,
  isWorkforcePhoneChangeIssueResult,
  isWorkforcePhoneChangeNewPhoneOtpResult,
  isWorkforcePhoneChangeResult,
  isWorkforcePrincipalContext,
  isWorkforceWechatRebindIssueResult,
  isWorkforceWechatRebindResult,
  ORDER_STRONG_REPORT_OPENING_METHODS,
  operatingConfigurationDraftsEqual,
  orderItemPricingFactsAreConsistent,
  saleReturnInventoryEffectForDisposition,
} from "@billiard/contracts";
import {
  canonicalJson,
  isGroupBuyFulfillmentSemanticallyConsistent,
  normalizeGroupBuyPlatformReference,
} from "@billiard/domain";
import type { CanonicalCoachProfileMaintenanceBaselineInvariant } from "./canonicalCoachProfileMaintenanceRecovery";
import { coachOperationOutcomeIsUnknown } from "./coachOperationRecovery";
import { coachServiceStopRequestOutcomeIsUnknown } from "./coachServiceStopRequestRecovery";
import {
  memberProfileUpdateCommandSha256,
  memberProfileUpdateOutcomeIsUnknown,
} from "./memberProfileUpdateFlow";
import {
  markNativeClientUpdateRequired,
  nativeAppInfo,
  nativeClientVersionHeader,
  nativeClientWritesBlocked,
} from "./nativeRuntime";
import { isNativeOperatorApp, type NativeSessionMode, nativeSessionVault } from "./nativeSession";
import {
  type ProductCatalogImportCommand,
  productCatalogImportOutcomeIsUnknown,
  readProductCatalogImportRecovery,
} from "./productCatalogImportRecovery";
import { type ProductSaveRequest, readProductSaveRecovery } from "./productSaveRecovery";
import { workforcePhoneChangeReasonContainsSecret } from "./workforcePhoneChangeRecovery";

export type { OperatorIdentity, OperatorSessionContext } from "@billiard/contracts";
export { productCatalogImportOutcomeIsUnknown } from "./productCatalogImportRecovery";

const gatewayUrl = import.meta.env.VITE_GATEWAY_URL ?? "http://127.0.0.1:4100";
const supportedDemoRoles = new Set(["CASHIER", "MANAGER", "OWNER", "WAITER", "COACH"]);
const demoQuery =
  typeof window === "undefined" ? null : new URLSearchParams(window.location.search);
const requestedDemoRole = demoQuery?.get("demoRole")?.toUpperCase() ?? null;
let operatorHeaders = {
  "content-type": "application/json",
  "x-demo-role":
    requestedDemoRole && supportedDemoRoles.has(requestedDemoRole) ? requestedDemoRole : "CASHIER",
  "x-actor-id": demoQuery?.get("demoActor") ?? "employee_cashier",
};
let operatorRequestScope = {
  tenantId: "tenant_demo",
  storeId: "store_demo",
  actorId: operatorHeaders["x-actor-id"],
  role:
    requestedDemoRole && supportedDemoRoles.has(requestedDemoRole)
      ? (requestedDemoRole as OperatorIdentity["role"])
      : ("CASHIER" as const),
};

export type OperatorAuthenticationInvalidationReason = "AUTH_REQUIRED" | "LOGOUT";
const operatorAuthenticationInvalidationListeners = new Set<
  (reason: OperatorAuthenticationInvalidationReason) => void
>();
let pendingOperatorRequestController = new AbortController();
let operatorIdentityEpoch = 0;

export function subscribeOperatorAuthenticationInvalidation(
  listener: (reason: OperatorAuthenticationInvalidationReason) => void,
): () => void {
  operatorAuthenticationInvalidationListeners.add(listener);
  return () => operatorAuthenticationInvalidationListeners.delete(listener);
}

function notifyOperatorAuthenticationInvalidation(
  reason: OperatorAuthenticationInvalidationReason,
): void {
  for (const listener of operatorAuthenticationInvalidationListeners) listener(reason);
}

export function cancelPendingOperatorRequests(): void {
  operatorIdentityEpoch += 1;
  pendingOperatorRequestController.abort();
  pendingOperatorRequestController = new AbortController();
}

export function currentOperatorIdentityEpoch(): number {
  return operatorIdentityEpoch;
}

export function assertOperatorIdentityUnchanged(epochAtDispatch: number): void {
  if (epochAtDispatch === operatorIdentityEpoch) return;
  throw new ApiRequestError(
    "OPERATOR_IDENTITY_CHANGED",
    "账号已切换；原账号的操作结果不会显示在当前账号，请回到原账号查询最终结果",
  );
}

function operatorRequestSignal(
  signal: AbortSignal | null | undefined,
  cancelOnIdentityChange: boolean,
): AbortSignal {
  return AbortSignal.any([
    AbortSignal.timeout(5_000),
    ...(cancelOnIdentityChange ? [pendingOperatorRequestController.signal] : []),
    ...(signal ? [signal] : []),
  ]);
}
export function setOperatorRequestIdentity(operator: OperatorIdentity): void {
  operatorHeaders = {
    "content-type": "application/json",
    "x-demo-role": operator.role,
    "x-actor-id": operator.id,
  };
  operatorRequestScope = {
    tenantId: operator.tenantId,
    storeId: operator.storeId,
    actorId: operator.id,
    role: operator.role,
  };
}

function csrfToken(): string | null {
  const native = nativeSessionVault.current();
  if (native) return native.csrfToken;
  if (typeof document === "undefined") return null;
  for (const part of document.cookie.split(";")) {
    const [name, ...value] = part.trim().split("=");
    if (name === "billiard_csrf") return decodeURIComponent(value.join("="));
  }
  return null;
}

function requestHeaders(init: RequestInit): Record<string, string> {
  const headers: Record<string, string> = {
    ...operatorHeaders,
    ...(init.headers as Record<string, string> | undefined),
  };
  const native = nativeSessionVault.current();
  const nativeVersion = nativeClientVersionHeader();
  if (isNativeOperatorApp() && nativeVersion) {
    headers["x-billiard-app-version"] = nativeVersion;
  }
  if (native) headers.authorization = `Bearer ${native.accessToken}`;
  if (init.method && !["GET", "HEAD", "OPTIONS"].includes(init.method)) {
    const token = csrfToken();
    if (token) headers["x-csrf-token"] = token;
  }
  return headers;
}
export interface CheckoutResult {
  order: OrderDetail;
  table: TableSnapshot;
  receipt: { effectId: string; status: "QUEUED"; evidence: "MOCK" | "REAL_HARDWARE" };
  memberDebit?: MemberDebitState;
}

export type ReconciliationSummary = ReconciliationSummaryReadModel;
export type OwnerBusinessSummary = OwnerBusinessSummaryReadModel;

export class ApiRequestError extends Error {
  public constructor(
    public readonly code: string,
    message: string,
    public readonly statusCode?: number,
    public readonly memberProfileUpdateGuardState?: "CLEARED",
    public readonly memberCreateGuardState?: "CLEARED",
    public readonly workforceWechatRebindGuardState?: "CLEARED",
    public readonly workforcePhoneChangeGuardState?: "CLEARED",
  ) {
    super(message);
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const changingRequest = Boolean(init.method && !["GET", "HEAD", "OPTIONS"].includes(init.method));
  const identityIndependentRead = path === "/v1/auth/session" || path === "/version";
  const safeUpdateRoute =
    path === "/v1/auth/mobile/login" ||
    path === "/v1/auth/mobile/activate" ||
    path === "/v1/auth/logout";
  if (isNativeOperatorApp() && changingRequest && !safeUpdateRoute && nativeClientWritesBlocked()) {
    throw new ApiRequestError(
      "NATIVE_UPDATE_REQUIRED",
      "当前 App 版本不能安全提交新的经营操作，请先升级；仍可查看记录或退出账号",
    );
  }
  if (
    isNativeOperatorApp() &&
    changingRequest &&
    !safeUpdateRoute &&
    nativeSessionSafetyUnavailable()
  ) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "手机安全存储状态无法确认，已停止新的经营操作；请完全关闭并重新打开 App",
    );
  }
  const nativeAccessTokenAtDispatch = nativeSessionVault.current()?.accessToken ?? null;
  const identityEpochAtDispatch = operatorIdentityEpoch;
  let response: Response;
  try {
    response = await fetch(`${gatewayUrl}${path}`, {
      ...init,
      // Operating reads must always reflect the current signed-in scope. A
      // browser or embedded WebView cache must never replay another moment's
      // staff, money, inventory, device, or workflow facts.
      ...(!changingRequest ? { cache: "no-store" as const } : {}),
      credentials: isNativeOperatorApp() ? "omit" : "include",
      signal: operatorRequestSignal(init.signal, !changingRequest && !identityIndependentRead),
      headers: requestHeaders(init),
    });
  } catch {
    assertOperatorIdentityUnchanged(identityEpochAtDispatch);
    throw new ApiRequestError("GATEWAY_UNREACHABLE", "门店网关连接失败");
  }
  assertOperatorIdentityUnchanged(identityEpochAtDispatch);
  let body: T & {
    code?: string;
    message?: string;
    memberProfileUpdateGuardState?: unknown;
    memberCreateGuardState?: unknown;
    workforceWechatRebindGuardState?: unknown;
    workforcePhoneChangeGuardState?: unknown;
  };
  try {
    body = (await response.json()) as T & { code?: string; message?: string };
  } catch {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "门店网关返回内容无法安全确认",
      response.status,
    );
  }
  assertOperatorIdentityUnchanged(identityEpochAtDispatch);
  if (!response.ok) {
    if (response.status === 401 && body.code === "AUTH_REQUIRED") {
      notifyOperatorAuthenticationInvalidation("AUTH_REQUIRED");
    }
    if (response.status === 426 && isNativeOperatorApp()) {
      markNativeClientUpdateRequired(
        body.code === "NATIVE_SERVER_UPDATE_REQUIRED"
          ? "SERVER_UPDATE_REQUIRED"
          : "UPDATE_REQUIRED",
      );
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("billiard-native-version-refresh"));
      }
    }
    if (
      response.status === 401 &&
      body.code === "AUTH_REQUIRED" &&
      isNativeOperatorApp() &&
      nativeAccessTokenAtDispatch
    ) {
      // Authentication state is authoritative. A failing or hung native bridge
      // must not replace AUTH_REQUIRED with an unrelated storage error. The
      // token guard prevents a late response for A from clearing newer B.
      await clearNativeSessionIfCurrentWithinDeadline(nativeAccessTokenAtDispatch);
    }
    throw new ApiRequestError(
      body.code ?? "REQUEST_FAILED",
      body.message ?? "请求失败",
      response.status,
      body.memberProfileUpdateGuardState === "CLEARED" ? "CLEARED" : undefined,
      body.memberCreateGuardState === "CLEARED" ? "CLEARED" : undefined,
      body.workforceWechatRebindGuardState === "CLEARED" ? "CLEARED" : undefined,
      body.workforcePhoneChangeGuardState === "CLEARED" ? "CLEARED" : undefined,
    );
  }
  return body;
}

export function requestOperatorJson<T>(path: string, init: RequestInit = {}): Promise<T> {
  return request<T>(path, init);
}

export interface OperatorBinaryResponse {
  bytes: Uint8Array;
  headers: Headers;
  statusCode: number;
}

export async function requestOperatorBinary(
  path: string,
  init: RequestInit = {},
): Promise<OperatorBinaryResponse> {
  const changingRequest = Boolean(init.method && !["GET", "HEAD", "OPTIONS"].includes(init.method));
  if (isNativeOperatorApp() && changingRequest && nativeClientWritesBlocked()) {
    throw new ApiRequestError(
      "NATIVE_UPDATE_REQUIRED",
      "当前 App 版本不能安全提交新的经营操作，请先升级；仍可查看记录或退出账号",
    );
  }
  if (isNativeOperatorApp() && changingRequest && nativeSessionSafetyUnavailable()) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "手机安全存储状态无法确认，已停止新的经营操作；请完全关闭并重新打开 App",
    );
  }
  const nativeAccessTokenAtDispatch = nativeSessionVault.current()?.accessToken ?? null;
  const identityEpochAtDispatch = operatorIdentityEpoch;
  let response: Response;
  try {
    response = await fetch(`${gatewayUrl}${path}`, {
      ...init,
      ...(!changingRequest ? { cache: "no-store" as const } : {}),
      credentials: isNativeOperatorApp() ? "omit" : "include",
      signal: operatorRequestSignal(init.signal, !changingRequest),
      headers: requestHeaders(init),
    });
  } catch {
    assertOperatorIdentityUnchanged(identityEpochAtDispatch);
    throw new ApiRequestError("GATEWAY_UNREACHABLE", "门店网关连接失败");
  }
  assertOperatorIdentityUnchanged(identityEpochAtDispatch);
  const bytes = new Uint8Array(await response.arrayBuffer());
  assertOperatorIdentityUnchanged(identityEpochAtDispatch);
  if (!response.ok) {
    let error: { code?: string; message?: string } = {};
    try {
      error = JSON.parse(new TextDecoder().decode(bytes)) as { code?: string; message?: string };
    } catch {
      // Preserve the stable fallback below for non-JSON proxy errors.
    }
    if (response.status === 401 && error.code === "AUTH_REQUIRED") {
      notifyOperatorAuthenticationInvalidation("AUTH_REQUIRED");
    }
    if (
      response.status === 401 &&
      error.code === "AUTH_REQUIRED" &&
      isNativeOperatorApp() &&
      nativeAccessTokenAtDispatch
    ) {
      await clearNativeSessionIfCurrentWithinDeadline(nativeAccessTokenAtDispatch);
    }
    if (response.status === 426 && isNativeOperatorApp()) {
      markNativeClientUpdateRequired(
        error.code === "NATIVE_SERVER_UPDATE_REQUIRED"
          ? "SERVER_UPDATE_REQUIRED"
          : "UPDATE_REQUIRED",
      );
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("billiard-native-version-refresh"));
      }
    }
    throw new ApiRequestError(
      error.code ?? "REQUEST_FAILED",
      error.message ?? "请求失败",
      response.status,
    );
  }
  return { bytes, headers: response.headers, statusCode: response.status };
}

async function requestPublicWorkforceInvitation<T>(path: string, body: unknown): Promise<T> {
  const timeout = new AbortController();
  const timeoutId = globalThis.setTimeout(() => timeout.abort(), 5_000);
  try {
    let response: Response;
    try {
      response = await fetch(`${gatewayUrl}${path}`, {
        method: "POST",
        cache: "no-store",
        credentials: "omit",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(body),
        signal: timeout.signal,
      });
    } catch {
      throw new ApiRequestError("GATEWAY_UNREACHABLE", "邀请服务暂时无法连接，请稍后重试");
    }
    let result: T & { code?: string; message?: string };
    try {
      result = (await response.json()) as T & { code?: string; message?: string };
    } catch {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "邀请服务返回内容无法安全确认",
        response.status,
      );
    }
    if (!response.ok) {
      throw new ApiRequestError(
        result.code ?? "REQUEST_FAILED",
        result.message ?? "邀请操作没有完成",
        response.status,
      );
    }
    return result;
  } finally {
    globalThis.clearTimeout(timeoutId);
  }
}

async function requestText(path: string, init: RequestInit = {}): Promise<string> {
  const changingRequest = Boolean(init.method && !["GET", "HEAD", "OPTIONS"].includes(init.method));
  if (isNativeOperatorApp() && changingRequest && nativeClientWritesBlocked()) {
    throw new ApiRequestError(
      "NATIVE_UPDATE_REQUIRED",
      "当前 App 版本不能安全提交新的经营操作，请先升级；仍可查看记录或退出账号",
    );
  }
  if (isNativeOperatorApp() && changingRequest && nativeSessionSafetyUnavailable()) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "手机安全存储状态无法确认，已停止新的经营操作；请完全关闭并重新打开 App",
    );
  }
  const nativeAccessTokenAtDispatch = nativeSessionVault.current()?.accessToken ?? null;
  const identityEpochAtDispatch = operatorIdentityEpoch;
  let response: Response;
  try {
    response = await fetch(`${gatewayUrl}${path}`, {
      ...init,
      ...(!changingRequest ? { cache: "no-store" as const } : {}),
      credentials: isNativeOperatorApp() ? "omit" : "include",
      signal: operatorRequestSignal(init.signal, !changingRequest),
      headers: requestHeaders(init),
    });
  } catch {
    assertOperatorIdentityUnchanged(identityEpochAtDispatch);
    throw new ApiRequestError("GATEWAY_UNREACHABLE", "门店网关连接失败");
  }
  assertOperatorIdentityUnchanged(identityEpochAtDispatch);
  const body = await response.text();
  assertOperatorIdentityUnchanged(identityEpochAtDispatch);
  if (!response.ok) {
    let error: { code?: string; message?: string } = {};
    try {
      error = JSON.parse(body) as { code?: string; message?: string };
    } catch {
      // Preserve the stable fallback below for non-JSON proxy errors.
    }
    if (response.status === 401 && error.code === "AUTH_REQUIRED") {
      notifyOperatorAuthenticationInvalidation("AUTH_REQUIRED");
    }
    if (
      response.status === 401 &&
      error.code === "AUTH_REQUIRED" &&
      isNativeOperatorApp() &&
      nativeAccessTokenAtDispatch
    ) {
      await clearNativeSessionIfCurrentWithinDeadline(nativeAccessTokenAtDispatch);
    }
    if (response.status === 426 && isNativeOperatorApp()) {
      markNativeClientUpdateRequired(
        error.code === "NATIVE_SERVER_UPDATE_REQUIRED"
          ? "SERVER_UPDATE_REQUIRED"
          : "UPDATE_REQUIRED",
      );
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("billiard-native-version-refresh"));
      }
    }
    throw new ApiRequestError(error.code ?? "REQUEST_FAILED", error.message ?? "请求失败");
  }
  return body;
}

export async function getOperatorSession(signal?: AbortSignal): Promise<OperatorSessionReadModel> {
  const result = await request<unknown>("/v1/auth/session", {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (!isOperatorSessionReadModel(result)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前登录账号和权限状态无法安全确认，请重新登录后再试",
    );
  }
  return result;
}

export async function getWorkforcePrincipalContext(
  expectedScope: Pick<OperatorIdentity, "tenantId" | "storeId">,
  signal?: AbortSignal,
): Promise<WorkforcePrincipalContext> {
  const result = await request<unknown>("/v1/workforce/me/context", {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (!isWorkforcePrincipalContext(result, expectedScope)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前账号在本店的人员和权限关系无法安全确认，请重新登录后再试",
    );
  }
  return result;
}

function sameWorkforceInvitationRoles(left: readonly string[], right: readonly string[]): boolean {
  const sortedLeft = [...left].sort();
  const sortedRight = [...right].sort();
  return (
    sortedLeft.length === sortedRight.length &&
    sortedLeft.every((role, index) => role === sortedRight[index])
  );
}

const workforceInvitationLifetimeMs = 24 * 60 * 60 * 1_000;

function workforceInvitationPurpose(value: { purpose?: string }): string {
  return value.purpose ?? "ACCOUNT_ACTIVATION";
}

function workforceInvitationHasExactLifetime(value: {
  issuedAt: string;
  expiresAt: string;
}): boolean {
  const issuedAt = Date.parse(value.issuedAt);
  const expiresAt = Date.parse(value.expiresAt);
  return (
    Number.isFinite(issuedAt) &&
    Number.isFinite(expiresAt) &&
    expiresAt - issuedAt === workforceInvitationLifetimeMs
  );
}

function workforceInvitationScopeFor(
  expectedTenantId: string,
  expectedStoreId: string,
): typeof operatorRequestScope {
  const scope = { ...operatorRequestScope };
  if (scope.tenantId !== expectedTenantId || scope.storeId !== expectedStoreId) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "当前账号或门店已经切换，原员工邀请没有读取或提交",
    );
  }
  return scope;
}

function assertWorkforceInvitationScopeUnchanged(expected: typeof operatorRequestScope): void {
  if (
    operatorRequestScope.tenantId !== expected.tenantId ||
    operatorRequestScope.storeId !== expected.storeId ||
    operatorRequestScope.actorId !== expected.actorId
  ) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号或门店已切换；原员工邀请结果不会显示在当前账号",
    );
  }
}

function sameWorkforceInvitationIdentity(
  left: WorkforceInvitationAdminReadModel,
  right: WorkforceInvitationAdminReadModel,
): boolean {
  return (
    workforceInvitationPurpose(left) === workforceInvitationPurpose(right) &&
    left.personId === right.personId &&
    left.employmentId === right.employmentId &&
    left.accountId === right.accountId &&
    left.storeId === right.storeId &&
    left.displayName === right.displayName &&
    sameWorkforceInvitationRoles(left.roles, right.roles) &&
    left.providerMode === right.providerMode &&
    left.issuedAt === right.issuedAt &&
    left.expiresAt === right.expiresAt &&
    left.evidence === right.evidence
  );
}

type WorkforceInvitationActivationExpectation = InspectWorkforceInvitationResult;

function workforceInvitationProviderEvidenceMatches(
  expected: Pick<WorkforceInvitationActivationExpectation, "providerMode" | "evidence">,
): boolean {
  return (
    (expected.providerMode === "SIMULATED" && expected.evidence === "PROVIDER_SIMULATED") ||
    (expected.providerMode === "EXTERNAL" && expected.evidence === "PROVIDER_ACCEPTED")
  );
}

export async function createWorkforceInvitation(
  command: CreateWorkforceInvitationCommand,
): Promise<WorkforceInvitationIssueResult> {
  if (!isCreateWorkforceInvitationCommand(command)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "员工邀请内容不完整，请检查后重试");
  }
  const expectedScope = workforceInvitationScopeFor(
    operatorRequestScope.tenantId,
    command.employment.storeId.trim(),
  );
  const result = await request<unknown>("/v1/workforce/invitations", {
    method: "POST",
    body: JSON.stringify(command),
  });
  assertWorkforceInvitationScopeUnchanged(expectedScope);
  const expectedEmploymentId =
    command.personMode === "EXISTING_PERSON" ? command.employment.employmentId : null;
  const versionMatches =
    isWorkforceInvitationIssueResult(result) &&
    result.identityVersion === 1 &&
    (command.personMode === "NEW_PERSON"
      ? result.employmentVersion === 1 && result.aggregateVersion === 1
      : result.employmentVersion === command.employment.expectedEmploymentVersion &&
        result.aggregateVersion === command.expectedAggregateVersion + 1);
  if (
    !isWorkforceInvitationIssueResult(result) ||
    workforceInvitationPurpose(result) !== "ACCOUNT_ACTIVATION" ||
    !workforceInvitationHasExactLifetime(result) ||
    result.personId !== command.person.personId.trim() ||
    result.storeId !== expectedScope.storeId ||
    result.idempotencyKey !== command.idempotencyKey ||
    !versionMatches ||
    (command.personMode === "NEW_PERSON" &&
      (result.displayName !== command.person.displayName.trim() ||
        !sameWorkforceInvitationRoles(result.roles, command.employment.roles))) ||
    (expectedEmploymentId !== null && result.employmentId !== expectedEmploymentId)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "员工邀请回执与原操作不一致，页面不会把它显示为成功",
    );
  }
  return result;
}

export async function createWorkforcePasswordResetInvitation(
  command: CreateWorkforcePasswordResetCommand,
  expected?: { storeId: string; displayName: string; roles: readonly string[] },
): Promise<WorkforceInvitationIssueResult> {
  if (!isCreateWorkforcePasswordResetCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "密码重置的员工、账号、版本或业务原因不完整，请刷新人员详情后重试",
    );
  }
  const result = await request<unknown>("/v1/workforce/password-reset-invitations", {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isWorkforceInvitationIssueResult(result) ||
    result.purpose !== "PASSWORD_RESET" ||
    result.personId !== command.personId ||
    result.employmentId !== command.employmentId ||
    result.accountId !== command.accountId ||
    (expected !== undefined &&
      (result.storeId !== expected.storeId ||
        result.displayName !== expected.displayName ||
        !sameWorkforceInvitationRoles(result.roles, expected.roles))) ||
    result.employmentVersion !== command.expectedEmploymentVersion ||
    result.identityVersion !== command.expectedIdentityVersion ||
    result.aggregateVersion !== command.expectedAggregateVersion ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "密码重置回执与原员工、账号、角色或版本不一致，页面不会把它显示为成功",
    );
  }
  return result;
}

export async function createWorkforceWechatRebind(
  command: CreateWorkforceWechatRebindCommand,
): Promise<WorkforceWechatRebindIssueResult> {
  if (!isCreateWorkforceWechatRebindCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "微信换绑原因或请求编号不完整，请检查后重试",
    );
  }
  const expectedScope = { ...operatorRequestScope };
  const principal = await getWorkforcePrincipalContext(expectedScope);
  const employment = principal.currentStoreContext;
  if (
    principal.resolutionStatus !== "RESOLVED" ||
    principal.account.status !== "ACTIVE" ||
    principal.person === null ||
    principal.person.status !== "ACTIVE" ||
    principal.personAggregateVersion === undefined ||
    employment === null ||
    employment.employmentId === null ||
    employment.storeId !== expectedScope.storeId ||
    !employment.roles.some(
      (role) => role === "MANAGER" || role === "CASHIER" || role === "WAITER" || role === "COACH",
    )
  ) {
    throw new ApiRequestError(
      "WORKFORCE_WECHAT_REBIND_NOT_ELIGIBLE",
      "当前账号在本店的在职关系无法安全确认，不能发起微信换绑",
    );
  }
  if (
    operatorRequestScope.tenantId !== expectedScope.tenantId ||
    operatorRequestScope.storeId !== expectedScope.storeId ||
    operatorRequestScope.actorId !== expectedScope.actorId
  ) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号已切换；原账号的微信换绑请求没有提交，请回到原账号重新操作",
    );
  }
  const result = await request<unknown>("/v1/workforce/me/wechat-rebinds", {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isWorkforceWechatRebindIssueResult(result) ||
    result.personId !== principal.person.id ||
    result.employmentId !== employment.employmentId ||
    result.accountId !== principal.account.id ||
    result.storeId !== employment.storeId ||
    result.displayName !== principal.person.displayName ||
    !sameWorkforceInvitationRoles(result.roles, employment.roles) ||
    result.identityVersion !== principal.account.identityVersion ||
    result.aggregateVersion !== principal.personAggregateVersion ||
    result.projectionRevision < principal.projection.revision ||
    result.idempotencyKey !== command.idempotencyKey ||
    Date.parse(result.expiresAt) <= Date.parse(result.issuedAt)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "微信换绑回执与当前账号、门店、角色或版本不一致，页面不会把它显示为成功",
    );
  }
  return result;
}

export async function createWorkforcePhoneChange(
  command: CreateWorkforcePhoneChangeCommand,
): Promise<WorkforcePhoneChangeIssueResult> {
  if (
    !isCreateWorkforcePhoneChangeCommand(command) ||
    workforcePhoneChangeReasonContainsSecret(command.reason)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      workforcePhoneChangeReasonContainsSecret(command.reason)
        ? "业务原因不能填写密码、验证码、token、secret、key 或类似敏感值"
        : "手机号更换原因或请求编号不完整，请检查后重试",
    );
  }
  const expectedScope = { ...operatorRequestScope };
  const principal = await getWorkforcePrincipalContext(expectedScope);
  const employment = principal.currentStoreContext;
  if (
    principal.resolutionStatus !== "RESOLVED" ||
    principal.account.status !== "ACTIVE" ||
    principal.person === null ||
    principal.person.status !== "ACTIVE" ||
    principal.personAggregateVersion === undefined ||
    employment === null ||
    employment.employmentId === null ||
    employment.storeId !== expectedScope.storeId ||
    employment.roles.length < 1
  ) {
    throw new ApiRequestError(
      "WORKFORCE_PHONE_CHANGE_NOT_ELIGIBLE",
      "当前账号在本店的在职关系无法安全确认，不能发起登录手机号更换",
    );
  }
  if (
    operatorRequestScope.tenantId !== expectedScope.tenantId ||
    operatorRequestScope.storeId !== expectedScope.storeId ||
    operatorRequestScope.actorId !== expectedScope.actorId
  ) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号已切换；原账号的手机号更换请求没有提交，请回到原账号重新操作",
    );
  }
  const result = await request<unknown>("/v1/workforce/me/phone-changes", {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isWorkforcePhoneChangeIssueResult(result) ||
    result.personId !== principal.person.id ||
    result.employmentId !== employment.employmentId ||
    result.accountId !== principal.account.id ||
    result.storeId !== employment.storeId ||
    result.displayName !== principal.person.displayName ||
    !sameWorkforceInvitationRoles(result.roles, employment.roles) ||
    result.identityVersion !== principal.account.identityVersion ||
    result.aggregateVersion !== principal.personAggregateVersion ||
    result.projectionRevision < principal.projection.revision ||
    result.idempotencyKey !== command.idempotencyKey ||
    Date.parse(result.expiresAt) <= Date.parse(result.issuedAt)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "手机号更换回执与当前账号、门店、角色或版本不一致，页面不会把它显示为成功",
    );
  }
  return result;
}

export async function getWorkforceInvitationAdmin(
  expectedTenantId: string,
  expectedStoreId: string,
  expectedPersonId: string,
  signal?: AbortSignal,
): Promise<WorkforceInvitationAdminReadModel> {
  const expectedScope = workforceInvitationScopeFor(expectedTenantId, expectedStoreId);
  const query = new URLSearchParams({ storeId: expectedStoreId });
  const result = await request<unknown>(
    `/v1/workforce/people/${encodeURIComponent(expectedPersonId)}/invitation?${query.toString()}`,
    { cache: "no-store", ...(signal ? { signal } : {}) },
  );
  assertWorkforceInvitationScopeUnchanged(expectedScope);
  if (
    !isWorkforceInvitationAdminReadModel(result) ||
    workforceInvitationPurpose(result) !== "ACCOUNT_ACTIVATION" ||
    !workforceInvitationHasExactLifetime(result) ||
    result.personId !== expectedPersonId ||
    result.storeId !== expectedStoreId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "员工邀请状态与当前人员或门店不一致，页面已停止显示",
    );
  }
  return result;
}

export async function getWorkforcePasswordResetInvitationAdmin(
  expectedTenantId: string,
  expectedStoreId: string,
  expectedPersonId: string,
  signal?: AbortSignal,
): Promise<WorkforceInvitationAdminReadModel | null> {
  const expectedScope = workforceInvitationScopeFor(expectedTenantId, expectedStoreId);
  const query = new URLSearchParams({ storeId: expectedStoreId });
  let result: unknown;
  try {
    result = await request<unknown>(
      `/v1/workforce/people/${encodeURIComponent(expectedPersonId)}/invitation?${query.toString()}`,
      { cache: "no-store", ...(signal ? { signal } : {}) },
    );
  } catch (error) {
    assertWorkforceInvitationScopeUnchanged(expectedScope);
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "WORKFORCE_INVITATION_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
  assertWorkforceInvitationScopeUnchanged(expectedScope);
  if (
    !isWorkforceInvitationAdminReadModel(result) ||
    !workforceInvitationHasExactLifetime(result) ||
    result.personId !== expectedPersonId ||
    result.storeId !== expectedStoreId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "密码恢复邀请与当前员工或门店不一致，请刷新后核对",
    );
  }
  return workforceInvitationPurpose(result) === "PASSWORD_RESET" ? result : null;
}

export async function cancelWorkforcePasswordResetInvitation(
  command: CancelWorkforceInvitationCommand,
  expected: WorkforceInvitationAdminReadModel,
): Promise<CancelWorkforceInvitationResult> {
  if (
    !isCancelWorkforceInvitationCommand(command) ||
    !isWorkforceInvitationAdminReadModel(expected) ||
    workforceInvitationPurpose(expected) !== "PASSWORD_RESET" ||
    !workforceInvitationHasExactLifetime(expected) ||
    expected.invitationId !== command.invitationId ||
    expected.personId !== command.personId ||
    (expected.status !== command.expectedStatus && expected.status !== "CANCELLED")
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "取消密码恢复的内容不完整，请刷新后核对",
    );
  }
  const expectedScope = workforceInvitationScopeFor(
    operatorRequestScope.tenantId,
    expected.storeId,
  );
  const result = await request<unknown>(
    `/v1/workforce/invitations/${encodeURIComponent(command.invitationId)}/cancel`,
    { method: "POST", body: JSON.stringify(command) },
  );
  assertWorkforceInvitationScopeUnchanged(expectedScope);
  if (
    !isCancelWorkforceInvitationResult(result) ||
    workforceInvitationPurpose(result) !== "PASSWORD_RESET" ||
    !workforceInvitationHasExactLifetime(result) ||
    !sameWorkforceInvitationIdentity(result, expected) ||
    result.invitationId !== command.invitationId ||
    result.personId !== command.personId ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "密码恢复取消结果与原员工或链接不一致，页面继续保留待确认状态",
    );
  }
  return result;
}

export async function cancelWorkforceInvitation(
  command: CancelWorkforceInvitationCommand,
  expected: WorkforceInvitationAdminReadModel,
): Promise<CancelWorkforceInvitationResult> {
  if (
    !isCancelWorkforceInvitationCommand(command) ||
    !isWorkforceInvitationAdminReadModel(expected) ||
    workforceInvitationPurpose(expected) !== "ACCOUNT_ACTIVATION" ||
    !workforceInvitationHasExactLifetime(expected) ||
    expected.invitationId !== command.invitationId ||
    expected.personId !== command.personId ||
    (expected.status !== command.expectedStatus && expected.status !== "CANCELLED")
  ) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "取消邀请内容不完整，请检查后重试");
  }
  const expectedScope = workforceInvitationScopeFor(
    operatorRequestScope.tenantId,
    expected.storeId,
  );
  const result = await request<unknown>(
    `/v1/workforce/invitations/${encodeURIComponent(command.invitationId)}/cancel`,
    { method: "POST", body: JSON.stringify(command) },
  );
  assertWorkforceInvitationScopeUnchanged(expectedScope);
  if (
    !isCancelWorkforceInvitationResult(result) ||
    !workforceInvitationHasExactLifetime(result) ||
    !sameWorkforceInvitationIdentity(result, expected) ||
    result.invitationId !== command.invitationId ||
    result.personId !== command.personId ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "取消邀请回执与当前员工不一致，页面继续保留待确认状态",
    );
  }
  return result;
}

export async function reissueWorkforceInvitation(
  command: ReissueWorkforceInvitationCommand,
  expected: WorkforceInvitationAdminReadModel,
): Promise<WorkforceInvitationIssueResult> {
  if (
    !isReissueWorkforceInvitationCommand(command) ||
    !isWorkforceInvitationAdminReadModel(expected) ||
    workforceInvitationPurpose(expected) !== "ACCOUNT_ACTIVATION" ||
    !workforceInvitationHasExactLifetime(expected) ||
    expected.personId !== command.personId ||
    (expected.invitationId === command.invitationId
      ? expected.status !== command.expectedStatus
      : expected.status !== "PENDING_IDENTITY_CONFIRMATION")
  ) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "重发邀请内容不完整，请检查后重试");
  }
  const expectedScope = workforceInvitationScopeFor(
    operatorRequestScope.tenantId,
    expected.storeId,
  );
  const result = await request<unknown>(
    `/v1/workforce/invitations/${encodeURIComponent(command.invitationId)}/reissue`,
    { method: "POST", body: JSON.stringify(command) },
  );
  assertWorkforceInvitationScopeUnchanged(expectedScope);
  if (
    !isWorkforceInvitationIssueResult(result) ||
    !workforceInvitationHasExactLifetime(result) ||
    workforceInvitationPurpose(result) !== workforceInvitationPurpose(expected) ||
    result.invitationId === command.invitationId ||
    result.personId !== command.personId ||
    result.idempotencyKey !== command.idempotencyKey ||
    result.employmentId !== expected.employmentId ||
    result.accountId !== expected.accountId ||
    result.storeId !== expected.storeId ||
    result.displayName !== expected.displayName ||
    !sameWorkforceInvitationRoles(result.roles, expected.roles) ||
    result.providerMode !== expected.providerMode ||
    result.evidence !== expected.evidence ||
    (expected.status === "PENDING_IDENTITY_CONFIRMATION" &&
      (result.invitationId !== expected.invitationId ||
        result.issuedAt !== expected.issuedAt ||
        result.expiresAt !== expected.expiresAt))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "重发邀请回执与当前员工不一致，页面继续保留待确认状态",
    );
  }
  return result;
}

export async function inspectWorkforceInvitation(
  command: InspectWorkforceInvitationCommand,
): Promise<InspectWorkforceInvitationResult> {
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/inspect",
    command,
  );
  if (!isInspectWorkforceInvitationResult(result) || !workforceInvitationHasExactLifetime(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "邀请状态无法安全确认");
  }
  return result;
}

export async function completeWorkforceWechatRebind(
  command: CompleteWorkforceWechatRebindCommand,
): Promise<WorkforceWechatRebindResult> {
  if (!isCompleteWorkforceWechatRebindCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "微信换绑链接或请求编号不完整，请保留原页面后重试",
    );
  }
  const inspection = await inspectWorkforceInvitation({
    activationToken: command.activationToken,
  });
  if (
    inspection.purpose !== "WECHAT_REBIND" ||
    !["WECHAT_BOUND", "ACTIVE"].includes(inspection.status) ||
    (inspection.status === "WECHAT_BOUND" && inspection.localCompletionRequired === true) ||
    Date.parse(inspection.expiresAt) <= Date.parse(inspection.issuedAt)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "服务端返回的用途或换绑进度与当前链接不一致，页面已保留原请求",
    );
  }
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/wechat/rebind",
    command,
  );
  if (
    !isWorkforceWechatRebindResult(result) ||
    result.purpose !== inspection.purpose ||
    result.invitationId !== inspection.invitationId ||
    result.displayName !== inspection.displayName ||
    !sameWorkforceInvitationRoles(result.roles, inspection.roles) ||
    result.idempotencyKey !== command.idempotencyKey ||
    result.evidence !== inspection.evidence
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "微信换绑完成回执与当前链接、员工或请求编号不一致，页面已保留原请求",
    );
  }
  return result;
}

export async function requestWorkforcePhoneChangeNewPhoneOtp(
  command: RequestWorkforcePhoneChangeNewPhoneOtpCommand,
  expected: Pick<InspectWorkforceInvitationResult, "evidence" | "invitationId" | "providerMode">,
): Promise<WorkforcePhoneChangeNewPhoneOtpResult> {
  if (!isRequestWorkforcePhoneChangeNewPhoneOtpCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "新手机号格式或请求编号不正确，请检查后重试",
    );
  }
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/phone-change/new-phone-otp",
    command,
  );
  if (
    !isWorkforcePhoneChangeNewPhoneOtpResult(result) ||
    result.invitationId !== expected.invitationId ||
    result.providerMode !== expected.providerMode ||
    result.evidence !== expected.evidence ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "新手机号验证码回执与当前更换流程不一致，页面已保留原请求",
    );
  }
  return result;
}

export async function verifyWorkforcePhoneChangeNewPhoneOtp(
  command: VerifyWorkforcePhoneChangeNewPhoneOtpCommand,
  expected: Pick<InspectWorkforceInvitationResult, "evidence" | "invitationId">,
): Promise<VerifyWorkforcePhoneChangeNewPhoneOtpResult> {
  if (!isVerifyWorkforcePhoneChangeNewPhoneOtpCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "新手机号验证码或请求编号不正确，请检查后重试",
    );
  }
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/phone-change/new-phone-otp/verify",
    command,
  );
  if (
    !isVerifyWorkforcePhoneChangeNewPhoneOtpResult(result) ||
    result.invitationId !== expected.invitationId ||
    result.evidence !== expected.evidence ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "新手机号验证回执与当前更换流程不一致，页面已保留原请求",
    );
  }
  return result;
}

export async function completeWorkforcePhoneChange(
  command: CompleteWorkforcePhoneChangeCommand,
): Promise<WorkforcePhoneChangeResult> {
  if (!isCompleteWorkforcePhoneChangeCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "手机号更换链接或请求编号不完整，请保留原页面后重试",
    );
  }
  const inspection = await inspectWorkforceInvitation({
    activationToken: command.activationToken,
  });
  if (
    inspection.purpose !== "PHONE_CHANGE" ||
    !["PHONE_CHANGE_READY", "ACTIVE"].includes(inspection.status) ||
    (inspection.status === "PHONE_CHANGE_READY" && inspection.localCompletionRequired === true) ||
    Date.parse(inspection.expiresAt) <= Date.parse(inspection.issuedAt)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "服务端返回的用途或手机号更换进度与当前链接不一致，页面已保留原请求",
    );
  }
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/phone-change/complete",
    command,
  );
  if (
    !isWorkforcePhoneChangeResult(result) ||
    result.purpose !== inspection.purpose ||
    result.invitationId !== inspection.invitationId ||
    result.displayName !== inspection.displayName ||
    !sameWorkforceInvitationRoles(result.roles, inspection.roles) ||
    result.idempotencyKey !== command.idempotencyKey ||
    result.evidence !== inspection.evidence
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "手机号更换完成回执与当前链接、员工或请求编号不一致，页面已保留原请求",
    );
  }
  return result;
}

export async function confirmWorkforceInvitationIdentity(
  command: ConfirmWorkforceInvitationIdentityCommand,
  expectedInvitationId: string,
): Promise<ConfirmWorkforceInvitationIdentityResult> {
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/identity/confirm",
    command,
  );
  if (
    !isConfirmWorkforceInvitationIdentityResult(result) ||
    result.invitationId !== expectedInvitationId ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "身份确认回执与当前邀请不一致");
  }
  return result;
}

export async function verifyWorkforceInvitationOtp(
  command: VerifyWorkforceInvitationOtpCommand,
  expectedInvitationId: string,
): Promise<VerifyWorkforceInvitationOtpResult> {
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/otp/verify",
    command,
  );
  if (
    !isVerifyWorkforceInvitationOtpResult(result) ||
    result.invitationId !== expectedInvitationId ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "验证码回执与当前邀请不一致");
  }
  return result;
}

export async function bindWorkforceInvitationWechat(
  command: BindWorkforceInvitationWechatCommand,
  expectedInvitationId: string,
): Promise<BindWorkforceInvitationWechatResult> {
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/wechat/bind",
    command,
  );
  if (
    !isBindWorkforceInvitationWechatResult(result) ||
    result.invitationId !== expectedInvitationId ||
    result.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "微信绑定回执与当前邀请不一致");
  }
  return result;
}

export async function activateWorkforceInvitation(
  command: ActivateWorkforceInvitationCommand,
  expected: WorkforceInvitationActivationExpectation,
): Promise<WorkforceInvitationActivationResult> {
  const result = await requestPublicWorkforceInvitation<unknown>(
    "/v1/workforce/invitations/activate",
    command,
  );
  if (
    !isWorkforceInvitationActivationResult(result) ||
    result.invitationId !== expected.invitationId ||
    result.idempotencyKey !== command.idempotencyKey ||
    !workforceInvitationHasExactLifetime(expected) ||
    !["WECHAT_BOUND", "ACTIVE"].includes(expected.status) ||
    (expected.status === "ACTIVE" && expected.localCompletionRequired !== true) ||
    !workforceInvitationProviderEvidenceMatches(expected) ||
    workforceInvitationPurpose(result) !== workforceInvitationPurpose(expected) ||
    result.displayName !== expected.displayName ||
    !sameWorkforceInvitationRoles(result.roles, expected.roles) ||
    result.evidence !== expected.evidence
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "账号启用回执与当前邀请不一致");
  }
  return result;
}

export async function listWorkforceDirectory(
  expectedTenantId: string,
  storeId: string,
  cursor?: string,
  signal?: AbortSignal,
): Promise<WorkforceDirectoryPage> {
  const query = new URLSearchParams({ storeId, limit: "100" });
  if (cursor) query.set("cursor", cursor);
  const result = await request<unknown>(`/v1/workforce/directory?${query.toString()}`, {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (
    !isWorkforceDirectoryPage(result) ||
    result.tenantId !== expectedTenantId ||
    !result.visibleStoreIds.includes(storeId)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "人员名单与当前组织或门店不一致，页面已停止显示，请刷新后重试",
    );
  }
  return result;
}

export async function listWorkforceMigrationConflicts(
  expectedTenantId: string,
  storeId: string,
  status: WorkforceMigrationConflictStatus,
  cursor?: string,
  signal?: AbortSignal,
): Promise<WorkforceMigrationConflictPage> {
  const query = new URLSearchParams({ storeId, status, limit: "100" });
  if (cursor) query.set("cursor", cursor);
  const result = await request<unknown>(`/v1/workforce/conflicts?${query.toString()}`, {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (
    !isWorkforceMigrationConflictPage(result) ||
    result.tenantId !== expectedTenantId ||
    result.status !== status ||
    result.items.some((item) => item.status !== status)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "历史数据核对与当前组织或选择状态不一致，页面已停止显示，请刷新后重试",
    );
  }
  return result;
}

export async function getWorkforcePersonDetail(
  tenantId: string,
  storeId: string,
  personId: string,
  signal?: AbortSignal,
): Promise<WorkforcePersonDetail> {
  const query = new URLSearchParams({ storeId });
  const result = await request<unknown>(
    `/v1/workforce/people/${encodeURIComponent(personId)}?${query.toString()}`,
    {
      cache: "no-store",
      ...(signal ? { signal } : {}),
    },
  );
  if (
    !isWorkforcePersonDetail(result) ||
    result.tenantId !== tenantId ||
    result.person.id !== personId ||
    !result.visibleStoreIds.includes(storeId)
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "人员详情返回内容无法安全确认");
  }
  return result;
}

export async function getWorkforceOffboardingPreview(
  storeId: string,
  personId: string,
  signal?: AbortSignal,
): Promise<WorkforceOffboardingPreview> {
  const result = await request<unknown>(
    `/v1/workforce/people/${encodeURIComponent(personId)}/offboarding-preview`,
    { cache: "no-store", ...(signal ? { signal } : {}) },
  );
  if (
    !isWorkforceOffboardingPreview(result) ||
    result.personId !== personId ||
    result.storeId !== storeId
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "离职安全检查返回内容无法安全确认");
  }
  return result;
}

export async function upsertCanonicalWorkforceEmployment(
  command: UpsertCanonicalWorkforceEmploymentCommand,
): Promise<UpsertCanonicalWorkforceEmploymentResult> {
  const result = await request<unknown>("/v1/workforce/employments", {
    method: "POST",
    body: JSON.stringify(command),
  });
  const requestedRoles = [...command.employment.roles].sort();
  const returnedRoles = isUpsertCanonicalWorkforceEmploymentResult(result)
    ? [...result.roles].sort()
    : [];
  const aggregateVersionMatches =
    command.personMode === "NEW_PERSON"
      ? isUpsertCanonicalWorkforceEmploymentResult(result) && result.aggregateVersion === 1
      : isUpsertCanonicalWorkforceEmploymentResult(result) &&
        result.aggregateVersion === command.expectedAggregateVersion + 1;
  if (
    !isUpsertCanonicalWorkforceEmploymentResult(result) ||
    result.personId !== command.person.personId.trim() ||
    result.displayName !== command.person.displayName.trim() ||
    result.storeId !== command.employment.storeId.trim() ||
    result.employmentNumber !== command.employment.employmentNumber.trim() ||
    result.positionTitle !== command.employment.positionTitle.trim() ||
    result.employmentStatus !== command.employment.status ||
    returnedRoles.length !== requestedRoles.length ||
    returnedRoles.some((role, index) => role !== requestedRoles[index]) ||
    (command.employment.status === "ACTIVE" ? result.endedAt !== null : result.endedAt === null) ||
    !aggregateVersionMatches
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "人员保存回执与原操作不一致，系统继续保留待确认状态",
    );
  }
  return result;
}

export interface PendingWorkforceAccountDisable {
  personId: string;
  accountId: string;
  request: DisableCanonicalWorkforceAccountCommand;
  commandSha256: string;
  recordedAt: string;
}

function stableWorkforceMutationJson(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableWorkforceMutationJson(item)).join(",")}]`;
  }
  if (value !== null && typeof value === "object") {
    return `{${Object.entries(value as Record<string, unknown>)
      .filter(([, item]) => item !== undefined)
      .sort(([left], [right]) => left.localeCompare(right))
      .map(([key, item]) => `${JSON.stringify(key)}:${stableWorkforceMutationJson(item)}`)
      .join(",")}}`;
  }
  return JSON.stringify(value) ?? "null";
}

function isPendingWorkforceAccountDisable(value: unknown): value is PendingWorkforceAccountDisable {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const pending = value as Record<string, unknown>;
  const expectedKeys = ["accountId", "commandSha256", "personId", "recordedAt", "request"];
  const actualKeys = Object.keys(pending).sort();
  if (
    actualKeys.length !== expectedKeys.length ||
    actualKeys.some((key, index) => key !== expectedKeys[index])
  ) {
    return false;
  }
  return (
    typeof pending.personId === "string" &&
    pending.personId.length > 0 &&
    pending.personId.length <= 512 &&
    typeof pending.accountId === "string" &&
    pending.accountId.length > 0 &&
    pending.accountId.length <= 512 &&
    isDisableCanonicalWorkforceAccountCommand(pending.request) &&
    typeof pending.commandSha256 === "string" &&
    /^[a-f0-9]{64}$/.test(pending.commandSha256) &&
    typeof pending.recordedAt === "string" &&
    Number.isFinite(Date.parse(pending.recordedAt))
  );
}

async function workforceAccountDisableCommandSha256(
  pending: Pick<PendingWorkforceAccountDisable, "personId" | "accountId" | "request">,
): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前浏览器无法校验待确认的账号停用请求，请升级浏览器后重试",
    );
  }
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(stableWorkforceMutationJson(pending)),
  );
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

async function workforceEmploymentCommandSha256(
  request: UpsertCanonicalWorkforceEmploymentCommand,
): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前浏览器无法校验待确认的人员变更，请升级浏览器后重试",
    );
  }
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(stableWorkforceMutationJson(request)),
  );
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

async function workforceInvitationCommandSha256(
  request:
    | CreateWorkforceInvitationCommand
    | CancelWorkforceInvitationCommand
    | ReissueWorkforceInvitationCommand,
): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前浏览器无法校验待确认的员工邀请，请升级浏览器后重试",
    );
  }
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(stableWorkforceMutationJson(request)),
  );
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

async function workforcePasswordResetCommandSha256(
  request: CreateWorkforcePasswordResetCommand,
): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前浏览器无法校验待确认的密码重置请求，请升级浏览器后重试",
    );
  }
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(stableWorkforceMutationJson(request)),
  );
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

export async function getPendingWorkforceMutation(
  signal?: AbortSignal,
): Promise<WorkforceMutationPending | null> {
  const result = await request<unknown>("/v1/workforce/mutations/pending", {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (result === null) return null;
  if (!isWorkforceMutationPending(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "待确认的人员变更无法安全恢复");
  }
  if (result.kind === "ACCOUNT_DISABLE") {
    const expectedSha256 = await workforceAccountDisableCommandSha256({
      personId: result.personId,
      accountId: result.accountId,
      request: result.request,
    });
    if (result.commandSha256 !== expectedSha256) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的账号停用请求摘要不一致，已停止恢复",
      );
    }
    return result;
  }
  if (result.kind === "ACCOUNT_INVITE") {
    if (result.personId !== result.request.person.personId) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的员工邀请目标与原始请求不一致，已停止恢复",
      );
    }
    const expectedSha256 = await workforceInvitationCommandSha256(result.request);
    if (result.commandSha256 !== expectedSha256) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的员工邀请请求摘要不一致，已停止恢复",
      );
    }
    return result;
  }
  if (result.kind === "ACCOUNT_INVITATION_CANCEL" || result.kind === "ACCOUNT_INVITATION_REISSUE") {
    if (result.personId !== result.request.personId) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的邀请操作目标与原始请求不一致，已停止恢复",
      );
    }
    const expectedSha256 = await workforceInvitationCommandSha256(result.request);
    if (result.commandSha256 !== expectedSha256) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的邀请操作摘要不一致，已停止恢复",
      );
    }
    return result;
  }
  if (result.kind === "ACCOUNT_PASSWORD_RESET") {
    if (
      result.personId !== result.request.personId ||
      result.accountId !== result.request.accountId
    ) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的密码重置目标与原始请求不一致，已停止恢复",
      );
    }
    const expectedSha256 = await workforcePasswordResetCommandSha256(result.request);
    if (result.commandSha256 !== expectedSha256) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "待确认的密码重置请求摘要不一致，已停止恢复",
      );
    }
    return result;
  }
  if (result.personId !== result.request.person.personId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待确认的人员变更目标与原始请求不一致，已停止恢复",
    );
  }
  const expectedSha256 = await workforceEmploymentCommandSha256(result.request);
  if (result.commandSha256 !== expectedSha256) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待确认的人员变更请求摘要不一致，已停止恢复",
    );
  }
  return result;
}

export async function getPendingWorkforceAccountDisable(
  signal?: AbortSignal,
): Promise<PendingWorkforceAccountDisable | null> {
  const result = await request<unknown>("/v1/workforce/account-disables/pending", {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (result === null) return null;
  if (!isPendingWorkforceAccountDisable(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "待确认的登录账号停用请求无法安全恢复");
  }
  const expectedSha256 = await workforceAccountDisableCommandSha256({
    personId: result.personId,
    accountId: result.accountId,
    request: result.request,
  });
  if (result.commandSha256 !== expectedSha256) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待确认的登录账号停用请求摘要不一致，已停止恢复",
    );
  }
  return result;
}

export async function disableWorkforceAccount(
  personId: string,
  accountId: string,
  command: DisableCanonicalWorkforceAccountCommand,
): Promise<DisableCanonicalWorkforceAccountResult> {
  if (
    !personId.trim() ||
    !accountId.trim() ||
    !isDisableCanonicalWorkforceAccountCommand(command)
  ) {
    throw new ApiRequestError(
      "WORKFORCE_ACCOUNT_DISABLE_REQUEST_INVALID",
      "停用登录账号所需资料不完整，请刷新人员详情后再试",
    );
  }

  let result: unknown;
  try {
    result = await request<unknown>(
      `/v1/workforce/people/${encodeURIComponent(personId)}/accounts/${encodeURIComponent(accountId)}/disable`,
      {
        method: "POST",
        body: JSON.stringify(command),
      },
    );
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.code === "GATEWAY_RESPONSE_INVALID" &&
      error.statusCode !== undefined &&
      error.statusCode >= 200 &&
      error.statusCode < 300
    ) {
      throw new ApiRequestError(
        "WORKFORCE_ACCOUNT_DISABLE_RESULT_UNKNOWN",
        "停用请求已经发出，但返回内容无法确认；请保留本次操作并继续确认",
      );
    }
    throw error;
  }

  if (
    !isDisableCanonicalWorkforceAccountResult(result) ||
    result.personId !== personId ||
    result.accountId !== accountId ||
    result.identityVersion !== command.expectedIdentityVersion + 1 ||
    result.aggregateVersion !== command.expectedAggregateVersion + 1
  ) {
    throw new ApiRequestError(
      "WORKFORCE_ACCOUNT_DISABLE_RESULT_UNKNOWN",
      "停用请求已经发出，但账号或版本结果无法确认；请保留本次操作并继续确认",
    );
  }
  return result;
}

const NATIVE_SESSION_CLEANUP_TIMEOUT_MS = 500;
const NATIVE_APP_INFO_TIMEOUT_MS = 500;
let nativeAuthenticationQueue: Promise<void> = Promise.resolve();
let nativeSessionBridgeUnsafe = false;
let nativeAppInfoRequest: ReturnType<typeof nativeAppInfo> | null = null;
let nativeAppInfoTimedOut = false;
const nativeSessionSafetyListeners = new Set<(unsafe: boolean) => void>();
let pendingNativeRevocation: {
  accessToken: string;
  csrfToken: string;
  expiresAt: string;
  appVersion: string;
} | null = null;

/** @internal Test-only process restart simulation; unavailable in release builds. */
export function resetNativeAuthenticationStateForTests(): void {
  if (import.meta.env.MODE !== "test") {
    throw new Error("native authentication state reset is test-only");
  }
  nativeAuthenticationQueue = Promise.resolve();
  setNativeSessionBridgeUnsafe(false);
  nativeAppInfoRequest = null;
  nativeAppInfoTimedOut = false;
  pendingNativeRevocation = null;
  nativeSessionVault.resetProcessMemoryForTests();
}

export async function initializeNativeAuthenticationState(): Promise<void> {
  if (!isNativeOperatorApp()) return;
  const restored = await runNativeStorageOperationWithinDeadline(async () => {
    await nativeSessionVault.restore();
  });
  if (!restored) return;
  await reconcilePendingNativeSessionRevocation().catch(() => undefined);
}

function setNativeSessionBridgeUnsafe(unsafe: boolean): void {
  if (nativeSessionBridgeUnsafe === unsafe) return;
  nativeSessionBridgeUnsafe = unsafe;
  for (const listener of nativeSessionSafetyListeners) listener(unsafe);
}

export function nativeSessionSafetyUnavailable(): boolean {
  return nativeSessionBridgeUnsafe;
}

export function subscribeNativeSessionSafety(listener: (unsafe: boolean) => void): () => void {
  nativeSessionSafetyListeners.add(listener);
  listener(nativeSessionBridgeUnsafe);
  return () => nativeSessionSafetyListeners.delete(listener);
}

async function clearNativeSessionWithinDeadline(): Promise<boolean> {
  return runNativeStorageOperationWithinDeadline(() => nativeSessionVault.clear());
}

async function clearNativeSessionIfCurrentWithinDeadline(accessToken: string): Promise<boolean> {
  return runNativeStorageOperationWithinDeadline(() =>
    nativeSessionVault.clearIfCurrent(accessToken),
  );
}

async function clearPendingNativeRevocationWithinDeadline(): Promise<boolean> {
  return runNativeStorageOperationWithinDeadline(() => nativeSessionVault.clearPendingRevocation());
}

async function savePendingNativeRevocationWithinDeadline(
  pending: NonNullable<typeof pendingNativeRevocation>,
): Promise<boolean> {
  return runNativeStorageOperationWithinDeadline(async () => {
    await nativeSessionVault.savePendingRevocation(pending);
  });
}

async function saveNativeSessionWithinDeadline(
  session: Parameters<typeof nativeSessionVault.save>[0],
): Promise<boolean> {
  return runNativeStorageOperationWithinDeadline(async () => {
    await nativeSessionVault.save(session);
  });
}

async function nativeAppInfoWithinDeadline(): Promise<Awaited<ReturnType<typeof nativeAppInfo>>> {
  if (nativeAppInfoTimedOut) return null;
  // App metadata is immutable for the lifetime of one native process. Reuse
  // one bridge request so an unresponsive Capacitor callback cannot accumulate
  // another permanently pending request on every login retry.
  if (!nativeAppInfoRequest) {
    const request = nativeAppInfo();
    nativeAppInfoRequest = request;
    void request.catch(() => {
      // An explicit native rejection is complete and can be retried. Only a
      // request whose callback never returns is quarantined until App restart.
      if (!nativeAppInfoTimedOut && nativeAppInfoRequest === request) {
        nativeAppInfoRequest = null;
      }
    });
  }
  const appInfoRequest = nativeAppInfoRequest;
  let timeout: ReturnType<typeof setTimeout> | undefined;
  let timedOut = false;
  try {
    return await Promise.race([
      appInfoRequest.catch(() => null),
      new Promise<null>((resolve) => {
        timeout = setTimeout(() => {
          timedOut = true;
          nativeAppInfoTimedOut = true;
          resolve(null);
        }, NATIVE_APP_INFO_TIMEOUT_MS);
      }),
    ]);
  } finally {
    if (timeout) clearTimeout(timeout);
    if (timedOut) nativeAppInfoTimedOut = true;
  }
}

async function runNativeStorageOperationWithinDeadline(
  operation: () => Promise<void>,
): Promise<boolean> {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  let timedOut = false;
  try {
    const cleared = await Promise.race([
      operation().then(
        () => true,
        () => false,
      ),
      new Promise<boolean>((resolve) => {
        timeout = setTimeout(() => {
          timedOut = true;
          resolve(false);
        }, NATIVE_SESSION_CLEANUP_TIMEOUT_MS);
      }),
    ]);
    // A timed-out remove cannot be cancelled. It may still complete later and
    // delete a newly saved token, so this App process must fail closed until a
    // full restart creates a fresh native bridge instance.
    if (timedOut || !cleared) {
      nativeSessionVault.invalidatePendingOperations();
      setNativeSessionBridgeUnsafe(true);
    }
    return cleared;
  } finally {
    if (timeout) clearTimeout(timeout);
  }
}

async function revokeNativeSession(
  accessToken: string,
  csrfToken: string,
  appVersion: string,
): Promise<boolean> {
  try {
    const response = await fetch(`${gatewayUrl}/v1/auth/logout`, {
      method: "POST",
      // Native bearer compensation must never inherit a stale browser cookie.
      // Cookie + Bearer is deliberately rejected before the Gateway revokes.
      credentials: "omit",
      signal: AbortSignal.timeout(5_000),
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${accessToken}`,
        "x-csrf-token": csrfToken,
        "x-billiard-app-version": appVersion,
      },
      body: "{}",
    });
    if (response.ok) return true;
    if (response.status !== 401) return false;
    // A retry can receive AUTH_REQUIRED after the first request revoked the
    // token but its response was lost. Other 401 codes, notably credential
    // conflicts, do not prove that this exact bearer token was revoked.
    const body = (await response.json().catch(() => null)) as { code?: unknown } | null;
    return body?.code === "AUTH_REQUIRED";
  } catch {
    return false;
  }
}

export async function reconcilePendingNativeSessionRevocation(): Promise<void> {
  let restoredPending: typeof pendingNativeRevocation = null;
  if (!pendingNativeRevocation && !nativeSessionVault.pendingRevocation()) {
    const restored = await runNativeStorageOperationWithinDeadline(async () => {
      restoredPending = await nativeSessionVault.restorePendingRevocation();
    });
    if (!restored) {
      throw new ApiRequestError(
        "NATIVE_SECURE_SESSION_UNAVAILABLE",
        "手机安全存储状态无法确认；请完全关闭并重新打开 App 后再试",
      );
    }
  }
  const pending =
    pendingNativeRevocation ?? nativeSessionVault.pendingRevocation() ?? restoredPending;
  if (!pending) return;
  pendingNativeRevocation = pending;
  if (!(await revokeNativeSession(pending.accessToken, pending.csrfToken, pending.appVersion))) {
    throw new ApiRequestError(
      "NATIVE_SESSION_REVOCATION_UNKNOWN",
      "仍无法确认上次登录会话是否已撤销；请先恢复门店网络，再重试登录核对",
    );
  }
  // Clear the active token first and the recovery marker last. If active-token
  // cleanup is uncertain, retaining the marker keeps the next restart closed.
  const sessionCleared = await clearNativeSessionWithinDeadline();
  const quarantineCleared = sessionCleared
    ? await clearPendingNativeRevocationWithinDeadline()
    : false;
  if (!sessionCleared || !quarantineCleared) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "上次登录会话已撤销，但手机安全存储仍无法完成清理；请完全关闭并重新打开 App 后再试",
    );
  }
  if (pendingNativeRevocation === pending) pendingNativeRevocation = null;
}

async function loginNativeOperator(
  login: string,
  password: string,
  sessionMode: NativeSessionMode,
): Promise<{ operator: OperatorIdentity }> {
  if (nativeSessionBridgeUnsafe) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "手机安全存储状态无法确认，请完全关闭并重新打开 App 后再登录",
    );
  }
  // Never create another server session while the previous compensation is
  // uncertain. Retrying login first retries revocation with the exact token.
  await reconcilePendingNativeSessionRevocation();
  if (nativeSessionBridgeUnsafe) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "手机安全存储状态无法确认，请完全关闭并重新打开 App 后再登录",
    );
  }
  if (!(await clearNativeSessionWithinDeadline())) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "App 无法安全清理旧登录状态，请重新打开应用并检查手机安全存储后再试",
    );
  }
  const appVersion = (await nativeAppInfoWithinDeadline())?.version;
  if (!appVersion) {
    throw new ApiRequestError(
      "NATIVE_APP_VERSION_REQUIRED",
      "无法读取 App 版本，请重新打开应用后再登录",
    );
  }
  const authenticated = await request<{
    operator: OperatorIdentity;
    session: {
      accessToken: string;
      csrfToken: string;
      expiresAt: string;
      mode: NativeSessionMode;
      shiftId: string | null;
      shiftStatus: "OPEN" | "HANDOVER_PENDING" | null;
      activationState: "PENDING_ACTIVATION" | "ACTIVE";
    };
  }>("/v1/auth/mobile/login", {
    method: "POST",
    body: JSON.stringify({ login, password, sessionMode, appVersion }),
  });
  const pending = {
    accessToken: authenticated.session.accessToken,
    csrfToken: authenticated.session.csrfToken,
    expiresAt: authenticated.session.expiresAt,
    appVersion,
  };
  pendingNativeRevocation = pending;
  let serverActivated = false;
  try {
    if (authenticated.session.activationState !== "PENDING_ACTIVATION") {
      throw new Error("native login did not issue a pending-activation session");
    }
    // Only private-device sessions may persist a revocation-capable token.
    // Public cashier sessions remain memory-only for their entire lifetime.
    if (
      authenticated.session.mode === "PERSONAL" &&
      !(await savePendingNativeRevocationWithinDeadline(pending))
    ) {
      throw new Error("native pending-revocation marker could not be saved");
    }
    if (!(await saveNativeSessionWithinDeadline(authenticated.session))) {
      throw new Error("native session could not be activated");
    }
    const activation = await request<{
      session: {
        expiresAt: string;
        activationState: "ACTIVE";
      };
    }>("/v1/auth/mobile/activate", { method: "POST", body: "{}" });
    if (
      activation.session.activationState !== "ACTIVE" ||
      activation.session.expiresAt !== authenticated.session.expiresAt
    ) {
      throw new Error("native session activation response did not match the issued session");
    }
    serverActivated = true;
    const markerCommitted =
      authenticated.session.mode !== "PERSONAL" ||
      (await clearPendingNativeRevocationWithinDeadline());
    if (!markerCommitted) throw new Error("native activation marker could not be cleared");
    pendingNativeRevocation = null;
  } catch {
    // Start authoritative server revocation before touching the native bridge
    // again. A hung Keychain/Keystore callback must never block that request.
    const revocation = revokeNativeSession(
      pending.accessToken,
      pending.csrfToken,
      pending.appVersion,
    );
    const cleanup = clearNativeSessionWithinDeadline();
    const [revoked, sessionCleared] = await Promise.all([revocation, cleanup]);
    if (revoked && sessionCleared) {
      const quarantineCleared = await clearPendingNativeRevocationWithinDeadline();
      if (quarantineCleared && pendingNativeRevocation === pending) {
        pendingNativeRevocation = null;
      }
    }
    throw new ApiRequestError(
      revoked ? "NATIVE_SECURE_SESSION_UNAVAILABLE" : "NATIVE_SESSION_REVOCATION_UNKNOWN",
      revoked
        ? serverActivated
          ? "App 未能安全确认登录激活，已撤销本次登录；请重新检查手机安全存储后再试"
          : "App 无法安全保存登录状态，已撤销本次登录；请重新检查手机安全存储后再试"
        : "App 无法安全保存登录状态，也无法确认本次会话是否已撤销；请先恢复门店网络，再重新打开 App 登录",
    );
  }
  return { operator: authenticated.operator };
}

export function loginOperator(
  login: string,
  password: string,
  sessionMode: NativeSessionMode = "PERSONAL",
): Promise<{ operator: OperatorIdentity }> {
  if (!isNativeOperatorApp()) {
    return request("/v1/auth/login", {
      method: "POST",
      body: JSON.stringify({ login, password }),
    });
  }
  // A device has one secure-session slot. Serialize login attempts so an older
  // failure cannot clear or overwrite a newer successful session.
  const attempt = nativeAuthenticationQueue.then(() =>
    loginNativeOperator(login, password, sessionMode),
  );
  nativeAuthenticationQueue = attempt.then(
    () => undefined,
    () => undefined,
  );
  return attempt;
}

async function logoutNativeOperator(): Promise<{ loggedOut: boolean }> {
  // A previous logout can have cleared local memory while its exact server
  // revocation remained unknown. Retry that persisted token before reporting
  // success or inspecting the current active slot.
  await reconcilePendingNativeSessionRevocation();
  const session = nativeSessionVault.current();
  if (!session) return { loggedOut: true };
  const appVersion = (await nativeAppInfoWithinDeadline())?.version ?? nativeClientVersionHeader();
  if (!appVersion) {
    throw new ApiRequestError(
      "NATIVE_APP_VERSION_REQUIRED",
      "无法读取 App 版本，暂不能安全退出；请完全关闭并重新打开 App 后再试",
    );
  }
  const pending = {
    accessToken: session.accessToken,
    csrfToken: session.csrfToken,
    expiresAt: session.expiresAt,
    appVersion,
  };
  pendingNativeRevocation = pending;
  if (session.mode === "PERSONAL" && !(await savePendingNativeRevocationWithinDeadline(pending))) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "手机安全存储无法记录退出状态；请完全关闭并重新打开 App 后再试",
    );
  }
  const [revoked, sessionCleared] = await Promise.all([
    revokeNativeSession(session.accessToken, session.csrfToken, appVersion),
    clearNativeSessionWithinDeadline(),
  ]);
  if (!revoked) {
    throw new ApiRequestError(
      "NATIVE_SESSION_REVOCATION_UNKNOWN",
      "无法确认账号是否已安全退出；请恢复门店网络后重试，系统不会重复创建会话",
    );
  }
  const quarantineCleared =
    session.mode !== "PERSONAL" ||
    (sessionCleared && (await clearPendingNativeRevocationWithinDeadline()));
  if (!sessionCleared || !quarantineCleared) {
    throw new ApiRequestError(
      "NATIVE_SECURE_SESSION_UNAVAILABLE",
      "账号已在服务端退出，但手机安全存储清理未完成；请完全关闭并重新打开 App",
    );
  }
  if (pendingNativeRevocation === pending) pendingNativeRevocation = null;
  return { loggedOut: true };
}

export function logoutOperator(): Promise<{ loggedOut: boolean }> {
  if (!isNativeOperatorApp()) {
    return request<unknown>("/v1/auth/logout", {
      method: "POST",
      body: "{}",
    }).then((result) => {
      if (
        typeof result !== "object" ||
        result === null ||
        Array.isArray(result) ||
        Object.keys(result).length !== 1 ||
        (result as Record<string, unknown>).loggedOut !== true
      ) {
        throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "退出结果无法安全确认，请稍后重试");
      }
      notifyOperatorAuthenticationInvalidation("LOGOUT");
      return { loggedOut: true };
    });
  }
  const attempt = nativeAuthenticationQueue.then(logoutNativeOperator);
  nativeAuthenticationQueue = attempt.then(
    () => undefined,
    () => undefined,
  );
  return attempt.then((result) => {
    notifyOperatorAuthenticationInvalidation("LOGOUT");
    return result;
  });
}

export function getPublicVersion(): Promise<VersionInfo> {
  return request("/version");
}

export type SecondaryAuthorizationAction =
  | "REFUND_ORDER"
  | "GIFT_ORDER_ITEM"
  | "MANAGE_OPERATOR_ACCOUNTS"
  | "RESET_OPERATOR_PASSWORD"
  | "RECONCILE_MEMBER_RECHARGE"
  | "RECONCILE_PAYMENT"
  | "RESOLVE_ORDER_CONFLICT"
  | "RESOLVE_COACH_CONFLICT"
  | "RECONCILE_GROUP_BUY"
  | "MIGRATE_TABLE_NODE"
  | "MANAGE_TABLE_KIOSK";

export interface GiftSecondaryAuthorizationContext {
  sessionId: string;
  skuId: string;
  quantity: number;
  expectedProductName: string;
  expectedListUnitPriceFen: number;
  reason: string;
}

export interface SecondaryAuthorizationGrant {
  token: string;
  authorizerId: string;
  authorizerDisplayName: string;
  expiresAt: string;
  evidence: "SIMULATED" | "STORE_ACCEPTED";
}

type NonGiftSecondaryAuthorizationAction = Exclude<SecondaryAuthorizationAction, "GIFT_ORDER_ITEM">;

function boundedTrimmedString(value: unknown, minimum: number, maximum: number): value is string {
  return (
    typeof value === "string" &&
    value === value.trim() &&
    [...value].length >= minimum &&
    [...value].length <= maximum
  );
}

function nonEmptyTrimmedString(value: unknown): value is string {
  return typeof value === "string" && value === value.trim() && value.length > 0;
}

function giftSecondaryAuthorizationContextIsValid(
  value: GiftSecondaryAuthorizationContext | undefined,
): value is GiftSecondaryAuthorizationContext {
  return (
    value !== undefined &&
    boundedTrimmedString(value.sessionId, 1, 256) &&
    boundedTrimmedString(value.skuId, 1, 128) &&
    Number.isSafeInteger(value.quantity) &&
    value.quantity >= 1 &&
    value.quantity <= 99 &&
    boundedTrimmedString(value.expectedProductName, 1, 120) &&
    Number.isSafeInteger(value.expectedListUnitPriceFen) &&
    value.expectedListUnitPriceFen >= 1 &&
    boundedTrimmedString(value.reason, 2, 200)
  );
}

function isSecondaryAuthorizationGrant(value: unknown): value is SecondaryAuthorizationGrant {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const expectedKeys = [
    "token",
    "authorizerId",
    "authorizerDisplayName",
    "expiresAt",
    "evidence",
  ] as const;
  return (
    Object.keys(record).length === expectedKeys.length &&
    expectedKeys.every((key) => Object.hasOwn(record, key)) &&
    nonEmptyTrimmedString(record.token) &&
    nonEmptyTrimmedString(record.authorizerId) &&
    boundedTrimmedString(record.authorizerDisplayName, 1, 120) &&
    nonEmptyTrimmedString(record.expiresAt) &&
    Number.isFinite(Date.parse(record.expiresAt)) &&
    (record.evidence === "SIMULATED" || record.evidence === "STORE_ACCEPTED")
  );
}

export function requestSecondaryAuthorization(
  action: "GIFT_ORDER_ITEM",
  credential: string,
  authorizerLogin: string,
  actionContext: GiftSecondaryAuthorizationContext,
): Promise<SecondaryAuthorizationGrant>;
export function requestSecondaryAuthorization(
  action: NonGiftSecondaryAuthorizationAction,
  credential: string,
  authorizerLogin?: string,
): Promise<SecondaryAuthorizationGrant>;
export async function requestSecondaryAuthorization(
  action: SecondaryAuthorizationAction,
  credential: string,
  authorizerLogin?: string,
  actionContext?: GiftSecondaryAuthorizationContext,
): Promise<SecondaryAuthorizationGrant> {
  if (
    (action === "GIFT_ORDER_ITEM" && !giftSecondaryAuthorizationContextIsValid(actionContext)) ||
    (action !== "GIFT_ORDER_ITEM" && actionContext !== undefined)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "请先核对赠品、数量、原价和原因，再请店长或老板授权",
      400,
    );
  }
  const value = await request<unknown>("/v1/auth/secondary-authorizations", {
    method: "POST",
    body: JSON.stringify({ action, credential, authorizerLogin, actionContext }),
  });
  if (!isSecondaryAuthorizationGrant(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "一次性授权结果无法安全确认，系统没有提交后续操作；请重新授权",
    );
  }
  return value;
}

function secondaryAuthorizationHeaders(token: string): Record<string, string> {
  return { "x-secondary-authorization": token };
}

export async function listTables(
  scope: Pick<OperatorIdentity, "tenantId" | "storeId">,
): Promise<TableSnapshot[]> {
  const value = await request<unknown>("/v1/tables", { cache: "no-store" });
  if (!isTableSnapshotList(value, scope.tenantId, scope.storeId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "球台状态无法安全确认，页面已停止显示并禁止经营操作，请刷新后重试",
    );
  }
  return value;
}

export async function listFrontdeskOperatingFacts(
  scope: Pick<OperatorIdentity, "tenantId" | "storeId">,
): Promise<FrontdeskOperatingFactReadModelList> {
  const value = await request<unknown>("/v1/frontdesk/operating-facts", {
    cache: "no-store",
  });
  if (
    !isFrontdeskOperatingFactReadModelList(value) ||
    value.some((fact) => fact.tenantId !== scope.tenantId || fact.storeId !== scope.storeId)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "前台经营状态无法安全确认，旧摘要已隐藏，当前经营操作已暂停",
    );
  }
  return value;
}

export async function getCoachRuntime(
  businessDate?: string,
  expectedCoachId?: string,
  sessionId?: string,
  signal?: AbortSignal,
): Promise<CoachRuntimeReadModel> {
  const query = new URLSearchParams();
  if (businessDate) query.set("businessDate", businessDate);
  if (sessionId) query.set(COACH_RUNTIME_SESSION_QUERY_KEY, sessionId);
  const suffix = query.size > 0 ? `?${query.toString()}` : "";
  const value = await request<unknown>(`/v1/coaches/runtime${suffix}`, {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (
    !isCoachRuntimeReadModel(value) ||
    value.assignmentAvailability === undefined ||
    (businessDate !== undefined && value.businessDate !== businessDate) ||
    (sessionId !== undefined &&
      value.services.some((service) => service.sessionId !== sessionId)) ||
    (expectedCoachId !== undefined &&
      (value.syncSummary !== null ||
        value.profiles.some((profile) => profile.id !== expectedCoachId) ||
        value.shifts.some((shift) => shift.coachId !== expectedCoachId) ||
        value.queue.some((entry) => entry.coachId !== expectedCoachId) ||
        value.services.some((service) => service.coachId !== expectedCoachId)))
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教营业看板返回内容无法安全确认");
  }
  return value;
}

export async function getCoachConfiguration(): Promise<CoachConfigurationSnapshot> {
  const value = await request<unknown>("/v1/coaches/configuration", { cache: "no-store" });
  if (!isCoachConfigurationSnapshot(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教经营配置返回内容无法安全确认");
  }
  return value;
}

export interface CanonicalCoachOnboardingApiContext {
  operator: OperatorIdentity;
  configuration: CoachConfigurationSnapshot;
  replayExactCommand?: boolean;
}

function canonicalCoachOnboardingScopeMatches(
  expected: CanonicalCoachOnboardingApiContext["operator"],
): boolean {
  return (
    expected.role === "OWNER" &&
    operatorRequestScope.role === "OWNER" &&
    operatorRequestScope.tenantId === expected.tenantId &&
    operatorRequestScope.storeId === expected.storeId &&
    operatorRequestScope.actorId === expected.id
  );
}

function canonicalCoachOnboardingResultMatches(
  result: CanonicalCoachOnboardingResult,
  command: CreateCanonicalCoachOnboardingCommand,
  context: CanonicalCoachOnboardingApiContext,
): boolean {
  const issuedAt = Date.parse(result.invitation.issuedAt);
  const expiresAt = Date.parse(result.invitation.expiresAt);
  const completedAt = Date.parse(result.completedAt);
  const providerEvidenceMatches =
    (result.invitation.providerMode === "SIMULATED" &&
      result.invitation.evidence === "PROVIDER_SIMULATED") ||
    (result.invitation.providerMode === "EXTERNAL" &&
      result.invitation.evidence === "PROVIDER_ACCEPTED");
  return (
    result.idempotencyKey === command.idempotencyKey &&
    result.profile.id === command.profileId &&
    result.profile.coachNumber === command.coachNumber &&
    result.profile.name === command.name &&
    result.profile.displayName === command.displayName &&
    result.profile.controlledPhone === command.controlledPhone &&
    result.profile.avatarUrl === command.avatarUrl &&
    result.profile.levelId === command.levelId &&
    result.profile.status === "ENABLED" &&
    result.profile.version === 1 &&
    result.profile.evidence === context.configuration.evidence &&
    result.coachConfigurationVersion === command.expectedCoachConfigurationVersion + 1 &&
    result.invitation.purpose === "ACCOUNT_ACTIVATION" &&
    result.invitation.idempotencyKey ===
      canonicalCoachOnboardingInvitationIdempotencyKey(command.idempotencyKey) &&
    result.invitation.storeId === context.operator.storeId &&
    result.invitation.displayName === command.displayName &&
    result.invitation.roles.length === 1 &&
    result.invitation.roles[0] === "COACH" &&
    result.invitation.status === "PENDING_IDENTITY_CONFIRMATION" &&
    providerEvidenceMatches &&
    Number.isFinite(issuedAt) &&
    Number.isFinite(expiresAt) &&
    Number.isFinite(completedAt) &&
    expiresAt - issuedAt === 24 * 60 * 60 * 1_000 &&
    completedAt >= issuedAt &&
    completedAt < expiresAt
  );
}

const canonicalCoachOnboardingDefiniteNoWriteCodes = new Set([
  "REQUEST_VALIDATION_FAILED",
  "CANONICAL_WORKFORCE_WRITE_UNAVAILABLE_IN_DEMO",
  "AUTH_REQUIRED",
  "CANONICAL_COACH_ONBOARDING_OWNER_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_VERSION_MISMATCH",
  "COACH_CONFIGURATION_MISSING",
  "COACH_CONFIGURATION_STALE",
  "COACH_PROFILE_ALREADY_EXISTS",
  "COACH_NUMBER_ALREADY_EXISTS",
  "COACH_LEVEL_UNAVAILABLE",
  "COACH_ONBOARDING_NAME_REQUIRED",
  "COACH_CONTROLLED_PHONE_INVALID",
]);

function canonicalCoachOnboardingResultIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  if (canonicalCoachOnboardingDefiniteNoWriteCodes.has(error.code)) return false;
  return (
    error.code === "CANONICAL_COACH_ONBOARDING_PROFILE_INVALID" ||
    error.code.includes("PROJECTION_PENDING") ||
    error.code.includes("ACCOUNT_EXISTS") ||
    error.code.startsWith("WORKFORCE_MUTATION_") ||
    error.code.includes("RESULT_INVALID") ||
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    error.statusCode === 408 ||
    (error.statusCode !== undefined && error.statusCode >= 400)
  );
}

export async function createCanonicalCoachOnboarding(
  command: CreateCanonicalCoachOnboardingCommand,
  context: CanonicalCoachOnboardingApiContext,
): Promise<CanonicalCoachOnboardingResult> {
  if (context.operator.role !== "OWNER") {
    throw new ApiRequestError(
      "OWNER_AUTHORITY_REQUIRED",
      "只有当前可信老板账号可以新增助教并发送邀请",
      403,
    );
  }
  if (!canonicalCoachOnboardingScopeMatches(context.operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或老板身份已经切换，原助教入职请求没有提交",
    );
  }
  const enabledLevel = context.configuration.levels.find(
    (level) => level.id === command.levelId && level.enabled,
  );
  if (
    !isCreateCanonicalCoachOnboardingCommand(command) ||
    !isCoachConfigurationSnapshot(context.configuration) ||
    (context.replayExactCommand
      ? context.configuration.version < command.expectedCoachConfigurationVersion
      : command.expectedCoachConfigurationVersion !== context.configuration.version) ||
    (!context.replayExactCommand && !enabledLevel) ||
    command.coachNumber !== command.coachNumber.trim() ||
    command.name !== command.name.trim() ||
    command.displayName !== command.displayName.trim() ||
    command.controlledPhone !== command.controlledPhone.trim() ||
    command.reason !== command.reason.trim() ||
    (command.avatarUrl !== null && command.avatarUrl !== command.avatarUrl.trim())
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "助教资料、启用级别或配置版本不完整，请刷新后检查原内容",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>("/v1/workforce/coaches", {
      method: "POST",
      body: JSON.stringify(command),
    });
  } catch (error) {
    if (!canonicalCoachOnboardingScopeMatches(context.operator)) {
      throw new ApiRequestError(
        "OPERATOR_IDENTITY_CHANGED",
        "账号、门店或老板身份已经切换，原助教入职结果不会显示在当前账号",
      );
    }
    if (!canonicalCoachOnboardingResultIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "CANONICAL_COACH_ONBOARDING_RESULT_UNKNOWN",
      "助教入职可能已经完成，但页面尚未取得可信结果；请保留原资料并重试同一操作",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
  if (!canonicalCoachOnboardingScopeMatches(context.operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或老板身份已经切换，原助教入职结果不会显示在当前账号",
    );
  }
  if (
    !isCanonicalCoachOnboardingResult(value) ||
    !canonicalCoachOnboardingResultMatches(value, command, context)
  ) {
    throw new ApiRequestError(
      "CANONICAL_COACH_ONBOARDING_RESULT_UNKNOWN",
      "助教入职回执与原资料、级别、门店或邀请不一致；页面已锁定原操作",
    );
  }
  return value;
}

function canonicalCoachLifecycleScopeMatches(expected: OperatorIdentity): boolean {
  return (
    (expected.role === "OWNER" || expected.role === "MANAGER") &&
    operatorRequestScope.role === expected.role &&
    operatorRequestScope.tenantId === expected.tenantId &&
    operatorRequestScope.storeId === expected.storeId &&
    operatorRequestScope.actorId === expected.id
  );
}

function assertCanonicalCoachLifecycleOperator(
  operator: OperatorIdentity,
  profileId: string,
): void {
  if (operator.role !== "OWNER" && operator.role !== "MANAGER") {
    throw new ApiRequestError(
      "CANONICAL_COACH_LIFECYCLE_ROLE_REQUIRED",
      "只有老板或本店店长可以办理助教停用和重新启用",
      403,
    );
  }
  if (!canonicalCoachLifecycleScopeMatches(operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或管理身份已经切换，本次助教启停没有提交",
    );
  }
  if (operator.role === "MANAGER" && operator.coachProfileId === profileId) {
    throw new ApiRequestError(
      "CANONICAL_COACH_LIFECYCLE_SELF_ACTION_FORBIDDEN",
      "店长不能为自己办理停用或重新启用，请由老板或其他有权限的本店店长办理",
      403,
    );
  }
}

function canonicalCoachLifecycleMessage(code: string, phase: "PREVIEW" | "APPLY"): string {
  switch (code) {
    case "AUTH_REQUIRED":
      return "登录状态已经失效，请重新登录后再办理助教启停";
    case "CANONICAL_COACH_LIFECYCLE_ROLE_REQUIRED":
    case "AUTHORIZATION_DEFAULT_DENY":
      return "当前账号没有办理这名助教启停的权限";
    case "CANONICAL_COACH_LIFECYCLE_SELF_ACTION_FORBIDDEN":
      return "店长不能为自己办理停用或重新启用，请换用符合权限的账号";
    case "COACH_PROFILE_NOT_FOUND":
      return "没有找到这名助教，请刷新人员列表后重新选择";
    case "COACH_CONFIGURATION_MISSING":
      return "门店助教资料尚未准备完成，请稍后刷新再试";
    case "CANONICAL_COACH_LIFECYCLE_PREVIEW_STALE":
    case "CANONICAL_COACH_LIFECYCLE_PREVIEW_INVALID":
    case "CANONICAL_COACH_LIFECYCLE_PREVIEW_CHANGED":
    case "COACH_CONFIGURATION_STALE":
    case "COACH_PROFILE_VERSION_STALE":
    case "WORKFORCE_PROJECTION_STALE":
      return "助教状态已经变化，请重新检查当前情况后再确认";
    case "CANONICAL_COACH_LIFECYCLE_FACTS_UNAVAILABLE":
    case "WORKFORCE_BINDING_CONFLICT":
      return "助教档案与人员任职暂时无法安全核对，请刷新后再试";
    case "CANONICAL_COACH_LIFECYCLE_ACTOR_IDENTITY_UNAVAILABLE":
      return "当前店长账号无法确认本人身份，为防止办理本人启停，本次没有提交";
    case "COACH_PROFILE_TIME_NOT_MONOTONIC":
      return "当前设备时间早于助教档案最后更新时间，请校准时间后再操作";
    case "CANONICAL_COACH_LIFECYCLE_BLOCKED":
      return "当前仍有未处理事项，暂时不能办理；请刷新页面查看具体原因";
    case "CANONICAL_COACH_LIFECYCLE_CLOUD_REJECTED":
      return "云端已明确拒绝本次办理且没有写入；请重新检查当前状态后发起新操作";
    case "CANONICAL_WORKFORCE_WRITE_UNAVAILABLE_IN_DEMO":
      return "当前演示环境不能办理真实助教启停";
    case "NATIVE_UPDATE_REQUIRED":
      return "当前 App 版本不能安全提交，请先升级；仍可查看助教状态";
    case "NATIVE_SECURE_SESSION_UNAVAILABLE":
      return "手机安全登录状态无法确认，请完全关闭并重新打开 App";
    case "REQUEST_VALIDATION_FAILED":
      return phase === "PREVIEW"
        ? "助教或操作类型不完整，请刷新后重新选择"
        : "确认信息不完整，请重新检查当前情况后再提交";
    default:
      return phase === "PREVIEW"
        ? "暂时无法确认这名助教能否办理，请稍后刷新重试"
        : "暂时无法确认本次办理结果，请保留当前页面并重试同一操作";
  }
}

function canonicalCoachLifecycleSanitizedError(
  error: unknown,
  phase: "PREVIEW" | "APPLY",
): ApiRequestError {
  const code = error instanceof ApiRequestError ? error.code : "GATEWAY_UNREACHABLE";
  return new ApiRequestError(
    code,
    canonicalCoachLifecycleMessage(code, phase),
    error instanceof ApiRequestError ? error.statusCode : undefined,
  );
}

export async function getCanonicalCoachLifecyclePreview(
  profileId: string,
  action: CanonicalCoachLifecycleAction,
  operator: OperatorIdentity,
): Promise<CanonicalCoachLifecyclePreview> {
  if (
    profileId.length === 0 ||
    profileId.length > 512 ||
    profileId !== profileId.trim() ||
    (action !== "DISABLE" && action !== "REENABLE")
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "助教或操作类型不完整，请刷新后重新选择",
      400,
    );
  }
  assertCanonicalCoachLifecycleOperator(operator, profileId);
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/workforce/coaches/${encodeURIComponent(profileId)}/lifecycle-preview?action=${encodeURIComponent(action)}`,
      { cache: "no-store" },
    );
  } catch (error) {
    if (!canonicalCoachLifecycleScopeMatches(operator)) {
      throw new ApiRequestError(
        "OPERATOR_IDENTITY_CHANGED",
        "账号、门店或管理身份已经切换，原助教启停检查不会显示在当前账号",
      );
    }
    throw canonicalCoachLifecycleSanitizedError(error, "PREVIEW");
  }
  if (!canonicalCoachLifecycleScopeMatches(operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或管理身份已经切换，原助教启停检查不会显示在当前账号",
    );
  }
  if (
    !isCanonicalCoachLifecyclePreview(value) ||
    value.profileId !== profileId ||
    value.action !== action ||
    value.storeId !== operator.storeId
  ) {
    throw new ApiRequestError(
      "CANONICAL_COACH_LIFECYCLE_PREVIEW_INVALID",
      "助教启停检查结果与当前门店、助教或操作不一致，请刷新后重试",
    );
  }
  return value;
}

const canonicalCoachLifecycleDefiniteNoWriteCodes = new Set([
  "REQUEST_VALIDATION_FAILED",
  "CANONICAL_WORKFORCE_WRITE_UNAVAILABLE_IN_DEMO",
  "AUTH_REQUIRED",
  "CANONICAL_COACH_LIFECYCLE_ROLE_REQUIRED",
  "CANONICAL_COACH_LIFECYCLE_SELF_ACTION_FORBIDDEN",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_VERSION_MISMATCH",
  "COACH_CONFIGURATION_MISSING",
  "COACH_PROFILE_NOT_FOUND",
  "COACH_CONFIGURATION_STALE",
  "COACH_PROFILE_VERSION_STALE",
  "COACH_PROFILE_TIME_NOT_MONOTONIC",
  "WORKFORCE_PROJECTION_STALE",
  "WORKFORCE_BINDING_CONFLICT",
  "CANONICAL_COACH_LIFECYCLE_FACTS_UNAVAILABLE",
  "CANONICAL_COACH_LIFECYCLE_ACTOR_IDENTITY_UNAVAILABLE",
  "CANONICAL_COACH_LIFECYCLE_PREVIEW_STALE",
  "CANONICAL_COACH_LIFECYCLE_PREVIEW_INVALID",
  "CANONICAL_COACH_LIFECYCLE_PREVIEW_CHANGED",
  "CANONICAL_COACH_LIFECYCLE_BLOCKED",
  "CANONICAL_COACH_LIFECYCLE_CLOUD_REJECTED",
]);

export async function applyCanonicalCoachLifecycle(
  command: ApplyCanonicalCoachLifecycleCommand,
  operator: OperatorIdentity,
): Promise<CanonicalCoachLifecycleResult> {
  if (!isApplyCanonicalCoachLifecycleCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "确认信息不完整，请重新检查当前情况后再提交",
      400,
    );
  }
  assertCanonicalCoachLifecycleOperator(operator, command.profileId);
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/workforce/coaches/${encodeURIComponent(command.profileId)}/lifecycle`,
      { method: "POST", body: JSON.stringify(command) },
    );
  } catch (error) {
    if (!canonicalCoachLifecycleScopeMatches(operator)) {
      throw new ApiRequestError(
        "OPERATOR_IDENTITY_CHANGED",
        "账号、门店或管理身份已经切换，原助教启停结果不会显示在当前账号",
      );
    }
    if (
      error instanceof ApiRequestError &&
      canonicalCoachLifecycleDefiniteNoWriteCodes.has(error.code)
    ) {
      throw canonicalCoachLifecycleSanitizedError(error, "APPLY");
    }
    throw new ApiRequestError(
      "CANONICAL_COACH_LIFECYCLE_RESULT_UNKNOWN",
      "本次助教启停可能已经生效，但页面尚未取得可信结果；请保留原确认内容并重试同一操作",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
  if (!canonicalCoachLifecycleScopeMatches(operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或管理身份已经切换，原助教启停结果不会显示在当前账号",
    );
  }
  if (
    !isCanonicalCoachLifecycleResult(value) ||
    !canonicalCoachLifecycleResultMatchesCommand(value, command)
  ) {
    throw new ApiRequestError(
      "CANONICAL_COACH_LIFECYCLE_RESULT_UNKNOWN",
      "助教启停回执与原确认内容或版本不一致；页面已保留原操作，请重试同一操作",
    );
  }
  return value;
}

export interface CanonicalCoachProfileMaintenanceApiContext {
  operator: OperatorIdentity;
  configuration: CoachConfigurationSnapshot;
  baselineProfile: CoachProfile | CanonicalCoachProfileMaintenanceBaselineInvariant;
  replayExactCommand?: boolean;
}

function canonicalCoachProfileMaintenanceScopeMatches(
  expected: CanonicalCoachProfileMaintenanceApiContext["operator"],
): boolean {
  return (
    (expected.role === "OWNER" || expected.role === "MANAGER") &&
    operatorRequestScope.role === expected.role &&
    operatorRequestScope.tenantId === expected.tenantId &&
    operatorRequestScope.storeId === expected.storeId &&
    operatorRequestScope.actorId === expected.id
  );
}

function coachProfilesExactlyMatch(left: CoachProfile, right: CoachProfile): boolean {
  return (
    left.id === right.id &&
    left.coachNumber === right.coachNumber &&
    left.name === right.name &&
    left.displayName === right.displayName &&
    left.controlledPhone === right.controlledPhone &&
    left.avatarUrl === right.avatarUrl &&
    left.levelId === right.levelId &&
    left.status === right.status &&
    left.version === right.version &&
    left.evidence === right.evidence &&
    left.createdAt === right.createdAt &&
    left.updatedAt === right.updatedAt
  );
}

function canonicalCoachProfileMaintenanceHasFullBaseline(
  baseline: CoachProfile | CanonicalCoachProfileMaintenanceBaselineInvariant,
): baseline is CoachProfile {
  return "id" in baseline && typeof baseline.id === "string";
}

function canonicalCoachProfileMaintenanceBaselineInvariant(
  baseline: CoachProfile | CanonicalCoachProfileMaintenanceBaselineInvariant,
): CanonicalCoachProfileMaintenanceBaselineInvariant {
  return canonicalCoachProfileMaintenanceHasFullBaseline(baseline)
    ? {
        profileId: baseline.id,
        coachNumber: baseline.coachNumber,
        status: baseline.status,
        createdAt: baseline.createdAt,
        evidence: baseline.evidence,
        expectedProfileVersion: baseline.version,
        updatedAt: baseline.updatedAt,
      }
    : baseline;
}

function canonicalCoachProfileMaintenanceResultMatchesBaseline(
  result: CanonicalCoachProfileMaintenanceResult,
  baseline: CoachProfile | CanonicalCoachProfileMaintenanceBaselineInvariant,
): boolean {
  const fullBaseline = canonicalCoachProfileMaintenanceHasFullBaseline(baseline) ? baseline : null;
  const baselineInvariant = canonicalCoachProfileMaintenanceBaselineInvariant(baseline);
  const baselineCreatedAt = Date.parse(baselineInvariant.createdAt);
  const baselineUpdatedAt = Date.parse(baselineInvariant.updatedAt);
  const resultUpdatedAt = Date.parse(result.profile.updatedAt);
  const completedAt = Date.parse(result.completedAt);
  return (
    result.profile.id === baselineInvariant.profileId &&
    result.profile.version === baselineInvariant.expectedProfileVersion + 1 &&
    (fullBaseline === null || result.profile.name === fullBaseline.name) &&
    (fullBaseline === null || result.profile.controlledPhone === fullBaseline.controlledPhone) &&
    result.profile.coachNumber === baselineInvariant.coachNumber &&
    result.profile.status === baselineInvariant.status &&
    result.profile.createdAt === baselineInvariant.createdAt &&
    result.profile.evidence === baselineInvariant.evidence &&
    Number.isFinite(baselineCreatedAt) &&
    Number.isFinite(baselineUpdatedAt) &&
    Number.isFinite(resultUpdatedAt) &&
    Number.isFinite(completedAt) &&
    resultUpdatedAt >= baselineUpdatedAt &&
    completedAt >= resultUpdatedAt
  );
}

const canonicalCoachProfileMaintenanceDefiniteNoWriteCodes = new Set([
  "REQUEST_VALIDATION_FAILED",
  "CANONICAL_WORKFORCE_WRITE_UNAVAILABLE_IN_DEMO",
  "AUTH_REQUIRED",
  "CANONICAL_COACH_PROFILE_MAINTENANCE_ROLE_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_VERSION_MISMATCH",
  "COACH_CONFIGURATION_MISSING",
  "COACH_CONFIGURATION_STALE",
  "COACH_PROFILE_NOT_FOUND",
  "COACH_PROFILE_VERSION_STALE",
  "COACH_LEVEL_UNAVAILABLE",
  "CANONICAL_COACH_PROFILE_MAINTENANCE_NO_CHANGE",
  "CANONICAL_COACH_PROFILE_MAINTENANCE_REASON_SENSITIVE",
  "COACH_PROFILE_TIME_NOT_MONOTONIC",
]);

function canonicalCoachProfileMaintenanceResultIsUnknown(error: unknown): boolean {
  return !(
    error instanceof ApiRequestError &&
    canonicalCoachProfileMaintenanceDefiniteNoWriteCodes.has(error.code)
  );
}

export async function updateCanonicalCoachProfile(
  command: UpdateCanonicalCoachProfileCommand,
  context: CanonicalCoachProfileMaintenanceApiContext,
): Promise<CanonicalCoachProfileMaintenanceResult> {
  if (context.operator.role !== "OWNER" && context.operator.role !== "MANAGER") {
    throw new ApiRequestError(
      "CANONICAL_COACH_PROFILE_MAINTENANCE_ROLE_REQUIRED",
      "只有当前可信老板或店长可以维护助教对客资料",
      403,
    );
  }
  if (!canonicalCoachProfileMaintenanceScopeMatches(context.operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或管理身份已经切换，原助教资料请求没有提交",
    );
  }
  const fullBaseline = canonicalCoachProfileMaintenanceHasFullBaseline(context.baselineProfile)
    ? context.baselineProfile
    : null;
  const baselineInvariant = canonicalCoachProfileMaintenanceBaselineInvariant(
    context.baselineProfile,
  );
  const baselineProfileId = baselineInvariant.profileId;
  const baselineProfileVersion = baselineInvariant.expectedProfileVersion;
  const configuredProfiles = context.configuration.profiles.filter(
    (profile) => profile.id === baselineProfileId,
  );
  const selectedLevel = context.configuration.levels.find(
    (level) => level.id === command.levelId && level.enabled,
  );
  const baselineIsUsable =
    baselineProfileId === command.profileId &&
    baselineProfileVersion === command.expectedProfileVersion &&
    Number.isSafeInteger(baselineProfileVersion) &&
    Number.isFinite(Date.parse(context.baselineProfile.createdAt)) &&
    Number.isFinite(Date.parse(context.baselineProfile.updatedAt));
  if (
    !isUpdateCanonicalCoachProfileCommand(command) ||
    !isCoachConfigurationSnapshot(context.configuration) ||
    !baselineIsUsable ||
    (context.replayExactCommand
      ? context.configuration.version < command.expectedCoachConfigurationVersion
      : command.expectedCoachConfigurationVersion !== context.configuration.version) ||
    (!context.replayExactCommand &&
      (fullBaseline === null ||
        configuredProfiles.length !== 1 ||
        !coachProfilesExactlyMatch(configuredProfiles[0] as CoachProfile, fullBaseline))) ||
    (!context.replayExactCommand && !selectedLevel)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "助教资料、启用级别或版本基线不完整，请刷新后检查原内容",
      400,
    );
  }

  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/workforce/coaches/${encodeURIComponent(command.profileId)}/profile-maintenance`,
      { method: "POST", body: JSON.stringify(command) },
    );
  } catch (error) {
    if (!canonicalCoachProfileMaintenanceScopeMatches(context.operator)) {
      throw new ApiRequestError(
        "OPERATOR_IDENTITY_CHANGED",
        "账号、门店或管理身份已经切换，原助教资料结果不会显示在当前账号",
      );
    }
    if (!canonicalCoachProfileMaintenanceResultIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "CANONICAL_COACH_PROFILE_MAINTENANCE_RESULT_UNKNOWN",
      "助教资料可能已经保存，但页面尚未取得可信结果；请保留原内容并重试同一操作",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
  if (!canonicalCoachProfileMaintenanceScopeMatches(context.operator)) {
    throw new ApiRequestError(
      "OPERATOR_IDENTITY_CHANGED",
      "账号、门店或管理身份已经切换，原助教资料结果不会显示在当前账号",
    );
  }
  if (
    !isCanonicalCoachProfileMaintenanceResult(value) ||
    !canonicalCoachProfileMaintenanceResultMatchesCommand(value, command) ||
    !canonicalCoachProfileMaintenanceResultMatchesBaseline(value, context.baselineProfile)
  ) {
    throw new ApiRequestError(
      "CANONICAL_COACH_PROFILE_MAINTENANCE_RESULT_UNKNOWN",
      "助教资料回执与原档案、修改内容或版本不一致；页面已锁定原操作",
    );
  }
  return value;
}

export async function listCoachProfilesSensitive(): Promise<CoachProfile[]> {
  const value = await request<unknown>("/v1/coaches/profiles/sensitive", { cache: "no-store" });
  if (!isCoachProfileList(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教受控资料返回内容无法安全确认");
  }
  return value;
}

export async function listCoachServiceRules(): Promise<CoachAssignableServiceOption[]> {
  const value = await request<unknown>("/v1/coaches/service-rules", { cache: "no-store" });
  if (!isCoachAssignableServiceOptionList(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "可分配的助教服务项目返回内容无法安全确认",
    );
  }
  return value;
}

async function coachOperationResult<T>(
  label: string,
  operation: () => Promise<T>,
  outcomeIsUnknown: (error: unknown) => boolean = coachOperationOutcomeIsUnknown,
): Promise<T> {
  try {
    return await operation();
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (outcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "COACH_OPERATION_RESULT_UNKNOWN",
        `${label}可能已经执行，但页面还没有确认结果。请保留当前操作并使用同一次请求安全重试`,
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export function checkInCoach(
  coachId: string,
  idempotencyKey: string,
): Promise<CoachRuntimeShiftReadModel>;
export function checkInCoach(
  coachId: string,
  reason: string | null | undefined,
  idempotencyKey: string,
): Promise<CoachRuntimeShiftReadModel>;
export async function checkInCoach(
  coachId: string,
  reasonOrIdempotencyKey: string | null | undefined,
  maybeIdempotencyKey?: string,
): Promise<CoachRuntimeShiftReadModel> {
  const reason = maybeIdempotencyKey === undefined ? undefined : reasonOrIdempotencyKey;
  const idempotencyKey = maybeIdempotencyKey ?? String(reasonOrIdempotencyKey ?? "");
  return coachOperationResult("签到", async () => {
    if (
      reason !== undefined &&
      reason !== null &&
      (reason !== reason.trim() || [...reason].length < 2 || [...reason].length > 500)
    ) {
      throw new ApiRequestError(
        "REQUEST_VALIDATION_FAILED",
        "签到代办原因必须填写 2 至 500 个字，系统没有提交签到",
        400,
      );
    }
    const value = await request<unknown>("/v1/coaches/check-in", {
      method: "POST",
      body: JSON.stringify({ coachId, reason, idempotencyKey }),
    });
    if (
      !isCoachRuntimeShiftReadModel(value) ||
      value.coachId !== coachId ||
      value.status !== "AVAILABLE" ||
      value.checkedInAt === null
    ) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教签到结果无法安全确认");
    }
    return value;
  });
}

export async function checkOutCoach(
  coachId: string,
  reason: string | null,
  idempotencyKey: string,
): Promise<CoachRuntimeShiftReadModel> {
  return coachOperationResult("签退", async () => {
    const value = await request<unknown>("/v1/coaches/check-out", {
      method: "POST",
      body: JSON.stringify({ coachId, reason, idempotencyKey }),
    });
    if (
      !isCoachRuntimeShiftReadModel(value) ||
      value.coachId !== coachId ||
      value.status !== "CHECKED_OUT" ||
      value.checkedInAt === null
    ) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教签退结果无法安全确认");
    }
    return value;
  });
}

export async function changeCoachQueue(
  input: CoachQueueActionRequest,
): Promise<CoachRuntimeQueueReadModel> {
  return coachOperationResult("排钟", async () => {
    const value = await request<unknown>("/v1/coaches/queue/actions", {
      method: "POST",
      body: JSON.stringify(input),
    });
    const expectedStatus =
      input.action === "PAUSE"
        ? "PAUSED"
        : input.action === "JOIN" || input.action === "RESUME"
          ? "QUEUED"
          : null;
    if (
      !isCoachRuntimeQueueReadModel(value) ||
      value.coachId !== input.coachId ||
      (expectedStatus !== null && value.status !== expectedStatus) ||
      (input.action === "MOVE" && value.position !== input.targetPosition)
    ) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教排钟结果无法安全确认");
    }
    return value;
  });
}

export interface CoachServiceAssignmentContext {
  tenantId: string;
  storeId: string;
  actorId: string;
}

export interface CoachServiceAssignmentExpected {
  coachId: string;
  coachDisplayName: string;
  tableNumber: string;
  serviceTypeName: string;
  priceFen: number;
}

export interface CoachServiceAssignmentCommand {
  context: CoachServiceAssignmentContext;
  request: AssignCoachServiceRequest;
  expected: CoachServiceAssignmentExpected;
}

export interface LegacyCoachServiceAssignmentCommand {
  context: CoachServiceAssignmentContext;
  request: Omit<AssignCoachServiceRequest, "previewToken">;
  expected: CoachServiceAssignmentExpected;
}

export type CoachServiceAssignmentRecoveryCommand =
  | CoachServiceAssignmentCommand
  | LegacyCoachServiceAssignmentCommand;

function coachServiceAssignmentPreviewRequestIsValid(
  value: unknown,
): value is CoachServiceAssignmentPreviewRequest {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const request = value as Record<string, unknown>;
  const actualKeys = Object.keys(request).sort();
  const expectedKeys = [
    "assignmentType",
    "coachId",
    "expectedCoachId",
    "expectedPriceFen",
    "pricingToken",
    "serviceRuleId",
    "sessionId",
  ].sort();
  return (
    actualKeys.length === expectedKeys.length &&
    actualKeys.every((key, index) => key === expectedKeys[index]) &&
    typeof request.sessionId === "string" &&
    request.sessionId.length > 0 &&
    request.sessionId.length <= 128 &&
    typeof request.expectedCoachId === "string" &&
    request.expectedCoachId.length > 0 &&
    request.expectedCoachId.length <= 64 &&
    ((request.assignmentType === "ROTATION" && request.coachId === null) ||
      (request.assignmentType === "REQUESTED" && request.coachId === request.expectedCoachId)) &&
    typeof request.serviceRuleId === "string" &&
    request.serviceRuleId.length > 0 &&
    request.serviceRuleId.length <= 64 &&
    typeof request.expectedPriceFen === "number" &&
    Number.isSafeInteger(request.expectedPriceFen) &&
    request.expectedPriceFen >= 0 &&
    request.expectedPriceFen <= 100_000_000 &&
    typeof request.pricingToken === "string" &&
    /^[a-f0-9]{64}$/.test(request.pricingToken)
  );
}

function parseCoachServiceAssignmentPreview(
  value: unknown,
  submitted: CoachServiceAssignmentPreviewRequest,
): CoachServiceAssignmentPreview {
  if (
    !isCoachServiceAssignmentPreview(value) ||
    value.sessionId !== submitted.sessionId ||
    value.coachId !== submitted.expectedCoachId ||
    value.assignmentType !== submitted.assignmentType ||
    value.serviceRuleId !== submitted.serviceRuleId ||
    value.priceFen !== submitted.expectedPriceFen ||
    value.pricingToken !== submitted.pricingToken
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "助教分配预览无法与当前球桌、助教、服务项目、价格和余额逐项对应，页面没有进入确认步骤",
    );
  }
  return value;
}

export async function previewCoachServiceAssignment(
  submitted: CoachServiceAssignmentPreviewRequest,
): Promise<CoachServiceAssignmentPreview> {
  if (!coachServiceAssignmentPreviewRequestIsValid(submitted)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "所选球桌、助教、服务项目或价格不完整，系统没有请求分配预览",
      400,
    );
  }
  const value = await request<unknown>("/v1/coaches/services/assignment-preview", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(submitted),
  });
  return parseCoachServiceAssignmentPreview(value, submitted);
}

function coachServiceAssignmentRecoveryCommandCoreIsValid(
  command: CoachServiceAssignmentRecoveryCommand,
): boolean {
  const { context, expected, request: assignment } = command;
  return (
    typeof context.tenantId === "string" &&
    context.tenantId.length > 0 &&
    typeof context.storeId === "string" &&
    context.storeId.length > 0 &&
    typeof context.actorId === "string" &&
    context.actorId.length > 0 &&
    typeof assignment.sessionId === "string" &&
    assignment.sessionId.length > 0 &&
    ["ROTATION", "REQUESTED"].includes(assignment.assignmentType) &&
    assignment.expectedCoachId === expected.coachId &&
    ((assignment.assignmentType === "ROTATION" && assignment.coachId === null) ||
      (assignment.assignmentType === "REQUESTED" && assignment.coachId === expected.coachId)) &&
    typeof assignment.serviceRuleId === "string" &&
    assignment.serviceRuleId.length > 0 &&
    assignment.expectedPriceFen === expected.priceFen &&
    /^[a-f0-9]{64}$/.test(assignment.pricingToken) &&
    (assignment.reason === undefined ||
      assignment.reason === null ||
      (typeof assignment.reason === "string" &&
        assignment.reason === assignment.reason.trim() &&
        [...assignment.reason].length >= 2 &&
        [...assignment.reason].length <= 500)) &&
    (assignment.customerRequestEventId === undefined ||
      (typeof assignment.customerRequestEventId === "string" &&
        assignment.customerRequestEventId.length >= 8 &&
        assignment.customerRequestEventId.length <= 128)) &&
    typeof assignment.idempotencyKey === "string" &&
    assignment.idempotencyKey.length >= 8 &&
    assignment.idempotencyKey.length <= 128 &&
    typeof expected.coachId === "string" &&
    expected.coachId.length > 0 &&
    typeof expected.coachDisplayName === "string" &&
    expected.coachDisplayName.length > 0 &&
    typeof expected.tableNumber === "string" &&
    expected.tableNumber.length > 0 &&
    typeof expected.serviceTypeName === "string" &&
    expected.serviceTypeName.length > 0 &&
    Number.isSafeInteger(expected.priceFen) &&
    expected.priceFen >= 0
  );
}

function coachServiceAssignmentCommandIsValid(command: CoachServiceAssignmentCommand): boolean {
  return (
    coachServiceAssignmentRecoveryCommandCoreIsValid(command) &&
    typeof command.request.previewToken === "string" &&
    /^[a-f0-9]{64}$/.test(command.request.previewToken)
  );
}

function legacyCoachServiceAssignmentCommandIsValid(
  command: CoachServiceAssignmentRecoveryCommand,
): command is LegacyCoachServiceAssignmentCommand {
  return (
    coachServiceAssignmentRecoveryCommandCoreIsValid(command) &&
    !Object.hasOwn(command.request, "previewToken")
  );
}

function parseCoachServiceAssignmentResult(
  value: unknown,
  command: CoachServiceAssignmentRecoveryCommand,
): CoachServiceAssignmentOperatorResult {
  if (
    !(
      coachServiceAssignmentCommandIsValid(command as CoachServiceAssignmentCommand) ||
      legacyCoachServiceAssignmentCommandIsValid(command)
    ) ||
    !isCoachServiceAssignmentOperatorResult(value) ||
    value.coachId !== command.expected.coachId ||
    value.tableNumber !== command.expected.tableNumber ||
    value.assignmentType !== command.request.assignmentType ||
    value.serviceTypeName !== command.expected.serviceTypeName ||
    value.priceFen !== command.request.expectedPriceFen ||
    value.pricingToken !== command.request.pricingToken
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "助教分配结果无法与提交前显示的球桌、助教、项目和即时上钟状态逐项对应，页面继续锁定",
    );
  }
  return value;
}

export interface LegacyCoachServiceAssignmentRecoveryResult {
  resolution: "ACTIVE" | "LEGACY_ASSIGNED" | "NOT_FOUND_REQUIRES_NEW_REQUEST";
  result: CoachServiceAssignmentOperatorResult | null;
}

export interface LegacyCoachServiceAssignmentRequest {
  sessionId: string;
  coachId: string | null;
  assignmentType: "ROTATION" | "REQUESTED";
  serviceRuleId: string;
  idempotencyKey: string;
}

function parseLegacyCoachServiceAssignmentResult(
  value: unknown,
  assignment: LegacyCoachServiceAssignmentRequest,
): CoachServiceAssignmentOperatorResult {
  if (
    !isCoachServiceAssignmentOperatorResult(value) ||
    value.assignmentType !== assignment.assignmentType ||
    (assignment.assignmentType === "REQUESTED" && value.coachId !== assignment.coachId)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "旧版本助教分配结果无法与原请求对应，页面继续锁定",
    );
  }
  return value;
}

export async function recoverLegacyCoachServiceAssignment(
  assignment: LegacyCoachServiceAssignmentRequest,
): Promise<LegacyCoachServiceAssignmentRecoveryResult> {
  const path = `/v1/coaches/sessions/${encodeURIComponent(assignment.sessionId)}/assignments/by-request/${encodeURIComponent(assignment.idempotencyKey)}`;
  try {
    const found = await request<unknown>(path, { cache: "no-store" });
    return {
      resolution: "ACTIVE",
      result: parseLegacyCoachServiceAssignmentResult(found, assignment),
    };
  } catch (error) {
    if (coachServiceAssignmentLegacyResultRequiresStart(error)) {
      return { resolution: "LEGACY_ASSIGNED", result: null };
    }
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "COACH_SERVICE_ASSIGNMENT_RESULT_NOT_FOUND"
    ) {
      return { resolution: "NOT_FOUND_REQUIRES_NEW_REQUEST", result: null };
    }
    throw error;
  }
}

export async function assignCoachService(
  command: CoachServiceAssignmentCommand,
): Promise<CoachServiceAssignmentOperatorResult> {
  if (!coachServiceAssignmentCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "所选球桌、助教、服务项目或价格不完整，系统没有发出分配请求",
      400,
    );
  }
  const value = await request<unknown>("/v1/coaches/services/assign", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command.request),
  });
  return parseCoachServiceAssignmentResult(value, command);
}

export async function getCoachServiceAssignmentByRequest(
  command: CoachServiceAssignmentRecoveryCommand,
): Promise<CoachServiceAssignmentOperatorResult | null> {
  if (
    !(
      coachServiceAssignmentCommandIsValid(command as CoachServiceAssignmentCommand) ||
      legacyCoachServiceAssignmentCommandIsValid(command)
    )
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本机保存的助教分配原请求不完整，系统没有查询或重试",
      400,
    );
  }
  try {
    const query = new URLSearchParams();
    if (command.request.customerRequestEventId !== undefined) {
      query.set("customerRequestEventId", command.request.customerRequestEventId);
    }
    if (command.request.reason !== undefined && command.request.reason !== null) {
      query.set("reason", command.request.reason);
    }
    const suffix = query.size > 0 ? `?${query.toString()}` : "";
    const value = await request<unknown>(
      `/v1/coaches/sessions/${encodeURIComponent(command.request.sessionId)}/assignments/by-request/${encodeURIComponent(command.request.idempotencyKey)}${suffix}`,
      { cache: "no-store" },
    );
    return parseCoachServiceAssignmentResult(value, command);
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "COACH_SERVICE_ASSIGNMENT_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export function coachServiceAssignmentOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  return (
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    error.code === "OPERATOR_IDENTITY_CHANGED" ||
    error.statusCode === 408 ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

export function coachServiceAssignmentLegacyResultRequiresStart(error: unknown): boolean {
  return (
    error instanceof ApiRequestError &&
    error.statusCode === 409 &&
    error.code === "COACH_SERVICE_ASSIGNMENT_LEGACY_RESULT_REQUIRES_START"
  );
}

export function coachServiceAssignmentFailureMessage(error: unknown): string {
  if (!(error instanceof ApiRequestError)) {
    return "门店连接中断，分配结果尚未确认；系统会先查询原请求，请勿再次分配。";
  }
  const messages: Record<string, string> = {
    COACH_SERVICE_ASSIGNMENT_REQUEST_INVALID:
      "分配内容不完整，系统没有执行；请重新选择球桌、助教和服务项目。",
    COACH_SERVICE_COACH_UNAVAILABLE: "所选助教已经接单、暂停或签退，请重新选择仍可接单的助教。",
    COACH_SERVICE_SESSION_NOT_ACTIVE: "所选球桌已经停表或关台，请重新选择仍在营业的球桌。",
    COACH_SERVICE_RULE_UNAVAILABLE: "所选服务项目或价格已经停用，请重新读取后选择当前项目。",
    COACH_SERVICE_PRICE_CHANGED:
      "这名助教的实际价格刚刚发生变化，系统没有执行分配。请刷新页面，重新核对助教、项目和价格后再确认。",
    COACH_ROTATION_SELECTION_CHANGED:
      "轮钟顺序刚刚发生变化，系统没有执行分配。请刷新页面，重新核对当前轮到的助教后再确认。",
    COACH_REQUESTED_SELECTION_MISMATCH:
      "点钟助教与刚才确认的助教不一致，系统没有执行分配。请刷新页面，重新选择助教后再确认。",
    COACH_SERVICE_ASSIGNMENT_LEGACY_RESULT_REQUIRES_START:
      "该历史任务已分配，请在当前任务确认上钟。",
    REQUEST_KEY_OWNED_BY_OTHER_ACTOR:
      "这个原请求属于另一名员工，当前账号不能接管；请切回原账号核对。",
    IDEMPOTENCY_COLLISION: "原请求号对应的内容不一致，系统没有执行；请重新读取当前状态。",
    AUTH_REQUIRED: "登录状态已失效，系统没有执行；请重新登录后再操作。",
    AUTHORIZATION_DEFAULT_DENY: "当前账号没有分配助教权限，系统没有执行。",
    CONDITIONAL_MODULE_DISABLED: "门店尚未启用助教模块，系统没有执行分配。",
    SHIFT_SESSION_NOT_STARTED: "当前班次尚未开始，系统没有执行分配。",
  };
  return messages[error.code] ?? error.message;
}

export async function listCoachServiceStopRequests(): Promise<CoachServiceStopRequestList> {
  const value = await request<unknown>("/v1/coaches/service-stop-requests", {
    cache: "no-store",
  });
  if (!isCoachServiceStopRequestList(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教下钟申请列表无法安全确认");
  }
  return value;
}

export interface CoachServiceStopRequestExpected {
  coachId: string;
  tableNumber: string;
  businessDate: string;
}

function coachServiceStopRequestExpectedIsValid(
  expected: unknown,
): expected is CoachServiceStopRequestExpected {
  if (typeof expected !== "object" || expected === null || Array.isArray(expected)) return false;
  const candidate = expected as Record<string, unknown>;
  return (
    Object.keys(candidate).length === 3 &&
    typeof candidate.coachId === "string" &&
    candidate.coachId.trim() === candidate.coachId &&
    [...candidate.coachId].length >= 1 &&
    [...candidate.coachId].length <= 64 &&
    typeof candidate.tableNumber === "string" &&
    candidate.tableNumber.trim() === candidate.tableNumber &&
    [...candidate.tableNumber].length >= 1 &&
    [...candidate.tableNumber].length <= 32 &&
    typeof candidate.businessDate === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(candidate.businessDate) &&
    Number.isFinite(Date.parse(`${candidate.businessDate}T00:00:00.000Z`)) &&
    new Date(`${candidate.businessDate}T00:00:00.000Z`).toISOString().slice(0, 10) ===
      candidate.businessDate
  );
}

function coachServiceStopRequestCommandIsValid(
  command: unknown,
): command is RequestCoachServiceStopRequest {
  if (typeof command !== "object" || command === null || Array.isArray(command)) return false;
  const candidate = command as Record<string, unknown>;
  return (
    Object.keys(candidate).length === 3 &&
    Object.hasOwn(candidate, "expectedServiceVersion") &&
    Object.hasOwn(candidate, "reason") &&
    Object.hasOwn(candidate, "idempotencyKey") &&
    Number.isSafeInteger(candidate.expectedServiceVersion) &&
    (candidate.expectedServiceVersion as number) >= 1 &&
    typeof candidate.reason === "string" &&
    candidate.reason.trim() === candidate.reason &&
    [...candidate.reason].length >= 2 &&
    [...candidate.reason].length <= 500 &&
    typeof candidate.idempotencyKey === "string" &&
    candidate.idempotencyKey.trim() === candidate.idempotencyKey &&
    [...candidate.idempotencyKey].length >= 8 &&
    [...candidate.idempotencyKey].length <= 128
  );
}

export async function requestCoachServiceStop(
  serviceId: string,
  command: RequestCoachServiceStopRequest,
  expected: CoachServiceStopRequestExpected,
): Promise<CoachServiceStopRequest> {
  if (
    typeof serviceId !== "string" ||
    serviceId.trim() !== serviceId ||
    [...serviceId].length < 1 ||
    [...serviceId].length > 64 ||
    !coachServiceStopRequestCommandIsValid(command) ||
    !coachServiceStopRequestExpectedIsValid(expected)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "助教下钟申请中的服务、版本、原因或请求编号不完整，系统没有提交",
      400,
    );
  }
  return coachOperationResult(
    "申请下钟",
    async () => {
      const value = await request<unknown>(
        `/v1/coaches/services/${encodeURIComponent(serviceId)}/stop-requests`,
        {
          method: "POST",
          cache: "no-store",
          body: JSON.stringify(command),
        },
      );
      if (
        !isCoachServiceStopRequest(value) ||
        value.serviceId !== serviceId ||
        value.coachId !== expected.coachId ||
        value.tableNumber !== expected.tableNumber ||
        value.businessDate !== expected.businessDate ||
        value.serviceVersionAtRequest !== command.expectedServiceVersion ||
        value.reason !== command.reason
      ) {
        throw new ApiRequestError(
          "GATEWAY_RESPONSE_INVALID",
          "助教下钟申请结果无法与原服务、版本和原因逐项对应",
        );
      }
      return value;
    },
    coachServiceStopRequestOutcomeIsUnknown,
  );
}

export async function transitionCoachService(
  serviceId: string,
  action: "START" | "COMPLETE" | "END_EARLY" | "CANCEL" | "TERMINATE_ABNORMAL",
  reason: string | null,
  idempotencyKey: string,
  stopRequest?: CoachServiceStopRequest | null,
): Promise<CoachRuntimeServiceReadModel> {
  return coachOperationResult(
    "助教服务状态变更",
    async () => {
      if (
        stopRequest !== undefined &&
        stopRequest !== null &&
        (action !== "COMPLETE" ||
          !isCoachServiceStopRequest(stopRequest) ||
          stopRequest.status !== "PENDING" ||
          stopRequest.serviceId !== serviceId ||
          stopRequest.requestId.trim() !== stopRequest.requestId)
      ) {
        throw new ApiRequestError(
          "REQUEST_VALIDATION_FAILED",
          "关联的下钟申请编号不完整，系统没有提交正式下钟",
          400,
        );
      }
      const value = await request<unknown>(
        `/v1/coaches/services/${encodeURIComponent(serviceId)}/transition`,
        {
          method: "POST",
          body: JSON.stringify({
            action,
            reason,
            ...(stopRequest ? { stopRequestId: stopRequest.requestId } : {}),
            idempotencyKey,
          }),
        },
      );
      const expectedStatus = {
        START: "ACTIVE",
        COMPLETE: "COMPLETED",
        END_EARLY: "EARLY_ENDED",
        CANCEL: "CANCELLED",
        TERMINATE_ABNORMAL: "ABNORMAL_TERMINATED",
      }[action];
      if (
        !isCoachRuntimeServiceReadModel(value) ||
        value.id !== serviceId ||
        value.status !== expectedStatus ||
        ((action === "START" || action === "COMPLETE" || action === "END_EARLY") &&
          value.startedAt === null) ||
        (stopRequest !== undefined &&
          stopRequest !== null &&
          (value.coachId !== stopRequest.coachId ||
            value.tableNumber !== stopRequest.tableNumber ||
            value.businessDate !== stopRequest.businessDate ||
            value.version !== stopRequest.serviceVersionAtRequest + 1))
      ) {
        throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教服务状态结果无法安全确认");
      }
      if (stopRequest) {
        const stopRequests = await listCoachServiceStopRequests();
        const completed = stopRequests.items.find(
          (item) => item.requestId === stopRequest.requestId,
        );
        if (
          !completed ||
          completed.status !== "COMPLETED" ||
          completed.completedServiceVersion !== value.version ||
          completed.contractVersion !== stopRequest.contractVersion ||
          completed.requestNumber !== stopRequest.requestNumber ||
          completed.serviceId !== stopRequest.serviceId ||
          completed.coachId !== stopRequest.coachId ||
          completed.coachDisplayName !== stopRequest.coachDisplayName ||
          completed.tableNumber !== stopRequest.tableNumber ||
          completed.businessDate !== stopRequest.businessDate ||
          completed.serviceVersionAtRequest !== stopRequest.serviceVersionAtRequest ||
          completed.reason !== stopRequest.reason ||
          completed.requestedAt !== stopRequest.requestedAt ||
          (reason !== null && completed.resolutionNote !== reason)
        ) {
          throw new ApiRequestError(
            "GATEWAY_RESPONSE_INVALID",
            "正式下钟回执与原申请无法逐项对应，页面继续保留原操作等待核对",
          );
        }
      }
      return value;
    },
    stopRequest !== undefined && stopRequest !== null
      ? coachServiceStopRequestOutcomeIsUnknown
      : coachOperationOutcomeIsUnknown,
  );
}

export async function previewCoachServiceReplacement(
  baseline: CoachRuntimeServiceReadModel,
  previewRequest: PreviewCoachServiceReplacementRequest,
): Promise<CoachServiceReplacementPreviewReadModel> {
  const normalizedReason = previewRequest.reason.trim();
  if (
    !isCoachRuntimeServiceReadModel(baseline) ||
    baseline.status !== "ACTIVE" ||
    baseline.startedAt === null ||
    previewRequest.replacementCoachId.length < 1 ||
    previewRequest.replacementCoachId === baseline.coachId ||
    previewRequest.expectedServiceVersion !== baseline.version ||
    previewRequest.reason !== normalizedReason ||
    [...normalizedReason].length < 2 ||
    [...normalizedReason].length > 500
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "只能预览服务中的助教换人；请重新选择可接单助教并填写 2 至 500 个字的原因",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/coaches/services/${encodeURIComponent(baseline.id)}/replacement-preview`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(previewRequest),
    },
  );
  if (
    !isCoachServiceReplacementPreviewReadModel(value) ||
    value.serviceId !== baseline.id ||
    value.replacementCoachId !== previewRequest.replacementCoachId ||
    value.expectedServiceVersion !== baseline.version ||
    value.reason !== normalizedReason ||
    Date.parse(value.expiresAt) - Date.parse(value.effectiveAt) !== 5 * 60 * 1_000
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "助教换人预览无法与当前服务、接替助教和金额逐项对应，请重新读取后再试",
    );
  }
  return value;
}

export interface CoachServiceReplacementContext {
  tenantId: string;
  storeId: string;
  actorId: string;
}

export interface CoachServiceReplacementCommand {
  context: CoachServiceReplacementContext;
  baseline: CoachRuntimeServiceReadModel;
  request: ReplaceCoachServiceRequest;
}

function coachServiceReplacementCommandIsValid(command: CoachServiceReplacementCommand): boolean {
  const { baseline, context, request: replacement } = command;
  return (
    isCoachRuntimeServiceReadModel(baseline) &&
    baseline.status === "ACTIVE" &&
    baseline.startedAt !== null &&
    typeof baseline.version === "number" &&
    Number.isSafeInteger(baseline.version) &&
    baseline.version >= 1 &&
    typeof context.tenantId === "string" &&
    context.tenantId.length > 0 &&
    typeof context.storeId === "string" &&
    context.storeId.length > 0 &&
    typeof context.actorId === "string" &&
    context.actorId.length > 0 &&
    typeof replacement.replacementCoachId === "string" &&
    replacement.replacementCoachId.length > 0 &&
    replacement.replacementCoachId !== baseline.coachId &&
    replacement.expectedServiceVersion === baseline.version &&
    typeof replacement.reason === "string" &&
    replacement.reason === replacement.reason.trim() &&
    [...replacement.reason].length >= 2 &&
    [...replacement.reason].length <= 500 &&
    Date.parse(replacement.previewExpiresAt) - Date.parse(replacement.effectiveAt) ===
      5 * 60 * 1_000 &&
    [
      replacement.expectedEffectiveSeconds,
      replacement.expectedBilledMinutes,
      replacement.expectedServiceFeeFen,
      replacement.expectedCommissionBaseFen,
      replacement.expectedCommissionFen,
      replacement.replacementRuleVersion,
      replacement.replacementPriceFen,
    ].every((value) => Number.isSafeInteger(value) && value >= 0) &&
    replacement.replacementRuleVersion >= 1 &&
    typeof replacement.replacementRuleId === "string" &&
    replacement.replacementRuleId.length > 0 &&
    /^[a-f0-9]{64}$/u.test(replacement.replacementPricingToken) &&
    /^[a-f0-9]{64}$/u.test(replacement.replacementToken) &&
    typeof replacement.idempotencyKey === "string" &&
    replacement.idempotencyKey.length >= 8 &&
    replacement.idempotencyKey.length <= 128
  );
}

function coachServiceReplacementResultMatches(
  result: CoachServiceReplacementOperatorResult,
  command: CoachServiceReplacementCommand,
): boolean {
  const { previousService, replacementService } = result;
  const { baseline, request: replacement } = command;
  return (
    previousService.id === baseline.id &&
    previousService.coachId === baseline.coachId &&
    previousService.businessDate === baseline.businessDate &&
    previousService.startedAt === baseline.startedAt &&
    previousService.status === "EARLY_ENDED" &&
    previousService.endedAt === replacement.effectiveAt &&
    previousService.billedMinutes === replacement.expectedBilledMinutes &&
    previousService.serviceFeeFen === replacement.expectedServiceFeeFen &&
    previousService.version === baseline.version + 1 &&
    previousService.replacementServiceId === replacementService.id &&
    replacementService.coachId === replacement.replacementCoachId &&
    replacementService.status === "ACTIVE" &&
    replacementService.version === 2 &&
    replacementService.assignedAt === replacement.effectiveAt &&
    replacementService.startedAt === replacement.effectiveAt &&
    replacementService.assignedAt === replacementService.startedAt &&
    replacementService.originalServiceId === previousService.id &&
    result.commissionFen === replacement.expectedCommissionFen
  );
}

function parseCoachServiceReplacementResult(
  value: unknown,
  command: CoachServiceReplacementCommand,
): CoachServiceReplacementOperatorResult {
  if (
    !coachServiceReplacementCommandIsValid(command) ||
    !isCoachServiceReplacementOperatorResult(value) ||
    !coachServiceReplacementResultMatches(value, command)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "助教换人结果无法与原服务、接替助教、计费和提成逐项对应，页面继续锁定",
    );
  }
  return value;
}

export async function replaceCoachService(
  command: CoachServiceReplacementCommand,
): Promise<CoachServiceReplacementOperatorResult> {
  if (!coachServiceReplacementCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "只能更换服务中的助教；请重新选择可接单助教并填写 2 至 500 个字的原因",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/coaches/services/${encodeURIComponent(command.baseline.id)}/replace`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(command.request),
    },
  );
  return parseCoachServiceReplacementResult(value, command);
}

export async function getCoachServiceReplacementByRequest(
  command: CoachServiceReplacementCommand,
): Promise<CoachServiceReplacementOperatorResult | null> {
  if (!coachServiceReplacementCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本机保存的助教换人原请求不完整，系统没有查询或重试",
      400,
    );
  }
  try {
    const value = await request<unknown>(
      `/v1/coaches/services/${encodeURIComponent(command.baseline.id)}/replacement-result`,
      {
        method: "POST",
        cache: "no-store",
        body: JSON.stringify(command.request),
      },
    );
    return parseCoachServiceReplacementResult(value, command);
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "COACH_SERVICE_REPLACEMENT_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export function coachServiceReplacementOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  return (
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    error.statusCode === 408 ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

export function coachServiceReplacementFailureMessage(error: unknown): string {
  if (!(error instanceof ApiRequestError)) {
    return "门店连接中断，结果尚未确认；系统会先查询原请求，请勿再次换人。";
  }
  const messages: Record<string, string> = {
    COACH_SERVICE_NOT_FOUND: "原助教服务已不存在，请重新读取当前任务。",
    COACH_SERVICE_STATE_CONFLICT: "原服务已经不在服务中，不能换人；请重新读取当前任务。",
    COACH_SERVICE_VERSION_CONFLICT: "原服务刚被其他员工处理过，请重新读取后再决定。",
    COACH_SERVICE_NOT_REPLACEABLE: "原服务已经不在服务中，不能换人；请重新读取当前任务。",
    COACH_REPLACEMENT_MUST_DIFFER: "接替助教不能与原助教相同，请选择另一人。",
    COACH_ALREADY_SERVING: "接替助教已有进行中的服务，请选择另一名当前可接单助教。",
    COACH_NOT_AVAILABLE: "接替助教已经暂停、签退或不可接单，请重新选择。",
    COACH_SERVICE_RULE_UNAVAILABLE: "接替助教当前没有同类服务价格，请先由店长核对经营设置。",
    COACH_SERVICE_REPLACEMENT_PREVIEW_EXPIRED: "金额预览已超过 5 分钟，请重新核对后再确认。",
    COACH_SERVICE_REPLACEMENT_FACTS_CHANGED:
      "服务时长、金额、提成或接替价格已经变化，请重新生成预览后再确认。",
    COACH_SERVICE_REPLACEMENT_COACH_UNAVAILABLE:
      "接替助教已经接单、暂停或签退，请重新选择仍可接单的助教。",
    COACH_SERVICE_REPLACEMENT_SAME_COACH: "接替助教不能与原助教相同，请选择另一人。",
    REQUEST_KEY_OWNED_BY_OTHER_ACTOR:
      "这个原请求属于另一名员工，当前账号不能接管；请切回原账号核对。",
    IDEMPOTENCY_COLLISION: "原请求号对应的内容不一致，系统没有执行；请重新读取当前任务。",
    AUTH_REQUIRED: "登录状态已失效，系统没有执行；请重新登录后再操作。",
    AUTHORIZATION_DEFAULT_DENY: "当前账号没有助教换人权限，系统没有执行。",
    CONDITIONAL_MODULE_DISABLED: "门店尚未启用助教模块，系统没有执行换人。",
    SHIFT_SESSION_NOT_STARTED: "当前班次尚未开始，系统没有执行换人。",
  };
  return messages[error.code] ?? error.message;
}

export async function getCoachSummary(
  businessDate?: string,
  expectedCoachId?: string,
): Promise<CoachSummaryRow[]> {
  const suffix = businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : "";
  const result = await request<unknown>(`/v1/coaches/summary${suffix}`, { cache: "no-store" });
  if (!Array.isArray(result) || result.length > 1_000) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "今日助教服务与提成返回内容无法安全确认");
  }
  const keys = new Set<string>();
  const rows = result.map((item) => {
    if (
      !isCoachSummaryRow(item) ||
      (businessDate !== undefined && item.businessDate !== businessDate) ||
      (expectedCoachId !== undefined && item.coachId !== expectedCoachId)
    ) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "今日助教服务与提成返回内容无法安全确认",
      );
    }
    const key = [item.businessDate, item.coachId, item.serviceTypeCode, item.assignmentType].join(
      "\u0000",
    );
    if (keys.has(key)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "今日助教服务与提成返回内容无法安全确认",
      );
    }
    keys.add(key);
    return item;
  });
  if (coachSummaryTotals(rows) === null) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "今日助教服务与提成返回内容无法安全确认");
  }
  return rows;
}

export async function getCoachMonthlyCommission(
  month?: string,
  coachId?: string,
): Promise<CoachMonthlyCommissionReadModel[]> {
  const parameters = new URLSearchParams();
  if (month) parameters.set("month", month);
  if (coachId) parameters.set("coachId", coachId);
  const suffix = parameters.size > 0 ? `?${parameters.toString()}` : "";
  const value = await request<unknown>(`/v1/coaches/monthly-commission${suffix}`, {
    cache: "no-store",
  });
  if (!isCoachMonthlyCommissionReadModelList(value, month, coachId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "月度小时或提成金额无法安全核对，页面已停止显示，请刷新后重试",
    );
  }
  return value;
}

export async function importCoachConfiguration(
  mode: "PREVIEW" | "APPLY",
  configuration: CoachConfigurationSnapshot,
  idempotencyKey: string,
): Promise<CoachConfigurationImportResult> {
  const value = await request<unknown>("/v1/coaches/configuration/import", {
    method: "POST",
    body: JSON.stringify({ mode, configuration, idempotencyKey }),
  });
  if (
    !isCoachConfigurationImportResult(value) ||
    value.idempotencyKey !== idempotencyKey ||
    value.mode !== mode ||
    value.evidence !== configuration.evidence
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "助教经营配置保存结果无法安全确认");
  }
  return value;
}

export function coachConfigurationMatchesSavedCommand(
  authoritative: CoachConfigurationSnapshot,
  command: CoachConfigurationSnapshot,
): boolean {
  return coachConfigurationSnapshotsEqual(authoritative, command);
}

export function onboardCoachProfileAccount(
  input: CoachProfileAccountOnboardingRequest,
  authorizationToken: string,
): Promise<CoachProfileAccountOnboardingResult> {
  return request("/v1/coaches/profile-account-onboarding", {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify(input),
  });
}

export interface OperatorAccountRecord {
  id: string;
  tenantId: string;
  storeId: string;
  login: string;
  displayName: string;
  role: OperatorIdentity["role"];
  coachProfileId: string | null;
  activationStatus: "ACTIVE" | "DISABLED";
  createdAt: string;
  updatedAt: string;
}

export function listOperatorAccounts(): Promise<OperatorAccountRecord[]> {
  return request("/v1/system/operators");
}

export function createOperatorAccount(
  input: {
    login: string;
    displayName: string;
    role: OperatorIdentity["role"];
    coachProfileId: string | null;
    password: string;
    idempotencyKey: string;
  },
  authorizationToken: string,
): Promise<OperatorAccountRecord> {
  return request("/v1/system/operators", {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify(input),
  });
}

export function setOperatorActivation(
  operatorId: string,
  activationStatus: "ACTIVE" | "DISABLED",
  reason: string,
  idempotencyKey: string,
  authorizationToken: string,
): Promise<OperatorAccountRecord> {
  return request(`/v1/system/operators/${operatorId}/activation`, {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify({ activationStatus, reason, idempotencyKey }),
  });
}

export function setOperatorCoachBinding(
  operatorId: string,
  coachProfileId: string | null,
  reason: string,
  idempotencyKey: string,
  authorizationToken: string,
): Promise<OperatorAccountRecord> {
  return request(`/v1/system/operators/${operatorId}/coach-binding`, {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify({ coachProfileId, reason, idempotencyKey }),
  });
}

export function resetOperatorPassword(
  operatorId: string,
  password: string,
  reason: string,
  idempotencyKey: string,
  authorizationToken: string,
): Promise<OperatorAccountRecord> {
  return request(`/v1/system/operators/${operatorId}/reset-password`, {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify({ password, reason, idempotencyKey }),
  });
}

export type EmployeeRole = Exclude<OperatorIdentity["role"], "COACH">;

export interface EmployeeProfileRecord {
  id: string;
  tenantId: string;
  assignedStoreId: string;
  fullName: string;
  phone: string;
  positionTitle: string;
  notes: string;
  role: EmployeeRole;
  employmentStatus: "EMPLOYED" | "LEFT";
  account: {
    id: string;
    login: string;
    displayName: string;
    role: EmployeeRole;
    activationStatus: "ACTIVE" | "DISABLED";
  } | null;
  version: number;
  createdAt: string;
  updatedAt: string;
}

export interface EmployeeProfileAuditRecord {
  id: string;
  actorId: string;
  authorizerId: string | null;
  action: string;
  detail: Record<string, unknown>;
  occurredAt: string;
}

export interface EmployeeProfileFields {
  fullName: string;
  phone: string;
  positionTitle: string;
  notes: string;
  assignedStoreId: string;
  role: EmployeeRole;
  employmentStatus: "EMPLOYED" | "LEFT";
}

export function listEmployeeProfiles(): Promise<EmployeeProfileRecord[]> {
  return request("/v1/staff/profiles");
}

export function createEmployeeProfile(
  input: EmployeeProfileFields & {
    account: { login: string; password: string } | null;
    reason: string;
    idempotencyKey: string;
  },
  authorizationToken: string,
): Promise<EmployeeProfileRecord> {
  return request("/v1/staff/profiles", {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify(input),
  });
}

export function updateEmployeeProfile(
  employeeId: string,
  input: EmployeeProfileFields & {
    expectedVersion: number;
    reason: string;
    idempotencyKey: string;
  },
  authorizationToken: string,
): Promise<EmployeeProfileRecord> {
  return request(`/v1/staff/profiles/${employeeId}`, {
    method: "PATCH",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify(input),
  });
}

export function createEmployeeProfileAccount(
  employeeId: string,
  input: { login: string; password: string; reason: string; idempotencyKey: string },
  authorizationToken: string,
): Promise<EmployeeProfileRecord> {
  return request(`/v1/staff/profiles/${employeeId}/account`, {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify(input),
  });
}

export function setEmployeeProfileAccountBinding(
  employeeId: string,
  input: { operatorId: string | null; reason: string; idempotencyKey: string },
  authorizationToken: string,
): Promise<EmployeeProfileRecord> {
  return request(`/v1/staff/profiles/${employeeId}/account-binding`, {
    method: "POST",
    headers: secondaryAuthorizationHeaders(authorizationToken),
    body: JSON.stringify(input),
  });
}

export function listEmployeeProfileAudit(
  employeeId: string,
): Promise<EmployeeProfileAuditRecord[]> {
  return request(`/v1/staff/profiles/${employeeId}/audit`);
}

export async function getConnectivity(): Promise<ConnectivityReadModel> {
  const result = await request<unknown>("/v1/connectivity", { cache: "no-store" });
  if (!isConnectivityReadModel(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "门店连接状态返回内容无法安全确认");
  }
  return result;
}

export async function simulateNetwork(offline: boolean): Promise<ConnectivityReadModel> {
  const result = await request<unknown>("/v1/simulation/network", {
    method: "POST",
    body: JSON.stringify({ offline }),
  });
  if (!isConnectivityReadModel(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "网络模拟后的门店连接状态无法安全确认");
  }
  return result;
}

export async function listProducts(): Promise<ProductSaleCatalogItem[]> {
  const result = await request<unknown>("/v1/products", { cache: "no-store" });
  if (!isProductSaleCatalogItemList(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "可售商品目录返回内容无法安全确认");
  }
  return result;
}

export async function findProductByBarcode(
  barcodeInput: string,
): Promise<ProductSaleBarcodeLookupResult> {
  const barcode = barcodeInput.trim();
  if (!/^[0-9A-Za-z._-]{4,32}$/u.test(barcode)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "商品条码格式不正确，请输入 4 至 32 位数字、字母、点、下划线或短横线",
      400,
    );
  }
  const result = await request<unknown>(`/v1/products/by-barcode/${encodeURIComponent(barcode)}`, {
    cache: "no-store",
  });
  if (!isProductSaleBarcodeLookupResult(result) || result.barcode !== barcode) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "扫码查商品结果无法与本次条码安全核对，系统没有提交加单",
    );
  }
  return result;
}

export type InventoryProductListView = "ALL" | "ATTENTION";

async function readInventoryProductsForView(
  view: InventoryProductListView,
): Promise<InventoryProductRecord[]> {
  if (view !== "ALL" && view !== "ATTENTION") {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "商品查看范围不正确，系统没有读取商品资料",
      400,
    );
  }
  const path =
    view === "ATTENTION" ? "/v1/inventory/products?stock=attention" : "/v1/inventory/products";
  const result = await request<unknown>(path, { cache: "no-store" });
  if (!isInventoryProductRecordList(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "商品资料返回内容无法安全确认");
  }
  if (
    view === "ATTENTION" &&
    result.some((product) => !product.trackInventory || (!product.lowStock && !product.outOfStock))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "低库存提醒包含无需处理的商品，页面已停止显示",
    );
  }
  return result;
}

export function listInventoryProducts(): Promise<InventoryProductRecord[]> {
  return readInventoryProductsForView("ALL");
}

export function listInventoryProductsForView(
  view: InventoryProductListView,
): Promise<InventoryProductRecord[]> {
  return readInventoryProductsForView(view);
}

export async function listProductUnitConversions(
  skuId: string,
  expectedBaseUnitName: string,
): Promise<ProductUnitConversionRecord[]> {
  const result = await request<unknown>(
    `/v1/inventory/products/${encodeURIComponent(skuId)}/unit-conversions`,
    { cache: "no-store" },
  );
  if (
    !isProductUnitConversionRecordList(result) ||
    result.some(
      (conversion) =>
        conversion.skuId !== skuId || conversion.baseUnitName !== expectedBaseUnitName,
    )
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "商品单位换算资料返回内容无法安全确认");
  }
  return result;
}

export async function listSuppliers(): Promise<SupplierRecord[]> {
  const result = await request<unknown>("/v1/inventory/suppliers", { cache: "no-store" });
  if (!isSupplierRecordList(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "供应商档案返回内容无法安全确认");
  }
  return result;
}

export async function listSupplierSettlementLedgerDirectory(): Promise<SupplierSettlementLedgerDirectory> {
  const result = await request<unknown>("/v1/purchase-payables/supplier-ledgers", {
    method: "GET",
    cache: "no-store",
  });
  if (!isSupplierSettlementLedgerDirectory(result)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "供应商往来目录返回内容无法安全确认，页面不会继续显示旧目录",
    );
  }
  return result;
}

export async function getSupplierSettlementLedger(
  supplierId: string,
  query: SupplierSettlementLedgerQuery,
): Promise<SupplierSettlementLedgerPage> {
  const beforeGatewaySequence = query.beforeGatewaySequence;
  if (
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(supplierId) ||
    !Number.isSafeInteger(query.limit) ||
    query.limit < 1 ||
    query.limit > 100 ||
    (beforeGatewaySequence !== null &&
      (!Number.isSafeInteger(beforeGatewaySequence) || beforeGatewaySequence < 1))
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商往来账查询条件不完整，请重新选择供应商",
      400,
    );
  }
  const search = new URLSearchParams({ limit: String(query.limit) });
  if (beforeGatewaySequence !== null) {
    search.set("beforeGatewaySequence", String(beforeGatewaySequence));
  }
  const result = await request<unknown>(
    `/v1/purchase-payables/supplier-ledgers/${encodeURIComponent(supplierId)}?${search.toString()}`,
    { cache: "no-store" },
  );
  if (
    !isSupplierSettlementLedgerPage(result) ||
    result.supplierId !== supplierId ||
    result.limit !== query.limit ||
    (beforeGatewaySequence !== null &&
      result.entries.some((entry) => entry.gatewaySequence >= beforeGatewaySequence))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "供应商往来账与本次查询不一致，页面不会把它显示为当前权威结果",
    );
  }
  return result;
}

export interface SupplierSettlementLedgerExportExpectedScope {
  tenantId: string;
  storeId: string;
}

function supplierSettlementLedgerExportRequestIsCanonical(
  supplierId: string,
  expectedScope: SupplierSettlementLedgerExportExpectedScope,
): boolean {
  return [supplierId, expectedScope.tenantId, expectedScope.storeId].every((value) =>
    /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(value),
  );
}

function supplierSettlementLedgerExportInvalid(): ApiRequestError {
  return new ApiRequestError(
    "GATEWAY_RESPONSE_INVALID",
    "供应商完整往来账无法安全确认，导出文件没有下载，请重新读取",
  );
}

async function supplierSettlementLedgerExportCsvSha256(csv: string): Promise<string> {
  if (!globalThis.crypto?.subtle || typeof globalThis.crypto.subtle.digest !== "function") {
    throw supplierSettlementLedgerExportInvalid();
  }
  try {
    const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(csv));
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join(
      "",
    );
  } catch {
    throw supplierSettlementLedgerExportInvalid();
  }
}

export async function getSupplierSettlementLedgerExport(
  supplierId: string,
  expectedScope: SupplierSettlementLedgerExportExpectedScope,
  signal?: AbortSignal,
): Promise<SupplierSettlementLedgerExportReadModel> {
  if (!supplierSettlementLedgerExportRequestIsCanonical(supplierId, expectedScope)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商或当前门店身份不正确，系统没有生成往来账导出文件",
      400,
    );
  }
  const result = await request<unknown>(
    `/v1/purchase-payables/supplier-ledgers/${encodeURIComponent(supplierId)}/export`,
    { cache: "no-store", ...(signal ? { signal } : {}) },
  );
  if (
    !isSupplierSettlementLedgerExportReadModel(result, {
      tenantId: expectedScope.tenantId,
      storeId: expectedScope.storeId,
      supplierId,
    })
  ) {
    throw supplierSettlementLedgerExportInvalid();
  }
  if ((await supplierSettlementLedgerExportCsvSha256(result.csv)) !== result.contentSha256) {
    throw supplierSettlementLedgerExportInvalid();
  }
  return result;
}

export async function listPurchaseOrderDrafts(): Promise<PurchaseOrderDraftRecord[]> {
  const result = await request<unknown>("/v1/procurement/purchase-orders?status=DRAFT", {
    cache: "no-store",
  });
  if (!isPurchaseOrderDraftRecordList(result)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "采购草稿返回内容无法安全确认，请重新读取",
    );
  }
  return result;
}

export function purchaseOrderDraftSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PURCHASE_ORDER_DRAFT_SAVE_RESULT_UNKNOWN",
      "PURCHASE_ORDER_DRAFT_SAVE_RESULT_INVALID",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definiteTerminalRejection =
    [
      "REQUEST_VALIDATION_FAILED",
      "IDEMPOTENCY_COLLISION",
      "PURCHASE_ORDER_VERSION_CONFLICT",
      "PURCHASE_ORDER_CAUSATION_CONFLICT",
      "PURCHASE_ORDER_NOT_DRAFT",
      "PURCHASE_ORDER_NUMBER_COLLISION",
      "PURCHASE_ORDER_DRAFT_LIMIT_REACHED",
      "SUPPLIER_NOT_FOUND",
      "SUPPLIER_DISABLED",
      "SUPPLIER_VERSION_CONFLICT",
      "PRODUCT_NOT_FOUND",
      "PRODUCT_DISABLED",
      "PRODUCT_NOT_INVENTORY",
      "PRODUCT_VERSION_CONFLICT",
      "PRODUCT_UNIT_NOT_FOUND",
      "PRODUCT_UNIT_DISABLED",
      "PRODUCT_UNIT_VERSION_CONFLICT",
      "PRODUCT_BASE_UNIT_MISMATCH",
      "ONLINE_SERVICE_REQUIRED",
      "CLOUD_COORDINATOR_UNAVAILABLE",
      "CLOUD_AUTHORIZATION_FAILED",
      "CONDITIONAL_MODULE_DISABLED",
      "GATEWAY_CREDENTIAL_MISMATCH",
      "GATEWAY_CREDENTIAL_REQUIRED",
      "GATEWAY_IDENTITY_MISMATCH",
      "GATEWAY_SCOPE_MISMATCH",
      "STORE_NOT_FOUND",
      "UNAUTHORIZED_GATEWAY",
      "VENUE_NOT_INITIALIZED",
    ].includes(error.code) ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_") ||
    error.code.startsWith("CLOUD_GATEWAY_CREDENTIAL_") ||
    error.code.startsWith("CLOUD_GATEWAY_SCOPE_") ||
    error.code.startsWith("CLOUD_GATEWAY_UNAUTHORIZED");
  if (definiteTerminalRejection) return false;
  return (
    error.statusCode === 408 ||
    error.statusCode === 429 ||
    (error.statusCode !== undefined && error.statusCode >= 500) ||
    (error.statusCode !== undefined && error.statusCode >= 400)
  );
}

function purchaseOrderRequestSnapshot(
  input: PurchaseOrderDraftUpsertRequest,
): PurchaseOrderDraftUpsertRequest {
  return {
    ...input,
    lines: input.lines.map((line) => ({
      ...line,
      unitSelection: { ...line.unitSelection },
    })),
    operationTrace: {
      ...input.operationTrace,
      businessNumber:
        input.operationTrace.businessNumber === null
          ? null
          : { ...input.operationTrace.businessNumber },
    },
  };
}

function businessOperationTraceMatches(
  left: PurchaseOrderDraftRecord["operationTrace"],
  right: PurchaseOrderDraftUpsertRequest["operationTrace"],
): boolean {
  return (
    left.contractVersion === right.contractVersion &&
    left.commandId === right.commandId &&
    left.correlationId === right.correlationId &&
    left.causationId === right.causationId &&
    left.idempotencyKey === right.idempotencyKey &&
    (left.businessNumber === null
      ? right.businessNumber === null
      : right.businessNumber !== null &&
        left.businessNumber.kind === right.businessNumber.kind &&
        left.businessNumber.value === right.businessNumber.value)
  );
}

export function purchaseOrderDraftWriteResultMatchesRequest(
  value: unknown,
  input: PurchaseOrderDraftUpsertRequest,
): value is PurchaseOrderDraftRecord {
  if (!isPurchaseOrderDraftRecord(value)) return false;
  if (
    value.purchaseOrderId !== input.purchaseOrderId ||
    value.businessDate !== input.businessDate ||
    value.supplier.supplierId !== input.supplierId ||
    value.supplier.version !== input.expectedSupplierVersion ||
    value.expectedDeliveryDate !== input.expectedDeliveryDate ||
    value.notes !== input.notes ||
    value.version !== input.expectedVersion + 1 ||
    value.lastCommandId !== input.idempotencyKey ||
    !businessOperationTraceMatches(value.operationTrace, input.operationTrace) ||
    value.lines.length !== input.lines.length
  ) {
    return false;
  }
  return input.lines.every((line, index) => {
    const record = value.lines[index];
    if (!record) return false;
    return (
      record.lineId === line.lineId &&
      record.skuId === line.skuId &&
      record.productVersion === line.expectedProductVersion &&
      record.inputUnitQuantity === line.inputUnitQuantity &&
      record.inputUnitPriceFen === line.inputUnitPriceFen &&
      record.taxFen === line.taxFen &&
      record.conversionId === line.unitSelection.conversionId &&
      record.conversionVersion === line.unitSelection.expectedConversionVersion
    );
  });
}

export async function savePurchaseOrderDraft(
  input: PurchaseOrderDraftUpsertRequest,
): Promise<PurchaseOrderDraftRecord> {
  const requestSnapshot = purchaseOrderRequestSnapshot(input);
  if (!isPurchaseOrderDraftUpsertRequest(requestSnapshot)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "采购草稿内容不符合保存要求，请检查日期、供应商、商品、数量和金额",
      400,
    );
  }
  try {
    const result = await request<unknown>(
      `/v1/procurement/purchase-orders/${encodeURIComponent(requestSnapshot.purchaseOrderId)}/draft`,
      { method: "PUT", body: JSON.stringify(requestSnapshot) },
    );
    if (!purchaseOrderDraftWriteResultMatchesRequest(result, requestSnapshot)) {
      throw new ApiRequestError(
        "PURCHASE_ORDER_DRAFT_SAVE_RESULT_INVALID",
        "采购草稿保存结果无法安全确认",
      );
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (purchaseOrderDraftSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PURCHASE_ORDER_DRAFT_SAVE_RESULT_UNKNOWN",
        "这次采购草稿可能已经保存，但页面尚未确认。请保留当前内容并使用同一请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function previewPurchaseOrderApproval(
  requestSnapshot: PreviewPurchaseOrderApprovalRequest,
): Promise<PurchaseOrderApprovalPreviewReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewPurchaseOrderApprovalRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "采购审批检查内容不完整，请重新选择采购单并填写申请原因",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-orders/${encodeURIComponent(input.purchaseOrderId)}/approval-requests/preview`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (
    !isPurchaseOrderApprovalPreviewReadModel(value) ||
    value.purchaseOrderId !== input.purchaseOrderId ||
    value.purchaseOrderVersion !== input.expectedPurchaseOrderVersion ||
    value.reason !== input.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "采购审批检查结果无法与当前采购单对应，请不要提交，重新读取采购草稿后再试",
    );
  }
  return value;
}

export async function createPurchaseOrderApproval(
  requestSnapshot: CreatePurchaseOrderApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreatePurchaseOrderApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "采购审批申请内容不完整，请重新核对采购单版本、申请原因和检查结果",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-orders/${encodeURIComponent(input.purchaseOrderId)}/approval-requests`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (
    !isApprovalRequestReadModel(value) ||
    value.snapshot.kind !== "PURCHASE_ORDER_APPROVAL" ||
    value.snapshot.purchaseOrderId !== input.purchaseOrderId ||
    value.snapshot.purchaseOrderVersion !== input.expectedPurchaseOrderVersion ||
    value.snapshot.reason !== input.reason ||
    value.snapshot.sourceReferenceSha256 !== input.sourceReferenceSha256 ||
    value.snapshot.businessFactSha256 !== input.businessFactSha256 ||
    value.policy.resource !== "PURCHASE_ORDER" ||
    value.policy.action !== "SUBMIT_APPROVAL" ||
    value.policy.requirement !== "MANAGER_OR_OWNER" ||
    value.policy.effect !== "MANAGER_OR_OWNER_APPROVAL" ||
    value.status !== "PENDING_MANAGER_OR_OWNER" ||
    value.execution.status !== "AWAITING_APPROVAL" ||
    value.steps.length !== 1 ||
    value.steps[0]?.requiredRole !== "MANAGER_OR_OWNER" ||
    value.steps[0]?.status !== "AVAILABLE"
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "采购审批申请结果无法安全确认，请保留原申请并去统一审批中心查询",
    );
  }
  return value;
}

function purchaseOrderApprovalMatchesRecovery(
  approval: ApprovalRequestReadModel,
  requestSnapshot: CreatePurchaseOrderApprovalCommand,
): boolean {
  return (
    approval.snapshot.kind === "PURCHASE_ORDER_APPROVAL" &&
    approval.snapshot.purchaseOrderId === requestSnapshot.purchaseOrderId &&
    approval.snapshot.purchaseOrderVersion === requestSnapshot.expectedPurchaseOrderVersion &&
    approval.snapshot.reason === requestSnapshot.reason &&
    approval.snapshot.sourceReferenceSha256 === requestSnapshot.sourceReferenceSha256 &&
    approval.snapshot.businessFactSha256 === requestSnapshot.businessFactSha256 &&
    approval.policy.resource === "PURCHASE_ORDER" &&
    approval.policy.action === "SUBMIT_APPROVAL" &&
    approval.policy.requirement === "MANAGER_OR_OWNER" &&
    approval.policy.effect === "MANAGER_OR_OWNER_APPROVAL"
  );
}

export async function recoverPurchaseOrderApproval(
  requestSnapshot: CreatePurchaseOrderApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreatePurchaseOrderApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原采购审批请求不完整，无法安全恢复",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-orders/${encodeURIComponent(input.purchaseOrderId)}/approval-requests`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (!isApprovalRequestReadModel(value) || !purchaseOrderApprovalMatchesRecovery(value, input)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "原采购审批申请的后续状态无法安全确认，系统继续保留原请求",
    );
  }
  return value;
}

export async function findPurchaseOrderApprovalForRecovery(
  requestSnapshot: CreatePurchaseOrderApprovalCommand,
): Promise<ApprovalRequestReadModel | null> {
  const input = structuredClone(requestSnapshot);
  if (!isCreatePurchaseOrderApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原采购审批请求不完整，无法安全查询后续状态",
      400,
    );
  }
  const [mine, history] = await Promise.all([listApprovals("MINE"), listApprovals("HISTORY")]);
  const candidateIds = new Set(
    [...mine.items, ...history.items]
      .filter((item) => item.summary.kind === "PURCHASE_ORDER_APPROVAL")
      .map((item) => item.approvalId),
  );
  const candidates = await Promise.all(
    [...candidateIds].map((approvalId) => getApproval(approvalId)),
  );
  const matches = candidates.filter((approval) =>
    purchaseOrderApprovalMatchesRecovery(approval, input),
  );
  if (matches.length > 1) {
    throw new ApiRequestError(
      "PURCHASE_ORDER_APPROVAL_RECOVERY_AMBIGUOUS",
      "查到多笔相同采购事实的审批记录，系统不会自动结束恢复锁，请保留原请求并人工核对",
    );
  }
  return matches[0] ?? null;
}

export async function listPurchaseOrderReceivingWorkspaces(): Promise<
  PurchaseOrderReceivingWorkspace[]
> {
  const value = await request<unknown>("/v1/procurement/purchase-orders/receiving", {
    cache: "no-store",
  });
  if (!isPurchaseOrderReceivingWorkspaceList(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待收货采购单返回内容无法安全确认，请重新读取",
    );
  }
  return value;
}

export async function getInventoryLotWorkspace(): Promise<InventoryLotWorkspace> {
  const value = await request<unknown>("/v1/inventory/lots", { cache: "no-store" });
  if (!isInventoryLotWorkspace(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "批次与效期库存返回内容无法安全确认，请重新读取",
    );
  }
  return value;
}

export async function getPurchaseOrderReceivingWorkspace(
  purchaseOrderId: string,
): Promise<PurchaseOrderReceivingWorkspace> {
  if (!purchaseOrderId || purchaseOrderId !== purchaseOrderId.trim()) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "采购单编号不完整，无法读取收货页面",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-orders/${encodeURIComponent(purchaseOrderId)}/receiving`,
    { cache: "no-store" },
  );
  if (!isPurchaseOrderReceivingWorkspace(value) || value.purchaseOrderId !== purchaseOrderId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "采购单收货内容与所选采购单不一致，系统已停止办理",
    );
  }
  return value;
}

function purchaseReceiptLinesMatchRequest(
  result: PurchaseReceiptWriteResult,
  input: RecordPurchaseReceiptRequest,
): boolean {
  if (result.receipt.lines.length !== input.lines.length) return false;
  const requested = new Map(input.lines.map((line) => [line.lineId, line]));
  return result.receipt.lines.every((line) => {
    const requestedLine = requested.get(line.lineId);
    if (!requestedLine || requestedLine.receivedBaseQuantity !== line.receivedBaseQuantity) {
      return false;
    }
    if (requestedLine.lotAllocations === undefined) return true;
    if (
      line.lotAllocations === undefined ||
      line.lotAllocations.length !== requestedLine.lotAllocations.length
    ) {
      return false;
    }
    const recordedById = new Map(
      line.lotAllocations.map((allocation) => [allocation.lotId, allocation]),
    );
    return requestedLine.lotAllocations.every((allocation) => {
      const recorded = recordedById.get(allocation.lotId);
      return (
        recorded?.lotNumber === allocation.lotNumber &&
        recorded.expiryDate === allocation.expiryDate &&
        recorded.receivedBaseQuantity === allocation.receivedBaseQuantity
      );
    });
  });
}

export function purchaseOrderReceiptWriteResultMatchesRequest(
  value: unknown,
  input: RecordPurchaseReceiptRequest,
  expectedReceiverActorId: string,
): value is PurchaseReceiptWriteResult {
  if (!isPurchaseReceiptWriteResult(value)) return false;
  const receipt = value.receipt;
  return (
    receipt.receiptId === input.receiptId &&
    receipt.purchaseOrderId === input.purchaseOrderId &&
    receipt.purchaseOrderVersionBefore === input.expectedPurchaseOrderVersion &&
    receipt.businessDate === input.businessDate &&
    receipt.notes === input.notes &&
    receipt.receiverActorId === expectedReceiverActorId &&
    JSON.stringify(receipt.operationTrace) === JSON.stringify(input.operationTrace) &&
    purchaseReceiptLinesMatchRequest(value, input)
  );
}

export function purchaseOrderReceiptOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PURCHASE_RECEIPT_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (
    error.code === "REQUEST_VALIDATION_FAILED" ||
    error.code === "AUTH_REQUIRED" ||
    error.code === "PURCHASE_RECEIVING_FORBIDDEN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_")
  ) {
    return false;
  }
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

function immutablePurchaseReceiptRequest(
  requestSnapshot: RecordPurchaseReceiptRequest,
): RecordPurchaseReceiptRequest {
  return structuredClone(requestSnapshot);
}

export async function recordPurchaseOrderReceipt(
  requestSnapshot: RecordPurchaseReceiptRequest,
  expectedReceiverActorId: string,
): Promise<PurchaseReceiptWriteResult> {
  const input = immutablePurchaseReceiptRequest(requestSnapshot);
  if (!isRecordPurchaseReceiptRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本次收货内容不完整，系统没有提交；请检查每行实收数量",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/procurement/purchase-orders/${encodeURIComponent(input.purchaseOrderId)}/receipts`,
      {
        method: "POST",
        cache: "no-store",
        body: JSON.stringify(input),
      },
    );
  } catch (error) {
    if (purchaseOrderReceiptOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PURCHASE_RECEIPT_RESULT_UNKNOWN",
        "本次收货可能已在本地完成，但页面尚未确认；请保留原内容并按收货记录号查询原结果",
      );
    }
    throw error;
  }
  if (!purchaseOrderReceiptWriteResultMatchesRequest(value, input, expectedReceiverActorId)) {
    throw new ApiRequestError(
      "PURCHASE_RECEIPT_RESULT_UNKNOWN",
      "本次收货可能已在本地完成，但返回结果与原请求不一致；请按收货记录号查询原结果",
    );
  }
  return value;
}

export async function recoverPurchaseOrderReceipt(
  requestSnapshot: RecordPurchaseReceiptRequest,
  expectedReceiverActorId: string,
): Promise<PurchaseReceiptWriteResult> {
  const input = immutablePurchaseReceiptRequest(requestSnapshot);
  if (!isRecordPurchaseReceiptRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原收货请求不完整，无法安全查询原结果",
      400,
    );
  }
  const query = new URLSearchParams({
    purchaseOrderId: input.purchaseOrderId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/procurement/purchase-receipts/${encodeURIComponent(input.receiptId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!purchaseOrderReceiptWriteResultMatchesRequest(value, input, expectedReceiverActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原收货记录号、采购单或原提交内容不一致，系统继续保留原请求",
    );
  }
  return value;
}

export function purchaseOrderShortCloseWriteResultMatchesRequest(
  value: unknown,
  input: ClosePurchaseOrderShortRequest,
  expectedCloserActorId: string,
): value is PurchaseOrderShortCloseWriteResult {
  if (!isPurchaseOrderShortCloseWriteResult(value)) return false;
  const shortClose = value.shortClose;
  return (
    shortClose.shortCloseId === input.shortCloseId &&
    shortClose.purchaseOrderId === input.purchaseOrderId &&
    shortClose.purchaseOrderVersionBefore === input.expectedPurchaseOrderVersion &&
    shortClose.businessDate === input.businessDate &&
    shortClose.reason === input.reason &&
    shortClose.closerActorId === expectedCloserActorId &&
    JSON.stringify(shortClose.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export function purchaseOrderShortCloseOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PURCHASE_ORDER_SHORT_CLOSE_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (
    error.code === "REQUEST_VALIDATION_FAILED" ||
    error.code === "AUTH_REQUIRED" ||
    error.code === "PURCHASE_RECEIVING_FORBIDDEN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_")
  ) {
    return false;
  }
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

function immutablePurchaseOrderShortCloseRequest(
  requestSnapshot: ClosePurchaseOrderShortRequest,
): ClosePurchaseOrderShortRequest {
  return structuredClone(requestSnapshot);
}

export async function closePurchaseOrderShort(
  requestSnapshot: ClosePurchaseOrderShortRequest,
  expectedCloserActorId: string,
): Promise<PurchaseOrderShortCloseWriteResult> {
  const input = immutablePurchaseOrderShortCloseRequest(requestSnapshot);
  if (!isClosePurchaseOrderShortRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "少收关闭内容不完整，系统没有提交；请检查业务日期和关闭原因",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/procurement/purchase-orders/${encodeURIComponent(input.purchaseOrderId)}/short-close`,
      {
        method: "POST",
        cache: "no-store",
        body: JSON.stringify(input),
      },
    );
  } catch (error) {
    if (purchaseOrderShortCloseOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PURCHASE_ORDER_SHORT_CLOSE_RESULT_UNKNOWN",
        "少收关闭可能已经生效，但页面尚未确认；请保留原内容并按少收关闭记录号查询原结果",
      );
    }
    throw error;
  }
  if (!purchaseOrderShortCloseWriteResultMatchesRequest(value, input, expectedCloserActorId)) {
    throw new ApiRequestError(
      "PURCHASE_ORDER_SHORT_CLOSE_RESULT_UNKNOWN",
      "少收关闭可能已经生效，但返回结果与原请求不一致；请按少收关闭记录号查询原结果",
    );
  }
  return value;
}

export async function recoverPurchaseOrderShortClose(
  requestSnapshot: ClosePurchaseOrderShortRequest,
  expectedCloserActorId: string,
): Promise<PurchaseOrderShortCloseWriteResult> {
  const input = immutablePurchaseOrderShortCloseRequest(requestSnapshot);
  if (!isClosePurchaseOrderShortRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原少收关闭请求不完整，无法安全查询原结果",
      400,
    );
  }
  const query = new URLSearchParams({
    purchaseOrderId: input.purchaseOrderId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/procurement/purchase-order-short-closes/${encodeURIComponent(input.shortCloseId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!purchaseOrderShortCloseWriteResultMatchesRequest(value, input, expectedCloserActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原少收关闭记录号、采购单或原提交内容不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function getPurchaseReturnWorkspace(
  receiptId: string,
): Promise<PurchaseReturnWorkspace> {
  if (!receiptId || receiptId !== receiptId.trim()) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原收货记录号不完整，无法读取供应商退货页面",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-receipts/${encodeURIComponent(receiptId)}/returns`,
    { cache: "no-store" },
  );
  if (!isPurchaseReturnWorkspace(value) || value.receipt.receiptId !== receiptId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "供应商退货内容与所选收货单不一致，系统已停止办理",
    );
  }
  return value;
}

function purchaseReturnLinesMatchRequest(
  result: PurchaseReturnWriteResult,
  input: RecordPurchaseReturnRequest,
): boolean {
  if (result.purchaseReturn.lines.length !== input.lines.length) return false;
  const requested = new Map(
    input.lines.map((line) => [line.receiptLineId, line.returnedBaseQuantity]),
  );
  return result.purchaseReturn.lines.every(
    (line) => requested.get(line.receiptLineId) === line.returnedBaseQuantity,
  );
}

export function purchaseReturnWriteResultMatchesRequest(
  value: unknown,
  input: RecordPurchaseReturnRequest,
  expectedReturnerActorId: string,
): value is PurchaseReturnWriteResult {
  if (!isPurchaseReturnWriteResult(value)) return false;
  const purchaseReturn = value.purchaseReturn;
  return (
    purchaseReturn.returnId === input.returnId &&
    purchaseReturn.receiptId === input.receiptId &&
    purchaseReturn.businessDate === input.businessDate &&
    purchaseReturn.reason === input.reason &&
    purchaseReturn.returnerActorId === expectedReturnerActorId &&
    JSON.stringify(purchaseReturn.operationTrace) === JSON.stringify(input.operationTrace) &&
    purchaseReturnLinesMatchRequest(value, input)
  );
}

export function purchaseReturnOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PURCHASE_RETURN_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (
    error.code === "REQUEST_VALIDATION_FAILED" ||
    error.code === "AUTH_REQUIRED" ||
    error.code === "PURCHASE_RETURN_FORBIDDEN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_")
  ) {
    return false;
  }
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

export async function recordPurchaseReturn(
  requestSnapshot: RecordPurchaseReturnRequest,
  expectedReturnerActorId: string,
): Promise<PurchaseReturnWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordPurchaseReturnRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本次供应商退货内容不完整，系统没有提交；请检查退货数量和原因",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/procurement/purchase-receipts/${encodeURIComponent(input.receiptId)}/returns`,
      {
        method: "POST",
        cache: "no-store",
        body: JSON.stringify(input),
      },
    );
  } catch (error) {
    if (purchaseReturnOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PURCHASE_RETURN_RESULT_UNKNOWN",
        "本次退货可能已在本店完成，但页面尚未确认；请保留原内容并查询原退货结果",
      );
    }
    throw error;
  }
  if (!purchaseReturnWriteResultMatchesRequest(value, input, expectedReturnerActorId)) {
    throw new ApiRequestError(
      "PURCHASE_RETURN_RESULT_UNKNOWN",
      "本次退货可能已在本店完成，但返回结果与原固定命令不一致；请查询原退货结果",
    );
  }
  return value;
}

export async function recoverPurchaseReturn(
  requestSnapshot: RecordPurchaseReturnRequest,
  expectedReturnerActorId: string,
): Promise<PurchaseReturnWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordPurchaseReturnRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原供应商退货命令不完整，无法安全查询原结果",
      400,
    );
  }
  const query = new URLSearchParams({
    receiptId: input.receiptId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/procurement/purchase-returns/${encodeURIComponent(input.returnId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!purchaseReturnWriteResultMatchesRequest(value, input, expectedReturnerActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原退货记录号、收货单或固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function getPurchasePayableWorkspace(
  receiptId: string,
): Promise<PurchasePayableWorkspace> {
  if (!receiptId || receiptId !== receiptId.trim()) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原收货记录号不完整，无法读取采购应付",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-receipts/${encodeURIComponent(receiptId)}/payable`,
    { cache: "no-store" },
  );
  if (!isPurchasePayableWorkspace(value) || value.receipt.receiptId !== receiptId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "采购应付内容与所选收货单不一致，系统已停止办理",
    );
  }
  return value;
}

export async function getPurchasePayableWorkspaceByReceiptNumber(
  receiptNumber: string,
): Promise<PurchasePayableWorkspace> {
  const normalized = receiptNumber.trim().toUpperCase();
  if (!isPurchaseReceiptNumber(normalized)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "收货单号格式不正确，请输入完整的 SH 开头收货单号",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/procurement/purchase-payables/by-receipt-number/${encodeURIComponent(normalized)}`,
    { cache: "no-store" },
  );
  if (!isPurchasePayableWorkspace(value) || value.receipt.receiptNumber !== normalized) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "采购应付内容与输入的收货单号不一致，系统已停止办理",
    );
  }
  return value;
}

function exactWriteEnvelope(
  value: unknown,
  resultKey: "reconciliation" | "payment" | "credit" | "refund" | "reversal",
): value is Record<string, unknown> {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const keys = Object.keys(value);
  return keys.length === 2 && keys.includes(resultKey) && keys.includes("cloudProjectionStatus");
}

function payableProjectionStatus(value: unknown): boolean {
  return value === "PENDING" || value === "SYNCED" || value === "NEEDS_REVIEW";
}

export function purchasePayableReconciliationResultMatchesRequest(
  value: unknown,
  input: ReconcilePurchasePayableRequest,
  expectedActorId: string,
): value is PurchasePayableReconciliationWriteResult {
  if (!exactWriteEnvelope(value, "reconciliation")) return false;
  const reconciliation = value.reconciliation;
  if (!isPurchasePayableReconciliationRecord(reconciliation)) return false;
  return (
    payableProjectionStatus(value.cloudProjectionStatus) &&
    reconciliation.reconciliationId === input.reconciliationId &&
    reconciliation.receiptId === input.receiptId &&
    reconciliation.businessDate === input.businessDate &&
    reconciliation.supplierInvoiceNumber === input.supplierInvoiceNumber &&
    reconciliation.invoiceDate === input.invoiceDate &&
    reconciliation.invoiceSubtotalFen === input.invoiceSubtotalFen &&
    reconciliation.invoiceTaxFen === input.invoiceTaxFen &&
    reconciliation.payableBalanceVersionBefore === input.expectedPayableBalanceVersion &&
    reconciliation.note === input.note &&
    reconciliation.reconcilerActorId === expectedActorId &&
    JSON.stringify(reconciliation.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export function supplierPaymentResultMatchesRequest(
  value: unknown,
  input: RecordSupplierPaymentRequest,
  expectedActorId: string,
): value is SupplierPaymentWriteResult {
  if (!exactWriteEnvelope(value, "payment")) return false;
  const payment = value.payment;
  if (!isSupplierPaymentRecord(payment)) return false;
  return (
    payableProjectionStatus(value.cloudProjectionStatus) &&
    payment.paymentId === input.paymentId &&
    payment.receiptId === input.receiptId &&
    payment.reconciliationId === input.reconciliationId &&
    payment.businessDate === input.businessDate &&
    payment.amountFen === input.amountFen &&
    payment.method === input.method &&
    payment.externalReference === input.externalReference &&
    payment.note === input.note &&
    payment.payableBalanceVersionBefore === input.expectedPayableBalanceVersion &&
    payment.payerActorId === expectedActorId &&
    JSON.stringify(payment.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export function purchasePayableOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PURCHASE_PAYABLE_RESULT_UNKNOWN",
      "SUPPLIER_PAYMENT_RESULT_UNKNOWN",
      "SUPPLIER_BATCH_PAYMENT_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (
    error.code === "REQUEST_VALIDATION_FAILED" ||
    error.code === "AUTH_REQUIRED" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_")
  ) {
    return false;
  }
  return (
    error.statusCode === 408 ||
    error.statusCode === 429 ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

export function supplierBatchPaymentPreviewMatchesRequest(
  value: unknown,
  input: PreviewSupplierBatchPaymentRequest,
): value is SupplierBatchPaymentPreview {
  if (!isSupplierBatchPaymentPreview(value)) return false;
  return (
    value.supplierId === input.supplierId &&
    value.businessDate === input.businessDate &&
    value.amountFen === input.amountFen &&
    value.method === input.method &&
    value.externalReference === input.externalReference &&
    value.note === input.note
  );
}

export async function previewSupplierBatchPayment(
  requestSnapshot: PreviewSupplierBatchPaymentRequest,
): Promise<SupplierBatchPaymentPreview> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewSupplierBatchPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "合并付款预览内容不完整，请核对供应商、金额、方式和外部凭证",
      400,
    );
  }
  const value = await request<unknown>("/v1/purchase-payables/supplier-batch-payments/preview", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  if (!supplierBatchPaymentPreviewMatchesRequest(value, input)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "合并付款预览与当前输入不一致，系统没有开放提交，请重新预览",
    );
  }
  return value;
}

function supplierBatchPaymentWriteResultMatchesRequest(
  value: unknown,
  input: RecordSupplierBatchPaymentRequest,
  expectedActorId: string,
): value is SupplierBatchPaymentWriteResult {
  if (!exactWriteEnvelope(value, "payment")) return false;
  const payment = value.payment;
  if (!isSupplierBatchPaymentRecord(payment)) return false;
  return (
    payableProjectionStatus(value.cloudProjectionStatus) &&
    payment.paymentId === input.paymentId &&
    payment.supplierId === input.supplierId &&
    payment.businessDate === input.businessDate &&
    payment.amountFen === input.amountFen &&
    payment.method === input.method &&
    payment.externalReference === input.externalReference &&
    payment.note === input.note &&
    payment.sourceReferenceSha256 === input.sourceReferenceSha256 &&
    payment.businessFactSha256 === input.businessFactSha256 &&
    payment.payerActorId === expectedActorId &&
    JSON.stringify(payment.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export async function recordSupplierBatchPayment(
  requestSnapshot: RecordSupplierBatchPaymentRequest,
  expectedActorId: string,
): Promise<SupplierBatchPaymentWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierBatchPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "合并付款登记内容不完整，系统没有提交",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>("/v1/purchase-payables/supplier-batch-payments", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
  } catch (error) {
    if (purchasePayableOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "SUPPLIER_BATCH_PAYMENT_RESULT_UNKNOWN",
        "合并付款登记可能已完成，请只查询原付款记录，不要重复登记",
      );
    }
    throw error;
  }
  if (!supplierBatchPaymentWriteResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "SUPPLIER_BATCH_PAYMENT_RESULT_UNKNOWN",
      "合并付款返回结果与原固定命令不一致，请只查询原结果",
    );
  }
  return value;
}

export async function recoverSupplierBatchPayment(
  requestSnapshot: RecordSupplierBatchPaymentRequest,
  expectedActorId: string,
): Promise<SupplierBatchPaymentWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierBatchPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原合并付款命令不完整，无法安全查询",
      400,
    );
  }
  const query = new URLSearchParams({
    supplierId: input.supplierId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/purchase-payables/supplier-batch-payments/${encodeURIComponent(input.paymentId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!supplierBatchPaymentWriteResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原合并付款固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function reconcilePurchasePayable(
  requestSnapshot: ReconcilePurchasePayableRequest,
  expectedActorId: string,
): Promise<PurchasePayableReconciliationWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isReconcilePurchasePayableRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商发票对账内容不完整，系统没有提交",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/procurement/purchase-receipts/${encodeURIComponent(input.receiptId)}/payable/reconciliations`,
      { method: "POST", cache: "no-store", body: JSON.stringify(input) },
    );
  } catch (error) {
    if (purchasePayableOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PURCHASE_PAYABLE_RESULT_UNKNOWN",
        "发票对账可能已完成，请查询原固定命令，不要重复提交",
      );
    }
    throw error;
  }
  if (!purchasePayableReconciliationResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "PURCHASE_PAYABLE_RESULT_UNKNOWN",
      "发票对账返回结果与原固定命令不一致，请查询原结果",
    );
  }
  return value;
}

export async function recoverPurchasePayableReconciliation(
  inputSnapshot: ReconcilePurchasePayableRequest,
  expectedActorId: string,
): Promise<PurchasePayableReconciliationWriteResult> {
  const input = structuredClone(inputSnapshot);
  if (!isReconcilePurchasePayableRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原发票对账命令不完整，无法安全查询",
      400,
    );
  }
  const query = new URLSearchParams({ idempotencyKey: input.idempotencyKey });
  const value = await request<unknown>(
    `/v1/procurement/purchase-receipts/${encodeURIComponent(input.receiptId)}/payable/reconciliations/${encodeURIComponent(input.reconciliationId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!purchasePayableReconciliationResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原发票对账固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function recordSupplierPayment(
  requestSnapshot: RecordSupplierPaymentRequest,
  expectedActorId: string,
): Promise<SupplierPaymentWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商付款登记内容不完整，系统没有提交",
      400,
    );
  }
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/procurement/purchase-receipts/${encodeURIComponent(input.receiptId)}/payable/payments`,
      { method: "POST", cache: "no-store", body: JSON.stringify(input) },
    );
  } catch (error) {
    if (purchasePayableOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "SUPPLIER_PAYMENT_RESULT_UNKNOWN",
        "付款登记可能已完成，请查询原固定命令，不要重复登记",
      );
    }
    throw error;
  }
  if (!supplierPaymentResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "SUPPLIER_PAYMENT_RESULT_UNKNOWN",
      "付款登记返回结果与原固定命令不一致，请查询原结果",
    );
  }
  return value;
}

export async function recoverSupplierPayment(
  inputSnapshot: RecordSupplierPaymentRequest,
  expectedActorId: string,
): Promise<SupplierPaymentWriteResult> {
  const input = structuredClone(inputSnapshot);
  if (!isRecordSupplierPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原付款登记命令不完整，无法安全查询",
      400,
    );
  }
  const query = new URLSearchParams({
    reconciliationId: input.reconciliationId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/procurement/purchase-receipts/${encodeURIComponent(input.receiptId)}/payable/payments/${encodeURIComponent(input.paymentId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!supplierPaymentResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原付款登记固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

function supplierCreditSettlementWorkspaceMatchesReceipt(
  value: unknown,
  receiptId: string,
): value is SupplierCreditSettlementWorkspace {
  let validWorkspace = false;
  try {
    validWorkspace = isSupplierCreditSettlementWorkspace(value);
  } catch {
    return false;
  }
  if (!validWorkspace) return false;
  const workspace = value as SupplierCreditSettlementWorkspace;
  if (workspace.receipt.receiptId !== receiptId) {
    return false;
  }
  const reconciliationId = workspace.reconciliation.reconciliationId;
  return (
    workspace.reconciliation.receiptId === receiptId &&
    workspace.payments.every(
      (item) => item.receiptId === receiptId && item.reconciliationId === reconciliationId,
    ) &&
    workspace.credits.every(
      (item) => item.receiptId === receiptId && item.reconciliationId === reconciliationId,
    ) &&
    workspace.refunds.every(
      (item) => item.receiptId === receiptId && item.reconciliationId === reconciliationId,
    ) &&
    workspace.paymentReversals.every(
      (item) => item.receiptId === receiptId && item.reconciliationId === reconciliationId,
    )
  );
}

export async function fetchSupplierCreditSettlementWorkspace(
  receiptId: string,
): Promise<SupplierCreditSettlementWorkspace> {
  if (!receiptId || receiptId !== receiptId.trim()) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原收货记录号不完整，无法读取供应商贷项与退款处理页面",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/purchase-payables/${encodeURIComponent(receiptId)}/settlement`,
    { cache: "no-store" },
  );
  if (!supplierCreditSettlementWorkspaceMatchesReceipt(value, receiptId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "供应商贷项与退款工作区和所选收货单不一致，系统已停止办理",
    );
  }
  return value;
}

export function supplierCreditResultMatchesRequest(
  value: unknown,
  input: RecordSupplierCreditRequest,
  expectedActorId: string,
): value is SupplierCreditWriteResult {
  if (!exactWriteEnvelope(value, "credit")) return false;
  try {
    if (!isSupplierCreditRecord(value.credit)) return false;
  } catch {
    return false;
  }
  const credit = value.credit;
  const inputLineById = new Map(input.lines.map((line) => [line.receiptLineId, line]));
  return (
    payableProjectionStatus(value.cloudProjectionStatus) &&
    credit.creditId === input.creditId &&
    credit.receiptId === input.receiptId &&
    credit.reconciliationId === input.reconciliationId &&
    credit.businessDate === input.businessDate &&
    credit.supplierCreditNoteNumber === input.supplierCreditNoteNumber &&
    credit.creditNoteDate === input.creditNoteDate &&
    credit.reason === input.reason &&
    credit.payableBalanceVersionBefore === input.expectedPayableBalanceVersion &&
    credit.creditorActorId === expectedActorId &&
    credit.lines.length === input.lines.length &&
    credit.lines.every((line) => {
      const requested = inputLineById.get(line.receiptLineId);
      return (
        requested !== undefined &&
        line.returnedBaseQuantity === requested.returnedBaseQuantity &&
        line.creditSubtotalFen === requested.creditSubtotalFen &&
        line.creditTaxFen === requested.creditTaxFen
      );
    }) &&
    JSON.stringify(credit.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export function supplierRefundResultMatchesRequest(
  value: unknown,
  input: RecordSupplierRefundRequest,
  expectedActorId: string,
): value is SupplierRefundWriteResult {
  if (!exactWriteEnvelope(value, "refund")) return false;
  try {
    if (!isSupplierRefundRecord(value.refund)) return false;
  } catch {
    return false;
  }
  const refund = value.refund;
  return (
    payableProjectionStatus(value.cloudProjectionStatus) &&
    refund.refundId === input.refundId &&
    refund.receiptId === input.receiptId &&
    refund.reconciliationId === input.reconciliationId &&
    refund.businessDate === input.businessDate &&
    refund.amountFen === input.amountFen &&
    refund.method === input.method &&
    refund.externalReference === input.externalReference &&
    refund.note === input.note &&
    refund.payableBalanceVersionBefore === input.expectedPayableBalanceVersion &&
    refund.receiverActorId === expectedActorId &&
    JSON.stringify(refund.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export function supplierPaymentReversalResultMatchesRequest(
  value: unknown,
  input: ReverseSupplierPaymentRequest,
  expectedActorId: string,
): value is SupplierPaymentReversalWriteResult {
  if (!exactWriteEnvelope(value, "reversal")) return false;
  try {
    if (!isSupplierPaymentReversalRecord(value.reversal)) return false;
  } catch {
    return false;
  }
  const reversal = value.reversal;
  return (
    payableProjectionStatus(value.cloudProjectionStatus) &&
    reversal.reversalId === input.reversalId &&
    reversal.receiptId === input.receiptId &&
    reversal.reconciliationId === input.reconciliationId &&
    reversal.paymentId === input.paymentId &&
    reversal.businessDate === input.businessDate &&
    reversal.reason === input.reason &&
    reversal.payableBalanceVersionBefore === input.expectedPayableBalanceVersion &&
    reversal.reverserActorId === expectedActorId &&
    JSON.stringify(reversal.operationTrace) === JSON.stringify(input.operationTrace)
  );
}

export function supplierCreditSettlementOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "SUPPLIER_CREDIT_RESULT_UNKNOWN",
      "SUPPLIER_REFUND_RESULT_UNKNOWN",
      "SUPPLIER_PAYMENT_REVERSAL_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (error.statusCode === 408 || error.statusCode === 429) return true;
  if (error.statusCode !== undefined) return error.statusCode >= 500;
  return false;
}

async function postSupplierSettlementCommand<TRequest, TResult>(
  input: TRequest,
  route: string,
  expectedActorId: string,
  matches: (value: unknown, request: TRequest, actorId: string) => value is TResult,
  resultUnknownCode: string,
  unknownMessage: string,
): Promise<TResult> {
  let value: unknown;
  try {
    value = await request<unknown>(route, {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
  } catch (error) {
    if (supplierCreditSettlementOutcomeIsUnknown(error)) {
      throw new ApiRequestError(resultUnknownCode, unknownMessage);
    }
    throw error;
  }
  if (!matches(value, input, expectedActorId)) {
    throw new ApiRequestError(resultUnknownCode, unknownMessage);
  }
  return value;
}

export async function recordSupplierCredit(
  requestSnapshot: RecordSupplierCreditRequest,
  expectedActorId: string,
): Promise<SupplierCreditWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierCreditRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商贷项内容不完整，系统没有提交",
      400,
    );
  }
  return postSupplierSettlementCommand(
    input,
    `/v1/purchase-payables/${encodeURIComponent(input.receiptId)}/supplier-credits`,
    expectedActorId,
    supplierCreditResultMatchesRequest,
    "SUPPLIER_CREDIT_RESULT_UNKNOWN",
    "供应商贷项可能已经登记，请按原固定命令查询，不要重复提交",
  );
}

export async function recoverSupplierCredit(
  requestSnapshot: RecordSupplierCreditRequest,
  expectedActorId: string,
): Promise<SupplierCreditWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierCreditRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原供应商贷项命令不完整，无法安全查询",
      400,
    );
  }
  const query = new URLSearchParams({
    reconciliationId: input.reconciliationId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/purchase-payables/${encodeURIComponent(input.receiptId)}/supplier-credits/${encodeURIComponent(input.creditId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!supplierCreditResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原供应商贷项固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function recordSupplierRefund(
  requestSnapshot: RecordSupplierRefundRequest,
  expectedActorId: string,
): Promise<SupplierRefundWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierRefundRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商退款登记内容不完整，系统没有提交",
      400,
    );
  }
  return postSupplierSettlementCommand(
    input,
    `/v1/purchase-payables/${encodeURIComponent(input.receiptId)}/supplier-refunds`,
    expectedActorId,
    supplierRefundResultMatchesRequest,
    "SUPPLIER_REFUND_RESULT_UNKNOWN",
    "供应商退款可能已经登记，请按原固定命令查询，不要重复提交",
  );
}

export async function recoverSupplierRefund(
  requestSnapshot: RecordSupplierRefundRequest,
  expectedActorId: string,
): Promise<SupplierRefundWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isRecordSupplierRefundRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原供应商退款命令不完整，无法安全查询",
      400,
    );
  }
  const query = new URLSearchParams({
    reconciliationId: input.reconciliationId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/purchase-payables/${encodeURIComponent(input.receiptId)}/supplier-refunds/${encodeURIComponent(input.refundId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!supplierRefundResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原供应商退款固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function reverseSupplierPayment(
  requestSnapshot: ReverseSupplierPaymentRequest,
  expectedActorId: string,
): Promise<SupplierPaymentReversalWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isReverseSupplierPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "供应商付款冲销内容不完整，系统没有提交",
      400,
    );
  }
  return postSupplierSettlementCommand(
    input,
    `/v1/purchase-payables/${encodeURIComponent(input.receiptId)}/supplier-payment-reversals`,
    expectedActorId,
    supplierPaymentReversalResultMatchesRequest,
    "SUPPLIER_PAYMENT_REVERSAL_RESULT_UNKNOWN",
    "供应商付款冲销可能已经完成，请按原固定命令查询，不要重复提交",
  );
}

export async function recoverSupplierPaymentReversal(
  requestSnapshot: ReverseSupplierPaymentRequest,
  expectedActorId: string,
): Promise<SupplierPaymentReversalWriteResult> {
  const input = structuredClone(requestSnapshot);
  if (!isReverseSupplierPaymentRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原供应商付款冲销命令不完整，无法安全查询",
      400,
    );
  }
  const query = new URLSearchParams({
    reconciliationId: input.reconciliationId,
    paymentId: input.paymentId,
    idempotencyKey: input.idempotencyKey,
  });
  const value = await request<unknown>(
    `/v1/purchase-payables/${encodeURIComponent(input.receiptId)}/supplier-payment-reversals/${encodeURIComponent(input.reversalId)}?${query.toString()}`,
    { cache: "no-store" },
  );
  if (!supplierPaymentReversalResultMatchesRequest(value, input, expectedActorId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原供应商付款冲销固定命令不一致，系统继续保留原请求",
    );
  }
  return value;
}

const groupBuyOnlineRedemptionCapabilityKeys = [
  "provider",
  "enabled",
  "validate",
  "redeem",
  "query",
  "revoke",
  "evidence",
] as const;

function isGroupBuyOnlineRedemptionCapability(
  value: unknown,
): value is GroupBuyOnlineRedemptionCapability {
  if (value === null || typeof value !== "object" || Array.isArray(value)) return false;
  const capability = value as Record<string, unknown>;
  return (
    Object.keys(capability).length === groupBuyOnlineRedemptionCapabilityKeys.length &&
    groupBuyOnlineRedemptionCapabilityKeys.every((key) => Object.hasOwn(capability, key)) &&
    (capability.provider === "MEITUAN" || capability.provider === "DOUYIN") &&
    typeof capability.enabled === "boolean" &&
    typeof capability.validate === "boolean" &&
    typeof capability.redeem === "boolean" &&
    typeof capability.query === "boolean" &&
    typeof capability.revoke === "boolean" &&
    (capability.evidence === "NOT_VERIFIED" ||
      capability.evidence === "SANDBOX" ||
      capability.evidence === "STORE_ACCEPTED")
  );
}

function isGroupBuyOnlineRedemptionCapabilityList(
  value: unknown,
): value is GroupBuyOnlineRedemptionCapability[] {
  if (!Array.isArray(value) || !value.every(isGroupBuyOnlineRedemptionCapability)) return false;
  return new Set(value.map((capability) => capability.provider)).size === value.length;
}

function groupBuyOnlineRedemptionRecordMatchesStart(
  value: unknown,
  input: StartGroupBuyOnlineRedemptionRequest,
  expectedActorId: string,
): value is GroupBuyOnlineRedemptionRecord {
  if (!isGroupBuyOnlineRedemptionRecord(value)) return false;
  return (
    value.redemptionId === input.redemptionId &&
    value.tableId === input.tableId &&
    value.expectedTableRevision === input.expectedTableRevision &&
    value.channelSnapshot.id === input.channelId &&
    value.channelSnapshot.version === input.expectedChannelVersion &&
    value.packageSnapshot.id === input.packageId &&
    value.packageSnapshot.version === input.expectedPackageVersion &&
    value.customerRequestId === (input.customerRequestId ?? null) &&
    value.note === input.note.trim() &&
    value.actorId === expectedActorId &&
    groupBuyOnlineOperatorDecisionMatchesRequest(value, input)
  );
}

export type GroupBuyOnlineRedemptionFrozenIntent = Omit<
  StartGroupBuyOnlineRedemptionRequest,
  "voucherCode"
>;

function groupBuyOnlineOperatorInputIsCanonical(
  input: Pick<StartGroupBuyOnlineRedemptionRequest, "operatorMode" | "takeoverReason">,
): boolean {
  if (input.operatorMode === undefined) return input.takeoverReason === undefined;
  if (input.operatorMode === "CASHIER_CONFIRMATION") {
    return input.takeoverReason === undefined || input.takeoverReason === null;
  }
  return typeof input.takeoverReason === "string";
}

function groupBuyOnlineOperatorDecisionMatchesRequest(
  record: GroupBuyOnlineRedemptionRecord,
  input: Pick<StartGroupBuyOnlineRedemptionRequest, "operatorMode" | "takeoverReason">,
): boolean {
  if (!groupBuyOnlineOperatorInputIsCanonical(input)) return false;
  if (input.operatorMode === undefined) {
    return (
      (record.contractVersion === "1.0.0" && record.operatorDecision === undefined) ||
      (record.contractVersion === "1.1.0" &&
        record.operatorDecision?.mode === "CASHIER_CONFIRMATION" &&
        record.operatorDecision.reason === null)
    );
  }
  if (record.contractVersion !== "1.1.0" || record.operatorDecision === undefined) return false;
  const expectedReason = input.takeoverReason ?? null;
  return (
    record.operatorDecision.mode === input.operatorMode &&
    record.operatorDecision.reason === expectedReason
  );
}

function groupBuyOnlineRedemptionRecordMatchesFrozenIntent(
  value: unknown,
  intent: GroupBuyOnlineRedemptionFrozenIntent,
  expectedActorId: string,
  frozenOperatorDecision?: NonNullable<GroupBuyOnlineRedemptionRecord["operatorDecision"]>,
): value is GroupBuyOnlineRedemptionRecord {
  return (
    isStartGroupBuyOnlineRedemptionRequest({ ...intent, voucherCode: "SCAN" }) &&
    groupBuyOnlineOperatorInputIsCanonical(intent) &&
    groupBuyOnlineRedemptionRecordMatchesStart(
      value,
      { ...intent, voucherCode: "SCAN" },
      expectedActorId,
    ) &&
    (frozenOperatorDecision === undefined ||
      JSON.stringify(value.operatorDecision) === JSON.stringify(frozenOperatorDecision))
  );
}

function groupBuyVoucherCodeSuffix(value: string): string {
  const normalized = value.normalize("NFKC").replace(/\s+/gu, "").toUpperCase();
  return [...normalized].slice(-4).join("");
}

function groupBuyOfflinePrecheckRecordMatchesRequest(
  value: unknown,
  input: StartGroupBuyOnlineRedemptionRequest,
  expectedActorId: string,
): value is GroupBuyOnlineRedemptionRecord {
  return (
    groupBuyOnlineRedemptionRecordMatchesStart(value, input, expectedActorId) &&
    value.voucherCodeSuffix === groupBuyVoucherCodeSuffix(input.voucherCode) &&
    value.entryMode === "OFFLINE_PRECHECK" &&
    value.status === "PREPARED" &&
    value.providerStatus === "NOT_CALLED" &&
    value.providerReference === null &&
    value.providerEvidence === null &&
    value.sessionId === null &&
    value.orderId === null &&
    value.orderNumber === null &&
    value.fulfillmentId === null &&
    value.reviewWorkItemId === null &&
    value.failureCode === null &&
    value.failureMessage === null
  );
}

function groupBuyOnlineRedemptionRecordMatchesIdentity(
  value: unknown,
  redemptionId: string,
  expectedActorId: string,
): value is GroupBuyOnlineRedemptionRecord {
  return (
    isGroupBuyOnlineRedemptionRecord(value) &&
    value.redemptionId === redemptionId &&
    value.actorId === expectedActorId
  );
}

function isSafeGroupBuyRedemptionId(value: string): boolean {
  return /^[A-Za-z0-9][A-Za-z0-9._:-]{11,127}$/u.test(value);
}

const groupBuyOnlineRedemptionDefiniteNoEffectCodes = new Set([
  "AUTH_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_FACTS_NOT_TRUSTED",
  "CLOUD_COORDINATOR_UNAVAILABLE",
  "CSRF_REJECTED",
  "GROUP_BUY_CASHIER_CONFIRMATION_REQUIRED",
  "GROUP_BUY_MANAGER_TAKEOVER_CASHIER_AVAILABLE",
  "GROUP_BUY_MANAGER_TAKEOVER_REASON_REQUIRED",
  "GROUP_BUY_MANUAL_ROLE_MISMATCH",
  "GROUP_BUY_OPEN_CASH_SHIFT_REQUIRED",
  "GROUP_BUY_OWNER_EXCEPTION_REASON_REQUIRED",
  "GROUP_BUY_WORKFORCE_FACTS_UNAVAILABLE",
  "MOBILE_SESSION_ACTIVATION_REQUIRED",
  "NATIVE_APP_VERSION_INVALID",
  "NATIVE_APP_VERSION_MISMATCH",
  "NATIVE_APP_VERSION_REQUIRED",
  "NATIVE_SECURE_SESSION_UNAVAILABLE",
  "NATIVE_SERVER_UPDATE_REQUIRED",
  "NATIVE_UPDATE_REQUIRED",
  "OFFLINE_AUTHORITY_UNAVAILABLE",
  "ONLINE_SERVICE_REQUIRED",
  "ORIGIN_REJECTED",
  "REQUEST_VALIDATION_FAILED",
]);

export function groupBuyOnlineRedemptionOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  if (groupBuyOnlineRedemptionDefiniteNoEffectCodes.has(error.code)) return false;
  if (
    [
      "GROUP_BUY_BUSINESS_DATE_CHANGED",
      "GROUP_BUY_CASH_SHIFT_CHANGED",
      "GROUP_BUY_LEGACY_OPERATOR_DECISION_REQUIRED",
      "GROUP_BUY_ONLINE_REDEMPTION_RESULT_UNKNOWN",
      "GROUP_BUY_OPERATING_CONFIGURATION_CHANGED",
      "GROUP_BUY_TABLE_PRECONDITION_CHANGED",
      "GROUP_BUY_WORKFORCE_DECISION_CHANGED",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  return (
    error.statusCode === 408 ||
    error.statusCode === undefined ||
    (error.statusCode >= 500 && error.statusCode <= 599)
  );
}

function groupBuyOfflinePrecheckOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  if (groupBuyOnlineRedemptionDefiniteNoEffectCodes.has(error.code)) return false;
  if (
    [
      "GROUP_BUY_OFFLINE_PRECHECK_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (error.statusCode !== undefined && error.statusCode >= 400 && error.statusCode <= 499) {
    return false;
  }
  return error.statusCode === undefined || error.statusCode >= 500;
}

export async function listGroupBuyOnlineRedemptionCapabilities(): Promise<
  GroupBuyOnlineRedemptionCapability[]
> {
  const value = await request<unknown>("/v1/group-buy/online-redemption-capabilities", {
    cache: "no-store",
  });
  if (!isGroupBuyOnlineRedemptionCapabilityList(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "在线团购核销能力无法安全确认");
  }
  return value;
}

export async function listCustomerGroupBuyRequests(): Promise<CustomerGroupBuyRequestReadModel[]> {
  const value = await request<unknown>("/v1/group-buy/customer-requests", {
    cache: "no-store",
  });
  if (
    !Array.isArray(value) ||
    value.length > 100 ||
    !value.every(isCustomerGroupBuyRequestReadModel) ||
    new Set(value.map((item) => item.requestId)).size !== value.length
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "顾客团购请求清单无法安全确认，页面已停止显示旧内容",
    );
  }
  return value;
}

export async function startGroupBuyOnlineRedemption(
  requestSnapshot: StartGroupBuyOnlineRedemptionRequest,
  expectedActorId: string,
): Promise<GroupBuyOnlineRedemptionRecord> {
  const input = structuredClone(requestSnapshot);
  if (
    !isStartGroupBuyOnlineRedemptionRequest(input) ||
    !groupBuyOnlineOperatorInputIsCanonical(input)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "在线团购核销内容不完整，系统没有提交",
      400,
    );
  }
  try {
    const value = await request<unknown>("/v1/group-buy/online-redemptions", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
    if (!groupBuyOnlineRedemptionRecordMatchesStart(value, input, expectedActorId)) {
      throw new ApiRequestError(
        "GROUP_BUY_ONLINE_REDEMPTION_RESULT_UNKNOWN",
        "在线团购核销可能已经开始，请先查询原核销记录，不要重新提交",
      );
    }
    return value;
  } catch (error) {
    if (!groupBuyOnlineRedemptionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_ONLINE_REDEMPTION_RESULT_UNKNOWN",
      "在线团购核销结果暂时无法确认，请先查询原核销记录，不要重新提交",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function createGroupBuyOfflinePrecheck(
  requestSnapshot: StartGroupBuyOnlineRedemptionRequest,
  expectedActorId: string,
): Promise<GroupBuyOnlineRedemptionRecord> {
  const input = structuredClone(requestSnapshot);
  if (
    !isStartGroupBuyOnlineRedemptionRequest(input) ||
    !groupBuyOnlineOperatorInputIsCanonical(input)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "团购券离线预检内容不完整，系统没有提交",
      400,
    );
  }
  try {
    const value = await request<unknown>("/v1/group-buy/offline-prechecks", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
    if (!groupBuyOfflinePrecheckRecordMatchesRequest(value, input, expectedActorId)) {
      throw new ApiRequestError(
        "GROUP_BUY_OFFLINE_PRECHECK_RESULT_UNKNOWN",
        "团购券离线预检结果无法安全确认，请查询原核销记录，不要重新提交",
      );
    }
    return value;
  } catch (error) {
    if (!groupBuyOfflinePrecheckOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_OFFLINE_PRECHECK_RESULT_UNKNOWN",
      "团购券离线预检结果暂时无法确认，请查询原核销记录，不要重新提交",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function getGroupBuyOnlineRedemption(
  redemptionId: string,
  expectedActorId: string,
  frozenIntent?: GroupBuyOnlineRedemptionFrozenIntent,
  frozenOperatorDecision?: NonNullable<GroupBuyOnlineRedemptionRecord["operatorDecision"]>,
): Promise<GroupBuyOnlineRedemptionRecord> {
  if (
    !isSafeGroupBuyRedemptionId(redemptionId) ||
    (frozenOperatorDecision !== undefined && frozenIntent === undefined) ||
    (frozenIntent !== undefined &&
      (!isStartGroupBuyOnlineRedemptionRequest({ ...frozenIntent, voucherCode: "SCAN" }) ||
        !groupBuyOnlineOperatorInputIsCanonical(frozenIntent) ||
        frozenIntent.redemptionId !== redemptionId))
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原在线团购核销记录号不完整，无法安全查询",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/group-buy/online-redemptions/${encodeURIComponent(redemptionId)}`,
    { cache: "no-store" },
  );
  if (
    !groupBuyOnlineRedemptionRecordMatchesIdentity(value, redemptionId, expectedActorId) ||
    (frozenIntent !== undefined &&
      !groupBuyOnlineRedemptionRecordMatchesFrozenIntent(
        value,
        frozenIntent,
        expectedActorId,
        frozenOperatorDecision,
      ))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "查询结果与原在线团购核销记录不一致，系统继续保留原请求",
    );
  }
  return value;
}

export async function resumeGroupBuyOnlineRedemption(
  redemptionId: string,
  requestSnapshot: ResumeGroupBuyOnlineRedemptionRequest,
  expectedActorId: string,
  frozenIntent?: GroupBuyOnlineRedemptionFrozenIntent,
  frozenOperatorDecision?: NonNullable<GroupBuyOnlineRedemptionRecord["operatorDecision"]>,
): Promise<GroupBuyOnlineRedemptionRecord> {
  const input = structuredClone(requestSnapshot);
  if (
    !isSafeGroupBuyRedemptionId(redemptionId) ||
    !isResumeGroupBuyOnlineRedemptionRequest(input) ||
    (frozenOperatorDecision !== undefined && frozenIntent === undefined) ||
    (frozenIntent !== undefined &&
      (!isStartGroupBuyOnlineRedemptionRequest({ ...frozenIntent, voucherCode: "SCAN" }) ||
        !groupBuyOnlineOperatorInputIsCanonical(frozenIntent) ||
        frozenIntent.redemptionId !== redemptionId))
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "复扫券码或原核销记录不完整，系统没有提交",
      400,
    );
  }
  try {
    const value = await request<unknown>(
      `/v1/group-buy/online-redemptions/${encodeURIComponent(redemptionId)}/resume`,
      {
        method: "POST",
        cache: "no-store",
        body: JSON.stringify(input),
      },
    );
    if (
      !groupBuyOnlineRedemptionRecordMatchesIdentity(value, redemptionId, expectedActorId) ||
      (frozenIntent !== undefined &&
        !groupBuyOnlineRedemptionRecordMatchesFrozenIntent(
          value,
          frozenIntent,
          expectedActorId,
          frozenOperatorDecision,
        ))
    ) {
      throw new ApiRequestError(
        "GROUP_BUY_ONLINE_REDEMPTION_RESULT_UNKNOWN",
        "复扫后的核销结果无法确认，请重新查询原核销记录",
      );
    }
    return value;
  } catch (error) {
    if (!groupBuyOnlineRedemptionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_ONLINE_REDEMPTION_RESULT_UNKNOWN",
      "复扫后的核销结果暂时无法确认，请重新查询原核销记录",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

function groupBuyStatementLinesMatch(
  left: PreviewGroupBuyDailyReconciliationRequest["statementLines"],
  right: PreviewGroupBuyDailyReconciliationRequest["statementLines"],
): boolean {
  return (
    left.length === right.length &&
    left.every((line, index) => {
      const candidate = right[index];
      return (
        candidate !== undefined &&
        line.lineNumber === candidate.lineNumber &&
        line.platformReference === candidate.platformReference &&
        line.actualSettlementFen === candidate.actualSettlementFen &&
        line.actualFeeFen === candidate.actualFeeFen &&
        line.actualSubsidyFen === candidate.actualSubsidyFen
      );
    })
  );
}

function groupBuyDailyReconciliationPreviewMatchesRequest(
  value: unknown,
  input: PreviewGroupBuyDailyReconciliationRequest,
): value is GroupBuyDailyReconciliationPreview {
  return (
    isGroupBuyDailyReconciliationPreview(value) &&
    value.reconciliationId === input.reconciliationId &&
    value.businessDate === input.businessDate &&
    value.provider === input.provider &&
    value.statementReference === input.statementReference &&
    groupBuyStatementLinesMatch(value.statementLines, input.statementLines) &&
    value.note === input.note
  );
}

function groupBuyDailyReconciliationTraceMatchesCommand(
  snapshot: Extract<
    ApprovalRequestReadModel["snapshot"],
    { kind: "GROUP_BUY_DAILY_RECONCILIATION" }
  >,
  input: CreateGroupBuyDailyReconciliationApprovalCommand,
): boolean {
  const expected = input.operationTrace;
  const actual = snapshot.operationTrace;
  return (
    actual.contractVersion === expected.contractVersion &&
    actual.commandId === expected.commandId &&
    actual.correlationId === expected.correlationId &&
    actual.causationId === expected.causationId &&
    actual.idempotencyKey === expected.idempotencyKey &&
    actual.businessNumber?.kind === expected.businessNumber?.kind &&
    actual.businessNumber?.value === expected.businessNumber?.value
  );
}

function groupBuyDailyReconciliationApprovalMatchesCommand(
  value: unknown,
  input: CreateGroupBuyDailyReconciliationApprovalCommand,
): value is ApprovalRequestReadModel {
  if (!isApprovalRequestReadModel(value)) return false;
  const snapshot = value.snapshot;
  return (
    snapshot.kind === "GROUP_BUY_DAILY_RECONCILIATION" &&
    snapshot.reconciliationId === input.reconciliationId &&
    snapshot.reconciliationNumber === input.operationTrace.businessNumber?.value &&
    snapshot.businessDate === input.businessDate &&
    snapshot.provider === input.provider &&
    snapshot.statementReference === input.statementReference &&
    groupBuyStatementLinesMatch(snapshot.statementLines, input.statementLines) &&
    snapshot.note === input.note &&
    snapshot.sourceReferenceSha256 === input.sourceReferenceSha256 &&
    snapshot.businessFactSha256 === input.businessFactSha256 &&
    groupBuyDailyReconciliationTraceMatchesCommand(snapshot, input) &&
    snapshot.orderEffect === "NONE" &&
    snapshot.inventoryEffect === "NONE" &&
    snapshot.memberBalanceEffect === "NONE" &&
    snapshot.moneyLedgerEffect === "NONE" &&
    value.policy.resource === "ORDER" &&
    value.policy.action === "RECONCILE_GROUP_BUY" &&
    value.policy.requirement === "MANAGER_OR_OWNER" &&
    value.policy.effect === "MANAGER_OR_OWNER_APPROVAL"
  );
}

const groupBuyDailyReconciliationDefiniteNoEffectCodes = new Set([
  "AUTH_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_FACTS_NOT_TRUSTED",
  "CSRF_REJECTED",
  "MOBILE_SESSION_ACTIVATION_REQUIRED",
  "NATIVE_APP_VERSION_INVALID",
  "NATIVE_APP_VERSION_MISMATCH",
  "NATIVE_APP_VERSION_REQUIRED",
  "NATIVE_SECURE_SESSION_UNAVAILABLE",
  "NATIVE_SERVER_UPDATE_REQUIRED",
  "NATIVE_UPDATE_REQUIRED",
  "OFFLINE_AUTHORITY_UNAVAILABLE",
  "ONLINE_SERVICE_REQUIRED",
  "ORIGIN_REJECTED",
  "REQUEST_VALIDATION_FAILED",
]);

function groupBuyDailyReconciliationOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  if (groupBuyDailyReconciliationDefiniteNoEffectCodes.has(error.code)) return false;
  if (
    [
      "GROUP_BUY_DAILY_RECONCILIATION_PREVIEW_RESULT_UNKNOWN",
      "GROUP_BUY_DAILY_RECONCILIATION_APPROVAL_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (error.statusCode !== undefined && error.statusCode >= 400 && error.statusCode <= 499) {
    return false;
  }
  return error.statusCode === undefined || error.statusCode >= 500;
}

export async function previewGroupBuyDailyReconciliation(
  requestSnapshot: PreviewGroupBuyDailyReconciliationRequest,
): Promise<GroupBuyDailyReconciliationPreview> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewGroupBuyDailyReconciliationRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "团购日结单内容不完整，请核对营业日、平台、日结单名称和每一行金额",
      400,
    );
  }
  try {
    const value = await request<unknown>("/v1/group-buy/daily-reconciliations/preview", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
    if (!groupBuyDailyReconciliationPreviewMatchesRequest(value, input)) {
      throw new ApiRequestError(
        "GROUP_BUY_DAILY_RECONCILIATION_PREVIEW_RESULT_UNKNOWN",
        "团购日结单检查结果无法与当前内容对应，请勿提交审批",
      );
    }
    return value;
  } catch (error) {
    if (!groupBuyDailyReconciliationOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_DAILY_RECONCILIATION_PREVIEW_RESULT_UNKNOWN",
      "团购日结单检查结果暂时无法确认，请保留当前内容并重新检查",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function createGroupBuyDailyReconciliationApproval(
  requestSnapshot: CreateGroupBuyDailyReconciliationApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateGroupBuyDailyReconciliationApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "团购日对账审批内容不完整，请重新检查日结单、核对结果和业务单号",
      400,
    );
  }
  let receiptAccepted = false;
  try {
    const value = await request<unknown>("/v1/group-buy/daily-reconciliations/approval-requests", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
    if (!groupBuyDailyReconciliationApprovalMatchesCommand(value, input)) {
      throw new ApiRequestError(
        "GROUP_BUY_DAILY_RECONCILIATION_APPROVAL_RESULT_UNKNOWN",
        "团购日对账审批申请结果无法安全确认，请保留原请求并查询统一审批中心",
      );
    }
    receiptAccepted = true;
    const authoritative = await getApproval(value.approvalId);
    if (!groupBuyDailyReconciliationApprovalMatchesCommand(authoritative, input)) {
      throw new ApiRequestError(
        "GROUP_BUY_DAILY_RECONCILIATION_APPROVAL_RESULT_UNKNOWN",
        "权威审批记录与原团购日对账请求不一致，系统继续保留原请求",
      );
    }
    return authoritative;
  } catch (error) {
    if (!receiptAccepted && !groupBuyDailyReconciliationOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_DAILY_RECONCILIATION_APPROVAL_RESULT_UNKNOWN",
      "团购日对账审批申请结果暂时无法确认，请勿另建一张日对账单",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function recoverGroupBuyDailyReconciliationApproval(
  requestSnapshot: CreateGroupBuyDailyReconciliationApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateGroupBuyDailyReconciliationApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原团购日对账审批请求不完整，无法安全恢复",
      400,
    );
  }
  let receiptAccepted = false;
  try {
    const value = await request<unknown>("/v1/group-buy/daily-reconciliations/approval-requests", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
    if (!groupBuyDailyReconciliationApprovalMatchesCommand(value, input)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "原团购日对账审批申请的后续状态无法安全确认，系统继续保留原请求",
      );
    }
    receiptAccepted = true;
    const authoritative = await getApproval(value.approvalId);
    if (!groupBuyDailyReconciliationApprovalMatchesCommand(authoritative, input)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "权威审批记录与原团购日对账请求不一致，系统继续保留原请求",
      );
    }
    return authoritative;
  } catch (error) {
    if (!receiptAccepted && !groupBuyDailyReconciliationOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_DAILY_RECONCILIATION_APPROVAL_RESULT_UNKNOWN",
      "原团购日对账审批状态暂时无法确认，系统继续保留原请求",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function findGroupBuyDailyReconciliationApprovalForRecovery(
  requestSnapshot: CreateGroupBuyDailyReconciliationApprovalCommand,
): Promise<ApprovalRequestReadModel | null> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateGroupBuyDailyReconciliationApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原团购日对账审批请求不完整，无法安全查询后续状态",
      400,
    );
  }
  const [mine, history] = await Promise.all([listApprovals("MINE"), listApprovals("HISTORY")]);
  const candidateIds = new Set(
    [...mine.items, ...history.items]
      .filter((item) => item.summary.kind === "GROUP_BUY_DAILY_RECONCILIATION")
      .map((item) => item.approvalId),
  );
  const candidates = await Promise.all(
    [...candidateIds].map((approvalId) => getApproval(approvalId)),
  );
  const matches = candidates.filter((approval) =>
    groupBuyDailyReconciliationApprovalMatchesCommand(approval, input),
  );
  if (matches.length > 1) {
    throw new ApiRequestError(
      "GROUP_BUY_DAILY_RECONCILIATION_RECOVERY_AMBIGUOUS",
      "查到多笔相同团购日结事实的审批记录，系统不会自动结束恢复锁，请保留 GH 单号并人工核对",
    );
  }
  return matches[0] ?? null;
}

function groupBuyResolutionRequestLinesMatch(
  snapshot: GroupBuyReconciliationResolutionPreview,
  input:
    | PreviewGroupBuyReconciliationResolutionRequest
    | CreateGroupBuyReconciliationResolutionApprovalCommand,
): boolean {
  return (
    snapshot.lines.length === input.lines.length &&
    snapshot.lines.every((line, index) => {
      const candidate = input.lines[index];
      return (
        candidate !== undefined &&
        line.target.targetId === candidate.targetId &&
        line.disposition === candidate.disposition &&
        line.evidenceReference === candidate.evidenceReference &&
        line.note === candidate.note
      );
    })
  );
}

function groupBuyResolutionPreviewMatchesRequest(
  value: unknown,
  input: PreviewGroupBuyReconciliationResolutionRequest,
): value is GroupBuyReconciliationResolutionPreview {
  return (
    isGroupBuyReconciliationResolutionPreview(value) &&
    value.resolutionId === input.resolutionId &&
    value.reconciliationId === input.reconciliationId &&
    value.reviewWorkItemId === input.reviewWorkItemId &&
    groupBuyResolutionRequestLinesMatch(value, input)
  );
}

function groupBuyResolutionTraceMatchesCommand(
  snapshot: Extract<
    ApprovalRequestReadModel["snapshot"],
    { kind: "GROUP_BUY_RECONCILIATION_RESOLUTION" }
  >,
  input: CreateGroupBuyReconciliationResolutionApprovalCommand,
): boolean {
  const expected = input.operationTrace;
  const actual = snapshot.operationTrace;
  return (
    actual.contractVersion === expected.contractVersion &&
    actual.commandId === expected.commandId &&
    actual.correlationId === expected.correlationId &&
    actual.causationId === expected.causationId &&
    actual.idempotencyKey === expected.idempotencyKey &&
    actual.businessNumber?.kind === expected.businessNumber?.kind &&
    actual.businessNumber?.value === expected.businessNumber?.value
  );
}

function groupBuyResolutionApprovalMatchesCommand(
  value: unknown,
  input: CreateGroupBuyReconciliationResolutionApprovalCommand,
): value is ApprovalRequestReadModel {
  if (!isApprovalRequestReadModel(value)) return false;
  const snapshot = value.snapshot;
  return (
    snapshot.kind === "GROUP_BUY_RECONCILIATION_RESOLUTION" &&
    snapshot.resolutionId === input.resolutionId &&
    snapshot.reconciliationId === input.reconciliationId &&
    snapshot.reconciliationNumber === input.operationTrace.businessNumber?.value &&
    snapshot.reviewWorkItemId === input.reviewWorkItemId &&
    groupBuyResolutionRequestLinesMatch(snapshot, input) &&
    snapshot.sourceReconciliationSha256 === input.sourceReconciliationSha256 &&
    groupBuyResolutionTraceMatchesCommand(snapshot, input) &&
    snapshot.orderEffect === "NONE" &&
    snapshot.inventoryEffect === "NONE" &&
    snapshot.memberBalanceEffect === "NONE" &&
    snapshot.originalBusinessFactEffect === "NONE" &&
    snapshot.moneyLedgerEffect === "APPEND_ONLY_GROUP_BUY_SETTLEMENT" &&
    value.policy.resource === "ORDER" &&
    value.policy.action === "RECONCILE_GROUP_BUY" &&
    value.policy.requirement === "MANAGER_OR_OWNER" &&
    value.policy.effect === "MANAGER_OR_OWNER_APPROVAL"
  );
}

const groupBuyResolutionDefiniteNoEffectCodes = new Set([
  "AUTH_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_FACTS_NOT_TRUSTED",
  "CSRF_REJECTED",
  "MOBILE_SESSION_ACTIVATION_REQUIRED",
  "NATIVE_APP_VERSION_INVALID",
  "NATIVE_APP_VERSION_MISMATCH",
  "NATIVE_APP_VERSION_REQUIRED",
  "NATIVE_SECURE_SESSION_UNAVAILABLE",
  "NATIVE_SERVER_UPDATE_REQUIRED",
  "NATIVE_UPDATE_REQUIRED",
  "OFFLINE_AUTHORITY_UNAVAILABLE",
  "ONLINE_SERVICE_REQUIRED",
  "ORIGIN_REJECTED",
  "REQUEST_VALIDATION_FAILED",
]);

function groupBuyResolutionOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  if (groupBuyResolutionDefiniteNoEffectCodes.has(error.code)) return false;
  if (
    [
      "GROUP_BUY_RECONCILIATION_RESOLUTION_PREVIEW_RESULT_UNKNOWN",
      "GROUP_BUY_RECONCILIATION_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (error.statusCode !== undefined && error.statusCode >= 400 && error.statusCode <= 499) {
    return false;
  }
  return error.statusCode === undefined || error.statusCode >= 500;
}

export async function listGroupBuyReconciliationResolutionSources(): Promise<GroupBuyReconciliationResolutionSourceListReadModel> {
  const value = await request<unknown>("/v1/group-buy/reconciliation-resolutions/sources", {
    cache: "no-store",
  });
  if (!isGroupBuyReconciliationResolutionSourceListReadModel(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "可处理的团购差异清单无法安全确认，请重新读取",
    );
  }
  return value;
}

export async function previewGroupBuyReconciliationResolution(
  requestSnapshot: PreviewGroupBuyReconciliationResolutionRequest,
): Promise<GroupBuyReconciliationResolutionPreview> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewGroupBuyReconciliationResolutionRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "团购差异处置内容不完整，请逐笔填写处置方式、凭证和说明",
      400,
    );
  }
  try {
    const value = await request<unknown>("/v1/group-buy/reconciliation-resolutions/preview", {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    });
    if (!groupBuyResolutionPreviewMatchesRequest(value, input)) {
      throw new ApiRequestError(
        "GROUP_BUY_RECONCILIATION_RESOLUTION_PREVIEW_RESULT_UNKNOWN",
        "团购差异处置检查结果与当前逐笔选择不一致，请勿提交审批",
      );
    }
    return value;
  } catch (error) {
    if (!groupBuyResolutionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_RECONCILIATION_RESOLUTION_PREVIEW_RESULT_UNKNOWN",
      "团购差异处置检查结果暂时无法确认，请保留当前逐笔选择并重新检查",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function createGroupBuyReconciliationResolutionApproval(
  requestSnapshot: CreateGroupBuyReconciliationResolutionApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateGroupBuyReconciliationResolutionApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "团购差异处置审批内容不完整，请重新检查 GH 单号、逐笔处置和操作编号",
      400,
    );
  }
  let receiptAccepted = false;
  try {
    const value = await request<unknown>(
      "/v1/group-buy/reconciliation-resolutions/approval-requests",
      { method: "POST", cache: "no-store", body: JSON.stringify(input) },
    );
    if (!groupBuyResolutionApprovalMatchesCommand(value, input)) {
      throw new ApiRequestError(
        "GROUP_BUY_RECONCILIATION_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
        "团购差异处置审批申请无法与原逐笔选择对应，系统继续保留原请求",
      );
    }
    receiptAccepted = true;
    const authoritative = await getApproval(value.approvalId);
    if (!groupBuyResolutionApprovalMatchesCommand(authoritative, input)) {
      throw new ApiRequestError(
        "GROUP_BUY_RECONCILIATION_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
        "权威审批记录与原团购差异处置请求不一致，系统继续保留原请求",
      );
    }
    return authoritative;
  } catch (error) {
    if (!receiptAccepted && !groupBuyResolutionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_RECONCILIATION_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
      "团购差异处置审批结果暂时无法确认，请勿另建一笔处置",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function recoverGroupBuyReconciliationResolutionApproval(
  requestSnapshot: CreateGroupBuyReconciliationResolutionApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateGroupBuyReconciliationResolutionApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原团购差异处置审批请求不完整，无法安全恢复",
      400,
    );
  }
  let receiptAccepted = false;
  try {
    const value = await request<unknown>(
      "/v1/group-buy/reconciliation-resolutions/approval-requests",
      { method: "POST", cache: "no-store", body: JSON.stringify(input) },
    );
    if (!groupBuyResolutionApprovalMatchesCommand(value, input)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "原团购差异处置审批的后续状态无法安全确认，系统继续保留原请求",
      );
    }
    receiptAccepted = true;
    const authoritative = await getApproval(value.approvalId);
    if (!groupBuyResolutionApprovalMatchesCommand(authoritative, input)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "权威审批记录与原团购差异处置请求不一致，系统继续保留原请求",
      );
    }
    return authoritative;
  } catch (error) {
    if (!receiptAccepted && !groupBuyResolutionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "GROUP_BUY_RECONCILIATION_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
      "原团购差异处置审批状态暂时无法确认，系统继续保留原请求",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function findGroupBuyReconciliationResolutionApprovalForRecovery(
  requestSnapshot: CreateGroupBuyReconciliationResolutionApprovalCommand,
): Promise<ApprovalRequestReadModel | null> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateGroupBuyReconciliationResolutionApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原团购差异处置审批请求不完整，无法安全查询后续状态",
      400,
    );
  }
  const [mine, history] = await Promise.all([listApprovals("MINE"), listApprovals("HISTORY")]);
  const candidateIds = new Set(
    [...mine.items, ...history.items]
      .filter((item) => item.summary.kind === "GROUP_BUY_RECONCILIATION_RESOLUTION")
      .map((item) => item.approvalId),
  );
  const candidates = await Promise.all(
    [...candidateIds].map((approvalId) => getApproval(approvalId)),
  );
  const matches = candidates.filter((approval) =>
    groupBuyResolutionApprovalMatchesCommand(approval, input),
  );
  if (matches.length > 1) {
    throw new ApiRequestError(
      "GROUP_BUY_RECONCILIATION_RESOLUTION_RECOVERY_AMBIGUOUS",
      "查到多笔相同团购差异处置审批，系统不会自动结束恢复锁，请保留 GH 单号并人工核对",
    );
  }
  return matches[0] ?? null;
}

export async function getGroupBuyReconciliationSignoff(
  resolutionId: string,
): Promise<GroupBuyReconciliationSignoffPackage> {
  if (
    resolutionId !== resolutionId.trim() ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{11,127}$/u.test(resolutionId)
  ) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "团购差异处置编号无效", 400);
  }
  const value = await request<unknown>(
    `/v1/group-buy/reconciliation-resolutions/${encodeURIComponent(resolutionId)}/signoff`,
    { cache: "no-store" },
  );
  if (!isGroupBuyReconciliationSignoffPackage(value) || value.resolutionId !== resolutionId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "团购差异处置签结结果与当前 GH 记录无法安全对应",
    );
  }
  return value;
}

export async function findGroupBuyReconciliationSignoffByReviewWorkItem(
  reviewWorkItemId: string,
): Promise<GroupBuyReconciliationSignoffPackage | null> {
  if (!isGroupBuyReconciliationInternalReferenceId(reviewWorkItemId)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "团购差异工作项编号无效", 400);
  }
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/group-buy/reconciliation-resolutions/review-work-items/${encodeURIComponent(reviewWorkItemId)}/signoff`,
      { cache: "no-store" },
    );
  } catch (error) {
    if (error instanceof ApiRequestError && error.statusCode === 404) return null;
    throw error;
  }
  if (
    !isGroupBuyReconciliationSignoffPackage(value) ||
    value.snapshot.reviewWorkItemId !== reviewWorkItemId
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "团购差异签结结果与原工作项无法安全对应");
  }
  return value;
}

export async function listGroupBuyChannels(
  includeDisabled = false,
): Promise<GroupBuyChannelRecord[]> {
  const result = await request<unknown>(
    `/v1/group-buy/channels?includeDisabled=${includeDisabled}`,
    { cache: "no-store" },
  );
  if (!isGroupBuyChannelReadResultList(result, includeDisabled)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "团购渠道列表无法安全确认");
  }
  return result;
}

export function groupBuyChannelSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "GROUP_BUY_CHANNEL_SAVE_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  if (definitelyStoppedBeforeCloud) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

const groupBuyChannelWriteResultKeys = [
  "id",
  "provider",
  "displayName",
  "fulfillmentMode",
  "officialIntegration",
  "enabled",
  "version",
  "createdAt",
  "updatedAt",
  "evidence",
] as const;

function isCanonicalGroupBuyChannelTimestamp(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) && new Date(milliseconds).toISOString() === value;
}

function isGroupBuyChannelReadResult(value: unknown, includeDisabled: boolean): boolean {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const createdAt = Date.parse(
    isCanonicalGroupBuyChannelTimestamp(record.createdAt) ? record.createdAt : "",
  );
  const updatedAt = Date.parse(
    isCanonicalGroupBuyChannelTimestamp(record.updatedAt) ? record.updatedAt : "",
  );
  const displayNameLength =
    typeof record.displayName === "string" ? [...record.displayName].length : -1;
  return (
    Object.keys(record).length === groupBuyChannelWriteResultKeys.length &&
    groupBuyChannelWriteResultKeys.every((key) => Object.hasOwn(record, key)) &&
    typeof record.id === "string" &&
    /^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/.test(record.id) &&
    (record.provider === "MEITUAN" || record.provider === "DOUYIN") &&
    typeof record.displayName === "string" &&
    record.displayName.trim().length > 0 &&
    displayNameLength >= 1 &&
    displayNameLength <= 40 &&
    record.fulfillmentMode === "MANUAL_PLATFORM_APP" &&
    record.officialIntegration === "NOT_VERIFIED" &&
    typeof record.enabled === "boolean" &&
    (includeDisabled || record.enabled) &&
    Number.isSafeInteger(record.version) &&
    (record.version as number) >= 1 &&
    Number.isFinite(createdAt) &&
    Number.isFinite(updatedAt) &&
    updatedAt >= createdAt &&
    record.evidence === "MANUAL_FALLBACK"
  );
}

function isGroupBuyChannelReadResultList(
  value: unknown,
  includeDisabled: boolean,
): value is GroupBuyChannelRecord[] {
  if (
    !Array.isArray(value) ||
    !value.every((item) => isGroupBuyChannelReadResult(item, includeDisabled))
  ) {
    return false;
  }
  const channels = value as GroupBuyChannelRecord[];
  return (
    new Set(channels.map((channel) => channel.id)).size === channels.length &&
    new Set(channels.map((channel) => channel.provider)).size === channels.length
  );
}

function isGroupBuyChannelWriteResult(
  value: unknown,
  channelId: string,
  input: GroupBuyChannelUpsertRequest,
): value is GroupBuyChannelRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const keys = Object.keys(record);
  const createdAt = Date.parse(
    isCanonicalGroupBuyChannelTimestamp(record.createdAt) ? record.createdAt : "",
  );
  const updatedAt = Date.parse(
    isCanonicalGroupBuyChannelTimestamp(record.updatedAt) ? record.updatedAt : "",
  );
  const expectedVersion = input.expectedVersion === null ? null : input.expectedVersion + 1;
  return (
    keys.length === groupBuyChannelWriteResultKeys.length &&
    groupBuyChannelWriteResultKeys.every((key) => Object.hasOwn(record, key)) &&
    record.id === channelId &&
    record.provider === input.provider &&
    record.displayName === input.displayName.trim() &&
    record.fulfillmentMode === "MANUAL_PLATFORM_APP" &&
    record.officialIntegration === "NOT_VERIFIED" &&
    record.enabled === input.enabled &&
    Number.isSafeInteger(record.version) &&
    (record.version as number) >= 1 &&
    (expectedVersion === null || record.version === expectedVersion) &&
    Number.isFinite(createdAt) &&
    Number.isFinite(updatedAt) &&
    updatedAt >= createdAt &&
    record.evidence === "MANUAL_FALLBACK"
  );
}

export async function saveGroupBuyChannel(
  channelId: string,
  input: GroupBuyChannelUpsertRequest,
): Promise<GroupBuyChannelRecord> {
  const requestSnapshot: GroupBuyChannelUpsertRequest = { ...input };
  try {
    const result = await request<unknown>(
      `/v1/group-buy/channels/${encodeURIComponent(channelId)}`,
      {
        method: "PUT",
        body: JSON.stringify(requestSnapshot),
      },
    );
    if (!isGroupBuyChannelWriteResult(result, channelId, requestSnapshot)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "团购渠道保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (groupBuyChannelSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "GROUP_BUY_CHANNEL_SAVE_RESULT_UNKNOWN",
        "这次渠道内容可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function listGroupBuyPackages(
  includeDisabled = false,
): Promise<GroupBuyPackageRecord[]> {
  const result = await request<unknown>(
    `/v1/group-buy/packages?includeDisabled=${includeDisabled}`,
    { cache: "no-store" },
  );
  if (!isGroupBuyPackageReadResultList(result, includeDisabled)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "团购套餐列表无法安全确认");
  }
  return result;
}

export function groupBuyPackageSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "GROUP_BUY_PACKAGE_SAVE_RESULT_UNKNOWN",
      "GROUP_BUY_CONFIGURATION_AUDIT_UNVERIFIED",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  if (definitelyStoppedBeforeCloud) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

const groupBuyPackageWriteResultKeys = [
  "id",
  "channelId",
  "name",
  "includedMinutes",
  "components",
  "voucherCoveredFen",
  "customerSupplementFen",
  "expectedSettlementFen",
  "expectedFeeFen",
  "expectedSubsidyFen",
  "enabled",
  "version",
  "createdAt",
  "updatedAt",
  "evidence",
] as const;

const groupBuyPackageComponentWriteResultKeys = [
  "kind",
  "referenceId",
  "name",
  "quantity",
] as const;

function isCanonicalGroupBuyPackageTimestamp(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) && new Date(milliseconds).toISOString() === value;
}

function isGroupBuyPackageComponentReadResult(value: unknown): boolean {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const component = value as Record<string, unknown>;
  const referenceLength =
    typeof component.referenceId === "string" ? [...component.referenceId].length : -1;
  const nameLength = typeof component.name === "string" ? [...component.name].length : -1;
  return (
    Object.keys(component).length === groupBuyPackageComponentWriteResultKeys.length &&
    groupBuyPackageComponentWriteResultKeys.every((key) => Object.hasOwn(component, key)) &&
    (component.kind === "PRODUCT" || component.kind === "SERVICE") &&
    (component.referenceId === null ||
      (typeof component.referenceId === "string" &&
        referenceLength >= 1 &&
        referenceLength <= 64)) &&
    (component.kind !== "PRODUCT" || typeof component.referenceId === "string") &&
    typeof component.name === "string" &&
    component.name.trim().length > 0 &&
    nameLength >= 1 &&
    nameLength <= 80 &&
    Number.isSafeInteger(component.quantity) &&
    (component.quantity as number) >= 1 &&
    (component.quantity as number) <= 99
  );
}

function isGroupBuyPackageReadResult(value: unknown, includeDisabled: boolean): boolean {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const createdAt = Date.parse(
    isCanonicalGroupBuyPackageTimestamp(record.createdAt) ? record.createdAt : "",
  );
  const updatedAt = Date.parse(
    isCanonicalGroupBuyPackageTimestamp(record.updatedAt) ? record.updatedAt : "",
  );
  const nameLength = typeof record.name === "string" ? [...record.name].length : -1;
  const moneyKeys = [
    "voucherCoveredFen",
    "customerSupplementFen",
    "expectedSettlementFen",
    "expectedFeeFen",
    "expectedSubsidyFen",
  ] as const;
  if (
    Object.keys(record).length !== groupBuyPackageWriteResultKeys.length ||
    !groupBuyPackageWriteResultKeys.every((key) => Object.hasOwn(record, key)) ||
    typeof record.id !== "string" ||
    !/^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/.test(record.id) ||
    typeof record.channelId !== "string" ||
    !/^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/.test(record.channelId) ||
    typeof record.name !== "string" ||
    record.name.trim().length === 0 ||
    nameLength < 1 ||
    nameLength > 80 ||
    !Number.isSafeInteger(record.includedMinutes) ||
    (record.includedMinutes as number) < 0 ||
    (record.includedMinutes as number) > 1_440 ||
    !Array.isArray(record.components) ||
    record.components.length > 30 ||
    !record.components.every(isGroupBuyPackageComponentReadResult) ||
    (record.includedMinutes === 0 && record.components.length === 0) ||
    moneyKeys.some(
      (key) =>
        !Number.isSafeInteger(record[key]) ||
        (record[key] as number) < 0 ||
        (record[key] as number) > 100_000_000,
    ) ||
    typeof record.enabled !== "boolean" ||
    (!includeDisabled && !record.enabled) ||
    !Number.isSafeInteger(record.version) ||
    (record.version as number) < 1 ||
    !Number.isFinite(createdAt) ||
    !Number.isFinite(updatedAt) ||
    updatedAt < createdAt ||
    (record.evidence !== "SIMULATED" && record.evidence !== "STORE_ACCEPTED")
  ) {
    return false;
  }
  const productReferences = (record.components as Array<Record<string, unknown>>)
    .filter((component) => component.kind === "PRODUCT")
    .map((component) => component.referenceId as string);
  return new Set(productReferences).size === productReferences.length;
}

function isGroupBuyPackageReadResultList(
  value: unknown,
  includeDisabled: boolean,
): value is GroupBuyPackageRecord[] {
  if (
    !Array.isArray(value) ||
    !value.every((item) => isGroupBuyPackageReadResult(item, includeDisabled))
  ) {
    return false;
  }
  return new Set(value.map((item) => (item as GroupBuyPackageRecord).id)).size === value.length;
}

function packageComponentsMatch(
  value: unknown,
  expected: GroupBuyPackageUpsertRequest["components"],
): boolean {
  if (!Array.isArray(value) || value.length !== expected.length) return false;
  return value.every((item, index) => {
    if (typeof item !== "object" || item === null || Array.isArray(item)) return false;
    const component = item as Record<string, unknown>;
    const expectedComponent = expected[index];
    return (
      expectedComponent !== undefined &&
      Object.keys(component).length === groupBuyPackageComponentWriteResultKeys.length &&
      groupBuyPackageComponentWriteResultKeys.every((key) => Object.hasOwn(component, key)) &&
      component.kind === expectedComponent.kind &&
      component.referenceId === expectedComponent.referenceId &&
      component.name === expectedComponent.name &&
      component.quantity === expectedComponent.quantity
    );
  });
}

function isGroupBuyPackageWriteResult(
  value: unknown,
  packageId: string,
  input: GroupBuyPackageUpsertRequest,
): value is GroupBuyPackageRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const createdAt = Date.parse(
    isCanonicalGroupBuyPackageTimestamp(record.createdAt) ? record.createdAt : "",
  );
  const updatedAt = Date.parse(
    isCanonicalGroupBuyPackageTimestamp(record.updatedAt) ? record.updatedAt : "",
  );
  const expectedVersion = input.expectedVersion === null ? null : input.expectedVersion + 1;
  return (
    Object.keys(record).length === groupBuyPackageWriteResultKeys.length &&
    groupBuyPackageWriteResultKeys.every((key) => Object.hasOwn(record, key)) &&
    record.id === packageId &&
    record.channelId === input.channelId &&
    record.name === input.name.trim() &&
    record.includedMinutes === input.includedMinutes &&
    packageComponentsMatch(record.components, input.components) &&
    record.voucherCoveredFen === input.voucherCoveredFen &&
    record.customerSupplementFen === input.customerSupplementFen &&
    record.expectedSettlementFen === input.expectedSettlementFen &&
    record.expectedFeeFen === input.expectedFeeFen &&
    record.expectedSubsidyFen === input.expectedSubsidyFen &&
    record.enabled === input.enabled &&
    Number.isSafeInteger(record.version) &&
    (record.version as number) >= 1 &&
    (expectedVersion === null || record.version === expectedVersion) &&
    Number.isFinite(createdAt) &&
    Number.isFinite(updatedAt) &&
    updatedAt >= createdAt &&
    (record.evidence === "SIMULATED" || record.evidence === "STORE_ACCEPTED")
  );
}

export async function saveGroupBuyPackage(
  packageId: string,
  input: GroupBuyPackageUpsertRequest,
): Promise<GroupBuyPackageRecord> {
  const requestSnapshot: GroupBuyPackageUpsertRequest = {
    ...input,
    components: input.components.map((component) => ({ ...component })),
  };
  try {
    const result = await request<unknown>(
      `/v1/group-buy/packages/${encodeURIComponent(packageId)}`,
      {
        method: "PUT",
        body: JSON.stringify(requestSnapshot),
      },
    );
    if (!isGroupBuyPackageWriteResult(result, packageId, requestSnapshot)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "团购套餐保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (groupBuyPackageSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "GROUP_BUY_PACKAGE_SAVE_RESULT_UNKNOWN",
        "这次套餐内容可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

const groupBuyFulfillmentDefiniteRejections = new Set([
  "AUTH_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_FACTS_NOT_TRUSTED",
  "AUTHORIZATION_IDENTITY_NOT_ACTIVE",
  "CONDITIONAL_MODULE_DISABLED",
  "CSRF_REJECTED",
  "FORBIDDEN",
  "GROUP_BUY_AMOUNT_SNAPSHOT_MISMATCH",
  "GROUP_BUY_CASHIER_CONFIRMATION_REQUIRED",
  "GROUP_BUY_CHANNEL_UNAVAILABLE",
  "GROUP_BUY_CONFIGURATION_VERSION_CHANGED",
  "GROUP_BUY_LEGACY_INTENT_RECONFIRMATION_REQUIRED",
  "GROUP_BUY_MANAGER_TAKEOVER_CASHIER_AVAILABLE",
  "GROUP_BUY_MANAGER_TAKEOVER_REASON_REQUIRED",
  "GROUP_BUY_MANUAL_ROLE_MISMATCH",
  "GROUP_BUY_OPEN_CASH_SHIFT_REQUIRED",
  "GROUP_BUY_OWNER_EXCEPTION_REASON_REQUIRED",
  "GROUP_BUY_ORDER_ALREADY_FULFILLED",
  "GROUP_BUY_PACKAGE_UNAVAILABLE",
  "GROUP_BUY_PRODUCT_DUPLICATE",
  "GROUP_BUY_PRODUCT_UNAVAILABLE",
  "GROUP_BUY_REFERENCE_DUPLICATE",
  "GROUP_BUY_REFERENCE_INVALID",
  "GROUP_BUY_WORKFORCE_FACTS_UNAVAILABLE",
  "IDEMPOTENCY_COLLISION",
  "MEMBER_CHECKOUT_IN_PROGRESS",
  "OFFLINE_AUTHORITY_UNAVAILABLE",
  "ONLINE_SERVICE_REQUIRED",
  "ORIGIN_REJECTED",
]);

export function groupBuyFulfillmentOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError) || error.code === "OPERATOR_IDENTITY_CHANGED") {
    return false;
  }
  if (groupBuyFulfillmentDefiniteRejections.has(error.code)) return false;
  return (
    error.code === "GROUP_BUY_FULFILLMENT_RESULT_UNKNOWN" ||
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    error.statusCode === 408 ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

function groupBuyManualOperatorInputIsCanonical(
  input: Pick<RecordGroupBuyFulfillmentRequest, "operatorMode" | "exceptionReason">,
): boolean {
  if (input.operatorMode === undefined) return input.exceptionReason === undefined;
  if (input.operatorMode === "OWNER_EXCEPTION") {
    return typeof input.exceptionReason === "string";
  }
  return input.exceptionReason === undefined || input.exceptionReason === null;
}

function groupBuyManualOperatorDecisionMatchesRequest(
  fulfillment: GroupBuyFulfillmentRecord,
  input: Pick<RecordGroupBuyFulfillmentRequest, "operatorMode" | "exceptionReason">,
): boolean {
  if (!groupBuyManualOperatorInputIsCanonical(input)) return false;
  if (input.operatorMode === undefined) {
    return fulfillment.operatorDecision === undefined;
  }
  const expectedReason = input.exceptionReason ?? null;
  return (
    fulfillment.operatorDecision?.mode === input.operatorMode &&
    fulfillment.operatorDecision.reason === expectedReason
  );
}

function isGroupBuyFulfillmentWriteResult(
  value: unknown,
  input: RecordGroupBuyFulfillmentRequest,
  expectedActorId: string,
): value is { fulfillment: GroupBuyFulfillmentRecord; order: OrderDetail } {
  if (value === null || typeof value !== "object" || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  if (
    Object.keys(record).length !== 2 ||
    !Object.hasOwn(record, "fulfillment") ||
    !Object.hasOwn(record, "order") ||
    !isGroupBuyFulfillmentRecord(record.fulfillment) ||
    !isOrderDetail(record.order) ||
    !isGroupBuyFulfillmentSemanticallyConsistent(record.fulfillment)
  ) {
    return false;
  }
  const fulfillment = record.fulfillment;
  const order = record.order;
  const orderFulfillment = order.groupBuyFulfillments?.find(
    (candidate) => candidate.id === fulfillment.id,
  );
  return (
    fulfillment.actorId === expectedActorId &&
    fulfillment.authorizerId === null &&
    groupBuyManualOperatorDecisionMatchesRequest(fulfillment, input) &&
    fulfillment.sessionId === input.sessionId &&
    fulfillment.channelSnapshot.id === input.channelId &&
    fulfillment.channelSnapshot.version === input.expectedChannelVersion &&
    fulfillment.channelSnapshot.fulfillmentMode === "MANUAL_PLATFORM_APP" &&
    fulfillment.channelSnapshot.officialIntegration === "NOT_VERIFIED" &&
    fulfillment.inventoryEffects !== undefined &&
    fulfillment.packageSnapshot.id === input.packageId &&
    fulfillment.packageSnapshot.version === input.expectedPackageVersion &&
    fulfillment.platformReference === normalizeGroupBuyPlatformReference(input.platformReference) &&
    fulfillment.voucherCoveredFen === input.voucherCoveredFen &&
    fulfillment.customerSupplementFen === input.customerSupplementFen &&
    fulfillment.expectedSettlementFen === input.expectedSettlementFen &&
    fulfillment.expectedFeeFen === input.expectedFeeFen &&
    fulfillment.expectedSubsidyFen === input.expectedSubsidyFen &&
    fulfillment.note === input.note.trim() &&
    fulfillment.reconciliationOutcome === "PENDING" &&
    fulfillment.actualSettlementFen === null &&
    fulfillment.actualFeeFen === null &&
    fulfillment.actualSubsidyFen === null &&
    fulfillment.reconciliationNote === null &&
    fulfillment.reconciledAt === null &&
    fulfillment.evidence === "MANUAL_FALLBACK" &&
    order.id === fulfillment.orderId &&
    order.sessionId === fulfillment.sessionId &&
    order.tableId === fulfillment.tableId &&
    order.tableNumber === fulfillment.tableNumber &&
    order.businessDate === fulfillment.businessDate &&
    orderFulfillment !== undefined &&
    JSON.stringify(orderFulfillment) === JSON.stringify(fulfillment)
  );
}

export async function recordGroupBuyFulfillment(
  input: RecordGroupBuyFulfillmentRequest,
  expectedActorId: string,
): Promise<{ fulfillment: GroupBuyFulfillmentRecord; order: OrderDetail }> {
  const requestSnapshot: RecordGroupBuyFulfillmentRequest = { ...input };
  if (
    !isRecordGroupBuyFulfillmentRequest(requestSnapshot) ||
    !groupBuyManualOperatorInputIsCanonical(requestSnapshot)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "团购人工登记内容或办理岗位不完整，系统没有提交",
      400,
    );
  }
  try {
    const result = await request<unknown>("/v1/group-buy/fulfillments", {
      method: "POST",
      body: JSON.stringify(requestSnapshot),
    });
    if (!isGroupBuyFulfillmentWriteResult(result, requestSnapshot, expectedActorId)) {
      throw new ApiRequestError(
        "GROUP_BUY_FULFILLMENT_RESULT_UNKNOWN",
        "这次团购履约可能已经登记，但页面无法安全确认结果。请保留当前内容并使用同一次请求核对",
      );
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (groupBuyFulfillmentOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "GROUP_BUY_FULFILLMENT_RESULT_UNKNOWN",
        "这次团购履约可能已经登记，但页面无法安全确认结果。请保留当前内容并使用同一次请求核对",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function listGroupBuyFulfillments(
  businessDate?: string,
): Promise<GroupBuyFulfillmentRecord[]> {
  const suffix = businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : "";
  const result = await request<unknown>(`/v1/group-buy/fulfillments${suffix}`, {
    cache: "no-store",
  });
  if (
    !Array.isArray(result) ||
    result.length > 10_000 ||
    result.some(
      (item) =>
        !isGroupBuyFulfillmentRecord(item) ||
        !isGroupBuyFulfillmentSemanticallyConsistent(item) ||
        (businessDate !== undefined && item.businessDate !== businessDate),
    )
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "团购履约记录格式异常，页面已停止使用这份结果",
    );
  }
  const records = result as GroupBuyFulfillmentRecord[];
  if (new Set(records.map((record) => record.id)).size !== records.length) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "团购履约记录存在重复，页面已停止使用这份结果",
    );
  }
  return records;
}

export async function getGroupBuyReconciliation(
  businessDate?: string,
): Promise<GroupBuyReconciliationSummary> {
  const suffix = businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : "";
  const value = await request<unknown>(`/v1/group-buy/reconciliation${suffix}`, {
    cache: "no-store",
  });
  if (!isGroupBuyReconciliationSummary(value, businessDate)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "团购核对汇总无法安全确认，页面已停止显示，请刷新后重试",
    );
  }
  return value;
}

export function productSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PRODUCT_SAVE_RESULT_UNKNOWN",
      "PRODUCT_SAVE_AUDIT_UNVERIFIED",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code === "AUTH_REQUIRED" ||
    error.code === "AUTH_CREDENTIAL_CONFLICT" ||
    error.code === "AUTHORITY_EXPIRED" ||
    error.code === "CSRF_REJECTED" ||
    error.code === "DEMO_AUTH_DISABLED" ||
    error.code === "MOBILE_SESSION_ACTIVATION_REQUIRED" ||
    error.code === "ORIGIN_REJECTED" ||
    error.code === "SHIFT_SESSION_NOT_STARTED" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  const definiteTerminalRejection = [
    "CLOUD_AUTHORIZATION_FAILED",
    "GATEWAY_CREDENTIAL_MISMATCH",
    "GATEWAY_CREDENTIAL_REQUIRED",
    "GATEWAY_IDENTITY_MISMATCH",
    "GATEWAY_SCOPE_MISMATCH",
    "UNAUTHORIZED_GATEWAY",
    "PRODUCT_ID_MISMATCH",
    "PRODUCT_BASE_UNIT_MIGRATION_REQUIRED",
    "NEGATIVE_STOCK_APPROVAL_REQUIRED",
    "NEGATIVE_STOCK_RECONCILIATION_REQUIRED",
    "REQUEST_VALIDATION_FAILED",
    "CONDITIONAL_MODULE_DISABLED",
    "PRODUCT_VERSION_CONFLICT",
    "PRODUCT_BARCODE_CONFLICT",
    "IDEMPOTENCY_COLLISION",
    "STORE_NOT_FOUND",
    "VENUE_NOT_INITIALIZED",
  ].includes(error.code);
  if (definitelyStoppedBeforeCloud || definiteTerminalRejection) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 400);
}

function isInventoryProductWriteResult(
  value: unknown,
  input: ProductSaveRequest,
): value is InventoryProductRecord {
  if (!isInventoryProductRecord(value)) return false;
  const record = value as InventoryProductRecord;
  const expectedVersion = input.expectedVersion + 1;
  return (
    (record.stockOnHand >= 0 || input.allowNegativeStock) &&
    record.skuId === input.skuId &&
    (record.storeProductCode ?? null) === input.storeProductCode &&
    record.name === input.name &&
    record.category === input.category &&
    record.unit === input.unit &&
    record.unitPriceFen === input.unitPriceFen &&
    record.costFen === input.costFen &&
    record.barcode === input.barcode &&
    record.trackInventory === input.trackInventory &&
    record.lowStockThreshold === input.lowStockThreshold &&
    record.allowNegativeStock === input.allowNegativeStock &&
    record.customerStorageEligible === (input.customerStorageEligible ?? false) &&
    record.customerRentalEnabled === (input.customerRentalEnabled ?? false) &&
    record.customerRentalUnitPriceFen === (input.customerRentalUnitPriceFen ?? 0) &&
    record.customerRentalTotalQuantity === (input.customerRentalTotalQuantity ?? 0) &&
    record.enabled === input.enabled &&
    record.version === expectedVersion
  );
}

export async function saveInventoryProduct(
  input: ProductSaveRequest,
): Promise<InventoryProductRecord> {
  const requestSnapshot: ProductSaveRequest = { ...input };
  try {
    const result = await request<unknown>(
      `/v1/inventory/products/${encodeURIComponent(requestSnapshot.skuId)}`,
      {
        method: "PUT",
        body: JSON.stringify(requestSnapshot),
      },
    );
    if (!isInventoryProductWriteResult(result, requestSnapshot)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "商品保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (productSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PRODUCT_SAVE_RESULT_UNKNOWN",
        "这次商品资料可能已经保存到云端，但页面尚未确认。库存数量没有通过这次操作调整，请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export function productUnitConversionSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "PRODUCT_UNIT_SAVE_RESULT_UNKNOWN",
      "PRODUCT_UNIT_SAVE_AUDIT_UNVERIFIED",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code === "AUTH_REQUIRED" ||
    error.code === "AUTH_CREDENTIAL_CONFLICT" ||
    error.code === "AUTHORITY_EXPIRED" ||
    error.code === "CSRF_REJECTED" ||
    error.code === "DEMO_AUTH_DISABLED" ||
    error.code === "MOBILE_SESSION_ACTIVATION_REQUIRED" ||
    error.code === "ORIGIN_REJECTED" ||
    error.code === "SHIFT_SESSION_NOT_STARTED" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  const definiteTerminalRejection = [
    "CLOUD_AUTHORIZATION_FAILED",
    "CONDITIONAL_MODULE_DISABLED",
    "GATEWAY_CREDENTIAL_MISMATCH",
    "GATEWAY_CREDENTIAL_REQUIRED",
    "GATEWAY_IDENTITY_MISMATCH",
    "GATEWAY_SCOPE_MISMATCH",
    "IDEMPOTENCY_COLLISION",
    "PRODUCT_BASE_UNIT_MISMATCH",
    "PRODUCT_NOT_FOUND",
    "PRODUCT_UNIT_BARCODE_CONFLICT",
    "PRODUCT_UNIT_ID_MISMATCH",
    "PRODUCT_UNIT_LIMIT_REACHED",
    "PRODUCT_UNIT_NAME_CONFLICT",
    "PRODUCT_UNIT_VERSION_CONFLICT",
    "PRODUCT_VERSION_CONFLICT",
    "REQUEST_VALIDATION_FAILED",
    "STORE_NOT_FOUND",
    "UNAUTHORIZED_GATEWAY",
    "VENUE_NOT_INITIALIZED",
  ].includes(error.code);
  if (definitelyStoppedBeforeCloud || definiteTerminalRejection) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 400);
}

function isProductUnitConversionWriteResult(
  value: unknown,
  input: ProductUnitConversionUpsertRequest,
): value is ProductUnitConversionRecord {
  if (!isProductUnitConversionRecord(value)) return false;
  return (
    value.skuId === input.skuId &&
    value.conversionId === input.conversionId &&
    value.unitName === input.unitName &&
    value.baseUnitName === input.baseUnitName &&
    value.baseUnitQuantity === input.baseUnitQuantity &&
    value.barcode === input.barcode &&
    value.enabled === input.enabled &&
    value.productVersion === input.expectedProductVersion &&
    value.version === input.expectedVersion + 1
  );
}

export async function saveProductUnitConversion(
  input: ProductUnitConversionUpsertRequest,
): Promise<ProductUnitConversionRecord> {
  const requestSnapshot: ProductUnitConversionUpsertRequest = { ...input };
  if (!isProductUnitConversionUpsertRequest(requestSnapshot)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "换算单位内容不符合保存要求，请检查名称、整数倍数和条码后重试",
      400,
    );
  }
  try {
    const result = await request<unknown>(
      `/v1/inventory/products/${encodeURIComponent(requestSnapshot.skuId)}/unit-conversions/${encodeURIComponent(requestSnapshot.conversionId)}`,
      { method: "PUT", body: JSON.stringify(requestSnapshot) },
    );
    if (!isProductUnitConversionWriteResult(result, requestSnapshot)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "商品单位换算保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (productUnitConversionSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PRODUCT_UNIT_SAVE_RESULT_UNKNOWN",
        "这次换算单位可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export function supplierSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "SUPPLIER_SAVE_RESULT_UNKNOWN",
      "SUPPLIER_SAVE_AUDIT_UNVERIFIED",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code === "AUTH_REQUIRED" ||
    error.code === "AUTH_CREDENTIAL_CONFLICT" ||
    error.code === "AUTHORITY_EXPIRED" ||
    error.code === "CSRF_REJECTED" ||
    error.code === "DEMO_AUTH_DISABLED" ||
    error.code === "MOBILE_SESSION_ACTIVATION_REQUIRED" ||
    error.code === "ORIGIN_REJECTED" ||
    error.code === "SHIFT_SESSION_NOT_STARTED" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  const definiteTerminalRejection = [
    "CLOUD_AUTHORIZATION_FAILED",
    "CONDITIONAL_MODULE_DISABLED",
    "GATEWAY_CREDENTIAL_MISMATCH",
    "GATEWAY_CREDENTIAL_REQUIRED",
    "GATEWAY_IDENTITY_MISMATCH",
    "GATEWAY_SCOPE_MISMATCH",
    "IDEMPOTENCY_COLLISION",
    "REQUEST_VALIDATION_FAILED",
    "STORE_NOT_FOUND",
    "SUPPLIER_CODE_CONFLICT",
    "SUPPLIER_ID_MISMATCH",
    "SUPPLIER_VERSION_CONFLICT",
    "UNAUTHORIZED_GATEWAY",
    "VENUE_NOT_INITIALIZED",
  ].includes(error.code);
  if (definitelyStoppedBeforeCloud || definiteTerminalRejection) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 400);
}

function isSupplierWriteResult(
  value: unknown,
  input: SupplierUpsertRequest,
): value is SupplierRecord {
  if (!isSupplierRecord(value)) return false;
  return (
    value.supplierId === input.supplierId &&
    value.supplierCode === input.supplierCode &&
    value.name === input.name &&
    value.contactName === input.contactName &&
    value.contactPhone === input.contactPhone &&
    value.paymentTermsDays === input.paymentTermsDays &&
    value.notes === input.notes &&
    value.enabled === input.enabled &&
    value.version === input.expectedVersion + 1
  );
}

export async function saveSupplier(input: SupplierUpsertRequest): Promise<SupplierRecord> {
  const requestSnapshot: SupplierUpsertRequest = { ...input };
  try {
    const result = await request<unknown>(
      `/v1/inventory/suppliers/${encodeURIComponent(requestSnapshot.supplierId)}`,
      {
        method: "PUT",
        body: JSON.stringify(requestSnapshot),
      },
    );
    if (!isSupplierWriteResult(result, requestSnapshot)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "供应商保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (supplierSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "SUPPLIER_SAVE_RESULT_UNKNOWN",
        "这次供应商资料可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function saveInventoryProductWithCatalogImportGuard(
  catalogImportIdentityKey: string,
  input: ProductSaveRequest,
): Promise<InventoryProductRecord> {
  if (readProductCatalogImportRecovery(catalogImportIdentityKey).status !== "NONE") {
    throw new ApiRequestError(
      "PRODUCT_CATALOG_IMPORT_RESULT_UNKNOWN",
      "商品批量导入结果尚未确认，单品保存已暂停；请先回到批量工具处理原请求",
    );
  }
  return await saveInventoryProduct(input);
}

export async function listInventoryMovements(
  skuId?: string,
): Promise<InventoryMovementReadModel[]> {
  const suffix = skuId ? `?skuId=${encodeURIComponent(skuId)}` : "";
  const value = await request<unknown>(`/v1/inventory/movements${suffix}`, {
    cache: "no-store",
  });
  if (!isInventoryMovementReadModelList(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "库存流水返回内容无法安全确认，请刷新后重试",
    );
  }
  return value;
}

export async function getInventoryMovementsCsv(skuId: string): Promise<string> {
  const csv = await requestText(`/v1/inventory/movements.csv?skuId=${encodeURIComponent(skuId)}`);
  const excelCsv = csv.startsWith("\uFEFF") ? csv : `\uFEFF${csv}`;
  if (!excelCsv.startsWith("\uFEFF商品编号,商品名称,业务类型,业务说明,下一步,")) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "库存流水导出文件无法安全确认，请稍后重试",
    );
  }
  return excelCsv;
}

export async function listMembers(search = ""): Promise<MemberReadModel[]> {
  const suffix = search ? `?search=${encodeURIComponent(search)}` : "";
  const value = await request<unknown>(`/v1/members${suffix}`, { cache: "no-store" });
  if (!isMemberReadModelList(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员名册无法安全确认，页面已隐藏会员资料和余额，请重新读取",
    );
  }
  return value;
}

export async function getMember(memberId: string): Promise<MemberReadModel> {
  const value = await request<unknown>(`/v1/members/${encodeURIComponent(memberId)}`, {
    cache: "no-store",
  });
  if (!isMemberReadModel(value, memberId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员详情无法安全确认，页面已隐藏会员资料和余额，请重新读取",
    );
  }
  return value;
}

export async function getMemberCrmProfile(
  memberId: string,
  signal?: AbortSignal,
): Promise<MemberCrmProfileReadModel> {
  const value = await request<unknown>(`/v1/members/${encodeURIComponent(memberId)}/crm-profile`, {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (!isMemberCrmProfileReadModel(value) || value.memberId !== memberId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员客户资料无法安全确认，页面已隐藏资料和变更记录，请重新读取",
    );
  }
  return value;
}

export async function getMemberLifecycle(
  memberId: string,
  expectedScope: { tenantId: string; storeId: string },
  signal?: AbortSignal,
): Promise<MemberLifecycleReadModel> {
  if (!/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(memberId)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "会员标识不正确，系统没有读取生命周期资料",
      400,
    );
  }
  const value = await request<unknown>(`/v1/members/${encodeURIComponent(memberId)}/lifecycle`, {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (!isMemberLifecycleReadModel(value, memberId, expectedScope)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员生命周期无法安全确认，页面已隐藏旧生命周期、金额和时间线，请重新读取",
    );
  }
  return value;
}

export async function getMemberSensitive(memberId: string): Promise<MemberSensitiveProfile> {
  const result = await request<unknown>(`/v1/members/${encodeURIComponent(memberId)}/sensitive`, {
    cache: "no-store",
  });
  if (!isMemberSensitiveProfile(result) || result.id !== memberId) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "完整会员资料返回内容无法安全确认");
  }
  return result;
}

const memberCreateKnownPreCloudFailures = new Set([
  "MEMBER_CREATE_GUARD_UNAVAILABLE",
  "ONLINE_SERVICE_REQUIRED",
  "CLOUD_COORDINATOR_UNAVAILABLE",
  "AUTHORIZATION_FACTS_NOT_TRUSTED",
  "AUTHORIZATION_CONTEXT_UNAVAILABLE",
  "AUTHORIZATION_CONTEXT_MISSING",
  "WORKFORCE_MUTATION_OUTCOME_UNKNOWN",
  "MEMBER_CREATE_BROWSER_DIGEST_UNAVAILABLE",
  "REQUEST_VALIDATION_FAILED",
  "NATIVE_UPDATE_REQUIRED",
  "NATIVE_SECURE_SESSION_UNAVAILABLE",
]);

export function memberCreateFailureIsDefinitelyPreCloud(error: unknown): boolean {
  return (
    error instanceof ApiRequestError &&
    (memberCreateKnownPreCloudFailures.has(error.code) ||
      error.code.startsWith("AUTHORIZATION_") ||
      error.code.startsWith("NATIVE_"))
  );
}

export function memberCreateOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (memberCreateFailureIsDefinitelyPreCloud(error)) return false;
  return error.memberCreateGuardState !== "CLEARED";
}

export async function memberCreateCommandSha256(input: CreateMemberRequest): Promise<string> {
  if (!globalThis.crypto?.subtle) {
    throw new ApiRequestError(
      "MEMBER_CREATE_BROWSER_DIGEST_UNAVAILABLE",
      "当前浏览器无法校验会员建档摘要，请升级浏览器后重试",
    );
  }
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(canonicalMemberCreateCommand(input)),
  );
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

export async function getPendingMemberCreate(
  signal?: AbortSignal,
): Promise<MemberCreatePending | null> {
  const identityEpochAtIntent = currentOperatorIdentityEpoch();
  const result = await request<unknown>("/v1/member-creates/pending", {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  assertOperatorIdentityUnchanged(identityEpochAtIntent);
  if (result === null) return null;
  if (!isMemberCreatePending(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "待确认的会员建档请求无法安全恢复");
  }
  const expectedCommandSha256 = await memberCreateCommandSha256(result.request);
  assertOperatorIdentityUnchanged(identityEpochAtIntent);
  if (result.commandSha256 !== expectedCommandSha256) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待确认的会员建档请求摘要不一致，已停止恢复",
    );
  }
  return result;
}

export async function createMember(input: CreateMemberRequest): Promise<MemberCreateAck> {
  const identityEpochAtIntent = currentOperatorIdentityEpoch();
  const command: CreateMemberRequest = {
    name: input.name,
    phone: input.phone,
    memberNumber: input.memberNumber,
    notes: input.notes,
    tags: [...input.tags],
    idempotencyKey: input.idempotencyKey,
  };
  try {
    const expectedCommandSha256 = await memberCreateCommandSha256(command);
    assertOperatorIdentityUnchanged(identityEpochAtIntent);
    const result = await request<unknown>("/v1/members", {
      method: "POST",
      body: JSON.stringify(command),
    });
    assertOperatorIdentityUnchanged(identityEpochAtIntent);
    if (
      !isMemberCreateAck(result) ||
      result.name !== command.name ||
      (command.memberNumber !== null && result.memberNumber !== command.memberNumber) ||
      result.commandSha256 !== expectedCommandSha256
    ) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "会员建档结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (memberCreateOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "MEMBER_CREATE_RESULT_UNKNOWN",
        "建档请求可能已经生效，但页面尚未确认。请保留当前内容并使用同一请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
        undefined,
        error instanceof ApiRequestError ? error.memberCreateGuardState : undefined,
      );
    }
    throw error;
  }
}

export async function getPendingMemberProfileUpdate(
  signal?: AbortSignal,
): Promise<MemberProfileUpdatePending | null> {
  const result = await request<unknown>("/v1/member-profile-updates/pending", {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (result === null) return null;
  if (!isMemberProfileUpdatePending(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "待确认的会员资料保存请求无法安全恢复");
  }
  const expectedCommandSha256 = await memberProfileUpdateCommandSha256(result.request);
  if (result.commandSha256 !== expectedCommandSha256) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待确认的会员资料保存请求摘要不一致，已停止恢复",
    );
  }
  return result;
}

export async function updateMember(
  memberId: string,
  input: UpdateMemberRequest,
): Promise<MemberProfileUpdateAck> {
  const expectedCommandSha256 = await memberProfileUpdateCommandSha256(input);
  try {
    const result = await request<unknown>(`/v1/members/${encodeURIComponent(memberId)}`, {
      method: "PUT",
      body: JSON.stringify(input),
    });
    if (
      !isMemberProfileUpdateAck(result) ||
      result.id !== memberId ||
      result.name !== input.name ||
      result.status !== input.status ||
      result.version !== input.expectedVersion + 1 ||
      result.commandSha256 !== expectedCommandSha256
    ) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "会员资料保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (memberProfileUpdateOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "MEMBER_PROFILE_UPDATE_RESULT_UNKNOWN",
        "保存请求可能已经生效，但页面尚未确认。请保留当前内容并使用同一请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function listWalletDefinitions(
  includeDisabled = false,
): Promise<WalletDefinitionRecord[]> {
  const value = await request<unknown>(
    `/v1/wallet-definitions?includeDisabled=${includeDisabled}`,
    { cache: "no-store" },
  );
  if (!isWalletDefinitionRecordList(value, includeDisabled)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员权益账户资料不完整，无法安全确认；页面已隐藏到账钱包，请重新读取",
    );
  }
  return value;
}

export function walletDefinitionSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "WALLET_DEFINITION_SAVE_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  if (definitelyStoppedBeforeCloud) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

const walletDefinitionWriteResultKeys = [
  "id",
  "name",
  "unit",
  "customUnitLabel",
  "precision",
  "businessType",
  "refundable",
  "enabled",
  "version",
  "createdAt",
  "updatedAt",
  "evidence",
] as const;

function isWalletDefinitionWriteResult(
  value: unknown,
  walletDefinitionId: string,
  input: WalletDefinitionUpsertRequest,
): value is WalletDefinitionRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const keys = Object.keys(record);
  const createdAt =
    typeof record.createdAt === "string" ? Date.parse(record.createdAt) : Number.NaN;
  const updatedAt =
    typeof record.updatedAt === "string" ? Date.parse(record.updatedAt) : Number.NaN;
  const expectedVersion = input.expectedVersion === null ? null : input.expectedVersion + 1;
  return (
    keys.length === walletDefinitionWriteResultKeys.length &&
    walletDefinitionWriteResultKeys.every((key) => Object.hasOwn(record, key)) &&
    record.id === walletDefinitionId &&
    record.name === input.name &&
    record.unit === input.unit &&
    record.customUnitLabel === input.customUnitLabel &&
    record.precision === input.precision &&
    record.businessType === input.businessType &&
    record.refundable === input.refundable &&
    record.enabled === input.enabled &&
    Number.isSafeInteger(record.version) &&
    (record.version as number) >= 1 &&
    (expectedVersion === null || record.version === expectedVersion) &&
    Number.isFinite(createdAt) &&
    Number.isFinite(updatedAt) &&
    updatedAt >= createdAt &&
    (record.evidence === "SIMULATED" || record.evidence === "STORE_ACCEPTED")
  );
}

export async function saveWalletDefinition(
  walletDefinitionId: string,
  input: WalletDefinitionUpsertRequest,
): Promise<WalletDefinitionRecord> {
  try {
    const result = await request<unknown>(
      `/v1/wallet-definitions/${encodeURIComponent(walletDefinitionId)}`,
      {
        method: "PUT",
        body: JSON.stringify(input),
      },
    );
    if (!isWalletDefinitionWriteResult(result, walletDefinitionId, input)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "权益账户保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (walletDefinitionSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "WALLET_DEFINITION_SAVE_RESULT_UNKNOWN",
        "这次内容可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export function listWalletDisplayGroups(
  includeDisabled = false,
): Promise<WalletDisplayGroupRecord[]> {
  return request<unknown>(`/v1/wallet-display-groups?includeDisabled=${includeDisabled}`, {
    cache: "no-store",
  }).then((value) => {
    if (!isWalletDisplayGroupRecordList(value, includeDisabled)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "会员余额展示资料不完整，无法安全确认；页面已隐藏余额分组，请重新读取",
      );
    }
    return value;
  });
}

export function walletDisplayGroupSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "WALLET_DISPLAY_GROUP_SAVE_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  if (definitelyStoppedBeforeCloud) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

const walletDisplayGroupWriteResultKeys = [
  "id",
  "name",
  "unit",
  "presentation",
  "walletDefinitionIds",
  "enabled",
  "version",
  "createdAt",
  "updatedAt",
  "evidence",
] as const;

function isCanonicalWalletDisplayGroupTimestamp(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) && new Date(milliseconds).toISOString() === value;
}

function isWalletDisplayGroupWriteResult(
  value: unknown,
  groupId: string,
  input: WalletDisplayGroupUpsertRequest,
): value is WalletDisplayGroupRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const keys = Object.keys(record);
  const createdAt = isCanonicalWalletDisplayGroupTimestamp(record.createdAt)
    ? Date.parse(record.createdAt)
    : Number.NaN;
  const updatedAt = isCanonicalWalletDisplayGroupTimestamp(record.updatedAt)
    ? Date.parse(record.updatedAt)
    : Number.NaN;
  const expectedVersion = input.expectedVersion === null ? null : input.expectedVersion + 1;
  return (
    keys.length === walletDisplayGroupWriteResultKeys.length &&
    walletDisplayGroupWriteResultKeys.every((key) => Object.hasOwn(record, key)) &&
    record.id === groupId &&
    record.name === input.name &&
    record.unit === input.unit &&
    record.presentation === input.presentation &&
    Array.isArray(record.walletDefinitionIds) &&
    record.walletDefinitionIds.length === input.walletDefinitionIds.length &&
    record.walletDefinitionIds.every(
      (walletDefinitionId, index) => walletDefinitionId === input.walletDefinitionIds[index],
    ) &&
    record.enabled === input.enabled &&
    Number.isSafeInteger(record.version) &&
    (record.version as number) >= 1 &&
    (expectedVersion === null || record.version === expectedVersion) &&
    Number.isFinite(createdAt) &&
    Number.isFinite(updatedAt) &&
    updatedAt >= createdAt &&
    (record.evidence === "SIMULATED" || record.evidence === "STORE_ACCEPTED")
  );
}

export async function saveWalletDisplayGroup(
  groupId: string,
  input: WalletDisplayGroupUpsertRequest,
): Promise<WalletDisplayGroupRecord> {
  if (!/^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/.test(groupId)) {
    throw new ApiRequestError("WALLET_DISPLAY_GROUP_ID_INVALID", "钱包展示分组编号格式不正确", 400);
  }
  try {
    const result = await request<unknown>(
      `/v1/wallet-display-groups/${encodeURIComponent(groupId)}`,
      {
        method: "PUT",
        body: JSON.stringify(input),
      },
    );
    if (!isWalletDisplayGroupWriteResult(result, groupId, input)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "钱包展示分组保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (walletDisplayGroupSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "WALLET_DISPLAY_GROUP_SAVE_RESULT_UNKNOWN",
        "这次内容可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function listWalletPaymentRules(
  includeDisabled = false,
): Promise<WalletPaymentRuleRecord[]> {
  const value = await request<unknown>(
    `/v1/wallet-payment-rules?includeDisabled=${includeDisabled}`,
    { cache: "no-store" },
  );
  if (!isWalletPaymentRuleRecordList(value, includeDisabled)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员余额消费规则资料不完整，无法安全确认；页面已停止显示扣款顺序，请重新读取",
    );
  }
  return value;
}

export async function listWalletPaymentTargets(): Promise<WalletPaymentTargetOption[]> {
  const value = await request<unknown>("/v1/wallet-payment-targets", { cache: "no-store" });
  if (!isWalletPaymentTargetOptionList(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "可使用会员余额的消费项目资料不完整，无法安全确认；页面已停止显示，请重新读取",
    );
  }
  return value;
}

export function walletPaymentRuleSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "WALLET_PAYMENT_RULE_SAVE_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  if (definitelyStoppedBeforeCloud) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

const walletPaymentRuleWriteResultKeys = [
  "id",
  "name",
  "targetType",
  "targetId",
  "mode",
  "externalShortfallAllowed",
  "components",
  "enabled",
  "version",
  "createdAt",
  "updatedAt",
  "evidence",
] as const;

const walletPaymentRuleWriteComponentKeys = [
  "walletDefinitionId",
  "priority",
  "ratioBps",
  "valueFenPerUnit",
  "allowFallback",
] as const;
const walletPaymentRuleWriteRequestKeys = [
  "name",
  "targetType",
  "targetId",
  "mode",
  "externalShortfallAllowed",
  "components",
  "enabled",
  "expectedVersion",
  "idempotencyKey",
] as const;

function isCanonicalWalletPaymentRuleTimestamp(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) && new Date(milliseconds).toISOString() === value;
}

function isWalletPaymentRuleWriteResult(
  value: unknown,
  ruleId: string,
  input: WalletPaymentRuleUpsertRequest,
): value is WalletPaymentRuleRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const inputRecord = input as unknown as Record<string, unknown>;
  const keys = Object.keys(record);
  const inputKeys = Object.keys(inputRecord);
  const createdAt = Date.parse(
    isCanonicalWalletPaymentRuleTimestamp(record.createdAt) ? record.createdAt : "",
  );
  const updatedAt = Date.parse(
    isCanonicalWalletPaymentRuleTimestamp(record.updatedAt) ? record.updatedAt : "",
  );
  const expectedVersion = input.expectedVersion === null ? null : input.expectedVersion + 1;
  if (
    inputKeys.length !== walletPaymentRuleWriteRequestKeys.length ||
    !walletPaymentRuleWriteRequestKeys.every((key) => Object.hasOwn(inputRecord, key)) ||
    !(
      input.expectedVersion === null ||
      (Number.isSafeInteger(input.expectedVersion) && input.expectedVersion >= 1)
    ) ||
    typeof input.idempotencyKey !== "string" ||
    input.idempotencyKey.length < 8 ||
    input.idempotencyKey.length > 128 ||
    keys.length !== walletPaymentRuleWriteResultKeys.length ||
    !walletPaymentRuleWriteResultKeys.every((key) => Object.hasOwn(record, key)) ||
    record.id !== ruleId ||
    typeof record.id !== "string" ||
    record.id.length < 1 ||
    record.name !== input.name ||
    typeof record.name !== "string" ||
    record.name.length < 1 ||
    record.name.length > 80 ||
    record.targetType !== input.targetType ||
    !["ORDER", "PRODUCT", "TABLE_TIME", "COACH_SERVICE"].includes(record.targetType as string) ||
    record.targetId !== input.targetId ||
    !(
      (record.targetType === "ORDER" && record.targetId === null) ||
      (record.targetType !== "ORDER" &&
        typeof record.targetId === "string" &&
        record.targetId.length > 0 &&
        record.targetId.length <= 80)
    ) ||
    record.mode !== input.mode ||
    (record.mode !== "PRIORITY" && record.mode !== "STRICT_RATIO") ||
    record.externalShortfallAllowed !== input.externalShortfallAllowed ||
    typeof record.externalShortfallAllowed !== "boolean" ||
    record.enabled !== input.enabled ||
    typeof record.enabled !== "boolean" ||
    !Number.isSafeInteger(record.version) ||
    (record.version as number) < 1 ||
    (expectedVersion !== null && record.version !== expectedVersion) ||
    !Number.isFinite(createdAt) ||
    !Number.isFinite(updatedAt) ||
    updatedAt < createdAt ||
    (record.evidence !== "SIMULATED" && record.evidence !== "STORE_ACCEPTED") ||
    !Array.isArray(record.components) ||
    record.components.length < 1 ||
    record.components.length > 20 ||
    record.components.length !== input.components.length
  ) {
    return false;
  }
  const walletDefinitionIds = new Set<string>();
  const priorities = new Set<number>();
  let ratioTotal = 0;
  const validComponents = record.components.every((component, index) => {
    if (typeof component !== "object" || component === null || Array.isArray(component)) {
      return false;
    }
    const componentRecord = component as Record<string, unknown>;
    const expected = input.components[index];
    const componentKeys = Object.keys(componentRecord);
    const valid =
      expected !== undefined &&
      componentKeys.length === walletPaymentRuleWriteComponentKeys.length &&
      walletPaymentRuleWriteComponentKeys.every((key) => Object.hasOwn(componentRecord, key)) &&
      typeof componentRecord.walletDefinitionId === "string" &&
      componentRecord.walletDefinitionId.length > 0 &&
      componentRecord.walletDefinitionId.length <= 64 &&
      !walletDefinitionIds.has(componentRecord.walletDefinitionId) &&
      Number.isSafeInteger(componentRecord.priority) &&
      (componentRecord.priority as number) >= 1 &&
      (componentRecord.priority as number) <= 100 &&
      !priorities.has(componentRecord.priority as number) &&
      Number.isSafeInteger(componentRecord.ratioBps) &&
      (componentRecord.ratioBps as number) >= 0 &&
      (componentRecord.ratioBps as number) <= 10_000 &&
      Number.isSafeInteger(componentRecord.valueFenPerUnit) &&
      (componentRecord.valueFenPerUnit as number) >= 1 &&
      (componentRecord.valueFenPerUnit as number) <= 1_000_000 &&
      typeof componentRecord.allowFallback === "boolean" &&
      componentRecord.walletDefinitionId === expected.walletDefinitionId &&
      componentRecord.priority === expected.priority &&
      componentRecord.ratioBps === expected.ratioBps &&
      componentRecord.valueFenPerUnit === expected.valueFenPerUnit &&
      componentRecord.allowFallback === expected.allowFallback;
    if (valid) {
      walletDefinitionIds.add(componentRecord.walletDefinitionId as string);
      priorities.add(componentRecord.priority as number);
      ratioTotal += componentRecord.ratioBps as number;
    }
    return valid;
  });
  if (!validComponents) return false;
  return (
    (record.mode === "PRIORITY" &&
      record.components.every(
        (component) => (component as Record<string, unknown>).ratioBps === 0,
      )) ||
    (record.mode === "STRICT_RATIO" &&
      ratioTotal === 10_000 &&
      record.components.every(
        (component) => (component as Record<string, unknown>).allowFallback === false,
      ))
  );
}

export async function saveWalletPaymentRule(
  ruleId: string,
  input: WalletPaymentRuleUpsertRequest,
): Promise<WalletPaymentRuleRecord> {
  try {
    const result = await request<unknown>(
      `/v1/wallet-payment-rules/${encodeURIComponent(ruleId)}`,
      {
        method: "PUT",
        body: JSON.stringify(input),
      },
    );
    if (!isWalletPaymentRuleWriteResult(result, ruleId, input)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "钱包消费规则保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (walletPaymentRuleSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "WALLET_PAYMENT_RULE_SAVE_RESULT_UNKNOWN",
        "这次内容可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function listRechargePlans(includeDisabled = false): Promise<RechargePlanRecord[]> {
  const value = await request<unknown>(
    `/v1/members/recharge-plans?includeDisabled=${includeDisabled}`,
    { cache: "no-store" },
  );
  if (!isRechargePlanRecordList(value, includeDisabled)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员充值方案资料不完整，无法安全确认；页面已隐藏方案金额，请重新读取",
    );
  }
  return value;
}

export function rechargePlanSaveOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false;
  if (
    [
      "RECHARGE_PLAN_SAVE_RESULT_UNKNOWN",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "CLOUD_UNREACHABLE",
      "CLOUD_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  const definitelyStoppedBeforeCloud =
    error.code === "ONLINE_SERVICE_REQUIRED" ||
    error.code === "CLOUD_COORDINATOR_UNAVAILABLE" ||
    error.code === "WORKFORCE_MUTATION_OUTCOME_UNKNOWN" ||
    error.code.startsWith("AUTHORIZATION_") ||
    error.code.startsWith("NATIVE_");
  if (definitelyStoppedBeforeCloud) return false;
  return error.statusCode === 408 || (error.statusCode !== undefined && error.statusCode >= 500);
}

const rechargePlanWriteResultKeys = [
  "id",
  "name",
  "rechargeAmountFen",
  "bonusAmountFen",
  "allocations",
  "expectedRecharge",
  "description",
  "enabled",
  "validFrom",
  "validUntil",
  "version",
  "createdAt",
  "updatedAt",
  "evidence",
] as const;
const rechargePlanWriteAllocationKeys = ["walletDefinitionId", "amount"] as const;
const rechargePlanWriteExpectedRechargeKeys = [
  "paidAmountFen",
  "principalFen",
  "bonusFen",
  "allocations",
] as const;
const rechargePlanWriteRequestKeys = [
  "name",
  "rechargeAmountFen",
  "bonusAmountFen",
  "allocations",
  "description",
  "enabled",
  "validFrom",
  "validUntil",
  "expectedVersion",
  "idempotencyKey",
] as const;
const rechargePlanWriteRequiredRequestKeys = [
  "name",
  "rechargeAmountFen",
  "description",
  "enabled",
  "validFrom",
  "validUntil",
  "expectedVersion",
  "idempotencyKey",
] as const;

function canonicalRechargePlanTimestamp(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) && new Date(milliseconds).toISOString() === value
    ? value
    : null;
}

function normalizedRechargePlanTimestamp(value: string): string | null {
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) ? new Date(milliseconds).toISOString() : null;
}

function isRechargePlanWriteResult(
  value: unknown,
  planId: string,
  input: RechargePlanUpsertRequest,
): value is RechargePlanRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const inputRecord = input as unknown as Record<string, unknown>;
  const inputKeys = Object.keys(inputRecord);
  const keys = Object.keys(record);
  const inputValidFrom = normalizedRechargePlanTimestamp(input.validFrom);
  const inputValidUntil =
    input.validUntil === null ? null : normalizedRechargePlanTimestamp(input.validUntil);
  const createdAt = canonicalRechargePlanTimestamp(record.createdAt);
  const updatedAt = canonicalRechargePlanTimestamp(record.updatedAt);
  const recordValidFrom = canonicalRechargePlanTimestamp(record.validFrom);
  const recordValidUntil =
    record.validUntil === null ? null : canonicalRechargePlanTimestamp(record.validUntil);
  const expectedVersion = input.expectedVersion === null ? null : input.expectedVersion + 1;
  const inputAllocations = input.allocations;
  const inputAllocationIds = new Set<string>();
  const validInputAllocations =
    inputAllocations === undefined ||
    (Array.isArray(inputAllocations) &&
      inputAllocations.length >= 1 &&
      inputAllocations.length <= 20 &&
      inputAllocations.every((allocation) => {
        const allocationRecord = allocation as unknown as Record<string, unknown>;
        const allocationKeys = Object.keys(allocationRecord);
        const valid =
          allocationKeys.length === rechargePlanWriteAllocationKeys.length &&
          rechargePlanWriteAllocationKeys.every((key) => Object.hasOwn(allocationRecord, key)) &&
          typeof allocation.walletDefinitionId === "string" &&
          allocation.walletDefinitionId.length >= 1 &&
          allocation.walletDefinitionId.length <= 64 &&
          !inputAllocationIds.has(allocation.walletDefinitionId) &&
          Number.isSafeInteger(allocation.amount) &&
          allocation.amount >= 1 &&
          allocation.amount <= 1_000_000_000_000;
        if (valid) inputAllocationIds.add(allocation.walletDefinitionId);
        return valid;
      }));
  if (
    inputKeys.some((key) => !rechargePlanWriteRequestKeys.includes(key as never)) ||
    !rechargePlanWriteRequiredRequestKeys.every((key) => Object.hasOwn(inputRecord, key)) ||
    typeof planId !== "string" ||
    planId.length < 1 ||
    planId.length > 64 ||
    typeof input.name !== "string" ||
    input.name.length < 1 ||
    input.name.length > 80 ||
    !Number.isSafeInteger(input.rechargeAmountFen) ||
    input.rechargeAmountFen < 1 ||
    input.rechargeAmountFen > 100_000_000 ||
    !(
      input.bonusAmountFen === undefined ||
      (Number.isSafeInteger(input.bonusAmountFen) &&
        input.bonusAmountFen >= 0 &&
        input.bonusAmountFen <= 100_000_000)
    ) ||
    !validInputAllocations ||
    typeof input.description !== "string" ||
    input.description.length > 200 ||
    typeof input.enabled !== "boolean" ||
    inputValidFrom === null ||
    (input.validUntil !== null && inputValidUntil === null) ||
    (inputValidUntil !== null && Date.parse(inputValidUntil) <= Date.parse(inputValidFrom)) ||
    !(
      input.expectedVersion === null ||
      (Number.isSafeInteger(input.expectedVersion) && input.expectedVersion >= 1)
    ) ||
    typeof input.idempotencyKey !== "string" ||
    input.idempotencyKey.length < 8 ||
    input.idempotencyKey.length > 128 ||
    keys.length !== rechargePlanWriteResultKeys.length ||
    !rechargePlanWriteResultKeys.every((key) => Object.hasOwn(record, key)) ||
    record.id !== planId ||
    record.name !== input.name ||
    record.rechargeAmountFen !== input.rechargeAmountFen ||
    !Number.isSafeInteger(record.bonusAmountFen) ||
    (record.bonusAmountFen as number) < 0 ||
    (record.bonusAmountFen as number) > 100_000_000 ||
    record.description !== input.description ||
    record.enabled !== input.enabled ||
    recordValidFrom === null ||
    recordValidFrom !== inputValidFrom ||
    (record.validUntil !== null && recordValidUntil === null) ||
    recordValidUntil !== inputValidUntil ||
    (recordValidUntil !== null && Date.parse(recordValidUntil) <= Date.parse(recordValidFrom)) ||
    !Number.isSafeInteger(record.version) ||
    (record.version as number) < 1 ||
    (expectedVersion !== null && record.version !== expectedVersion) ||
    createdAt === null ||
    updatedAt === null ||
    Date.parse(updatedAt) < Date.parse(createdAt) ||
    (record.evidence !== "SIMULATED" && record.evidence !== "STORE_ACCEPTED") ||
    !Array.isArray(record.allocations)
  ) {
    return false;
  }

  const resultAllocations = record.allocations;
  const resultAllocationIds = new Set<string>();
  const validResultAllocations = resultAllocations.every((allocation, index) => {
    if (typeof allocation !== "object" || allocation === null || Array.isArray(allocation)) {
      return false;
    }
    const allocationRecord = allocation as Record<string, unknown>;
    const allocationKeys = Object.keys(allocationRecord);
    const expected = inputAllocations?.[index];
    const valid =
      allocationKeys.length === rechargePlanWriteAllocationKeys.length &&
      rechargePlanWriteAllocationKeys.every((key) => Object.hasOwn(allocationRecord, key)) &&
      typeof allocationRecord.walletDefinitionId === "string" &&
      allocationRecord.walletDefinitionId.length >= 1 &&
      allocationRecord.walletDefinitionId.length <= 64 &&
      !resultAllocationIds.has(allocationRecord.walletDefinitionId) &&
      Number.isSafeInteger(allocationRecord.amount) &&
      (allocationRecord.amount as number) >= 1 &&
      (allocationRecord.amount as number) <= 1_000_000_000_000 &&
      (expected === undefined ||
        (allocationRecord.walletDefinitionId === expected.walletDefinitionId &&
          allocationRecord.amount === expected.amount));
    if (valid) resultAllocationIds.add(allocationRecord.walletDefinitionId as string);
    return valid;
  });
  if (!validResultAllocations) return false;
  if (
    typeof record.expectedRecharge !== "object" ||
    record.expectedRecharge === null ||
    Array.isArray(record.expectedRecharge)
  ) {
    return false;
  }
  const expectedRecharge = record.expectedRecharge as Record<string, unknown>;
  if (
    Object.keys(expectedRecharge).length !== rechargePlanWriteExpectedRechargeKeys.length ||
    !rechargePlanWriteExpectedRechargeKeys.every((key) => Object.hasOwn(expectedRecharge, key)) ||
    expectedRecharge.paidAmountFen !== record.rechargeAmountFen ||
    !Number.isSafeInteger(expectedRecharge.principalFen) ||
    (expectedRecharge.principalFen as number) < 0 ||
    (expectedRecharge.principalFen as number) > 100_000_000 ||
    expectedRecharge.bonusFen !== record.bonusAmountFen ||
    !Array.isArray(expectedRecharge.allocations) ||
    expectedRecharge.allocations.length !== resultAllocations.length ||
    !expectedRecharge.allocations.every((allocation, index) => {
      if (typeof allocation !== "object" || allocation === null || Array.isArray(allocation)) {
        return false;
      }
      const allocationRecord = allocation as Record<string, unknown>;
      const expected = resultAllocations[index] as Record<string, unknown> | undefined;
      return (
        expected !== undefined &&
        Object.keys(allocationRecord).length === rechargePlanWriteAllocationKeys.length &&
        rechargePlanWriteAllocationKeys.every((key) => Object.hasOwn(allocationRecord, key)) &&
        allocationRecord.walletDefinitionId === expected.walletDefinitionId &&
        allocationRecord.amount === expected.amount
      );
    })
  ) {
    return false;
  }
  if (inputAllocations !== undefined) {
    return resultAllocations.length === inputAllocations.length;
  }
  const legacyAmounts = [
    input.rechargeAmountFen,
    ...((input.bonusAmountFen ?? 0) > 0 ? [input.bonusAmountFen ?? 0] : []),
  ];
  return (
    record.bonusAmountFen === (input.bonusAmountFen ?? 0) &&
    resultAllocations.length === legacyAmounts.length &&
    resultAllocations.every(
      (allocation, index) =>
        (allocation as Record<string, unknown>).amount === legacyAmounts[index],
    )
  );
}

export async function saveRechargePlan(
  planId: string,
  input: RechargePlanUpsertRequest,
): Promise<RechargePlanRecord> {
  try {
    const result = await request<unknown>(
      `/v1/members/recharge-plans/${encodeURIComponent(planId)}`,
      {
        method: "PUT",
        body: JSON.stringify(input),
      },
    );
    if (!isRechargePlanWriteResult(result, planId, input)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "充值方案保存结果无法安全确认");
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (rechargePlanSaveOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "RECHARGE_PLAN_SAVE_RESULT_UNKNOWN",
        "这次内容可能已经保存到云端，但页面尚未确认。请保留当前内容并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export function rechargeMember(
  memberId: string,
  input: MemberRechargeRequest,
): Promise<{ recharge: MemberRechargeRecord; member: MemberRecord }> {
  return request(`/v1/members/${encodeURIComponent(memberId)}/recharges`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function listMemberRecharges(pendingOnly = false): Promise<MemberRechargeRecord[]> {
  const value = await request<unknown>(`/v1/member-recharges?pendingOnly=${pendingOnly}`, {
    cache: "no-store",
  });
  if (!isMemberRechargeRecordList(value, pendingOnly)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "待核对充值无法安全确认，页面已隐藏充值记录，请重新读取",
    );
  }
  return value;
}

export interface MemberRechargeReconciliationPreviewBaseline {
  workItemId: string;
  memberName: string;
  method: "STATIC_WECHAT" | "STATIC_ALIPAY";
  amountFen: number;
  createdAt: string;
}

const MEMBER_RECHARGE_WORK_ITEM_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/u;

function memberRechargePreviewBaselineIsValid(
  value: unknown,
): value is MemberRechargeReconciliationPreviewBaseline {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const candidate = value as Partial<MemberRechargeReconciliationPreviewBaseline>;
  return (
    typeof candidate.workItemId === "string" &&
    MEMBER_RECHARGE_WORK_ITEM_ID_PATTERN.test(candidate.workItemId) &&
    typeof candidate.memberName === "string" &&
    [...candidate.memberName].length >= 1 &&
    [...candidate.memberName].length <= 80 &&
    (candidate.method === "STATIC_WECHAT" || candidate.method === "STATIC_ALIPAY") &&
    Number.isSafeInteger(candidate.amountFen) &&
    Number(candidate.amountFen) >= 1 &&
    Number(candidate.amountFen) <= 100_000_000 &&
    typeof candidate.createdAt === "string" &&
    Number.isFinite(Date.parse(candidate.createdAt))
  );
}

function memberRechargeConfirmationRequestIsValid(
  value: unknown,
): value is ConfirmMemberRechargeReconciliationRequest {
  if (
    typeof value !== "object" ||
    value === null ||
    Array.isArray(value) ||
    Object.keys(value).length !== 3
  ) {
    return false;
  }
  const candidate = value as Partial<ConfirmMemberRechargeReconciliationRequest>;
  return (
    typeof candidate.previewId === "string" &&
    MEMBER_RECHARGE_WORK_ITEM_ID_PATTERN.test(candidate.previewId) &&
    typeof candidate.confirmationToken === "string" &&
    /^[a-f0-9]{64}$/u.test(candidate.confirmationToken) &&
    typeof candidate.idempotencyKey === "string" &&
    candidate.idempotencyKey.length >= 8 &&
    candidate.idempotencyKey.length <= 128 &&
    Object.hasOwn(value, "previewId") &&
    Object.hasOwn(value, "confirmationToken") &&
    Object.hasOwn(value, "idempotencyKey")
  );
}

function memberRechargePaymentEvidenceMatches(
  reference: string | null,
  ending: string | null,
): boolean {
  return reference === null
    ? ending === null
    : ending !== null && reference.trim().toUpperCase().slice(-8) === ending;
}

function memberRechargeWalletCreditsEqual(
  left: readonly MemberRechargeReconciliationPreview["walletCredits"][number][],
  right: readonly MemberRechargeReconciliationPreview["walletCredits"][number][],
): boolean {
  return (
    left.length === right.length &&
    left.every((credit, index) => {
      const expected = right[index];
      return (
        expected !== undefined &&
        credit.walletName === expected.walletName &&
        credit.unit === expected.unit &&
        credit.customUnitLabel === expected.customUnitLabel &&
        credit.precision === expected.precision &&
        credit.businessType === expected.businessType &&
        credit.amount === expected.amount
      );
    })
  );
}

function assertMemberRechargeRequestScopeUnchanged(
  expectedScope: typeof operatorRequestScope,
): void {
  if (
    operatorRequestScope.tenantId === expectedScope.tenantId &&
    operatorRequestScope.storeId === expectedScope.storeId &&
    operatorRequestScope.actorId === expectedScope.actorId
  ) {
    return;
  }
  throw new ApiRequestError(
    "OPERATOR_IDENTITY_CHANGED",
    "账号已切换；原账号的充值核对结果不会显示在当前账号，请回到原账号查询最终结果",
  );
}

function memberRechargePreviewMatchesRequest(
  value: unknown,
  workItemId: string,
  input: MemberRechargeReconciliationPreviewRequest,
  baseline: MemberRechargeReconciliationPreviewBaseline,
): value is MemberRechargeReconciliationPreview {
  if (!isMemberRechargeReconciliationPreview(value)) return false;
  const baselineCreatedAt = Date.parse(baseline.createdAt);
  const previewCreatedAt = Date.parse(value.createdAt);
  return (
    value.workItemId === workItemId &&
    value.workItemId === baseline.workItemId &&
    value.outcome === input.outcome &&
    value.memberName === baseline.memberName &&
    value.method === baseline.method &&
    value.requestedPaidAmountFen === baseline.amountFen &&
    value.actualReceivedFen === input.actualReceivedFen &&
    memberRechargePaymentEvidenceMatches(
      input.paymentEvidenceReference,
      value.paymentEvidenceEnding,
    ) &&
    value.note === input.note &&
    Number.isFinite(baselineCreatedAt) &&
    Number.isFinite(previewCreatedAt) &&
    previewCreatedAt >= baselineCreatedAt
  );
}

function memberRechargeResultMatchesPreview(
  value: unknown,
  workItemId: string,
  input: ConfirmMemberRechargeReconciliationRequest,
  preview: MemberRechargeReconciliationPreview,
): value is MemberRechargeReconciliationResult {
  if (!isMemberRechargeReconciliationResult(value)) return false;
  const reconciledAt = Date.parse(value.reconciledAt);
  const previewCreatedAt = Date.parse(preview.createdAt);
  const previewExpiresAt = Date.parse(preview.expiresAt);
  return (
    input.previewId === preview.previewId &&
    input.confirmationToken === preview.confirmationToken &&
    value.workItemId === workItemId &&
    value.workItemId === preview.workItemId &&
    value.previewId === preview.previewId &&
    value.outcome === preview.outcome &&
    value.memberName === preview.memberName &&
    value.method === preview.method &&
    value.requestedPaidAmountFen === preview.requestedPaidAmountFen &&
    value.actualReceivedFen === preview.actualReceivedFen &&
    value.cnyWalletCreditTotalFen === preview.cnyWalletCreditTotalFen &&
    memberRechargeWalletCreditsEqual(value.walletCredits, preview.walletCredits) &&
    value.paymentEvidenceEnding === preview.paymentEvidenceEnding &&
    value.note === preview.note &&
    value.balanceEffect === preview.balanceEffectOnConfirmation &&
    Number.isFinite(reconciledAt) &&
    Number.isFinite(previewCreatedAt) &&
    Number.isFinite(previewExpiresAt) &&
    reconciledAt >= previewCreatedAt &&
    reconciledAt <= previewExpiresAt
  );
}

export async function previewMemberRechargeReconciliation(
  workItemId: string,
  inputSnapshot: MemberRechargeReconciliationPreviewRequest,
  baselineSnapshot: MemberRechargeReconciliationPreviewBaseline,
): Promise<MemberRechargeReconciliationPreview> {
  const input = structuredClone(inputSnapshot);
  const baseline = structuredClone(baselineSnapshot);
  if (
    !MEMBER_RECHARGE_WORK_ITEM_ID_PATTERN.test(workItemId) ||
    !isMemberRechargeReconciliationPreviewRequest(input) ||
    !memberRechargePreviewBaselineIsValid(baseline) ||
    baseline.workItemId !== workItemId
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "充值核对预览内容不完整，系统没有提交",
      400,
    );
  }
  const expectedScope = { ...operatorRequestScope };
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/manual-review/${encodeURIComponent(workItemId)}/member-recharge/reconciliation-previews`,
      {
        method: "POST",
        cache: "no-store",
        body: JSON.stringify(input),
      },
    );
  } catch (error) {
    assertMemberRechargeRequestScopeUnchanged(expectedScope);
    throw error;
  }
  assertMemberRechargeRequestScopeUnchanged(expectedScope);
  if (!memberRechargePreviewMatchesRequest(value, workItemId, input, baseline)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "充值核对预览与原待办或输入不一致，请废弃本次预览后重新生成",
    );
  }
  return value;
}

export async function confirmMemberRechargeReconciliation(
  workItemId: string,
  inputSnapshot: ConfirmMemberRechargeReconciliationRequest,
  previewSnapshot: MemberRechargeReconciliationPreview,
  authorizationToken: string,
): Promise<MemberRechargeReconciliationResult> {
  const input = structuredClone(inputSnapshot);
  const preview = structuredClone(previewSnapshot);
  if (
    !MEMBER_RECHARGE_WORK_ITEM_ID_PATTERN.test(workItemId) ||
    !memberRechargeConfirmationRequestIsValid(input) ||
    !isMemberRechargeReconciliationPreview(preview) ||
    preview.workItemId !== workItemId ||
    input.previewId !== preview.previewId ||
    input.confirmationToken !== preview.confirmationToken
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "充值核对确认内容与原预览不一致，系统没有提交",
      400,
    );
  }
  const expectedScope = { ...operatorRequestScope };
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/manual-review/${encodeURIComponent(workItemId)}/member-recharge/reconcile`,
      {
        method: "POST",
        cache: "no-store",
        headers: secondaryAuthorizationHeaders(authorizationToken),
        body: JSON.stringify(input),
      },
    );
  } catch (error) {
    assertMemberRechargeRequestScopeUnchanged(expectedScope);
    throw error;
  }
  assertMemberRechargeRequestScopeUnchanged(expectedScope);
  if (!memberRechargeResultMatchesPreview(value, workItemId, input, preview)) {
    throw new ApiRequestError(
      "MEMBER_RECHARGE_RECONCILIATION_RESULT_UNKNOWN",
      "充值核对可能已经完成，但返回结果与原预览不一致；请保留原预览并使用同一请求重试",
    );
  }
  return value;
}

export interface MemberReceivableRetryExpected {
  amountFen: number;
  lastAttemptAt: string;
}

export async function retryMemberReceivableManualReview(
  workItemId: string,
  input: MemberReceivableRetryRequest,
  expected: MemberReceivableRetryExpected,
): Promise<MemberReceivableRetryResult> {
  const expectedLastAttemptMilliseconds =
    typeof expected?.lastAttemptAt === "string" ? Date.parse(expected.lastAttemptAt) : Number.NaN;
  if (
    !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/u.test(workItemId) ||
    typeof input !== "object" ||
    input === null ||
    Array.isArray(input) ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/u.test(input.idempotencyKey) ||
    Object.keys(input).length !== 1 ||
    typeof expected !== "object" ||
    expected === null ||
    Array.isArray(expected) ||
    Object.keys(expected).length !== 2 ||
    !Number.isSafeInteger(expected.amountFen) ||
    expected.amountFen < 1 ||
    !Number.isFinite(expectedLastAttemptMilliseconds) ||
    new Date(expectedLastAttemptMilliseconds).toISOString() !== expected.lastAttemptAt
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "会员应收工作项、待扣金额、上次尝试时间或原请求号无法安全确认，系统没有发出请求",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/manual-review/${encodeURIComponent(workItemId)}/member-receivable/retry`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify({ idempotencyKey: input.idempotencyKey }),
    },
  );
  if (
    !isMemberReceivableRetryResult(value) ||
    value.workItemId !== workItemId ||
    value.amountFen !== expected.amountFen ||
    Date.parse(value.retriedAt) < expectedLastAttemptMilliseconds
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员应收重试结果无法安全确认，原请求已保留，请使用同一请求安全重试",
    );
  }
  return value;
}

export function getMemberRefundStatus(
  input: MemberRefundRequest,
): Promise<MemberRefundStatusResult> {
  return request("/v1/member-funds/refund-status", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function previewMemberBalanceRefundApproval(
  requestSnapshot: PreviewMemberBalanceRefundApprovalRequest,
): Promise<MemberBalanceRefundApprovalPreviewReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewMemberBalanceRefundApprovalRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "余额退款金额或原因不完整，请补充后再检查",
    );
  }
  const value = await request<unknown>("/v1/member-funds/refund-approvals/preview", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  if (
    !isMemberBalanceRefundApprovalPreviewReadModel(value) ||
    value.memberId !== input.memberId ||
    value.amountFen !== input.amountFen ||
    value.reason !== input.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "余额退款检查结果无法安全确认，请不要提交，重新读取会员资金流水后再试",
    );
  }
  return value;
}

export async function createMemberBalanceRefundApproval(
  requestSnapshot: CreateMemberBalanceRefundApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateMemberBalanceRefundApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "余额退款申请内容不完整，请重新检查原消费、金额和原因",
    );
  }
  const value = await request<unknown>("/v1/member-funds/refund-approvals", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  if (
    !isApprovalRequestReadModel(value) ||
    value.snapshot.kind !== "MEMBER_BALANCE_REFUND" ||
    value.snapshot.memberId !== input.memberId ||
    value.snapshot.amountFen !== input.amountFen ||
    value.snapshot.reason !== input.reason ||
    value.snapshot.sourceReferenceSha256 !== input.sourceReferenceSha256 ||
    value.snapshot.businessFactSha256 !== input.businessFactSha256
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "余额退款审批申请结果无法安全确认，请保留原申请并去统一审批中心查询",
    );
  }
  return value;
}

export async function previewInventoryOperationApproval(
  requestSnapshot: PreviewInventoryOperationApprovalRequest,
): Promise<InventoryOperationApprovalPreviewReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewInventoryOperationApprovalRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "库存操作的商品、类型、数量或原因不完整，请修改后再检查",
    );
  }
  const value = await request<unknown>(
    `/v1/inventory/products/${encodeURIComponent(input.skuId)}/operation-approvals/preview`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (
    !isInventoryOperationApprovalPreviewReadModel(value) ||
    value.skuId !== input.skuId ||
    value.operationType !== input.operationType ||
    value.requestedQuantity !== input.quantity ||
    value.unitCostFen !== input.unitCostFen ||
    value.referenceNumber !== input.referenceNumber ||
    value.reason !== input.reason ||
    (input.operationType === "LOSS_OUT" &&
      (input.unitCostFen !== null || value.unitCostFen !== null || value.lossCapture === undefined))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "库存操作检查结果无法安全确认，请不要提交，重新读取商品和库存后再试",
    );
  }
  return value;
}

export async function createInventoryOperationApproval(
  requestSnapshot: CreateInventoryOperationApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateInventoryOperationApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "库存审批申请内容不完整，请重新检查商品、数量和原因",
    );
  }
  const value = await request<unknown>(
    `/v1/inventory/products/${encodeURIComponent(input.skuId)}/operation-approvals`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (
    !isApprovalRequestReadModel(value) ||
    value.snapshot.kind !== "INVENTORY_OPERATION" ||
    value.snapshot.skuId !== input.skuId ||
    value.snapshot.operationType !== input.operationType ||
    value.snapshot.requestedQuantity !== input.quantity ||
    value.snapshot.unitCostFen !== input.unitCostFen ||
    value.snapshot.referenceNumber !== input.referenceNumber ||
    value.snapshot.reason !== input.reason ||
    value.snapshot.sourceReferenceSha256 !== input.sourceReferenceSha256 ||
    value.snapshot.businessFactSha256 !== input.businessFactSha256 ||
    (input.operationType === "LOSS_OUT" &&
      (input.unitCostFen !== null ||
        value.snapshot.snapshotVersion !== 2 ||
        value.snapshot.unitCostFen !== null ||
        value.snapshot.lossCapture === undefined))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "库存审批申请结果无法安全确认，请保留原申请并去统一审批中心查询",
    );
  }
  return value;
}

export async function getInventoryCountProgress(
  skuId: string,
  approvalId: string,
): Promise<InventoryCountProgressReadModel> {
  if (!skuId.trim() || !approvalId.trim()) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "盘点商品或审批编号不完整，请重新打开这笔审批",
    );
  }
  const value = await request<unknown>(
    `/v1/inventory/products/${encodeURIComponent(skuId)}/count-approvals/${encodeURIComponent(approvalId)}/progress`,
    { cache: "no-store" },
  );
  if (
    !isInventoryCountProgressReadModel(value) ||
    value.skuId !== skuId ||
    value.approvalId !== approvalId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "盘点期间变化无法安全确认，旧进度已隐藏，本次不能执行",
    );
  }
  return value;
}

export async function listMemberTransactions(
  memberId: string,
): Promise<MemberFundTransactionReadModel[]> {
  const value = await request<unknown>(`/v1/members/${encodeURIComponent(memberId)}/transactions`, {
    cache: "no-store",
  });
  if (!isMemberFundTransactionReadModelList(value, memberId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员资金流水无法安全确认，页面已隐藏金额记录，请重新读取",
    );
  }
  return value;
}

export async function getMemberDashboard(): Promise<MemberDashboard> {
  const value = await request<unknown>("/v1/members-dashboard", { cache: "no-store" });
  if (!isMemberDashboard(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员经营概览无法安全确认，页面已隐藏汇总金额，请重新读取",
    );
  }
  return value;
}

export async function openSession(
  tableId: string,
  idempotencyKey: string,
  expectedTableRevision: number,
  expectedScope?: { tenantId: string; storeId: string },
  selection?: {
    pricingPlanId: string;
    expectedPricingPlanVersion: number;
    pricingPlanName: string;
  },
  customerRequestEventId?: string,
): Promise<TableSnapshot> {
  if (!Number.isSafeInteger(expectedTableRevision) || expectedTableRevision < 0) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "开台前看到的球台版本无法安全确认，请刷新球台后重试",
    );
  }
  if (
    selection !== undefined &&
    (!/^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/u.test(selection.pricingPlanId) ||
      !Number.isSafeInteger(selection.expectedPricingPlanVersion) ||
      selection.expectedPricingPlanVersion < 1 ||
      selection.pricingPlanName !== selection.pricingPlanName.trim() ||
      [...selection.pricingPlanName].length < 1 ||
      [...selection.pricingPlanName].length > 80)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "所选价格方案无法安全确认，请重新读取价格方案后再开台",
    );
  }
  if (
    customerRequestEventId !== undefined &&
    (customerRequestEventId !== customerRequestEventId.trim() ||
      [...customerRequestEventId].length < 8 ||
      [...customerRequestEventId].length > 128)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "关联的顾客开台申请无法安全确认，请返回员工工作中心重新进入",
    );
  }
  const command: FrontdeskOpenSessionRequest = {
    tableId,
    idempotencyKey,
    expectedTableRevision,
    ...(selection
      ? {
          pricingPlanId: selection.pricingPlanId,
          expectedPricingPlanVersion: selection.expectedPricingPlanVersion,
        }
      : {}),
    ...(customerRequestEventId === undefined ? {} : { customerRequestEventId }),
  };
  if (!isFrontdeskOpenSessionRequest(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "开台请求无法安全确认，请刷新球台和价格方案后重试",
    );
  }
  const result = await request<unknown>("/v1/sessions/open", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  if (
    !isTableSnapshot(result) ||
    result.tableId !== tableId ||
    result.state !== "IN_USE" ||
    !result.sessionId ||
    !result.sessionStartedAt ||
    result.billingState !== "RUNNING" ||
    result.revision <= expectedTableRevision ||
    (selection !== undefined && result.pricingPlanName !== selection.pricingPlanName) ||
    (expectedScope !== undefined &&
      (result.tenantId !== expectedScope.tenantId || result.storeId !== expectedScope.storeId))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "开台结果无法安全确认；系统不会把这次操作显示为成功，请使用原请求继续核对",
    );
  }
  return result;
}

export async function previewMemberPrepaidSessionOpen(
  input: MemberPrepaidSessionOpenPreviewRequest,
): Promise<MemberPrepaidSessionOpenPreview> {
  const value = await request<unknown>("/v1/sessions/open/prepaid-preview", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  if (
    !isMemberPrepaidSessionOpenPreview(value) ||
    value.tableId !== input.tableId ||
    value.expectedTableRevision !== input.expectedTableRevision ||
    value.pricingPlanId !== input.pricingPlanId ||
    value.expectedPricingPlanVersion !== input.expectedPricingPlanVersion ||
    value.memberId !== input.memberId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员预付开台预览与当前球台、方案或会员不一致，页面不会开放确认。",
    );
  }
  return value;
}

function memberPrepaidOpenResultMatches(
  value: unknown,
  command: MemberPrepaidSessionOpenRequest,
): value is TableSnapshot {
  return (
    isTableSnapshot(value) &&
    value.tenantId === command.preview.tenantId &&
    value.storeId === command.preview.storeId &&
    value.tableId === command.preview.tableId &&
    value.tableNumber === command.preview.tableNumber &&
    value.state === "IN_USE" &&
    value.sessionId === command.preview.proposedSessionId &&
    value.billingState === "RUNNING" &&
    value.pricingPlanName === command.preview.pricingPlanName &&
    value.funding?.paymentTiming === "PREPAID" &&
    value.funding.paymentMethod === "MEMBER_BALANCE" &&
    value.funding.memberId === command.preview.memberId &&
    value.funding.prepaidFen === command.preview.prepaidFen &&
    value.funding.prepaymentStatus === "CONFIRMED"
  );
}

export async function openMemberPrepaidSession(
  command: MemberPrepaidSessionOpenRequest,
): Promise<TableSnapshot> {
  if (!isMemberPrepaidSessionOpenRequest(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "会员预付开台确认内容不完整，请重新预览。",
      400,
    );
  }
  const value = await request<unknown>("/v1/sessions/open/prepaid", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  if (!memberPrepaidOpenResultMatches(value, command)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员扣款后的开台结果无法安全核对；原请求已保留，请勿换请求号重复提交。",
    );
  }
  return value;
}

export async function getMemberPrepaidSessionOpenResult(
  command: MemberPrepaidSessionOpenRequest,
): Promise<TableSnapshot> {
  if (!isMemberPrepaidSessionOpenRequest(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原会员预付开台请求不完整，系统没有查询其他记录。",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/sessions/open/prepaid/by-request/${encodeURIComponent(command.idempotencyKey)}`,
    { cache: "no-store" },
  );
  if (!memberPrepaidOpenResultMatches(value, command)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "已保存的会员预付开台结果与原请求不一致，系统已停止展示。",
    );
  }
  return value;
}

export async function getFrontdeskPricingOptions(
  tableId: string,
  expectedScope: { tenantId: string; storeId: string },
): Promise<FrontdeskPricingOptionsReadModel> {
  if (
    tableId !== tableId.trim() ||
    tableId.length < 1 ||
    tableId.length > 128 ||
    expectedScope.tenantId !== expectedScope.tenantId.trim() ||
    expectedScope.tenantId.length < 1 ||
    expectedScope.storeId !== expectedScope.storeId.trim() ||
    expectedScope.storeId.length < 1
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "球台或门店范围无法安全确认，系统没有读取价格方案",
    );
  }
  const value = await request<unknown>(
    `/v1/tables/${encodeURIComponent(tableId)}/pricing-options`,
    { cache: "no-store" },
  );
  if (
    !isFrontdeskPricingOptionsReadModel(value) ||
    value.tenantId !== expectedScope.tenantId ||
    value.storeId !== expectedScope.storeId ||
    value.tableId !== tableId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "价格方案无法与当前门店和球台对应，旧选项已隐藏，请重新读取",
    );
  }
  return value;
}

export async function getOrder(sessionId: string): Promise<OrderDetail> {
  const result = await request<unknown>(`/v1/sessions/${sessionId}/order`, {
    cache: "no-store",
  });
  if (!isOrderDetailReadModel(result) || result.sessionId !== sessionId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "台单内容无法安全确认；商品、收款和结账已暂停，请刷新后重试",
    );
  }
  return result;
}

export async function listPaidOrderItemReturnCandidates(): Promise<PaidOrderReturnCandidateListReadModel> {
  const value = await request<unknown>("/v1/approvals/order-item-paid-returns/candidates", {
    cache: "no-store",
  });
  if (!isPaidOrderReturnCandidateListReadModel(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "已结账商品退回清单无法安全确认，旧内容已隐藏，请重新读取",
    );
  }
  return value;
}

export async function previewPaidOrderItemReturnApproval(
  requestSnapshot: PreviewPaidOrderItemReturnApprovalRequest,
): Promise<PaidOrderItemReturnApprovalPreviewReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewPaidOrderItemReturnApprovalRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "商品、退回数量或原因不完整，请检查后再预览",
    );
  }
  const value = await request<unknown>("/v1/approvals/order-item-paid-returns/preview", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  if (
    !isPaidOrderItemReturnApprovalPreviewReadModel(value) ||
    value.orderId !== input.orderId ||
    value.itemId !== input.itemId ||
    value.returnQuantity !== input.quantity ||
    value.physicalDisposition !== input.physicalDisposition ||
    value.reason !== input.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "商品退回影响无法安全确认，请不要提交，重新读取原订单后再试",
    );
  }
  return value;
}

export async function createPaidOrderItemReturnApproval(
  requestSnapshot: CreatePaidOrderItemReturnApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreatePaidOrderItemReturnApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "商品退回申请内容不完整，请重新检查商品、数量和原因",
    );
  }
  const value = await request<unknown>("/v1/approvals/order-item-paid-returns", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  if (
    !isApprovalRequestReadModel(value) ||
    value.snapshot.kind !== "ORDER_ITEM_PAID_RETURN" ||
    value.snapshot.orderId !== input.orderId ||
    value.snapshot.itemId !== input.itemId ||
    value.snapshot.returnQuantity !== input.quantity ||
    value.snapshot.physicalDisposition !== input.physicalDisposition ||
    value.snapshot.reason !== input.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "商品退回审批申请结果无法安全确认，请保留原请求并查询最新状态",
    );
  }
  return value;
}

export interface PaidOrderItemReturnExecutionExpected {
  approvalSnapshotVersion: 1 | 2 | 3 | 4;
  itemId: string;
  returnQuantity: number;
  amountFen: number;
  paymentMethod: PaidOrderItemReturnApprovalPreviewReadModel["paymentMethod"];
  refundExecutionMode:
    | "LOCAL_CASH_CONFIRMATION"
    | "MANUAL_STATIC_CODE_CONFIRMATION"
    | "MEMBER_BALANCE_CLOUD_REFUND"
    | "OFFICIAL_PROVIDER_REFUND"
    | null;
  refundAllocations?: PaidSaleReturnOriginalPayment[];
  returnedQuantityAfter: number;
  physicalDisposition: PaidOrderItemReturnApprovalPreviewReadModel["physicalDisposition"];
  inventoryEffect: PaidOrderItemReturnApprovalPreviewReadModel["inventoryEffect"];
  inventoryQuantityBefore: number | null;
  inventoryQuantityAfter: number | null;
  inventorySnapshotKnown: boolean;
}

export async function executePaidOrderItemReturn(
  requestSnapshot: ExecutePaidOrderItemReturnCommand,
  expectedSnapshot: PaidOrderItemReturnExecutionExpected,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  const expected = structuredClone(expectedSnapshot);
  const refundAllocations = expected.refundAllocations;
  const combinedRefund = refundAllocations !== undefined;
  const staticRefundAllocations = refundAllocations?.filter(
    (allocation) => allocation.method === "STATIC_WECHAT" || allocation.method === "STATIC_ALIPAY",
  );
  const externalRefundReferences = input.externalRefundReferences ?? [];
  const staticReferenceIds = new Set(externalRefundReferences.map((item) => item.paymentId));
  const combinedReferencesValid =
    combinedRefund &&
    input.externalRefundReference === null &&
    externalRefundReferences.length === staticRefundAllocations?.length &&
    staticReferenceIds.size === externalRefundReferences.length &&
    staticRefundAllocations.every((allocation) =>
      externalRefundReferences.some((reference) => reference.paymentId === allocation.paymentId),
    );
  const allocationPlanValid =
    combinedRefund &&
    (expected.approvalSnapshotVersion === 3 || expected.approvalSnapshotVersion === 4) &&
    expected.paymentMethod === null &&
    expected.refundExecutionMode === null &&
    refundAllocations.length >= (expected.approvalSnapshotVersion === 4 ? 1 : 2) &&
    refundAllocations.reduce((total, allocation) => total + allocation.refundAmountFen, 0) ===
      expected.amountFen;
  const staticCodeRefund =
    !combinedRefund && expected.refundExecutionMode === "MANUAL_STATIC_CODE_CONFIRMATION";
  const inventoryExpectationValid =
    expected.approvalSnapshotVersion === 4
      ? expected.returnQuantity === 1 &&
        expected.returnedQuantityAfter === 1 &&
        expected.inventoryQuantityBefore === null &&
        expected.inventoryQuantityAfter === null
      : expected.inventorySnapshotKnown
        ? expected.physicalDisposition === "SALEABLE_RETURNED"
          ? Number.isSafeInteger(expected.inventoryQuantityBefore) &&
            (expected.inventoryQuantityBefore as number) >= 0 &&
            Number.isSafeInteger(expected.inventoryQuantityAfter) &&
            expected.inventoryQuantityAfter ===
              (expected.inventoryQuantityBefore as number) + expected.returnQuantity
          : expected.approvalSnapshotVersion === 1
            ? Number.isSafeInteger(expected.inventoryQuantityBefore) &&
              (expected.inventoryQuantityBefore as number) >= 0 &&
              expected.inventoryQuantityAfter === expected.inventoryQuantityBefore
            : expected.inventoryQuantityBefore === null && expected.inventoryQuantityAfter === null
        : expected.approvalSnapshotVersion === 1 &&
          expected.physicalDisposition === "SALEABLE_RETURNED" &&
          expected.inventoryQuantityBefore === null &&
          expected.inventoryQuantityAfter === null;
  const paymentMatchesExecutionMode = combinedRefund
    ? allocationPlanValid
    : (expected.paymentMethod === "CASH" &&
        expected.refundExecutionMode === "LOCAL_CASH_CONFIRMATION") ||
      ((expected.paymentMethod === "STATIC_WECHAT" || expected.paymentMethod === "STATIC_ALIPAY") &&
        expected.refundExecutionMode === "MANUAL_STATIC_CODE_CONFIRMATION") ||
      (expected.paymentMethod === "MEMBER_BALANCE" &&
        expected.refundExecutionMode === "MEMBER_BALANCE_CLOUD_REFUND") ||
      ((expected.paymentMethod === "WECHAT_PAY" || expected.paymentMethod === "ALIPAY") &&
        expected.refundExecutionMode === "OFFICIAL_PROVIDER_REFUND");
  if (
    !isExecutePaidOrderItemReturnCommand(input) ||
    !expected.itemId ||
    !Number.isSafeInteger(expected.returnQuantity) ||
    expected.returnQuantity < 1 ||
    !Number.isSafeInteger(expected.amountFen) ||
    expected.amountFen < 1 ||
    !Number.isSafeInteger(expected.returnedQuantityAfter) ||
    expected.returnedQuantityAfter < expected.returnQuantity ||
    ![1, 2, 3, 4].includes(expected.approvalSnapshotVersion) ||
    expected.inventoryEffect !==
      saleReturnInventoryEffectForDisposition(expected.physicalDisposition) ||
    !inventoryExpectationValid ||
    !paymentMatchesExecutionMode ||
    (combinedRefund
      ? !combinedReferencesValid
      : input.externalRefundReferences !== undefined ||
        (staticCodeRefund
          ? input.externalRefundReference === null
          : input.externalRefundReference !== null))
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      combinedRefund
        ? "组合退款的逐路确认或外部退款凭证不完整，请按每一路原收款重新核对"
        : staticCodeRefund
          ? "请填写 2 至 128 字的外部退款凭证，再执行已批准的退回"
          : "当前退款方式不需要外部退款凭证，请重新读取审批后再试",
    );
  }
  const value = await request<unknown>(
    `/v1/approvals/${encodeURIComponent(input.approvalId)}/paid-return-execute`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (
    !isApprovalRequestReadModel(value) ||
    value.approvalId !== input.approvalId ||
    value.version < input.expectedCaseVersion ||
    value.status !== "APPROVED" ||
    value.snapshot.kind !== "ORDER_ITEM_PAID_RETURN" ||
    value.snapshot.snapshotVersion !== expected.approvalSnapshotVersion ||
    value.snapshot.itemId !== expected.itemId ||
    value.snapshot.returnQuantity !== expected.returnQuantity ||
    value.snapshot.amountFen !== expected.amountFen ||
    value.snapshot.paymentMethod !== expected.paymentMethod ||
    value.snapshot.refundExecutionMode !== expected.refundExecutionMode ||
    JSON.stringify(value.snapshot.refundAllocations) !== JSON.stringify(refundAllocations) ||
    value.snapshot.returnedQuantityAfter !== expected.returnedQuantityAfter ||
    value.snapshot.physicalDisposition !== expected.physicalDisposition ||
    value.snapshot.inventoryEffect !== expected.inventoryEffect ||
    (expected.inventorySnapshotKnown &&
      (value.snapshot.inventoryQuantityBefore !== expected.inventoryQuantityBefore ||
        value.snapshot.inventoryQuantityAfter !== expected.inventoryQuantityAfter))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "商品退回、退款或库存结果无法安全确认；系统保留原请求，请先查询，不能重复执行",
    );
  }
  return value;
}

export async function previewOrderCashRefundApproval(
  requestSnapshot: PreviewOrderCashRefundApprovalRequest,
): Promise<OrderCashRefundApprovalPreviewReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isPreviewOrderCashRefundApprovalRequest(input)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "退款金额或原因不完整，请检查后再预览");
  }
  const value = await request<unknown>(
    `/v1/orders/${encodeURIComponent(input.orderId)}/refund-approvals/preview`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  if (
    !isOrderCashRefundApprovalPreviewReadModel(value) ||
    value.orderId !== input.orderId ||
    value.amountFen !== input.amountFen ||
    value.reason !== input.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "退款申请检查结果无法安全确认，请不要提交，重新读取订单后再试",
    );
  }
  return value;
}

export async function createOrderCashRefundApproval(
  requestSnapshot: CreateOrderCashRefundApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateOrderCashRefundApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "退款申请内容不完整，请重新检查原单和金额",
    );
  }
  const value = await request<unknown>(
    `/v1/orders/${encodeURIComponent(input.orderId)}/refund-approvals`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  if (
    !isApprovalRequestReadModel(value) ||
    value.snapshot.kind !== "ORDER_CASH_REFUND" ||
    value.snapshot.orderId !== input.orderId ||
    value.snapshot.amountFen !== input.amountFen ||
    value.snapshot.reason !== input.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "退款审批申请结果无法安全确认，请保留原请求并查询最新状态",
    );
  }
  return value;
}

export async function getApprovalSummary(): Promise<ApprovalSummaryReadModel> {
  const value = await request<unknown>("/v1/approvals/summary", { cache: "no-store" });
  if (!isApprovalSummaryReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "审批数量无法安全确认，请重新读取");
  }
  return value;
}

export async function listApprovals(view: ApprovalListView): Promise<ApprovalRequestListReadModel> {
  if (!isApprovalListView(view)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "审批清单分类不正确");
  }
  const value = await request<unknown>(`/v1/approvals?view=${encodeURIComponent(view)}`, {
    cache: "no-store",
  });
  if (!isApprovalRequestListReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "审批清单无法安全确认，旧内容已隐藏");
  }
  return value;
}

export async function getApproval(approvalId: string): Promise<ApprovalRequestReadModel> {
  const value = await request<unknown>(`/v1/approvals/${encodeURIComponent(approvalId)}`, {
    cache: "no-store",
  });
  if (!isApprovalRequestReadModel(value) || value.approvalId !== approvalId) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "审批详情无法安全确认，旧内容已隐藏");
  }
  return value;
}

export async function decideApproval(
  requestSnapshot: DecideApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isDecideApprovalCommand(input)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "审批原因或当前步骤不完整");
  }
  const value = await request<unknown>(
    `/v1/approvals/${encodeURIComponent(input.approvalId)}/decisions`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  const expectedStatus = input.decision === "REJECT" ? "REJECTED" : null;
  if (
    !isApprovalRequestReadModel(value) ||
    value.approvalId !== input.approvalId ||
    value.version <= input.expectedCaseVersion ||
    (expectedStatus !== null && value.status !== expectedStatus) ||
    (input.decision === "APPROVE" &&
      value.steps[input.expectedStepNumber - 1]?.status !== "APPROVED")
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "审批决定结果无法安全确认，请保留原决定并查询最新状态",
    );
  }
  return value;
}

export async function cancelApproval(
  requestSnapshot: CancelApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCancelApprovalCommand(input)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "撤回原因或申请版本不完整");
  }
  const value = await request<unknown>(
    `/v1/approvals/${encodeURIComponent(input.approvalId)}/cancel`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  if (
    !isApprovalRequestReadModel(value) ||
    value.approvalId !== input.approvalId ||
    value.version <= input.expectedCaseVersion ||
    value.status !== "CANCELLED"
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "撤回结果无法安全确认，请保留原请求并查询最新状态",
    );
  }
  return value;
}

export async function executeApproval(
  requestSnapshot: RetryApprovalExecutionCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isRetryApprovalExecutionCommand(input)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "执行申请编号、版本或操作编号不完整");
  }
  const value = await request<unknown>(
    `/v1/approvals/${encodeURIComponent(input.approvalId)}/execution`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(input),
    },
  );
  if (
    !isApprovalRequestReadModel(value) ||
    value.approvalId !== input.approvalId ||
    value.status !== "APPROVED" ||
    value.version <= input.expectedCaseVersion ||
    value.execution.status === "AWAITING_APPROVAL" ||
    value.execution.status === "NOT_APPLICABLE" ||
    value.execution.status === "READY"
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "审批执行结果无法安全确认；系统保留原请求，请先查询，不能重复执行",
    );
  }
  return value;
}

export interface SessionTransferExpectedResult {
  sourceTable: TableSnapshot;
  targetTable: TableSnapshot;
  baselineOrder: OrderDetail;
}

export interface SessionTransferResult {
  order: OrderDetail;
  sourceTable: TableSnapshot;
  targetTable: TableSnapshot;
}

function normalizedOrderPriceSnapshots(
  order: OrderDetail,
): NonNullable<OrderDetail["priceSnapshots"]> {
  return order.priceSnapshots ?? [order.priceSnapshot];
}

function transferredPriceSnapshotsAreConsistent(
  order: OrderDetail,
  baseline: OrderDetail,
): boolean {
  const baselineSnapshots = normalizedOrderPriceSnapshots(baseline);
  const resultSnapshots = normalizedOrderPriceSnapshots(order);
  const transferPricingMode = baseline.priceSnapshot.transferPricingMode ?? "CONTINUE";
  if (transferPricingMode === "CONTINUE") {
    return (
      jsonEqual(order.priceSnapshot, baseline.priceSnapshot) &&
      jsonEqual(resultSnapshots, baselineSnapshots)
    );
  }
  if (baseline.priceSnapshot.billingMode === "PACKAGE") return false;
  if (
    resultSnapshots.length < baselineSnapshots.length ||
    resultSnapshots.length > baselineSnapshots.length + 1 ||
    !baselineSnapshots.every((snapshot, index) => jsonEqual(resultSnapshots[index], snapshot))
  ) {
    return false;
  }
  const snapshotKeys = new Set<string>();
  for (const snapshot of resultSnapshots) {
    const key = JSON.stringify([snapshot.id, snapshot.version]);
    if (snapshotKeys.has(key)) return false;
    snapshotKeys.add(key);
  }
  return resultSnapshots.some((snapshot) => jsonEqual(snapshot, order.priceSnapshot));
}

function transferredOrderIsConsistent(
  value: unknown,
  sessionId: string,
  expected: SessionTransferExpectedResult,
): value is OrderDetail {
  if (!isOrderDetail(value)) return false;
  const baseline = expected.baselineOrder;
  const tableFeeDelta = value.tableFeeFen - baseline.tableFeeFen;
  return (
    baseline.status === "OPEN" &&
    baseline.sessionId === sessionId &&
    baseline.tableId === expected.sourceTable.tableId &&
    baseline.tableNumber === expected.sourceTable.tableNumber &&
    expected.sourceTable.state === "IN_USE" &&
    expected.sourceTable.sessionId === sessionId &&
    expected.sourceTable.sessionStartedAt === baseline.startedAt &&
    expected.sourceTable.billingState === baseline.billingState &&
    expected.sourceTable.billingPausedAt === baseline.billingPausedAt &&
    expected.sourceTable.pricingPlanName === baseline.priceSnapshot.name &&
    expected.sourceTable.estimatedFeeFen === baseline.tableFeeFen &&
    expected.sourceTable.currentTotalFen === baseline.totalFen &&
    expected.targetTable.state === "IDLE" &&
    expected.targetTable.sessionId === null &&
    expected.targetTable.sessionStartedAt === null &&
    expected.targetTable.billingState === "ENDED" &&
    expected.targetTable.billingPausedAt === null &&
    expected.targetTable.pricingPlanName === null &&
    expected.targetTable.estimatedFeeFen === 0 &&
    expected.targetTable.currentTotalFen === 0 &&
    expected.targetTable.sessionElapsedSeconds === 0 &&
    expected.sourceTable.tenantId === expected.targetTable.tenantId &&
    expected.sourceTable.storeId === expected.targetTable.storeId &&
    expected.sourceTable.tableId !== expected.targetTable.tableId &&
    value.id === baseline.id &&
    value.sessionId === sessionId &&
    value.tableId === expected.targetTable.tableId &&
    value.tableNumber === expected.targetTable.tableNumber &&
    value.businessDate === baseline.businessDate &&
    value.status === "OPEN" &&
    value.billingState === baseline.billingState &&
    value.billingPausedAt === baseline.billingPausedAt &&
    value.startedAt === baseline.startedAt &&
    value.endedAt === null &&
    value.tableFeeFen >= baseline.tableFeeFen &&
    Number.isSafeInteger(tableFeeDelta) &&
    value.productTotalFen === baseline.productTotalFen &&
    value.coachServiceTotalFen === baseline.coachServiceTotalFen &&
    value.totalFen - baseline.totalFen === tableFeeDelta &&
    value.paidFen === baseline.paidFen &&
    value.refundedFen === baseline.refundedFen &&
    value.offlineOrigin === baseline.offlineOrigin &&
    sessionBillingBreakdownIsConsistent(baseline) &&
    sessionBillingBreakdownIsConsistent(value) &&
    transferredPriceSnapshotsAreConsistent(value, baseline) &&
    jsonEqual(value.voidedAt, baseline.voidedAt) &&
    jsonEqual(value.voidReason, baseline.voidReason) &&
    jsonEqual(value.items, baseline.items) &&
    jsonEqual(value.coachServiceItems, baseline.coachServiceItems) &&
    jsonEqual(value.groupBuyFulfillments, baseline.groupBuyFulfillments) &&
    jsonEqual(value.payments, baseline.payments) &&
    jsonEqual(value.refunds, baseline.refunds)
  );
}

function tableListIsConsistent(
  value: unknown,
  order: OrderDetail,
  expected: SessionTransferExpectedResult,
): value is TableSnapshot[] {
  if (!Array.isArray(value) || !value.every(isTableSnapshot)) return false;
  const tableIds = new Set<string>();
  const tableNodeIds = new Set<string>();
  const tableNumbers = new Set<string>();
  for (const table of value) {
    if (
      table.tenantId !== expected.sourceTable.tenantId ||
      table.storeId !== expected.sourceTable.storeId ||
      tableIds.has(table.tableId) ||
      tableNodeIds.has(table.tableNodeId) ||
      tableNumbers.has(table.tableNumber)
    ) {
      return false;
    }
    tableIds.add(table.tableId);
    tableNodeIds.add(table.tableNodeId);
    tableNumbers.add(table.tableNumber);
  }
  const source = value.find((table) => table.tableId === expected.sourceTable.tableId);
  const target = value.find((table) => table.tableId === expected.targetTable.tableId);
  if (!source || !target) return false;
  const sourceAuthoritativeAt = Date.parse(source.authoritativeAt);
  const targetAuthoritativeAt = Date.parse(target.authoritativeAt);
  const targetEstimatedFeeFen = target.estimatedFeeFen;
  const targetCurrentTotalFen = target.currentTotalFen;
  const targetFeeDelta =
    typeof targetEstimatedFeeFen === "number" ? targetEstimatedFeeFen - order.tableFeeFen : -1;
  const targetTotalDelta =
    typeof targetCurrentTotalFen === "number" ? targetCurrentTotalFen - order.totalFen : -1;
  return (
    source.tableNodeId === expected.sourceTable.tableNodeId &&
    source.tableNumber === expected.sourceTable.tableNumber &&
    source.area === expected.sourceTable.area &&
    source.state === "IDLE" &&
    source.sessionId === null &&
    source.sessionStartedAt === null &&
    source.billingState === "ENDED" &&
    source.billingPausedAt === null &&
    source.pricingPlanName === null &&
    source.estimatedFeeFen === 0 &&
    source.currentTotalFen === 0 &&
    source.sessionElapsedSeconds === 0 &&
    source.sessionRiskLevel === "NORMAL" &&
    source.longSessionWarningMinutes === expected.sourceTable.longSessionWarningMinutes &&
    source.longSessionCriticalMinutes === expected.sourceTable.longSessionCriticalMinutes &&
    source.billingEvidence === expected.sourceTable.billingEvidence &&
    Number.isFinite(sourceAuthoritativeAt) &&
    sourceAuthoritativeAt >= Date.parse(expected.sourceTable.authoritativeAt) &&
    source.revision > expected.sourceTable.revision &&
    target.tableNodeId === expected.targetTable.tableNodeId &&
    target.tableNumber === expected.targetTable.tableNumber &&
    target.area === expected.targetTable.area &&
    target.state === "IN_USE" &&
    target.sessionId === order.sessionId &&
    target.sessionStartedAt === order.startedAt &&
    target.billingState === order.billingState &&
    target.billingPausedAt === order.billingPausedAt &&
    target.pricingPlanName === order.priceSnapshot.name &&
    Number.isSafeInteger(targetEstimatedFeeFen) &&
    Number.isSafeInteger(targetCurrentTotalFen) &&
    Number.isSafeInteger(targetFeeDelta) &&
    targetFeeDelta >= 0 &&
    targetTotalDelta === targetFeeDelta &&
    Number.isSafeInteger(target.sessionElapsedSeconds) &&
    (target.sessionElapsedSeconds ?? -1) >= 0 &&
    target.longSessionWarningMinutes === expected.targetTable.longSessionWarningMinutes &&
    target.longSessionCriticalMinutes === expected.targetTable.longSessionCriticalMinutes &&
    target.billingEvidence === order.priceSnapshot.evidence &&
    Number.isFinite(targetAuthoritativeAt) &&
    targetAuthoritativeAt >= Date.parse(expected.targetTable.authoritativeAt) &&
    target.revision > expected.targetTable.revision
  );
}

export async function transferSession(
  sessionId: string,
  targetTableId: string,
  idempotencyKey: string,
  reason: string,
  expected: SessionTransferExpectedResult,
): Promise<SessionTransferResult> {
  const order = await request<unknown>(`/v1/sessions/${sessionId}/transfer`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify({ targetTableId, reason, idempotencyKey }),
  });
  if (!transferredOrderIsConsistent(order, sessionId, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "转台结果无法安全确认；系统不会把球台或台单显示为成功，请使用原请求继续核对",
    );
  }
  const tables = await request<unknown>("/v1/tables", { cache: "no-store" });
  if (!tableListIsConsistent(tables, order, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "转台结果无法安全确认；系统不会把球台或台单显示为成功，请使用原请求继续核对",
    );
  }
  const sourceTable = tables.find((table) => table.tableId === expected.sourceTable.tableId);
  const targetTable = tables.find((table) => table.tableId === expected.targetTable.tableId);
  if (!sourceTable || !targetTable) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "转台后的球台状态缺失，请使用原请求继续核对",
    );
  }
  return { order, sourceTable, targetTable };
}

export interface SessionBillingExpectedResult {
  baselineOrder: OrderDetail;
}

export interface SessionEndExpectedResult extends SessionBillingExpectedResult {
  baselineTable: TableSnapshot | null;
}

export interface SessionStartAdjustmentPreviewExpectedResult extends SessionBillingExpectedResult {
  tenantId: string;
  storeId: string;
}

function sessionStartAdjustmentPreviewMatchesExpected(
  preview: SessionStartAdjustmentPreview,
  sessionId: string,
  proposedStartedAt: string,
  expected: SessionStartAdjustmentPreviewExpectedResult,
): boolean {
  const baseline = expected.baselineOrder;
  return (
    preview.tenantId === expected.tenantId &&
    preview.storeId === expected.storeId &&
    preview.sessionId === sessionId &&
    preview.orderId === baseline.id &&
    preview.orderNumber.length > 0 &&
    preview.tableId === baseline.tableId &&
    preview.tableNumber === baseline.tableNumber &&
    preview.billingState === baseline.billingState &&
    preview.previousStartedAt === baseline.startedAt &&
    preview.proposedStartedAt === proposedStartedAt &&
    preview.previousBusinessDate === baseline.businessDate &&
    preview.proposedBusinessDate === baseline.businessDate &&
    preview.cashShiftBusinessDate === baseline.businessDate &&
    Date.parse(preview.cashShiftStartedAt) <= Date.parse(preview.previousStartedAt) &&
    Date.parse(preview.cashShiftStartedAt) <= Date.parse(preview.proposedStartedAt) &&
    preview.previousTableFeeFen >= baseline.tableFeeFen &&
    preview.prepaidFen === 0 &&
    preview.prepaidAdjustmentFen === 0 &&
    preview.prepaymentOutcome === "NO_PREPAYMENT" &&
    preview.notificationAudience[0] === "OWNER" &&
    preview.notificationAudience[1] === "MANAGER" &&
    preview.notificationChannel === "BUSINESS_OPERATION_LOG" &&
    preview.notificationOutcome === "RECORDED_IN_SAME_TRANSACTION" &&
    Date.parse(preview.generatedAt) <= Date.now() + 5_000 &&
    Date.parse(preview.expiresAt) > Date.now()
  );
}

export async function getSessionStartAdjustmentPreview(
  sessionId: string,
  proposedStartedAt: string,
  expected: SessionStartAdjustmentPreviewExpectedResult,
): Promise<SessionStartAdjustmentPreview> {
  const parsedStartedAt = Date.parse(proposedStartedAt);
  if (
    !sessionId ||
    !Number.isFinite(parsedStartedAt) ||
    new Date(parsedStartedAt).toISOString() !== proposedStartedAt
  ) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "请选择有效的新开台时间后再预览。", 400);
  }
  const query = new URLSearchParams({ startedAt: proposedStartedAt });
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/adjust-start-preview?${query.toString()}`,
    { cache: "no-store" },
  );
  if (
    !isSessionStartAdjustmentPreview(value) ||
    !sessionStartAdjustmentPreviewMatchesExpected(value, sessionId, proposedStartedAt, expected)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "调时预览与当前账号、门店或台单不一致，系统没有执行；请刷新台单后重新预览。",
    );
  }
  return value;
}

function isExpectedSessionStartAdjustmentResult(
  value: unknown,
  command: SessionStartAdjustmentCommand,
  expected: SessionBillingExpectedResult,
): value is OrderDetail {
  if (!isOrderDetail(value)) return false;
  const baseline = expected.baselineOrder;
  const preview = command.preview;
  return (
    baseline.status === "OPEN" &&
    baseline.endedAt === null &&
    (baseline.billingState === "RUNNING" || baseline.billingState === "PAUSED") &&
    value.id === baseline.id &&
    value.sessionId === baseline.sessionId &&
    value.sessionId === preview.sessionId &&
    value.tableId === baseline.tableId &&
    value.tableNumber === baseline.tableNumber &&
    value.status === "OPEN" &&
    value.billingState === baseline.billingState &&
    value.billingPausedAt === baseline.billingPausedAt &&
    value.startedAt === preview.proposedStartedAt &&
    value.businessDate === preview.proposedBusinessDate &&
    value.endedAt === null &&
    value.tableFeeFen >= preview.proposedTableFeeFen &&
    value.totalFen === value.tableFeeFen &&
    value.productTotalFen === baseline.productTotalFen &&
    value.coachServiceTotalFen === baseline.coachServiceTotalFen &&
    value.paidFen === 0 &&
    value.refundedFen === 0 &&
    value.offlineOrigin === baseline.offlineOrigin &&
    sessionBillingBreakdownIsConsistent(value) &&
    jsonEqual(value.priceSnapshot, baseline.priceSnapshot) &&
    jsonEqual(value.priceSnapshots, baseline.priceSnapshots) &&
    jsonEqual(value.voidedAt, baseline.voidedAt) &&
    jsonEqual(value.voidReason, baseline.voidReason) &&
    jsonEqual(value.items, baseline.items) &&
    jsonEqual(value.coachServiceItems, baseline.coachServiceItems) &&
    jsonEqual(value.groupBuyFulfillments, baseline.groupBuyFulfillments) &&
    jsonEqual(value.payments, baseline.payments) &&
    jsonEqual(value.refunds, baseline.refunds)
  );
}

export async function adjustSessionStart(
  command: SessionStartAdjustmentCommand,
  expected: SessionBillingExpectedResult,
): Promise<OrderDetail> {
  const baseline = expected.baselineOrder;
  const noOtherBusinessFacts =
    baseline.productTotalFen === 0 &&
    baseline.coachServiceTotalFen === 0 &&
    baseline.paidFen === 0 &&
    baseline.refundedFen === 0 &&
    baseline.items.length === 0 &&
    baseline.coachServiceItems.length === 0 &&
    (baseline.groupBuyFulfillments ?? []).length === 0 &&
    baseline.payments.length === 0 &&
    baseline.refunds.length === 0;
  if (
    !isSessionStartAdjustmentCommand(command) ||
    command.preview.orderId !== baseline.id ||
    command.preview.sessionId !== baseline.sessionId ||
    command.preview.tableId !== baseline.tableId ||
    command.preview.tableNumber !== baseline.tableNumber ||
    command.preview.billingState !== baseline.billingState ||
    command.preview.previousStartedAt !== baseline.startedAt ||
    command.preview.previousBusinessDate !== baseline.businessDate ||
    command.preview.proposedBusinessDate !== baseline.businessDate ||
    command.preview.cashShiftBusinessDate !== baseline.businessDate ||
    command.preview.notificationAudience[0] !== "OWNER" ||
    command.preview.notificationAudience[1] !== "MANAGER" ||
    command.preview.notificationChannel !== "BUSINESS_OPERATION_LOG" ||
    command.preview.notificationOutcome !== "RECORDED_IN_SAME_TRANSACTION" ||
    command.preview.previousTableFeeFen < baseline.tableFeeFen ||
    baseline.status !== "OPEN" ||
    baseline.endedAt !== null ||
    !noOtherBusinessFacts
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原调时预览与当前台单不一致，系统没有发出请求；请刷新台单后重新预览。",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(command.preview.sessionId)}/adjust-start`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(command),
    },
  );
  if (!isExpectedSessionStartAdjustmentResult(value, command, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "修改开台时间的结果无法安全确认；系统不会显示为成功，请使用原请求继续核对。",
    );
  }
  return value;
}

function coachSessionStopServicesMatchPreview(
  completed: readonly CoachSessionStopCompletedService[],
  preview: CoachSessionStopPreview,
  occurredAt: string,
): boolean {
  if (completed.length !== preview.services.length) return false;
  const completedById = new Map(completed.map((service) => [service.id, service] as const));
  if (completedById.size !== completed.length) return false;
  for (const expected of preview.services) {
    const actual = completedById.get(expected.id);
    if (
      !actual ||
      actual.coachId !== expected.coachId ||
      actual.coachDisplayName !== expected.coachDisplayName ||
      actual.businessDate !== expected.businessDate ||
      actual.serviceTypeName !== expected.serviceTypeName ||
      actual.startedAt !== expected.startedAt ||
      actual.endedAt !== occurredAt ||
      actual.version !== expected.version + 1 ||
      (expected.status === "ACTIVE"
        ? actual.status !== "COMPLETED" ||
          actual.billedMinutes < expected.estimatedBilledMinutes ||
          actual.serviceFeeFen < expected.estimatedServiceFeeFen
        : actual.status !== "CANCELLED" || actual.billedMinutes !== 0 || actual.serviceFeeFen !== 0)
    ) {
      return false;
    }
  }
  return true;
}

function isExpectedSessionEndResult(
  value: unknown,
  sessionId: string,
  expected: SessionEndExpectedResult,
  preview: CoachSessionStopPreview,
): value is CoachSessionStopResult {
  if (!isCoachSessionStopResult(value)) return false;
  const baseline = expected.baselineOrder;
  const order = value.order;
  const table = value.table;
  const occurredAt = Date.parse(value.occurredAt);
  const tableFeeDelta = order.tableFeeFen - baseline.tableFeeFen;
  const coachFeeDelta = order.coachServiceTotalFen - baseline.coachServiceTotalFen;
  const completedFeeFen = value.completedCoachServices.reduce(
    (total, service) => total + service.serviceFeeFen,
    0,
  );
  const authoritativeTableResultSafe =
    table === undefined ||
    (expected.baselineTable !== null &&
      expected.baselineTable.tenantId === table.tenantId &&
      expected.baselineTable.storeId === table.storeId &&
      expected.baselineTable.tableId === table.tableId &&
      expected.baselineTable.tableNodeId === table.tableNodeId &&
      expected.baselineTable.tableNumber === table.tableNumber &&
      expected.baselineTable.area === table.area &&
      expected.baselineTable.sessionId === table.sessionId &&
      expected.baselineTable.sessionStartedAt === table.sessionStartedAt &&
      expected.baselineTable.pricingPlanName === table.pricingPlanName &&
      expected.baselineTable.billingEvidence === table.billingEvidence &&
      table.revision > expected.baselineTable.revision &&
      table.tableId === order.tableId &&
      table.tableNumber === order.tableNumber &&
      table.sessionId === sessionId &&
      table.state === "IN_USE" &&
      table.billingState === "ENDED" &&
      table.billingPausedAt === null &&
      table.revision > 0 &&
      table.authoritativeAt === value.occurredAt &&
      table.estimatedFeeFen === order.tableFeeFen &&
      table.currentTotalFen === order.totalFen);
  return (
    preview.sessionId === sessionId &&
    value.coachServiceClosure === "COMPLETED" &&
    authoritativeTableResultSafe &&
    value.serviceSetToken === preview.serviceSetToken &&
    Number.isFinite(occurredAt) &&
    occurredAt >= Date.parse(preview.previewedAt) &&
    coachSessionStopServicesMatchPreview(value.completedCoachServices, preview, value.occurredAt) &&
    Number.isSafeInteger(completedFeeFen) &&
    baseline.status === "OPEN" &&
    baseline.sessionId === sessionId &&
    baseline.billingState === "RUNNING" &&
    baseline.billingPausedAt === null &&
    baseline.endedAt === null &&
    order.id === baseline.id &&
    order.sessionId === sessionId &&
    order.tableId === baseline.tableId &&
    order.tableId === preview.tableId &&
    order.tableNumber === baseline.tableNumber &&
    order.tableNumber === preview.tableNumber &&
    order.businessDate === baseline.businessDate &&
    order.status === "OPEN" &&
    order.billingState === "ENDED" &&
    order.billingPausedAt === null &&
    order.endedAt === value.occurredAt &&
    order.startedAt === baseline.startedAt &&
    Number.isSafeInteger(tableFeeDelta) &&
    tableFeeDelta >= 0 &&
    Number.isSafeInteger(coachFeeDelta) &&
    coachFeeDelta === completedFeeFen &&
    order.totalFen - baseline.totalFen === tableFeeDelta + coachFeeDelta &&
    order.productTotalFen === baseline.productTotalFen &&
    order.paidFen === baseline.paidFen &&
    order.refundedFen === baseline.refundedFen &&
    order.offlineOrigin === baseline.offlineOrigin &&
    sessionBillingBreakdownIsConsistent(baseline) &&
    sessionBillingBreakdownIsConsistent(order) &&
    jsonEqual(order.priceSnapshot, baseline.priceSnapshot) &&
    jsonEqual(order.priceSnapshots, baseline.priceSnapshots) &&
    jsonEqual(order.voidedAt, baseline.voidedAt) &&
    jsonEqual(order.voidReason, baseline.voidReason) &&
    jsonEqual(order.items, baseline.items) &&
    baseline.coachServiceItems.every((line) =>
      order.coachServiceItems.some((candidate) => jsonEqual(candidate, line)),
    ) &&
    jsonEqual(order.groupBuyFulfillments, baseline.groupBuyFulfillments) &&
    jsonEqual(order.payments, baseline.payments) &&
    jsonEqual(order.refunds, baseline.refunds)
  );
}

function sessionBillingBreakdownIsConsistent(order: OrderDetail): boolean {
  const breakdown = order.billingBreakdown;
  if (!breakdown) return true;
  let segmentTotalFen = 0;
  for (const segment of breakdown.segments) {
    segmentTotalFen += segment.amountFen;
    if (!Number.isSafeInteger(segmentTotalFen)) return false;
  }
  return (
    breakdown.priceSnapshotId === order.priceSnapshot.id &&
    breakdown.priceSnapshotVersion === order.priceSnapshot.version &&
    breakdown.subtotalFen === segmentTotalFen &&
    breakdown.totalFen === breakdown.subtotalFen + breakdown.minimumAmountAdjustmentFen &&
    breakdown.totalFen === order.tableFeeFen
  );
}

function isExpectedSessionBillingResult(
  value: unknown,
  action: "PAUSE" | "RESUME" | "END_EARLY",
  sessionId: string,
  expected: SessionBillingExpectedResult,
): value is OrderDetail {
  if (!isOrderDetail(value)) return false;
  const baseline = expected.baselineOrder;
  const targetBillingState =
    action === "PAUSE" ? "PAUSED" : action === "RESUME" ? "RUNNING" : "ENDED";
  const expectedBaselineState = action === "RESUME" ? "PAUSED" : "RUNNING";
  const tableFeeDelta = value.tableFeeFen - baseline.tableFeeFen;
  const endedAt = typeof value.endedAt === "string" ? Date.parse(value.endedAt) : null;
  return (
    baseline.status === "OPEN" &&
    baseline.sessionId === sessionId &&
    baseline.billingState === expectedBaselineState &&
    baseline.endedAt === null &&
    (action === "PAUSE"
      ? baseline.billingPausedAt === null &&
        value.billingPausedAt !== null &&
        value.endedAt === null
      : action === "RESUME"
        ? baseline.billingPausedAt !== null &&
          value.billingPausedAt === null &&
          value.endedAt === null
        : baseline.billingPausedAt === null &&
          value.billingPausedAt === null &&
          endedAt !== null &&
          Number.isFinite(endedAt) &&
          endedAt >= Date.parse(baseline.startedAt)) &&
    value.id === baseline.id &&
    value.sessionId === sessionId &&
    value.tableId === baseline.tableId &&
    value.tableNumber === baseline.tableNumber &&
    value.businessDate === baseline.businessDate &&
    value.status === "OPEN" &&
    value.billingState === targetBillingState &&
    value.startedAt === baseline.startedAt &&
    value.tableFeeFen >= baseline.tableFeeFen &&
    Number.isSafeInteger(tableFeeDelta) &&
    value.productTotalFen === baseline.productTotalFen &&
    value.coachServiceTotalFen === baseline.coachServiceTotalFen &&
    value.totalFen - baseline.totalFen === tableFeeDelta &&
    value.paidFen === baseline.paidFen &&
    value.refundedFen === baseline.refundedFen &&
    value.offlineOrigin === baseline.offlineOrigin &&
    sessionBillingBreakdownIsConsistent(baseline) &&
    (baseline.billingBreakdown === undefined || value.billingBreakdown !== undefined) &&
    sessionBillingBreakdownIsConsistent(value) &&
    jsonEqual(value.priceSnapshot, baseline.priceSnapshot) &&
    jsonEqual(value.priceSnapshots, baseline.priceSnapshots) &&
    jsonEqual(value.voidedAt, baseline.voidedAt) &&
    jsonEqual(value.voidReason, baseline.voidReason) &&
    jsonEqual(value.items, baseline.items) &&
    jsonEqual(value.coachServiceItems, baseline.coachServiceItems) &&
    jsonEqual(value.groupBuyFulfillments, baseline.groupBuyFulfillments) &&
    jsonEqual(value.payments, baseline.payments) &&
    jsonEqual(value.refunds, baseline.refunds)
  );
}

async function changeSessionBillingState(
  action: "PAUSE" | "RESUME",
  sessionId: string,
  reason: string,
  idempotencyKey: string,
  expected: SessionBillingExpectedResult,
): Promise<OrderDetail> {
  const result = await request<unknown>(
    `/v1/sessions/${sessionId}/${action === "PAUSE" ? "pause" : "resume"}`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify({ reason, idempotencyKey }),
    },
  );
  if (!isExpectedSessionBillingResult(result, action, sessionId, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      `${action === "PAUSE" ? "暂停" : "恢复"}计费结果无法安全确认；系统不会把这次操作显示为成功，请使用原请求继续核对`,
    );
  }
  return result;
}

export function pauseSession(
  sessionId: string,
  reason: string,
  idempotencyKey: string,
  expected: SessionBillingExpectedResult,
): Promise<OrderDetail> {
  return changeSessionBillingState("PAUSE", sessionId, reason, idempotencyKey, expected);
}

export function resumeSession(
  sessionId: string,
  reason: string,
  idempotencyKey: string,
  expected: SessionBillingExpectedResult,
): Promise<OrderDetail> {
  return changeSessionBillingState("RESUME", sessionId, reason, idempotencyKey, expected);
}

export async function getCoachSessionStopPreview(
  sessionId: string,
): Promise<CoachSessionStopPreview> {
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/end-early-preview`,
    { cache: "no-store" },
  );
  if (!isCoachSessionStopPreview(value) || value.sessionId !== sessionId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "停表前的助教下钟预览无法安全确认，系统没有执行；请刷新后重新核对。",
    );
  }
  return value;
}

export async function endSessionEarly(
  sessionId: string,
  reason: string,
  idempotencyKey: string,
  expected: SessionEndExpectedResult,
  coachStopPreview: CoachSessionStopPreview,
): Promise<CoachSessionStopResult> {
  if (expected.baselineTable === null) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原停表保护记录缺少请求前球台版本，系统不会重发请求；请先查询原结果。",
      400,
    );
  }
  const value = await request<unknown>(`/v1/sessions/${encodeURIComponent(sessionId)}/end-early`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify({
      reason,
      expectedCoachServiceSetToken: coachStopPreview.serviceSetToken,
      idempotencyKey,
    }),
  });
  if (!isExpectedSessionEndResult(value, sessionId, expected, coachStopPreview) || !value.table) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "停表和全部助教下钟结果无法安全确认；系统不会显示为成功，请使用原请求继续核对。",
    );
  }
  return value;
}

export async function getCoachSessionStopResultByRequest(
  sessionId: string,
  idempotencyKey: string,
  expected: SessionEndExpectedResult,
  coachStopPreview: CoachSessionStopPreview | null,
): Promise<CoachSessionStopResult | null> {
  let value: unknown;
  try {
    value = await request<unknown>(
      `/v1/sessions/${encodeURIComponent(sessionId)}/end-early/by-request/${encodeURIComponent(idempotencyKey)}`,
      { cache: "no-store" },
    );
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "SESSION_END_EARLY_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
  const safeValue =
    expected.baselineTable === null && isCoachSessionStopResult(value) && value.table
      ? (({ table: _untrustedLegacyTable, ...result }) => result)(value)
      : value;
  if (
    !isCoachSessionStopResult(safeValue) ||
    safeValue.order.sessionId !== sessionId ||
    (coachStopPreview !== null
      ? !isExpectedSessionEndResult(safeValue, sessionId, expected, coachStopPreview)
      : safeValue.coachServiceClosure !== "LEGACY_UNRECORDED" ||
        !isExpectedSessionBillingResult(safeValue.order, "END_EARLY", sessionId, expected))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "原停表和助教下钟结果无法安全确认，请勿改用新请求重复操作。",
    );
  }
  return safeValue;
}

export interface SessionVoidExpectedResult {
  baselineOrder: OrderDetail;
  baselineTable: TableSnapshot;
}

export interface SessionVoidResult {
  order: OrderDetail;
  table: TableSnapshot;
}

function voidedOrderIsConsistent(
  value: unknown,
  sessionId: string,
  reason: string,
  expected: SessionVoidExpectedResult,
): value is OrderDetail {
  if (!isOrderDetail(value)) return false;
  const baseline = expected.baselineOrder;
  const table = expected.baselineTable;
  const baselineGroupBuy = baseline.groupBuyFulfillments ?? [];
  const resultGroupBuy = value.groupBuyFulfillments ?? [];
  const breakdown = value.billingBreakdown;
  const endedAt = value.endedAt === null ? Number.NaN : Date.parse(value.endedAt);
  const voidedAt = value.voidedAt ? Date.parse(value.voidedAt) : Number.NaN;
  return (
    baseline.status === "OPEN" &&
    baseline.sessionId === sessionId &&
    baseline.endedAt === null &&
    (baseline.voidedAt === undefined || baseline.voidedAt === null) &&
    (baseline.voidReason === undefined || baseline.voidReason === null) &&
    (baseline.billingState === "RUNNING" || baseline.billingState === "PAUSED") &&
    (baseline.billingState === "PAUSED"
      ? baseline.billingPausedAt !== null
      : baseline.billingPausedAt === null) &&
    baseline.productTotalFen === 0 &&
    baseline.coachServiceTotalFen === 0 &&
    baseline.paidFen === 0 &&
    baseline.refundedFen === 0 &&
    baseline.items.length === 0 &&
    baseline.coachServiceItems.length === 0 &&
    baselineGroupBuy.length === 0 &&
    baseline.payments.length === 0 &&
    baseline.refunds.length === 0 &&
    table.state === "IN_USE" &&
    table.sessionId === sessionId &&
    table.sessionStartedAt === baseline.startedAt &&
    table.tableId === baseline.tableId &&
    table.tableNumber === baseline.tableNumber &&
    table.billingState === baseline.billingState &&
    table.billingPausedAt === baseline.billingPausedAt &&
    table.pricingPlanName === baseline.priceSnapshot.name &&
    table.estimatedFeeFen === baseline.tableFeeFen &&
    table.currentTotalFen === baseline.totalFen &&
    value.id === baseline.id &&
    value.sessionId === sessionId &&
    value.tableId === baseline.tableId &&
    value.tableNumber === baseline.tableNumber &&
    value.businessDate === baseline.businessDate &&
    value.status === "SETTLED" &&
    value.billingState === "ENDED" &&
    value.billingPausedAt === null &&
    value.startedAt === baseline.startedAt &&
    Number.isFinite(endedAt) &&
    endedAt >= Date.parse(baseline.startedAt) &&
    Number.isFinite(voidedAt) &&
    voidedAt === endedAt &&
    value.voidedAt === value.endedAt &&
    value.voidReason === reason &&
    value.tableFeeFen === 0 &&
    value.productTotalFen === 0 &&
    value.coachServiceTotalFen === 0 &&
    value.totalFen === 0 &&
    value.paidFen === 0 &&
    value.refundedFen === 0 &&
    value.offlineOrigin === baseline.offlineOrigin &&
    jsonEqual(value.priceSnapshot, baseline.priceSnapshot) &&
    jsonEqual(normalizedOrderPriceSnapshots(value), normalizedOrderPriceSnapshots(baseline)) &&
    value.items.length === 0 &&
    value.coachServiceItems.length === 0 &&
    resultGroupBuy.length === 0 &&
    value.payments.length === 0 &&
    value.refunds.length === 0 &&
    breakdown !== undefined &&
    breakdown.priceSnapshotId === baseline.priceSnapshot.id &&
    breakdown.priceSnapshotVersion === baseline.priceSnapshot.version &&
    breakdown.calculatedAt === value.endedAt &&
    breakdown.pausedSeconds === 0 &&
    breakdown.billableSeconds === 0 &&
    breakdown.billedMinutes === 0 &&
    breakdown.subtotalFen === 0 &&
    breakdown.minimumAmountAdjustmentFen === 0 &&
    breakdown.totalFen === 0 &&
    breakdown.segments.length === 0 &&
    breakdown.evidence === baseline.priceSnapshot.evidence &&
    sessionBillingBreakdownIsConsistent(value)
  );
}

function voidedTableListIsConsistent(
  value: unknown,
  expected: SessionVoidExpectedResult,
): value is TableSnapshot[] {
  if (!Array.isArray(value) || !value.every(isTableSnapshot)) return false;
  const baseline = expected.baselineTable;
  const tableIds = new Set<string>();
  const tableNodeIds = new Set<string>();
  const tableNumbers = new Set<string>();
  for (const table of value) {
    if (
      table.tenantId !== baseline.tenantId ||
      table.storeId !== baseline.storeId ||
      tableIds.has(table.tableId) ||
      tableNodeIds.has(table.tableNodeId) ||
      tableNumbers.has(table.tableNumber)
    ) {
      return false;
    }
    tableIds.add(table.tableId);
    tableNodeIds.add(table.tableNodeId);
    tableNumbers.add(table.tableNumber);
  }
  const table = value.find((candidate) => candidate.tableId === baseline.tableId);
  if (!table) return false;
  const authoritativeAt = Date.parse(table.authoritativeAt);
  return (
    table.tableNodeId === baseline.tableNodeId &&
    table.tableNumber === baseline.tableNumber &&
    table.area === baseline.area &&
    table.state === "IDLE" &&
    table.sessionId === null &&
    table.sessionStartedAt === null &&
    table.billingState === "ENDED" &&
    table.billingPausedAt === null &&
    table.pricingPlanName === null &&
    table.estimatedFeeFen === 0 &&
    table.currentTotalFen === 0 &&
    table.sessionElapsedSeconds === 0 &&
    table.sessionRiskLevel === "NORMAL" &&
    table.longSessionWarningMinutes === baseline.longSessionWarningMinutes &&
    table.longSessionCriticalMinutes === baseline.longSessionCriticalMinutes &&
    table.billingEvidence === baseline.billingEvidence &&
    Number.isFinite(authoritativeAt) &&
    authoritativeAt >= Date.parse(baseline.authoritativeAt) &&
    table.revision > baseline.revision
  );
}

export async function voidSession(
  sessionId: string,
  reason: string,
  idempotencyKey: string,
  expected: SessionVoidExpectedResult,
): Promise<SessionVoidResult> {
  const normalizedReason = reason.trim();
  const order = await request<unknown>(`/v1/sessions/${sessionId}/void`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify({ reason: normalizedReason, idempotencyKey }),
  });
  if (!voidedOrderIsConsistent(order, sessionId, normalizedReason, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "误开台作废结果无法安全确认；系统不会把台单或球台显示为成功，请使用原请求继续核对",
    );
  }
  const tables = await request<unknown>("/v1/tables", { cache: "no-store" });
  if (!voidedTableListIsConsistent(tables, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "误开台作废后的球台状态无法安全确认；请使用原请求继续核对",
    );
  }
  const table = tables.find((candidate) => candidate.tableId === expected.baselineTable.tableId);
  if (!table) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "误开台作废后的原球台缺失；请使用原请求继续核对",
    );
  }
  return { order, table };
}

export interface AddOrderItemExpectedResult {
  tableId: string;
  productName: string;
  unitPriceFen: number;
  baselineItems: readonly OrderItemRecord[];
}

export interface AddGiftOrderItemExpectedResult {
  tableId: string;
  productName: string;
  listUnitPriceFen: number;
  baselineItems: readonly OrderItemRecord[];
  originalAuthorizerId: string;
}

function orderItemsEqual(left: OrderItemRecord, right: OrderItemRecord): boolean {
  const fields = [
    "id",
    "skuId",
    "productVersion",
    "name",
    "unitPriceFen",
    "lineType",
    "pricingSource",
    "listUnitPriceFen",
    "unitDiscountFen",
    "adjustmentReason",
    "authorizedByRole",
    "authorizedById",
    "unitCostFen",
    "costSnapshotKnown",
    "inventoryCostSnapshot",
    "sourceReservationId",
    "quantity",
    "returnedQuantity",
    "evidence",
  ] as const;
  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);
  return (
    leftKeys.length === rightKeys.length &&
    leftKeys.every((field) => Object.hasOwn(right, field)) &&
    fields.every(
      (field) =>
        Object.hasOwn(left, field) === Object.hasOwn(right, field) &&
        (field === "inventoryCostSnapshot"
          ? JSON.stringify(left[field]) === JSON.stringify(right[field])
          : left[field] === right[field]),
    )
  );
}

const cashierForbiddenOrderItemCostFields = [
  "unitCostFen",
  "costSnapshotKnown",
  "inventoryCostSnapshot",
] as const;

function orderItemsAreCostSanitized(items: readonly OrderItemRecord[]): boolean {
  return items.every((item) =>
    cashierForbiddenOrderItemCostFields.every((field) => !Object.hasOwn(item, field)),
  );
}

const cashierAllowedOrderItemFields = new Set([
  "id",
  "skuId",
  "productVersion",
  "name",
  "unitPriceFen",
  "lineType",
  "pricingSource",
  "listUnitPriceFen",
  "unitDiscountFen",
  "adjustmentReason",
  "authorizedByRole",
  "authorizedById",
  "sourceReservationId",
  "quantity",
  "returnedQuantity",
  "evidence",
]);

function orderItemsAreValidSanitizedBaseline(items: readonly OrderItemRecord[]): boolean {
  return items.every(
    (item) =>
      Object.keys(item).every((field) => cashierAllowedOrderItemFields.has(field)) &&
      typeof item.id === "string" &&
      item.id.length >= 1 &&
      typeof item.skuId === "string" &&
      item.skuId.length >= 1 &&
      typeof item.name === "string" &&
      item.name.length >= 1 &&
      Number.isSafeInteger(item.unitPriceFen) &&
      item.unitPriceFen >= 0 &&
      Number.isSafeInteger(item.quantity) &&
      item.quantity >= 1 &&
      Number.isSafeInteger(item.returnedQuantity) &&
      item.returnedQuantity >= 0 &&
      item.returnedQuantity <= item.quantity &&
      (item.productVersion === undefined ||
        (Number.isSafeInteger(item.productVersion) && item.productVersion >= 1)) &&
      (item.sourceReservationId === undefined ||
        (typeof item.sourceReservationId === "string" &&
          item.sourceReservationId.length >= 1 &&
          item.sourceReservationId.length <= 128)) &&
      (item.evidence === "SIMULATED" || item.evidence === "STORE_ACCEPTED") &&
      orderItemPricingFactsAreConsistent(item),
  );
}

function orderItemsProductTotalFen(items: readonly OrderItemRecord[]): number | null {
  let total = 0;
  for (const item of items) {
    const lineTotal = item.unitPriceFen * (item.quantity - item.returnedQuantity);
    if (!Number.isSafeInteger(lineTotal)) return null;
    total += lineTotal;
    if (!Number.isSafeInteger(total)) return null;
  }
  return total;
}

function isExpectedOrderItemAddResult(
  value: unknown,
  sessionId: string,
  skuId: string,
  quantity: number,
  expected: AddOrderItemExpectedResult,
): value is OrderDetail {
  if (
    !isOrderDetailReadModel(value) ||
    value.sessionId !== sessionId ||
    value.tableId !== expected.tableId ||
    value.status !== "OPEN" ||
    !orderItemsAreCostSanitized(expected.baselineItems) ||
    !orderItemsAreCostSanitized(value.items)
  ) {
    return false;
  }
  const itemIds = value.items.map((item) => item.id);
  if (new Set(itemIds).size !== itemIds.length) return false;
  const baselineById = new Map(expected.baselineItems.map((item) => [item.id, item]));
  if (
    baselineById.size !== expected.baselineItems.length ||
    expected.baselineItems.some((baseline) => {
      const returned = value.items.find((item) => item.id === baseline.id);
      return !returned || !orderItemsEqual(returned, baseline);
    })
  ) {
    return false;
  }
  const introduced = value.items.filter((item) => !baselineById.has(item.id));
  const matchingRequestedItems = introduced.filter(
    (item) =>
      item.skuId === skuId &&
      item.name === expected.productName &&
      item.unitPriceFen === expected.unitPriceFen &&
      item.lineType !== "GIFT" &&
      item.quantity === quantity &&
      item.returnedQuantity === 0,
  );
  if (matchingRequestedItems.length !== 1) {
    return false;
  }
  let computedProductTotalFen = 0;
  for (const item of value.items) {
    if (item.returnedQuantity > item.quantity) return false;
    const lineTotal = item.unitPriceFen * (item.quantity - item.returnedQuantity);
    if (!Number.isSafeInteger(lineTotal)) return false;
    computedProductTotalFen += lineTotal;
    if (!Number.isSafeInteger(computedProductTotalFen)) return false;
  }
  return computedProductTotalFen === value.productTotalFen;
}

export async function addOrderItem(
  sessionId: string,
  skuId: string,
  quantity: number,
  idempotencyKey: string,
  expected: AddOrderItemExpectedResult,
): Promise<OrderDetail> {
  if (
    !sessionId ||
    !skuId ||
    !Number.isSafeInteger(quantity) ||
    quantity < 1 ||
    quantity > 99 ||
    !idempotencyKey ||
    !expected.tableId ||
    !expected.productName ||
    !Number.isSafeInteger(expected.unitPriceFen) ||
    expected.unitPriceFen < 0 ||
    new Set(expected.baselineItems.map((item) => item.id)).size !== expected.baselineItems.length ||
    !orderItemsAreCostSanitized(expected.baselineItems)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "商品加单原请求或成本脱敏基线无法安全确认，系统没有发出请求",
    );
  }
  const result = await request<unknown>(`/v1/sessions/${sessionId}/items`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify({ skuId, quantity, idempotencyKey }),
  });
  if (!isExpectedOrderItemAddResult(result, sessionId, skuId, quantity, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "商品加单结果无法安全确认；系统不会把库存变化显示为成功，请使用原请求继续核对",
    );
  }
  return result;
}

function giftOrderItemRequestIsValid(
  sessionId: string,
  skuId: string,
  quantity: number,
  normalizedReason: string,
  idempotencyKey: string,
  secondaryAuthorizationToken: string,
  expected: AddGiftOrderItemExpectedResult,
): boolean {
  return (
    sessionId.length >= 1 &&
    sessionId.length <= 256 &&
    sessionId === sessionId.trim() &&
    skuId.length >= 1 &&
    skuId.length <= 128 &&
    skuId === skuId.trim() &&
    Number.isSafeInteger(quantity) &&
    quantity >= 1 &&
    quantity <= 99 &&
    [...normalizedReason].length >= 2 &&
    [...normalizedReason].length <= 200 &&
    idempotencyKey.length >= 8 &&
    idempotencyKey.length <= 128 &&
    idempotencyKey === idempotencyKey.trim() &&
    secondaryAuthorizationToken.length >= 1 &&
    secondaryAuthorizationToken.length <= 256 &&
    secondaryAuthorizationToken === secondaryAuthorizationToken.trim() &&
    expected.tableId.length >= 1 &&
    expected.tableId.length <= 256 &&
    expected.tableId === expected.tableId.trim() &&
    expected.productName.length >= 1 &&
    expected.productName.length <= 120 &&
    expected.productName === expected.productName.trim() &&
    Number.isSafeInteger(expected.listUnitPriceFen) &&
    expected.listUnitPriceFen > 0 &&
    expected.originalAuthorizerId.length >= 1 &&
    expected.originalAuthorizerId.length <= 128 &&
    expected.originalAuthorizerId === expected.originalAuthorizerId.trim() &&
    expected.baselineItems.length <= 10_000 &&
    new Set(expected.baselineItems.map((item) => item.id)).size === expected.baselineItems.length &&
    orderItemsAreValidSanitizedBaseline(expected.baselineItems) &&
    orderItemsProductTotalFen(expected.baselineItems) !== null
  );
}

function isExpectedGiftOrderItemAddResult(
  value: unknown,
  sessionId: string,
  skuId: string,
  quantity: number,
  normalizedReason: string,
  expected: AddGiftOrderItemExpectedResult,
): value is OrderDetail {
  if (
    !isOrderDetailReadModel(value) ||
    value.sessionId !== sessionId ||
    value.tableId !== expected.tableId ||
    value.status !== "OPEN" ||
    !orderItemsAreCostSanitized(expected.baselineItems) ||
    !orderItemsAreCostSanitized(value.items)
  ) {
    return false;
  }
  const itemIds = value.items.map((item) => item.id);
  if (new Set(itemIds).size !== itemIds.length) return false;
  const baselineById = new Map(expected.baselineItems.map((item) => [item.id, item]));
  if (
    baselineById.size !== expected.baselineItems.length ||
    expected.baselineItems.some((baseline) => {
      const returned = value.items.find((item) => item.id === baseline.id);
      return !returned || !orderItemsEqual(returned, baseline);
    })
  ) {
    return false;
  }
  const introduced = value.items.filter((item) => !baselineById.has(item.id));
  const matchingGifts = introduced.filter(
    (gift) =>
      gift.skuId === skuId &&
      gift.name === expected.productName &&
      gift.quantity === quantity &&
      gift.returnedQuantity === 0 &&
      gift.lineType === "GIFT" &&
      gift.pricingSource === "AUTHORIZED_STORE_GIFT" &&
      gift.listUnitPriceFen === expected.listUnitPriceFen &&
      gift.unitDiscountFen === expected.listUnitPriceFen &&
      gift.unitPriceFen === 0 &&
      gift.adjustmentReason === normalizedReason &&
      (gift.authorizedByRole === "MANAGER" || gift.authorizedByRole === "OWNER") &&
      gift.authorizedById === expected.originalAuthorizerId,
  );
  return matchingGifts.length === 1;
}

export async function addGiftOrderItem(
  sessionId: string,
  skuId: string,
  quantity: number,
  reason: string,
  idempotencyKey: string,
  secondaryAuthorizationToken: string,
  expected: AddGiftOrderItemExpectedResult,
): Promise<OrderDetail> {
  const normalizedReason = reason.trim();
  if (
    !giftOrderItemRequestIsValid(
      sessionId,
      skuId,
      quantity,
      normalizedReason,
      idempotencyKey,
      secondaryAuthorizationToken,
      expected,
    )
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "赠品原请求、授权人或成本脱敏基线无法安全确认，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>(`/v1/sessions/${sessionId}/items`, {
    method: "POST",
    cache: "no-store",
    headers: secondaryAuthorizationHeaders(secondaryAuthorizationToken),
    body: JSON.stringify({
      skuId,
      quantity,
      lineType: "GIFT",
      reason: normalizedReason,
      expectedProductName: expected.productName,
      expectedListUnitPriceFen: expected.listUnitPriceFen,
      idempotencyKey,
    }),
  });
  if (
    !isExpectedGiftOrderItemAddResult(
      result,
      sessionId,
      skuId,
      quantity,
      normalizedReason,
      expected,
    )
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "赠品结果无法安全确认；系统不会把赠品或库存变化显示为成功，请由原授权人重新授权并使用原请求继续核对",
    );
  }
  return result;
}

function isExpectedOrderItemSaleReturnResult(
  value: unknown,
  sessionId: string,
  command: OrderItemSaleReturnRequest,
  baseline: OrderDetail,
): value is OrderItemSaleReturnOperatorResult {
  if (!isOrderItemSaleReturnOperatorResult(value)) return false;
  const result = value;
  const expectedInventoryEffect = saleReturnInventoryEffectForDisposition(
    command.physicalDisposition,
  );
  const expectedInventoryQuantityAfter =
    command.physicalDisposition === "SALEABLE_RETURNED"
      ? (result.inventoryQuantityBefore as number) + command.quantity
      : null;
  if (
    result.itemId !== command.itemId ||
    result.quantity !== command.quantity ||
    result.physicalDisposition !== command.physicalDisposition ||
    result.inventoryEffect !== expectedInventoryEffect ||
    (command.physicalDisposition === "UNSALEABLE_RETURNED" &&
      result.inventoryQuantityBefore !== null) ||
    result.inventoryQuantityAfter !== expectedInventoryQuantityAfter
  ) {
    return false;
  }
  const order = result.order;
  if (!orderItemsAreCostSanitized(order.items)) return false;
  const baselineItem = baseline.items.find((item) => item.id === command.itemId);
  const returnedItem = order.items.find((item) => item.id === command.itemId);
  if (!baselineItem || !returnedItem) return false;
  const expectedReductionFen = baselineItem.unitPriceFen * command.quantity;
  if (!Number.isSafeInteger(expectedReductionFen)) return false;
  if (
    result.orderAmountReductionFen !== expectedReductionFen ||
    order.id !== baseline.id ||
    order.sessionId !== sessionId ||
    baseline.sessionId !== sessionId ||
    order.tableId !== baseline.tableId ||
    order.tableNumber !== baseline.tableNumber ||
    order.businessDate !== baseline.businessDate ||
    order.status !== "OPEN" ||
    baseline.status !== "OPEN" ||
    baseline.paidFen !== 0 ||
    order.paidFen !== 0 ||
    order.refundedFen !== baseline.refundedFen ||
    JSON.stringify(order.payments) !== JSON.stringify(baseline.payments) ||
    JSON.stringify(order.refunds) !== JSON.stringify(baseline.refunds) ||
    order.tableFeeFen !== baseline.tableFeeFen ||
    order.coachServiceTotalFen !== baseline.coachServiceTotalFen ||
    order.productTotalFen !== baseline.productTotalFen - expectedReductionFen ||
    order.totalFen !== baseline.totalFen - expectedReductionFen ||
    order.items.length !== baseline.items.length ||
    returnedItem.returnedQuantity !== baselineItem.returnedQuantity + command.quantity ||
    returnedItem.quantity !== baselineItem.quantity ||
    returnedItem.skuId !== baselineItem.skuId ||
    returnedItem.name !== baselineItem.name ||
    returnedItem.unitPriceFen !== baselineItem.unitPriceFen ||
    order.items.some((item) => {
      const previous = baseline.items.find((candidate) => candidate.id === item.id);
      return !previous || (item.id !== command.itemId && !orderItemsEqual(item, previous));
    })
  ) {
    return false;
  }
  return true;
}

export async function returnSaleableOrderItem(
  sessionId: string,
  command: OrderItemSaleReturnRequest,
  expected: { baselineOrder: OrderDetail },
): Promise<OrderItemSaleReturnOperatorResult> {
  const baselineItem = expected.baselineOrder.items.find((item) => item.id === command.itemId);
  if (
    !sessionId ||
    !baselineItem ||
    expected.baselineOrder.sessionId !== sessionId ||
    expected.baselineOrder.status !== "OPEN" ||
    expected.baselineOrder.paidFen !== 0 ||
    expected.baselineOrder.refundedFen !== 0 ||
    expected.baselineOrder.payments.length !== 0 ||
    expected.baselineOrder.refunds.length !== 0 ||
    !Number.isSafeInteger(command.quantity) ||
    command.quantity < 1 ||
    command.quantity > baselineItem.quantity - baselineItem.returnedQuantity ||
    (command.physicalDisposition !== "SALEABLE_RETURNED" &&
      command.physicalDisposition !== "UNSALEABLE_RETURNED") ||
    command.paymentResolution !== "UNPAID_ORDER_REDUCTION" ||
    command.reason !== command.reason.trim() ||
    [...command.reason].length < 2 ||
    [...command.reason].length > 200 ||
    command.idempotencyKey !== command.idempotencyKey.trim() ||
    command.idempotencyKey.length < 8 ||
    command.idempotencyKey.length > 128 ||
    !orderItemsAreCostSanitized(expected.baselineOrder.items)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "商品退回原请求、实物状态或未付款台单基线无法安全确认，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/items/physical-return`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(command),
    },
  );
  if (!isExpectedOrderItemSaleReturnResult(result, sessionId, command, expected.baselineOrder)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "商品退回结果无法安全确认；页面不会把订单减免或库存变化显示为成功，请使用原请求继续核对",
    );
  }
  return result;
}

export function checkoutSession(
  sessionId: string,
  method: PaymentMethod,
  idempotencyKey: string,
  expected: CheckoutExpectedResult,
  member?: {
    memberId: string;
    memberBalanceFen?: number;
    memberSpendPlanHash?: string;
  },
): Promise<CheckoutResult> {
  return checkoutSessionStrict(sessionId, method, idempotencyKey, expected, member);
}

export interface MemberSpendPreviewGatewayRequest {
  memberId: string;
  memberBalanceFen: number;
  expectedTotalFen: number;
}

function isMemberSpendPreviewGatewayRequest(
  value: unknown,
): value is MemberSpendPreviewGatewayRequest {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  return (
    Object.keys(record).length === 3 &&
    ["memberId", "memberBalanceFen", "expectedTotalFen"].every((key) =>
      Object.hasOwn(record, key),
    ) &&
    typeof record.memberId === "string" &&
    record.memberId === record.memberId.trim() &&
    record.memberId.length > 0 &&
    record.memberId.length <= 256 &&
    Number.isSafeInteger(record.memberBalanceFen) &&
    Number(record.memberBalanceFen) > 0 &&
    Number.isSafeInteger(record.expectedTotalFen) &&
    Number(record.expectedTotalFen) > 0 &&
    Number(record.memberBalanceFen) <= Number(record.expectedTotalFen)
  );
}

export async function getMemberSpendPreview(
  sessionId: string,
  orderId: string,
  requestBody: MemberSpendPreviewGatewayRequest,
): Promise<MemberSpendPreviewResult> {
  if (
    sessionId.length < 1 ||
    sessionId.length > 256 ||
    sessionId !== sessionId.trim() ||
    orderId.length < 1 ||
    orderId.length > 256 ||
    orderId !== orderId.trim() ||
    !isMemberSpendPreviewGatewayRequest(requestBody)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "会员、会员扣款金额或本单应收无法形成同一笔安全预览请求，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/member-spend-preview`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(requestBody),
    },
  );
  if (
    !isMemberSpendPreviewResult(result) ||
    result.memberId !== requestBody.memberId ||
    result.orderId !== orderId ||
    result.amountFen !== requestBody.memberBalanceFen ||
    result.walletCoveredAmountFen !== requestBody.memberBalanceFen ||
    result.externalAmountFen !== 0
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "会员钱包扣款预览无法与当前会员、台单和金额安全对应；页面不会显示旧预览，也不会允许确认收款",
    );
  }
  return result;
}

export async function startOfficialPayment(
  sessionId: string,
  command: OfficialPaymentStartRequestV1,
  expectedPaymentFen = command.expectedTotalFen,
): Promise<OfficialPaymentOperatorResultV1> {
  const result = await request<unknown>(`/v1/sessions/${sessionId}/official-payment-attempts`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  return validateOfficialPaymentOperatorResult(result, command, expectedPaymentFen);
}

function validateOfficialPaymentOperatorResult(
  result: unknown,
  command: OfficialPaymentStartRequestV1,
  expectedPaymentFen: number,
): OfficialPaymentOperatorResultV1 {
  if (
    !isOfficialPaymentOperatorResultV1(result) ||
    result.attempt.rail !== command.rail ||
    result.attempt.amountFen !== expectedPaymentFen ||
    result.attempt.operationTrace.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "正式支付结果无法与原订单、原金额和原请求对应；系统不会把这笔钱显示为到账，请使用原请求继续核对",
    );
  }
  return result;
}

export async function recoverOfficialPayment(
  sessionId: string,
  command: OfficialPaymentStartRequestV1,
  expectedPaymentFen = command.expectedTotalFen,
): Promise<OfficialPaymentOperatorResultV1> {
  const result = await request<unknown>(
    `/v1/sessions/${sessionId}/official-payment-attempts/recover`,
    {
      method: "POST",
      cache: "no-store",
    },
  );
  return validateOfficialPaymentOperatorResult(result, command, expectedPaymentFen);
}

export interface CheckoutExpectedResult {
  tenantId: string;
  storeId: string;
  baselineOrder: OrderDetail;
  memberId: string | null;
}

function jsonEqual(left: unknown, right: unknown): boolean {
  return canonicalJson(left) === canonicalJson(right);
}

export interface CheckoutSplitSaveExpectedResult {
  tenantId: string;
  storeId: string;
  baselineOrder: OrderDetail;
  baselineTable: TableSnapshot;
  baselinePlan: CheckoutSplitPlanReadModel | null;
}

export interface CheckoutSplitPayExpectedResult
  extends Omit<CheckoutSplitSaveExpectedResult, "baselinePlan"> {
  baselinePlan: CheckoutSplitPlanReadModel;
}

interface CheckoutSplitPlanWireResult {
  plan: CheckoutSplitPlanReadModel;
  order: OrderDetail;
  table: TableSnapshot;
}

interface CheckoutSplitPaymentWireResult extends CheckoutSplitPlanWireResult {
  payment: PaymentRecord;
  manualReview: ManualReviewItem | null;
  receipt: CheckoutResult["receipt"];
}

function hasExactRecordKeys(
  value: unknown,
  keys: readonly string[],
): value is Record<string, unknown> {
  return (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    Object.keys(value).length === keys.length &&
    keys.every((key) => Object.hasOwn(value, key))
  );
}

function checkoutSplitPaymentStatusMatches(
  method: PayCheckoutSplitShareRequest["method"],
  status: PaymentRecord["status"],
): boolean {
  return method === "CASH" ? status === "CONFIRMED_LOCAL" : status === "PENDING_RECONCILIATION";
}

function checkoutSplitPaymentMatchesShare(
  payment: PaymentRecord | undefined,
  share: CheckoutSplitPlanReadModel["shares"][number],
): boolean {
  return (
    payment !== undefined &&
    share.status === "PAID" &&
    share.paymentId === payment.id &&
    share.paymentMethod === payment.method &&
    share.paidAt === payment.recordedAt &&
    payment.amountFen === share.amountFen &&
    checkoutSplitPaymentStatusMatches(
      payment.method as PayCheckoutSplitShareRequest["method"],
      payment.status,
    ) &&
    (payment.memberId === undefined || payment.memberId === null) &&
    (payment.referenceId === undefined || payment.referenceId === null) &&
    (payment.officialPaymentAttemptId === undefined || payment.officialPaymentAttemptId === null) &&
    (payment.providerCode === undefined || payment.providerCode === null) &&
    (payment.providerTransactionReference === undefined ||
      payment.providerTransactionReference === null)
  );
}

function activeCheckoutSplitTableMatchesOrder(table: TableSnapshot, order: OrderDetail): boolean {
  return (
    table.tableId === order.tableId &&
    table.tableNumber === order.tableNumber &&
    table.state === "IN_USE" &&
    table.sessionId === order.sessionId &&
    table.sessionStartedAt === order.startedAt &&
    table.billingState === "ENDED" &&
    table.billingPausedAt === null &&
    table.pricingPlanName === order.priceSnapshot.name &&
    table.estimatedFeeFen === order.tableFeeFen &&
    table.currentTotalFen === order.totalFen
  );
}

function completedCheckoutSplitTableMatchesOrder(
  table: TableSnapshot,
  order: OrderDetail,
): boolean {
  return (
    table.tableId === order.tableId &&
    table.tableNumber === order.tableNumber &&
    table.state === "AWAITING_CLEANING" &&
    table.sessionId === null &&
    table.sessionStartedAt === null &&
    table.billingState === "ENDED" &&
    table.billingPausedAt === null &&
    table.pricingPlanName === null &&
    table.estimatedFeeFen === 0 &&
    table.currentTotalFen === 0
  );
}

function checkoutSplitProjectionIsConsistent(
  plan: CheckoutSplitPlanReadModel,
  order: OrderDetail,
  table: TableSnapshot,
  sessionId: string,
): boolean {
  const paidShares = plan.shares.filter((share) => share.status === "PAID");
  const paymentById = new Map(order.payments.map((payment) => [payment.id, payment]));
  const paidSharePaymentIds = new Set(paidShares.map((share) => share.paymentId));
  const orderPaymentIds = new Set(order.payments.map((payment) => payment.id));
  return (
    plan.sessionId === sessionId &&
    plan.orderId === order.id &&
    plan.orderNumber === orderNumberIdentity(order) &&
    plan.businessDate === order.businessDate &&
    plan.totalFen === order.totalFen &&
    plan.paidFen === order.paidFen &&
    order.sessionId === sessionId &&
    order.billingState === "ENDED" &&
    order.billingPausedAt === null &&
    order.endedAt !== null &&
    order.refundedFen === 0 &&
    order.refunds.length === 0 &&
    order.payments.length === paidShares.length &&
    paidShares.every((share) => share.paymentId !== null) &&
    paidSharePaymentIds.size === paidShares.length &&
    orderPaymentIds.size === order.payments.length &&
    order.payments.every((payment) => paidSharePaymentIds.has(payment.id)) &&
    paidShares.every((share) =>
      checkoutSplitPaymentMatchesShare(paymentById.get(share.paymentId ?? ""), share),
    ) &&
    (plan.status === "COMPLETED"
      ? order.status === "SETTLED" && completedCheckoutSplitTableMatchesOrder(table, order)
      : order.status === "OPEN" && activeCheckoutSplitTableMatchesOrder(table, order))
  );
}

function parseCheckoutSplitPlanWireResult(
  value: unknown,
  sessionId: string,
): CheckoutSplitPlanWireResult | null {
  if (
    !hasExactRecordKeys(value, ["plan", "order", "table"]) ||
    !isCheckoutSplitPlanReadModel(value.plan) ||
    !isOrderDetail(value.order) ||
    !isTableSnapshot(value.table) ||
    !isTableSnapshotList([value.table], value.table.tenantId, value.table.storeId) ||
    !checkoutSplitProjectionIsConsistent(value.plan, value.order, value.table, sessionId)
  ) {
    return null;
  }
  return value as unknown as CheckoutSplitPlanWireResult;
}

function checkoutSplitBaselineIsConsistent(
  sessionId: string,
  expected: CheckoutSplitSaveExpectedResult,
): boolean {
  const order = expected.baselineOrder;
  const table = expected.baselineTable;
  return (
    expected.tenantId.length > 0 &&
    expected.storeId.length > 0 &&
    isOrderDetail(order) &&
    isTableSnapshot(table) &&
    isTableSnapshotList([table], expected.tenantId, expected.storeId) &&
    table.tenantId === expected.tenantId &&
    table.storeId === expected.storeId &&
    order.status === "OPEN" &&
    order.sessionId === sessionId &&
    order.billingState === "ENDED" &&
    order.billingPausedAt === null &&
    order.endedAt !== null &&
    order.totalFen > 0 &&
    order.refundedFen === 0 &&
    order.refunds.length === 0 &&
    activeCheckoutSplitTableMatchesOrder(table, order)
  );
}

function saveCheckoutSplitResultMatches(
  result: CheckoutSplitPlanWireResult,
  requestBody: SaveCheckoutSplitPlanRequest,
  expected: CheckoutSplitSaveExpectedResult,
): boolean {
  const baselinePlan = expected.baselinePlan;
  const plan = result.plan;
  return (
    jsonEqual(result.order, expected.baselineOrder) &&
    jsonEqual(result.table, expected.baselineTable) &&
    plan.version === (baselinePlan?.version ?? 0) + 1 &&
    plan.status === "DRAFT" &&
    plan.paidFen === 0 &&
    plan.remainingFen === plan.totalFen &&
    plan.allocationMode === requestBody.allocationMode &&
    plan.shares.length === requestBody.shares.length &&
    requestBody.shares.every((draft, index) => {
      const share = plan.shares[index];
      const previous = baselinePlan?.shares.find(
        (candidate) => candidate.shareKey === draft.shareKey,
      );
      return (
        share !== undefined &&
        share.allocationOrder === index + 1 &&
        share.shareKey === draft.shareKey &&
        share.payerLabel === draft.payerLabel &&
        share.amountFen === draft.amountFen &&
        share.otherAmountFen === draft.otherAmountFen &&
        jsonEqual(share.itemAllocations, draft.itemAllocations) &&
        share.status === "UNPAID" &&
        share.paymentId === null &&
        share.paymentMethod === null &&
        share.paidAt === null &&
        (previous === undefined || share.shareId === previous.shareId)
      );
    }) &&
    (baselinePlan === null ||
      (plan.planId === baselinePlan.planId &&
        plan.splitNumber === baselinePlan.splitNumber &&
        plan.createdBy === baselinePlan.createdBy &&
        plan.createdAt === baselinePlan.createdAt &&
        Date.parse(plan.updatedAt) >= Date.parse(baselinePlan.updatedAt)))
  );
}

function checkoutSplitReceiptIsStrict(value: unknown): value is CheckoutResult["receipt"] {
  return (
    hasExactRecordKeys(value, ["effectId", "status", "evidence"]) &&
    typeof value.effectId === "string" &&
    value.effectId.length > 0 &&
    value.status === "QUEUED" &&
    (value.evidence === "MOCK" || value.evidence === "REAL_HARDWARE")
  );
}

function checkoutSplitManualReviewMatches(
  value: unknown,
  payment: PaymentRecord,
  orderId: string,
): value is ManualReviewItem | null {
  if (payment.method === "CASH") return value === null;
  return (
    isManualReviewItem(value) &&
    value.type === "PAYMENT" &&
    value.objectId === payment.id &&
    value.orderId === orderId &&
    value.reasonCode === "STATIC_CODE_PENDING_CHANNEL_CHECK" &&
    value.amountFen === payment.amountFen &&
    value.status === "PENDING" &&
    value.createdAt === payment.recordedAt &&
    value.resolvedAt === null &&
    value.offlineOrigin === payment.offlineOrigin
  );
}

function completedCheckoutSplitTableMatchesBaseline(
  table: TableSnapshot,
  baseline: TableSnapshot,
  payment: PaymentRecord,
): boolean {
  return (
    table.tenantId === baseline.tenantId &&
    table.storeId === baseline.storeId &&
    table.tableId === baseline.tableId &&
    table.tableNodeId === baseline.tableNodeId &&
    table.tableNumber === baseline.tableNumber &&
    table.area === baseline.area &&
    table.billingEvidence === baseline.billingEvidence &&
    table.longSessionWarningMinutes === baseline.longSessionWarningMinutes &&
    table.longSessionCriticalMinutes === baseline.longSessionCriticalMinutes &&
    table.revision === baseline.revision + 1 &&
    table.authoritativeAt === payment.recordedAt
  );
}

function payCheckoutSplitResultMatches(
  value: unknown,
  sessionId: string,
  requestBody: PayCheckoutSplitShareRequest,
  expected: CheckoutSplitPayExpectedResult,
): value is CheckoutSplitPaymentWireResult {
  if (
    !hasExactRecordKeys(value, ["plan", "order", "table", "payment", "manualReview", "receipt"]) ||
    !checkoutSplitReceiptIsStrict(value.receipt)
  ) {
    return false;
  }
  const planResult = parseCheckoutSplitPlanWireResult(
    { plan: value.plan, order: value.order, table: value.table },
    sessionId,
  );
  if (!planResult) return false;
  const baselinePlan = expected.baselinePlan;
  const targetBefore = baselinePlan.shares.find((share) => share.shareId === requestBody.shareId);
  const targetAfter = planResult.plan.shares.find((share) => share.shareId === requestBody.shareId);
  const payment = planResult.order.payments.find(
    (candidate) => candidate.id === targetAfter?.paymentId,
  );
  if (
    !targetBefore ||
    !targetAfter ||
    !payment ||
    !jsonEqual(value.payment, payment) ||
    targetBefore.status !== "UNPAID" ||
    targetAfter.status !== "PAID" ||
    !checkoutSplitPaymentMatchesShare(payment, targetAfter) ||
    targetAfter.paymentMethod !== requestBody.method ||
    targetAfter.amountFen !== requestBody.expectedShareAmountFen ||
    planResult.plan.version !== baselinePlan.version + 1 ||
    planResult.plan.planId !== baselinePlan.planId ||
    planResult.plan.splitNumber !== baselinePlan.splitNumber ||
    planResult.plan.createdBy !== baselinePlan.createdBy ||
    planResult.plan.createdAt !== baselinePlan.createdAt ||
    Date.parse(planResult.plan.updatedAt) < Date.parse(baselinePlan.updatedAt) ||
    planResult.plan.shares.length !== baselinePlan.shares.length ||
    !baselinePlan.shares.every((share, index) => {
      const returned = planResult.plan.shares[index];
      if (!returned || returned.shareId !== share.shareId) return false;
      return share.shareId === requestBody.shareId
        ? jsonEqual(
            { ...returned, status: "UNPAID", paymentId: null, paymentMethod: null, paidAt: null },
            share,
          )
        : jsonEqual(returned, share);
    }) ||
    !checkoutSplitManualReviewMatches(value.manualReview, payment, planResult.order.id)
  ) {
    return false;
  }
  const appended = planResult.order.payments.slice(expected.baselineOrder.payments.length);
  const orderUnchangedExceptPayment = jsonEqual(
    {
      ...planResult.order,
      paidFen: expected.baselineOrder.paidFen,
      payments: expected.baselineOrder.payments,
      status: expected.baselineOrder.status,
      offlineOrigin: expected.baselineOrder.offlineOrigin,
    },
    expected.baselineOrder,
  );
  const finalPayment = planResult.plan.status === "COMPLETED";
  return (
    orderUnchangedExceptPayment &&
    appended.length === 1 &&
    jsonEqual(appended[0], payment) &&
    planResult.order.paidFen ===
      expected.baselineOrder.paidFen + requestBody.expectedShareAmountFen &&
    planResult.order.offlineOrigin ===
      (expected.baselineOrder.offlineOrigin || payment.offlineOrigin) &&
    (finalPayment
      ? planResult.order.status === "SETTLED" &&
        completedCheckoutSplitTableMatchesBaseline(
          planResult.table,
          expected.baselineTable,
          payment,
        )
      : planResult.order.status === "OPEN" && jsonEqual(planResult.table, expected.baselineTable))
  );
}

export async function getCheckoutSplitPlan(
  sessionId: string,
): Promise<CheckoutSplitPlanReadModel | null> {
  if (!/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(sessionId)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "台局编号无法安全确认，系统没有发出请求",
      400,
    );
  }
  try {
    const result = await request<unknown>(
      `/v1/sessions/${encodeURIComponent(sessionId)}/checkout-split`,
      { cache: "no-store" },
    );
    if (result === null) return null;
    const parsed = parseCheckoutSplitPlanWireResult(result, sessionId);
    if (!parsed) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "分账计划无法与当前台局、账单、付款和球台状态对应，页面不会显示为权威结果",
      );
    }
    return parsed.plan;
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "CHECKOUT_SPLIT_PLAN_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export async function saveCheckoutSplitPlan(
  sessionId: string,
  requestBody: SaveCheckoutSplitPlanRequest,
  expected: CheckoutSplitSaveExpectedResult,
): Promise<CheckoutSplitPlanReadModel> {
  if (
    !isSaveCheckoutSplitPlanRequest(requestBody) ||
    !checkoutSplitBaselineIsConsistent(sessionId, expected) ||
    requestBody.expectedOrderId !== expected.baselineOrder.id ||
    requestBody.expectedTotalFen !== expected.baselineOrder.totalFen ||
    requestBody.expectedPlanVersion !== (expected.baselinePlan?.version ?? null) ||
    expected.baselineOrder.paidFen !== 0 ||
    expected.baselineOrder.payments.length !== 0 ||
    (expected.baselinePlan !== null &&
      (!isCheckoutSplitPlanReadModel(expected.baselinePlan) ||
        expected.baselinePlan.status !== "DRAFT" ||
        !checkoutSplitProjectionIsConsistent(
          expected.baselinePlan,
          expected.baselineOrder,
          expected.baselineTable,
          sessionId,
        )))
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "分账方案、账单金额或保存前版本无法形成同一笔安全请求，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/checkout-split`,
    { method: "PUT", cache: "no-store", body: JSON.stringify(requestBody) },
  );
  const parsed = parseCheckoutSplitPlanWireResult(result, sessionId);
  if (!parsed || !saveCheckoutSplitResultMatches(parsed, requestBody, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "分账方案保存结果无法与原账单、原版本和每一份金额对应，页面不会显示为保存成功",
    );
  }
  return parsed.plan;
}

export async function payCheckoutSplitShare(
  sessionId: string,
  requestBody: PayCheckoutSplitShareRequest,
  expected: CheckoutSplitPayExpectedResult,
): Promise<CheckoutSplitPlanReadModel> {
  const target = expected.baselinePlan.shares.find(
    (share) => share.shareId === requestBody.shareId,
  );
  if (
    !isPayCheckoutSplitShareRequest(requestBody) ||
    !checkoutSplitBaselineIsConsistent(sessionId, expected) ||
    !isCheckoutSplitPlanReadModel(expected.baselinePlan) ||
    !checkoutSplitProjectionIsConsistent(
      expected.baselinePlan,
      expected.baselineOrder,
      expected.baselineTable,
      sessionId,
    ) ||
    requestBody.planId !== expected.baselinePlan.planId ||
    requestBody.expectedPlanVersion !== expected.baselinePlan.version ||
    !target ||
    target.status !== "UNPAID" ||
    target.amountFen !== requestBody.expectedShareAmountFen
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "付款份额、金额或付款前版本无法形成同一笔安全请求，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/checkout-split/payments`,
    { method: "POST", cache: "no-store", body: JSON.stringify(requestBody) },
  );
  if (!payCheckoutSplitResultMatches(result, sessionId, requestBody, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "分账付款结果无法与指定份额、付款方法、金额和关台状态对应，系统不会显示为付款成功",
    );
  }
  return result.plan;
}

export type CustomerStorageOperationType =
  | "CREATE"
  | "PICKUP"
  | "REPORT_EXCEPTION"
  | "DECIDE_EXCEPTION";

export async function listCustomerStorage(search = ""): Promise<CustomerStorageRecord[]> {
  const query = new URLSearchParams();
  if (search.trim()) query.set("search", search.trim());
  const value = await request<unknown>(
    `/v1/customer-storage${query.size > 0 ? `?${query.toString()}` : ""}`,
    { cache: "no-store" },
  );
  if (!Array.isArray(value) || !value.every(isCustomerStorageRecord)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "寄存记录无法安全确认，旧列表已停止显示，请重新读取",
    );
  }
  return value;
}

export async function listCustomerStorageSourceCandidates(
  memberId: string,
  orderQuery = "",
): Promise<CustomerStorageSourceCandidate[]> {
  const query = new URLSearchParams({ memberId });
  if (orderQuery.trim()) query.set("orderQuery", orderQuery.trim());
  const value = await request<unknown>(`/v1/customer-storage/source-candidates?${query}`, {
    cache: "no-store",
  });
  if (!isCustomerStorageSourceCandidateList(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "可寄存商品清单无法安全确认，请刷新会员和订单后重试",
    );
  }
  return value;
}

function parseCustomerStorageOperationResult(
  value: unknown,
  expectedStorageNumber?: string,
): CustomerStorageOperationResult {
  if (
    !isCustomerStorageOperationResult(value) ||
    (expectedStorageNumber !== undefined && value.storage.storageNumber !== expectedStorageNumber)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "寄存办理结果无法安全确认，请勿重复提交，并按原请求号查询结果",
    );
  }
  return value;
}

export async function createCustomerStorage(
  input: CustomerStorageCreateRequest,
): Promise<CustomerStorageOperationResult> {
  if (!isCustomerStorageCreateRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "寄存资料不完整，请重新选择会员、已结清订单、商品、数量和到期时间",
      400,
    );
  }
  const value = await request<unknown>("/v1/customer-storage", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  return parseCustomerStorageOperationResult(value);
}

export async function pickupCustomerStorage(
  storageNumber: string,
  input: CustomerStoragePickupRequest,
): Promise<CustomerStorageOperationResult> {
  if (!isCustomerStoragePickupRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "领取数量、原因或寄存版本不正确，请刷新后重试",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-storage/${encodeURIComponent(storageNumber)}/pickups`,
    { method: "POST", cache: "no-store", body: JSON.stringify(input) },
  );
  return parseCustomerStorageOperationResult(value, storageNumber);
}

export async function reportCustomerStorageException(
  storageNumber: string,
  input: CustomerStorageExceptionReportRequest,
): Promise<CustomerStorageOperationResult> {
  if (!isCustomerStorageExceptionReportRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "异常类型、说明或寄存版本不正确，请刷新后重试",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-storage/${encodeURIComponent(storageNumber)}/exceptions`,
    { method: "POST", cache: "no-store", body: JSON.stringify(input) },
  );
  return parseCustomerStorageOperationResult(value, storageNumber);
}

export async function decideCustomerStorageException(
  workItemId: string,
  input: CustomerStorageExceptionDecisionRequest,
): Promise<CustomerStorageOperationResult> {
  if (!isCustomerStorageExceptionDecisionRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "异常处理结果、原因或版本不正确，请刷新后重试",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-storage/exceptions/${encodeURIComponent(workItemId)}/decision`,
    { method: "POST", cache: "no-store", body: JSON.stringify(input) },
  );
  return parseCustomerStorageOperationResult(value);
}

export async function getCustomerStorageOperationResult(
  operationType: CustomerStorageOperationType,
  idempotencyKey: string,
): Promise<CustomerStorageOperationResult | null> {
  try {
    const value = await request<unknown>(
      `/v1/customer-storage/by-request/${operationType}/${encodeURIComponent(idempotencyKey)}`,
      { cache: "no-store" },
    );
    return parseCustomerStorageOperationResult(value);
  } catch (error) {
    if (error instanceof ApiRequestError && error.statusCode === 404) return null;
    throw error;
  }
}

export function customerStorageOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  return (
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

export type CustomerRentalOperationType =
  | "CREATE"
  | "RETURN"
  | "REPORT_EXCEPTION"
  | "DECIDE_EXCEPTION";

export async function listCustomerRentals(search = ""): Promise<CustomerRentalRecord[]> {
  const query = new URLSearchParams();
  if (search.trim()) query.set("search", search.trim());
  const value = await request<unknown>(
    `/v1/customer-rentals${query.size > 0 ? `?${query.toString()}` : ""}`,
    { cache: "no-store" },
  );
  if (!Array.isArray(value) || !value.every(isCustomerRentalRecord)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "租赁记录无法安全确认，旧列表已停止显示，请重新读取",
    );
  }
  return value;
}

export async function listCustomerRentalCandidates(
  sessionId: string,
): Promise<CustomerRentalCandidate[]> {
  if (!/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(sessionId)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "请先选择一个仍在进行中的台单", 400);
  }
  const query = new URLSearchParams({ sessionId });
  const value = await request<unknown>(`/v1/customer-rentals/candidates?${query.toString()}`, {
    cache: "no-store",
  });
  if (
    !isCustomerRentalCandidateList(value) ||
    value.some((candidate) => candidate.sessionId !== sessionId)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "当前台单的可租物品无法安全确认，请刷新后重新选择",
    );
  }
  return value;
}

function parseCustomerRentalOperationResult(
  value: unknown,
  expected: CustomerRentalOperationExpectation,
): CustomerRentalOperationResult {
  if (!isCustomerRentalOperationResult(value) || !customerRentalResultMatches(value, expected)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "租赁办理结果无法安全确认，请勿重复提交，并按原请求号查询结果",
    );
  }
  return value;
}

export type CustomerRentalOperationExpectation =
  | { operationType: "CREATE"; request: CustomerRentalCreateRequest }
  | {
      operationType: "RETURN";
      rentalNumber: string;
      request: CustomerRentalReturnRequest;
    }
  | {
      operationType: "REPORT_EXCEPTION";
      rentalNumber: string;
      request: CustomerRentalExceptionReportRequest;
    }
  | {
      operationType: "DECIDE_EXCEPTION";
      rentalNumber: string;
      workItemId: string;
      request: CustomerRentalExceptionDecisionRequest;
    };

function customerRentalOperationBindingMatches(
  result: CustomerRentalOperationResult["operation"],
  expected: CustomerRentalOperationExpectation,
): boolean {
  if (result.operationType !== expected.operationType) return false;
  switch (expected.operationType) {
    case "CREATE": {
      if (result.operationType !== "CREATE") return false;
      const actual = result.request;
      const requested = expected.request;
      return (
        actual.sessionId === requested.sessionId &&
        actual.skuId === requested.skuId &&
        actual.quantity === requested.quantity &&
        actual.expectedReturnAt === requested.expectedReturnAt &&
        actual.note === requested.note &&
        actual.expectedOrderVersion === requested.expectedOrderVersion &&
        actual.expectedProductVersion === requested.expectedProductVersion &&
        actual.idempotencyKey === requested.idempotencyKey
      );
    }
    case "RETURN": {
      if (result.operationType !== "RETURN") return false;
      const actual = result.request;
      const requested = expected.request;
      return (
        result.rentalNumber === expected.rentalNumber &&
        actual.quantity === requested.quantity &&
        actual.note === requested.note &&
        actual.expectedVersion === requested.expectedVersion &&
        actual.idempotencyKey === requested.idempotencyKey
      );
    }
    case "REPORT_EXCEPTION": {
      if (result.operationType !== "REPORT_EXCEPTION") return false;
      const actual = result.request;
      const requested = expected.request;
      return (
        result.rentalNumber === expected.rentalNumber &&
        actual.exceptionType === requested.exceptionType &&
        actual.note === requested.note &&
        actual.expectedVersion === requested.expectedVersion &&
        actual.idempotencyKey === requested.idempotencyKey
      );
    }
    case "DECIDE_EXCEPTION": {
      if (result.operationType !== "DECIDE_EXCEPTION") return false;
      const actual = result.request;
      const requested = expected.request;
      return (
        result.rentalNumber === expected.rentalNumber &&
        result.workItemId === expected.workItemId &&
        actual.decision === requested.decision &&
        actual.reason === requested.reason &&
        actual.expectedRentalVersion === requested.expectedRentalVersion &&
        actual.expectedWorkItemVersion === requested.expectedWorkItemVersion &&
        actual.idempotencyKey === requested.idempotencyKey
      );
    }
  }
}

export function customerRentalResultMatches(
  result: CustomerRentalOperationResult,
  expected: CustomerRentalOperationExpectation,
): boolean {
  if (!customerRentalOperationBindingMatches(result.operation, expected)) return false;
  const rental = result.rental;
  const lastHistory = rental.history.at(-1);
  switch (expected.operationType) {
    case "CREATE":
      return (
        result.workItemId === null &&
        rental.version === 1 &&
        rental.status === "ACTIVE" &&
        rental.chargeItem.sessionId === expected.request.sessionId &&
        rental.chargeItem.skuId === expected.request.skuId &&
        rental.chargeItem.productVersion === expected.request.expectedProductVersion &&
        rental.originalQuantity === expected.request.quantity &&
        rental.expectedReturnAt === expected.request.expectedReturnAt &&
        lastHistory?.action === "RENTED" &&
        lastHistory.note === expected.request.note
      );
    case "RETURN":
      return (
        result.workItemId === null &&
        rental.rentalNumber === expected.rentalNumber &&
        rental.version === expected.request.expectedVersion + 1 &&
        lastHistory?.action === "RETURNED" &&
        lastHistory.quantity === expected.request.quantity &&
        lastHistory.note === expected.request.note
      );
    case "REPORT_EXCEPTION":
      return (
        rental.rentalNumber === expected.rentalNumber &&
        rental.version === expected.request.expectedVersion + 1 &&
        result.workItemId !== null &&
        rental.latestException?.workItemId === result.workItemId &&
        rental.latestException.status === "PENDING" &&
        rental.latestException.exceptionType === expected.request.exceptionType &&
        rental.latestException.note === expected.request.note &&
        lastHistory?.action === "EXCEPTION_REPORTED" &&
        lastHistory.note === expected.request.note
      );
    case "DECIDE_EXCEPTION":
      return (
        rental.rentalNumber === expected.rentalNumber &&
        rental.version === expected.request.expectedRentalVersion + 1 &&
        result.workItemId === expected.workItemId &&
        rental.latestException?.workItemId === expected.workItemId &&
        rental.latestException.status ===
          (expected.request.decision === "CONFIRM" ? "CONFIRMED" : "REJECTED") &&
        rental.latestException.resolutionReason === expected.request.reason &&
        lastHistory?.action ===
          (expected.request.decision === "CONFIRM"
            ? "EXCEPTION_CONFIRMED"
            : "EXCEPTION_REJECTED") &&
        lastHistory.note === expected.request.reason
      );
  }
}

export async function createCustomerRental(
  input: CustomerRentalCreateRequest,
): Promise<CustomerRentalOperationResult> {
  if (!isCustomerRentalCreateRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "租赁资料不完整，请重新选择活动台单、可租物品、数量和预计归还时间",
      400,
    );
  }
  const value = await request<unknown>("/v1/customer-rentals", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(input),
  });
  return parseCustomerRentalOperationResult(value, { operationType: "CREATE", request: input });
}

export async function returnCustomerRental(
  rentalNumber: string,
  input: CustomerRentalReturnRequest,
): Promise<CustomerRentalOperationResult> {
  if (!isCustomerRentalReturnRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "归还数量、说明或租赁版本不正确，请刷新后重试",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-rentals/${encodeURIComponent(rentalNumber)}/returns`,
    { method: "POST", cache: "no-store", body: JSON.stringify(input) },
  );
  return parseCustomerRentalOperationResult(value, {
    operationType: "RETURN",
    rentalNumber,
    request: input,
  });
}

export async function reportCustomerRentalException(
  rentalNumber: string,
  input: CustomerRentalExceptionReportRequest,
): Promise<CustomerRentalOperationResult> {
  if (!isCustomerRentalExceptionReportRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "异常类型、说明或租赁版本不正确，请刷新后重试",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-rentals/${encodeURIComponent(rentalNumber)}/exceptions`,
    { method: "POST", cache: "no-store", body: JSON.stringify(input) },
  );
  return parseCustomerRentalOperationResult(value, {
    operationType: "REPORT_EXCEPTION",
    rentalNumber,
    request: input,
  });
}

export async function decideCustomerRentalException(
  workItemId: string,
  rentalNumber: string,
  input: CustomerRentalExceptionDecisionRequest,
): Promise<CustomerRentalOperationResult> {
  if (!isCustomerRentalExceptionDecisionRequest(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "异常处理结果、原因或版本不正确，请刷新后重试",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-rentals/exceptions/${encodeURIComponent(workItemId)}/decision`,
    { method: "POST", cache: "no-store", body: JSON.stringify(input) },
  );
  return parseCustomerRentalOperationResult(value, {
    operationType: "DECIDE_EXCEPTION",
    rentalNumber,
    workItemId,
    request: input,
  });
}

export async function getCustomerRentalOperationResult(
  expected: CustomerRentalOperationExpectation,
): Promise<CustomerRentalOperationResult | null> {
  try {
    const value = await request<unknown>(
      `/v1/customer-rentals/by-request/${expected.operationType}/${encodeURIComponent(expected.request.idempotencyKey)}`,
      { cache: "no-store" },
    );
    return parseCustomerRentalOperationResult(value, expected);
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "CUSTOMER_RENTAL_REQUEST_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export function customerRentalOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  return (
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

export interface CustomerReservationMutationContext {
  tenantId: string;
  storeId: string;
  actorId: string;
}

export type CustomerReservationMutationCommand =
  | {
      kind: "CREATE";
      request: CreateCustomerReservationRequest;
      context: CustomerReservationMutationContext;
    }
  | {
      kind: "TRANSITION";
      reservationId: string;
      request: CustomerReservationTransitionRequest;
      baseline: CustomerReservationReadModel;
      context: CustomerReservationMutationContext;
    }
  | {
      kind: "SEAT";
      reservationId: string;
      request: SeatCustomerReservationRequest;
      baseline: CustomerReservationReadModel;
      table: TableSnapshot;
      context: CustomerReservationMutationContext;
    };

function customerReservationContextIsValid(context: CustomerReservationMutationContext): boolean {
  return (
    context.tenantId.trim().length > 0 &&
    context.storeId.trim().length > 0 &&
    context.actorId.trim().length > 0
  );
}

function customerReservationBusinessDateIsValid(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/u.test(value)) return false;
  const milliseconds = Date.parse(`${value}T00:00:00.000Z`);
  return (
    Number.isFinite(milliseconds) &&
    new Date(milliseconds).toISOString() === `${value}T00:00:00.000Z`
  );
}

function customerReservationCommandIsValid(command: CustomerReservationMutationCommand): boolean {
  if (!customerReservationContextIsValid(command.context)) return false;
  if (command.kind === "CREATE") return isCreateCustomerReservationRequest(command.request);
  if (
    command.reservationId !== command.baseline.reservationId ||
    command.baseline.tenantId !== command.context.tenantId ||
    command.baseline.storeId !== command.context.storeId
  ) {
    return false;
  }
  if (command.kind === "TRANSITION") {
    return (
      isCustomerReservationTransitionRequest(command.request) &&
      command.request.expectedReservationVersion === command.baseline.reservationVersion &&
      (command.request.action !== "RETRACT_CALL" || command.baseline.state === "CALLED")
    );
  }
  return (
    command.baseline.state === "CALLED" &&
    command.request.expectedReservationVersion === command.baseline.reservationVersion &&
    command.request.tableId === command.table.tableId &&
    command.request.expectedTableRevision === command.table.revision &&
    command.table.tenantId === command.context.tenantId &&
    command.table.storeId === command.context.storeId &&
    command.table.state === "IDLE" &&
    command.table.sessionId === null &&
    command.table.sessionStartedAt === null &&
    command.table.billingState === "ENDED" &&
    command.table.billingPausedAt === null &&
    command.table.pricingPlanName === null &&
    command.table.estimatedFeeFen === 0 &&
    command.table.currentTotalFen === 0 &&
    command.table.sessionElapsedSeconds === 0
  );
}

function customerReservationIdentityUnchanged(
  returned: CustomerReservationReadModel,
  baseline: CustomerReservationReadModel,
): boolean {
  return (
    returned.reservationId === baseline.reservationId &&
    returned.reservationNumber === baseline.reservationNumber &&
    returned.tenantId === baseline.tenantId &&
    returned.storeId === baseline.storeId &&
    returned.businessDate === baseline.businessDate &&
    returned.customerName === baseline.customerName &&
    returned.customerMobile === baseline.customerMobile &&
    returned.partySize === baseline.partySize &&
    returned.requestedStartAt === baseline.requestedStartAt &&
    returned.requestedEndAt === baseline.requestedEndAt &&
    returned.note === baseline.note &&
    returned.depositFen === 0 &&
    returned.discountFen === 0 &&
    returned.source === baseline.source &&
    returned.createdBy === baseline.createdBy &&
    returned.createdAt === baseline.createdAt
  );
}

const customerReservationTransitionState = {
  CONFIRM: "CONFIRMED",
  ARRIVE: "WAITING",
  CALL: "CALLED",
  SKIP: "WAITING",
  RETRACT_CALL: "WAITING",
  CANCEL: "CANCELLED",
  NO_SHOW: "NO_SHOW",
  EXPIRE: "EXPIRED",
} as const;

function customerReservationRetractCallResultMatches(
  returned: CustomerReservationReadModel,
  baseline: CustomerReservationReadModel,
): boolean {
  return (
    baseline.state === "CALLED" &&
    returned.calledAt === null &&
    returned.confirmedAt === baseline.confirmedAt &&
    returned.arrivedAt === baseline.arrivedAt &&
    returned.queueEnteredAt === baseline.queueEnteredAt &&
    returned.seatedAt === baseline.seatedAt &&
    returned.cancelledAt === baseline.cancelledAt &&
    returned.noShowAt === baseline.noShowAt &&
    returned.expiredAt === baseline.expiredAt &&
    returned.assignedTableId === baseline.assignedTableId &&
    returned.assignedTableNumber === baseline.assignedTableNumber &&
    returned.sessionId === baseline.sessionId &&
    returned.orderId === baseline.orderId &&
    returned.orderNumber === baseline.orderNumber
  );
}

function customerReservationResultMatchesCommand(
  result: CustomerReservationMutationResult,
  command: CustomerReservationMutationCommand,
): boolean {
  const reservation = result.reservation;
  if (
    reservation.tenantId !== command.context.tenantId ||
    reservation.storeId !== command.context.storeId ||
    reservation.lastActionBy !== command.context.actorId
  ) {
    return false;
  }
  if (command.kind === "CREATE") {
    return (
      result.operation === "CREATE" &&
      result.seating === null &&
      reservation.customerName === command.request.customerName &&
      reservation.customerMobile === command.request.customerMobile &&
      reservation.partySize === command.request.partySize &&
      reservation.requestedStartAt === command.request.requestedStartAt &&
      reservation.note === command.request.note &&
      reservation.depositFen === 0 &&
      reservation.discountFen === 0 &&
      reservation.source === "FRONTDESK" &&
      reservation.createdBy === command.context.actorId &&
      reservation.reservationVersion === 1 &&
      reservation.state === "PENDING_CONFIRMATION"
    );
  }
  if (
    reservation.reservationVersion !== command.baseline.reservationVersion + 1 ||
    !customerReservationIdentityUnchanged(reservation, command.baseline)
  ) {
    return false;
  }
  if (command.kind === "TRANSITION") {
    const matchesTransition =
      result.operation === command.request.action &&
      result.seating === null &&
      reservation.state === customerReservationTransitionState[command.request.action];
    return (
      matchesTransition &&
      (command.request.action !== "RETRACT_CALL" ||
        customerReservationRetractCallResultMatches(reservation, command.baseline))
    );
  }
  return (
    result.operation === "SEAT" &&
    reservation.state === "SEATED" &&
    result.seating !== null &&
    result.seating.tableId === command.table.tableId &&
    result.seating.tableNumber === command.table.tableNumber &&
    result.seating.tableRevision === command.table.revision + 1 &&
    result.seating.depositFen === 0 &&
    result.seating.discountFen === 0
  );
}

function parseCustomerReservationResult(
  value: unknown,
  command: CustomerReservationMutationCommand,
): CustomerReservationMutationResult {
  if (
    !customerReservationCommandIsValid(command) ||
    !isCustomerReservationMutationResult(value) ||
    !customerReservationResultMatchesCommand(value, command)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "预约操作结果无法与原预约、原版本和球台逐项对应，页面继续锁定，请勿重复操作",
    );
  }
  return value;
}

export async function getCustomerReservationCalendarDay(
  scope: Pick<CustomerReservationMutationContext, "tenantId" | "storeId">,
  businessDate: string,
  signal?: AbortSignal,
): Promise<CustomerReservationCalendarDay> {
  if (
    scope.tenantId.trim().length === 0 ||
    scope.storeId.trim().length === 0 ||
    !customerReservationBusinessDateIsValid(businessDate)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "预约日历的门店身份或营业日不正确，系统没有读取预约",
      400,
    );
  }
  const query = new URLSearchParams({ businessDate });
  const value = await request<unknown>(`/v1/customer-reservations/calendar?${query.toString()}`, {
    cache: "no-store",
    ...(signal ? { signal } : {}),
  });
  if (
    !isCustomerReservationCalendarDay(value) ||
    value.tenantId !== scope.tenantId ||
    value.storeId !== scope.storeId ||
    value.businessDate !== businessDate
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "预约日历与当前门店或营业日不一致，页面已停止显示",
    );
  }
  return value;
}

export async function listCustomerReservations(
  scope: Pick<CustomerReservationMutationContext, "tenantId" | "storeId">,
): Promise<CustomerReservationWorkspace> {
  if (scope.tenantId.trim().length === 0 || scope.storeId.trim().length === 0) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "当前预约门店身份不完整，系统没有读取预约列表",
      400,
    );
  }

  const items: CustomerReservationWorkspaceItem[] = [];
  const reservationIds = new Set<string>();
  const requestedCursors = new Set<string>();
  let firstPage: CustomerReservationWorkspacePage | null = null;
  let cursor: string | undefined;

  for (;;) {
    if (cursor !== undefined) {
      if (requestedCursors.has(cursor)) {
        throw invalidCustomerReservationWorkspacePage();
      }
      requestedCursors.add(cursor);
    }
    const query = new URLSearchParams({ limit: "100" });
    if (cursor !== undefined) query.set("cursor", cursor);
    const value = await request<unknown>(`/v1/customer-reservations?${query.toString()}`, {
      cache: "no-store",
    });
    if (
      !isCustomerReservationWorkspacePage(value) ||
      value.pageLimit !== 100 ||
      value.itemsBefore !== items.length ||
      value.tenantId !== scope.tenantId ||
      value.storeId !== scope.storeId ||
      value.items.some(
        ({ reservation }) =>
          reservation.tenantId !== scope.tenantId || reservation.storeId !== scope.storeId,
      )
    ) {
      throw invalidCustomerReservationWorkspacePage();
    }
    if (firstPage === null) {
      firstPage = value;
    } else if (!customerReservationWorkspacePageMetadataMatches(firstPage, value)) {
      throw invalidCustomerReservationWorkspacePage();
    }
    for (const item of value.items) {
      if (reservationIds.has(item.reservation.reservationId)) {
        throw invalidCustomerReservationWorkspacePage();
      }
      reservationIds.add(item.reservation.reservationId);
      items.push(item);
    }
    if (
      items.length > firstPage.totalItems ||
      (value.nextCursor !== null && items.length >= firstPage.totalItems) ||
      (value.nextCursor !== null &&
        (value.nextCursor === cursor || requestedCursors.has(value.nextCursor)))
    ) {
      throw invalidCustomerReservationWorkspacePage();
    }
    if (value.nextCursor === null) break;
    cursor = value.nextCursor;
  }

  if (firstPage === null || items.length !== firstPage.totalItems) {
    throw invalidCustomerReservationWorkspacePage();
  }
  const workspace: CustomerReservationWorkspace = {
    tenantId: firstPage.tenantId,
    storeId: firstPage.storeId,
    timeZone: firstPage.timeZone,
    currentBusinessDate: firstPage.currentBusinessDate,
    items: [...items].sort(compareCustomerReservationWorkspaceItems),
    nextWaitingReservationId: firstPage.nextWaitingReservationId,
    idleTableCount: firstPage.idleTableCount,
    waitEstimateBasis: firstPage.waitEstimateBasis,
    generatedAt: firstPage.generatedAt,
  };
  if (!isCustomerReservationWorkspace(workspace)) {
    throw invalidCustomerReservationWorkspacePage();
  }
  return workspace;
}

function invalidCustomerReservationWorkspacePage(): ApiRequestError {
  return new ApiRequestError(
    "GATEWAY_RESPONSE_INVALID",
    "预约工作台分页返回无法形成同一份完整门店快照，已保留旧列表，请重新读取",
  );
}

function customerReservationWorkspacePageMetadataMatches(
  first: CustomerReservationWorkspacePage,
  current: CustomerReservationWorkspacePage,
): boolean {
  return (
    current.tenantId === first.tenantId &&
    current.storeId === first.storeId &&
    current.snapshotId === first.snapshotId &&
    current.timeZone === first.timeZone &&
    current.currentBusinessDate === first.currentBusinessDate &&
    current.pageLimit === first.pageLimit &&
    current.totalItems === first.totalItems &&
    current.nextWaitingReservationId === first.nextWaitingReservationId &&
    current.idleTableCount === first.idleTableCount &&
    current.waitEstimateBasis === first.waitEstimateBasis &&
    current.generatedAt === first.generatedAt
  );
}

function compareCustomerReservationWorkspaceItems(
  left: CustomerReservationWorkspaceItem,
  right: CustomerReservationWorkspaceItem,
): number {
  const leftQueued = left.queuePosition !== null;
  const rightQueued = right.queuePosition !== null;
  if (leftQueued !== rightQueued) return leftQueued ? -1 : 1;
  if (leftQueued && rightQueued && left.queuePosition !== right.queuePosition) {
    return (
      (left.queuePosition ?? Number.MAX_SAFE_INTEGER) -
      (right.queuePosition ?? Number.MAX_SAFE_INTEGER)
    );
  }
  if (left.reservation.requestedStartAt !== right.reservation.requestedStartAt) {
    return left.reservation.requestedStartAt < right.reservation.requestedStartAt ? -1 : 1;
  }
  if (left.reservation.updatedAt !== right.reservation.updatedAt) {
    return left.reservation.updatedAt > right.reservation.updatedAt ? -1 : 1;
  }
  if (left.reservation.reservationId === right.reservation.reservationId) return 0;
  return left.reservation.reservationId < right.reservation.reservationId ? -1 : 1;
}

export type CustomerReservationHistoryPageBoundary = Readonly<{
  tenantId: string;
  storeId: string;
  snapshotId: string;
  totalItems: number;
  generatedAt: string;
  requestedCursor: string | null;
  nextCursor: string | null;
  reservationIds: readonly string[];
  previous: CustomerReservationHistoryPageBoundary | null;
}>;

export type ValidatedCustomerReservationHistoryPage = CustomerReservationHistoryPage &
  Readonly<{ boundary: CustomerReservationHistoryPageBoundary }>;

function invalidCustomerReservationHistoryPage(): ApiRequestError {
  return new ApiRequestError(
    "GATEWAY_RESPONSE_INVALID",
    "预约历史分页返回无法形成同一份完整门店快照，已保留此前确认的记录",
  );
}

function customerReservationHistoryPageBoundary(
  scope: Pick<CustomerReservationMutationContext, "tenantId" | "storeId">,
  value: CustomerReservationHistoryPage,
  cursor: string | undefined,
  previous: CustomerReservationHistoryPageBoundary | null,
): CustomerReservationHistoryPageBoundary {
  const requestedCursor = cursor ?? null;
  if (
    (previous === null && cursor !== undefined) ||
    (previous !== null && (previous.nextCursor === null || previous.nextCursor !== requestedCursor))
  ) {
    throw invalidCustomerReservationHistoryPage();
  }

  const visitedBoundaries = new Set<CustomerReservationHistoryPageBoundary>();
  const requestedCursors = new Set<string | null>();
  const reservationIds = new Set<string>();
  for (let page = previous; page !== null; page = page.previous) {
    if (
      visitedBoundaries.has(page) ||
      page.tenantId !== scope.tenantId ||
      page.storeId !== scope.storeId ||
      page.snapshotId !== value.snapshotId ||
      page.totalItems !== value.totalItems ||
      page.generatedAt !== value.generatedAt ||
      requestedCursors.has(page.requestedCursor) ||
      (page.nextCursor !== null && page.nextCursor === page.requestedCursor) ||
      (page.previous !== null && page.requestedCursor !== page.previous.nextCursor) ||
      !Array.isArray(page.reservationIds) ||
      new Set(page.reservationIds).size !== page.reservationIds.length ||
      page.reservationIds.some(
        (reservationId) =>
          typeof reservationId !== "string" ||
          reservationId.length === 0 ||
          reservationIds.has(reservationId),
      )
    ) {
      throw invalidCustomerReservationHistoryPage();
    }
    visitedBoundaries.add(page);
    requestedCursors.add(page.requestedCursor);
    for (const reservationId of page.reservationIds) reservationIds.add(reservationId);
  }
  const accumulatedItemCount = reservationIds.size + value.items.length;
  if (
    value.itemsBefore !== reservationIds.size ||
    requestedCursors.has(requestedCursor) ||
    (value.nextCursor !== null &&
      (value.nextCursor === requestedCursor || requestedCursors.has(value.nextCursor))) ||
    value.items.some((item) => reservationIds.has(item.reservation.reservationId)) ||
    accumulatedItemCount > value.totalItems ||
    (value.nextCursor === null && accumulatedItemCount !== value.totalItems) ||
    (value.nextCursor !== null && accumulatedItemCount >= value.totalItems)
  ) {
    throw invalidCustomerReservationHistoryPage();
  }
  return Object.freeze({
    tenantId: value.tenantId,
    storeId: value.storeId,
    snapshotId: value.snapshotId,
    totalItems: value.totalItems,
    generatedAt: value.generatedAt,
    requestedCursor,
    nextCursor: value.nextCursor,
    reservationIds: Object.freeze(value.items.map((item) => item.reservation.reservationId)),
    previous,
  });
}

export async function listCustomerReservationHistory(
  scope: Pick<CustomerReservationMutationContext, "tenantId" | "storeId">,
  cursor: string | undefined,
  previous: CustomerReservationHistoryPageBoundary | null,
): Promise<ValidatedCustomerReservationHistoryPage> {
  if (previous === undefined) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "预约历史必须从第一页开始读取，系统没有跳过前页校验",
      400,
    );
  }
  if (scope.tenantId.trim().length === 0 || scope.storeId.trim().length === 0) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "当前预约门店身份不完整，系统没有读取预约历史",
      400,
    );
  }
  const query = new URLSearchParams({ limit: "50" });
  if (cursor !== undefined) query.set("cursor", cursor);
  const value = await request<unknown>(`/v1/customer-reservations/history?${query.toString()}`, {
    cache: "no-store",
  });
  if (
    !isCustomerReservationHistoryPage(value) ||
    value.pageLimit !== 50 ||
    value.tenantId !== scope.tenantId ||
    value.storeId !== scope.storeId ||
    value.items.some(
      ({ reservation }) =>
        reservation.tenantId !== scope.tenantId || reservation.storeId !== scope.storeId,
    ) ||
    (value.nextCursor !== null && value.nextCursor === cursor)
  ) {
    throw invalidCustomerReservationHistoryPage();
  }
  return {
    ...value,
    boundary: customerReservationHistoryPageBoundary(scope, value, cursor, previous),
  };
}

export async function getCustomerReservationByRequest(
  idempotencyKey: string,
  command: CustomerReservationMutationCommand,
): Promise<CustomerReservationMutationResult | null> {
  if (
    !customerReservationCommandIsValid(command) ||
    command.request.idempotencyKey !== idempotencyKey
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本机保存的预约原请求不完整，系统没有查询或重试",
      400,
    );
  }
  try {
    const value = await request<unknown>(
      `/v1/customer-reservations/by-request/${encodeURIComponent(idempotencyKey)}`,
      { cache: "no-store" },
    );
    return parseCustomerReservationResult(value, command);
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "CUSTOMER_RESERVATION_REQUEST_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export async function createCustomerReservation(
  command: Extract<CustomerReservationMutationCommand, { kind: "CREATE" }>,
): Promise<CustomerReservationMutationResult> {
  if (!customerReservationCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "预约姓名、手机号、人数、开始时间、时长或备注不完整，请按页面提示修改",
      400,
    );
  }
  const value = await request<unknown>("/v1/customer-reservations", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command.request),
  });
  return parseCustomerReservationResult(value, command);
}

export async function transitionCustomerReservation(
  command: Extract<CustomerReservationMutationCommand, { kind: "TRANSITION" }>,
): Promise<CustomerReservationMutationResult> {
  if (!customerReservationCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "预约已经变化或当前动作内容不完整，请刷新预约后重新选择",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-reservations/${encodeURIComponent(command.reservationId)}/transitions`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(command.request),
    },
  );
  return parseCustomerReservationResult(value, command);
}

export async function seatCustomerReservation(
  command: Extract<CustomerReservationMutationCommand, { kind: "SEAT" }>,
): Promise<CustomerReservationMutationResult> {
  if (!customerReservationCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "预约或所选球台已经变化，请重新读取空闲球台后再入座",
      400,
    );
  }
  const value = await request<unknown>(
    `/v1/customer-reservations/${encodeURIComponent(command.reservationId)}/seat`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(command.request),
    },
  );
  return parseCustomerReservationResult(value, command);
}

export function customerReservationOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  return (
    error.code === "GATEWAY_UNREACHABLE" ||
    error.code === "GATEWAY_RESPONSE_INVALID" ||
    (error.statusCode !== undefined && error.statusCode >= 500)
  );
}

export interface CombinedCheckoutBaselineItem {
  order: OrderDetail;
  table: TableSnapshot;
  splitPlan: CheckoutSplitPlanReadModel | null;
}

export interface CombinedCheckoutExpectedResult {
  tenantId: string;
  storeId: string;
  actorId: string;
  baselines: readonly CombinedCheckoutBaselineItem[];
}

export interface CombinedCheckoutResult {
  combinedCheckout: CombinedCheckoutReadModel;
  orders: OrderDetail[];
  tables: TableSnapshot[];
  manualReview: ManualReviewItem | null;
  receipt: CheckoutResult["receipt"];
}

function combinedCheckoutOrderIsEligible(order: OrderDetail, table: TableSnapshot): boolean {
  return (
    order.orderNumber !== undefined &&
    order.status === "OPEN" &&
    order.billingState === "ENDED" &&
    order.billingPausedAt === null &&
    order.endedAt !== null &&
    order.totalFen > 0 &&
    order.paidFen === 0 &&
    order.refundedFen === 0 &&
    order.payments.length === 0 &&
    order.refunds.length === 0 &&
    order.syncState !== "CONFLICT" &&
    order.syncState !== "FAILED" &&
    order.syncState !== "ISOLATED" &&
    table.tableId === order.tableId &&
    table.tableNumber === order.tableNumber &&
    table.state === "IN_USE" &&
    table.sessionId === order.sessionId &&
    table.sessionStartedAt === order.startedAt &&
    table.billingState === "ENDED" &&
    table.billingPausedAt === null &&
    table.pricingPlanName === order.priceSnapshot.name &&
    table.estimatedFeeFen === order.tableFeeFen &&
    table.currentTotalFen === order.totalFen
  );
}

function combinedCheckoutExpectedMatchesRequest(
  requestBody: CreateCombinedCheckoutRequest,
  expected: CombinedCheckoutExpectedResult,
): boolean {
  if (
    expected.tenantId.length === 0 ||
    expected.storeId.length === 0 ||
    expected.actorId.length === 0 ||
    expected.baselines.length !== requestBody.orders.length ||
    !isTableSnapshotList(
      expected.baselines.map((baseline) => baseline.table),
      expected.tenantId,
      expected.storeId,
    )
  ) {
    return false;
  }
  return requestBody.orders.every((requested) => {
    const baseline = expected.baselines.find(
      (candidate) => candidate.order.sessionId === requested.sessionId,
    );
    return (
      baseline !== undefined &&
      baseline.splitPlan === null &&
      isOrderDetailReadModel(baseline.order) &&
      combinedCheckoutOrderIsEligible(baseline.order, baseline.table) &&
      baseline.table.tenantId === expected.tenantId &&
      baseline.table.storeId === expected.storeId &&
      baseline.order.id === requested.orderId &&
      baseline.order.orderNumber === requested.orderNumber &&
      baseline.order.tableId === requested.tableId &&
      baseline.order.tableNumber === requested.tableNumber &&
      baseline.table.revision === requested.expectedTableRevision &&
      baseline.order.totalFen === requested.expectedAmountFen
    );
  });
}

function combinedCheckoutPaymentMatches(
  payment: PaymentRecord,
  method: CombinedCheckoutManualPaymentMethod,
  amountFen: number,
  combinedNumber: string,
  occurredAt: string,
  expectedStatus: PaymentRecord["status"],
): boolean {
  return (
    payment.method === method &&
    payment.amountFen === amountFen &&
    payment.status === expectedStatus &&
    payment.evidence === "MANUAL_FALLBACK" &&
    payment.recordedAt === occurredAt &&
    (payment.memberId === undefined || payment.memberId === null) &&
    payment.referenceId === combinedNumber &&
    (payment.officialPaymentAttemptId === undefined || payment.officialPaymentAttemptId === null) &&
    (payment.providerCode === undefined || payment.providerCode === null) &&
    (payment.providerTransactionReference === undefined ||
      payment.providerTransactionReference === null)
  );
}

function combinedCheckoutOrderResultMatches(
  returned: OrderDetail,
  baseline: OrderDetail,
  paymentId: string,
  method: CombinedCheckoutManualPaymentMethod,
  combinedNumber: string,
  occurredAt: string,
  expectedPaymentStatus: PaymentRecord["status"],
): boolean {
  const payment = returned.payments.find((candidate) => candidate.id === paymentId);
  return (
    payment !== undefined &&
    returned.payments.length === 1 &&
    combinedCheckoutPaymentMatches(
      payment,
      method,
      baseline.totalFen,
      combinedNumber,
      occurredAt,
      expectedPaymentStatus,
    ) &&
    returned.status === "SETTLED" &&
    returned.paidFen === baseline.totalFen &&
    returned.refundedFen === 0 &&
    returned.refunds.length === 0 &&
    returned.syncState === "PENDING" &&
    jsonEqual(
      {
        ...returned,
        status: baseline.status,
        paidFen: baseline.paidFen,
        payments: baseline.payments,
        offlineOrigin: baseline.offlineOrigin,
        syncState: baseline.syncState,
      },
      baseline,
    )
  );
}

function combinedCheckoutTableResultMatches(
  returned: TableSnapshot,
  baseline: TableSnapshot,
  occurredAt: string,
): boolean {
  return (
    returned.tenantId === baseline.tenantId &&
    returned.storeId === baseline.storeId &&
    returned.tableId === baseline.tableId &&
    returned.tableNodeId === baseline.tableNodeId &&
    returned.tableNumber === baseline.tableNumber &&
    returned.area === baseline.area &&
    returned.state === "AWAITING_CLEANING" &&
    returned.sessionId === null &&
    returned.sessionStartedAt === null &&
    returned.billingState === "ENDED" &&
    returned.billingPausedAt === null &&
    returned.pricingPlanName === null &&
    returned.estimatedFeeFen === 0 &&
    returned.currentTotalFen === 0 &&
    returned.sessionElapsedSeconds === 0 &&
    returned.sessionRiskLevel === "NORMAL" &&
    returned.longSessionWarningMinutes === baseline.longSessionWarningMinutes &&
    returned.longSessionCriticalMinutes === baseline.longSessionCriticalMinutes &&
    returned.billingEvidence === baseline.billingEvidence &&
    returned.authoritativeAt === occurredAt &&
    returned.revision === baseline.revision + 1
  );
}

function combinedCheckoutStableStringify(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map((item) => combinedCheckoutStableStringify(item)).join(",")}]`;
  }
  if (value !== null && typeof value === "object") {
    return `{${Object.entries(value as Record<string, unknown>)
      .sort(([left], [right]) => left.localeCompare(right))
      .map(([key, item]) => `${JSON.stringify(key)}:${combinedCheckoutStableStringify(item)}`)
      .join(",")}}`;
  }
  return JSON.stringify(value) ?? "null";
}

async function combinedCheckoutCommandSha256(
  requestBody: CreateCombinedCheckoutRequest,
): Promise<string | null> {
  if (!globalThis.crypto?.subtle) return null;
  const bytes = new TextEncoder().encode(combinedCheckoutStableStringify(requestBody));
  const digest = await globalThis.crypto.subtle.digest("SHA-256", bytes);
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

async function parseCombinedCheckoutResult(
  value: unknown,
  requestBody: CreateCombinedCheckoutRequest,
  expected: CombinedCheckoutExpectedResult,
): Promise<CombinedCheckoutResult | null> {
  if (
    !hasExactRecordKeys(value, [
      "combinedCheckout",
      "orders",
      "tables",
      "manualReview",
      "receipt",
    ]) ||
    !isCombinedCheckoutReadModel(value.combinedCheckout) ||
    !Array.isArray(value.orders) ||
    !Array.isArray(value.tables) ||
    value.orders.length !== requestBody.orders.length ||
    value.tables.length !== requestBody.orders.length ||
    !value.orders.every(isOrderDetailReadModel) ||
    !isTableSnapshotList(value.tables, expected.tenantId, expected.storeId) ||
    !checkoutSplitReceiptIsStrict(value.receipt) ||
    !combinedCheckoutExpectedMatchesRequest(requestBody, expected)
  ) {
    return null;
  }
  const combinedCheckout = value.combinedCheckout;
  const expectedCommandSha256 = await combinedCheckoutCommandSha256(requestBody);
  const orders = value.orders as OrderDetail[];
  const tables = value.tables as TableSnapshot[];
  const manualReview = isManualReviewItem(value.manualReview) ? value.manualReview : null;
  const expectedPaymentStatus: PaymentRecord["status"] | null =
    requestBody.method === "CASH"
      ? "CONFIRMED_LOCAL"
      : manualReview?.status === "RESOLVED" && manualReview.reasonCode === "MANUALLY_RECONCILED"
        ? "MANUALLY_RECONCILED"
        : manualReview?.status === "PENDING" &&
            ["NOT_RECEIVED", "AMOUNT_MISMATCH", "DUPLICATE_PAYMENT"].includes(
              manualReview.reasonCode,
            )
          ? "RECONCILIATION_EXCEPTION"
          : manualReview?.status === "PENDING" &&
              manualReview.reasonCode === "STATIC_CODE_PENDING_CHANNEL_CHECK"
            ? "PENDING_RECONCILIATION"
            : null;
  const paymentOfflineOrigins = orders.flatMap((returned) =>
    returned.payments.map((payment) => payment.offlineOrigin),
  );
  const manualReviewMatches =
    requestBody.method === "CASH"
      ? value.manualReview === null && combinedCheckout.manualReviewId === null
      : manualReview !== null &&
        manualReview.id === combinedCheckout.manualReviewId &&
        manualReview.type === "PAYMENT" &&
        manualReview.objectId === combinedCheckout.combinedCheckoutId &&
        manualReview.orderId === combinedCheckout.orders[0]?.orderId &&
        manualReview.amountFen === combinedCheckout.totalFen &&
        manualReview.createdAt === combinedCheckout.createdAt &&
        manualReview.offlineOrigin === paymentOfflineOrigins[0] &&
        paymentOfflineOrigins.every(
          (offlineOrigin) => offlineOrigin === manualReview.offlineOrigin,
        ) &&
        ((manualReview.status === "PENDING" && manualReview.resolvedAt === null) ||
          (manualReview.status === "RESOLVED" && manualReview.resolvedAt !== null));
  if (
    combinedCheckout.createdBy !== expected.actorId ||
    expectedCommandSha256 === null ||
    combinedCheckout.commandSha256 !== expectedCommandSha256 ||
    combinedCheckout.method !== requestBody.method ||
    combinedCheckout.totalFen !== requestBody.expectedTotalFen ||
    new Set(orders.map((returned) => returned.syncState)).size !== 1 ||
    expectedPaymentStatus === null ||
    !manualReviewMatches ||
    combinedCheckout.orders.length !== requestBody.orders.length ||
    combinedCheckout.orders.some((allocation, index) => {
      const requested = requestBody.orders[index];
      const baseline = expected.baselines.find(
        (candidate) => candidate.order.sessionId === allocation.sessionId,
      );
      const returnedOrder = orders.find((candidate) => candidate.id === allocation.orderId);
      const returnedTable = tables.find((candidate) => candidate.tableId === allocation.tableId);
      return (
        !requested ||
        !baseline ||
        allocation.allocationOrder !== index + 1 ||
        allocation.sessionId !== requested.sessionId ||
        allocation.orderId !== requested.orderId ||
        allocation.orderNumber !== requested.orderNumber ||
        allocation.tableId !== requested.tableId ||
        allocation.tableNumber !== requested.tableNumber ||
        allocation.businessDate !== baseline.order.businessDate ||
        allocation.amountFen !== requested.expectedAmountFen ||
        allocation.orderVersionAfter !== allocation.orderVersionBefore + 1 ||
        !returnedOrder ||
        !returnedTable ||
        !combinedCheckoutOrderResultMatches(
          returnedOrder,
          baseline.order,
          allocation.paymentId,
          requestBody.method,
          combinedCheckout.combinedNumber,
          combinedCheckout.createdAt,
          expectedPaymentStatus,
        ) ||
        !combinedCheckoutTableResultMatches(
          returnedTable,
          baseline.table,
          combinedCheckout.createdAt,
        )
      );
    })
  ) {
    return null;
  }
  return value as unknown as CombinedCheckoutResult;
}

export async function getCombinedCheckoutByRequest(
  idempotencyKey: string,
  requestBody: CreateCombinedCheckoutRequest,
  expected: CombinedCheckoutExpectedResult,
): Promise<CombinedCheckoutResult | null> {
  if (
    !isCreateCombinedCheckoutRequest(requestBody) ||
    requestBody.idempotencyKey !== idempotencyKey ||
    !combinedCheckoutExpectedMatchesRequest(requestBody, expected)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原合并收款请求与本机保存的台单不一致，系统没有查询或重试",
      400,
    );
  }
  const result = await request<unknown>(
    `/v1/combined-checkouts/by-request/${encodeURIComponent(idempotencyKey)}`,
    { cache: "no-store" },
  );
  if (result === null) return null;
  const parsed = await parseCombinedCheckoutResult(result, requestBody, expected);
  if (!parsed) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "合并收款查询结果无法与原请求、每张台单和球台状态逐一对应，页面继续锁定",
    );
  }
  return parsed;
}

export async function createCombinedCheckout(
  requestBody: CreateCombinedCheckoutRequest,
  expected: CombinedCheckoutExpectedResult,
): Promise<CombinedCheckoutResult> {
  if (
    !isCreateCombinedCheckoutRequest(requestBody) ||
    !combinedCheckoutExpectedMatchesRequest(requestBody, expected)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "所选台单、金额、球台版本或分账状态不能形成同一笔安全的合并收款，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>("/v1/combined-checkouts", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(requestBody),
  });
  const parsed = await parseCombinedCheckoutResult(result, requestBody, expected);
  if (!parsed) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "合并收款返回结果无法与原请求、逐单付款和关台状态逐一对应，不能显示为成功",
    );
  }
  return parsed;
}

export function combinedCheckoutOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  return ![
    "REQUEST_VALIDATION_FAILED",
    "AUTH_REQUIRED",
    "AUTHORIZATION_DEFAULT_DENY",
    "AUTHORITY_EXPIRED",
    "CSRF_REJECTED",
    "SHIFT_SESSION_NOT_STARTED",
    "PAYMENT_METHOD_DISABLED",
    "COACH_SERVICE_UNFINISHED",
    "TABLE_NOT_FOUND",
    "COMBINED_CHECKOUT_REQUEST_INVALID",
    "COMBINED_CHECKOUT_BILLING_NOT_FROZEN",
    "COMBINED_CHECKOUT_IDENTITY_CHANGED",
    "COMBINED_CHECKOUT_ORDER_INELIGIBLE",
    "COMBINED_CHECKOUT_TOTAL_CHANGED",
    "COMBINED_CHECKOUT_ORDER_CHANGED",
    "COMBINED_CHECKOUT_RESULT_INVALID",
    "IDEMPOTENCY_COLLISION",
  ].includes(error.code);
}

function orderNumberIdentity(order: { id: string; orderNumber?: string }): string {
  return order.orderNumber ?? order.id;
}

type CheckoutMemberInput = {
  memberId: string;
  memberBalanceFen?: number;
  memberSpendPlanHash?: string;
};

function checkoutRequestMatchesFrozenCommand(
  sessionId: string,
  method: PaymentMethod,
  idempotencyKey: string,
  expected: CheckoutExpectedResult,
  member?: CheckoutMemberInput,
): boolean {
  const baseline = expected.baselineOrder;
  const memberKeys = member ? Object.keys(member) : [];
  const expectedMemberKeys = member
    ? [
        "memberId",
        ...(member.memberBalanceFen === undefined ? [] : ["memberBalanceFen"]),
        ...(member.memberSpendPlanHash === undefined ? [] : ["memberSpendPlanHash"]),
      ]
    : [];
  if (
    !isOrderDetail(baseline) ||
    baseline.status !== "OPEN" ||
    baseline.sessionId !== sessionId ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/u.test(idempotencyKey) ||
    memberKeys.length !== expectedMemberKeys.length ||
    !expectedMemberKeys.every((key) => memberKeys.includes(key)) ||
    (member?.memberSpendPlanHash !== undefined &&
      !/^[a-f0-9]{64}$/u.test(member.memberSpendPlanHash))
  ) {
    return false;
  }
  if (member?.memberBalanceFen !== undefined) {
    return (
      (method === "CASH" || method === "STATIC_WECHAT" || method === "STATIC_ALIPAY") &&
      member.memberId === member.memberId.trim() &&
      member.memberId.length > 0 &&
      member.memberId.length <= 256 &&
      expected.memberId === member.memberId &&
      Number.isSafeInteger(member.memberBalanceFen) &&
      member.memberBalanceFen > 0 &&
      member.memberBalanceFen < baseline.totalFen
    );
  }
  if (method === "MEMBER_BALANCE") {
    return (
      member !== undefined &&
      member.memberId === member.memberId.trim() &&
      member.memberId.length > 0 &&
      member.memberId.length <= 256 &&
      expected.memberId === member.memberId
    );
  }
  return member === undefined && expected.memberId === null;
}

function paymentStatusMatchesMethod(
  method: PaymentMethod,
  status: OrderDetail["payments"][number]["status"],
): boolean {
  if (method === "CASH") return status === "CONFIRMED_LOCAL";
  if (method === "STATIC_WECHAT" || method === "STATIC_ALIPAY") {
    return status === "PENDING_RECONCILIATION";
  }
  return method === "MEMBER_BALANCE" && status === "CONFIRMED_CLOUD";
}

function memberPaymentMatchesDebit(
  payment: OrderDetail["payments"][number] | undefined,
  memberId: string,
  amountFen: number,
  memberDebit: MemberDebitState,
): boolean {
  if (
    payment?.method === "MEMBER_BALANCE" &&
    payment.amountFen === amountFen &&
    payment.status === memberDebit.status &&
    payment.memberId === memberId &&
    memberDebit.amountFen === amountFen &&
    Date.parse(memberDebit.updatedAt) >= Date.parse(payment.recordedAt)
  ) {
    return memberDebit.status === "CONFIRMED_CLOUD"
      ? typeof payment.referenceId === "string" && payment.referenceId.length > 0
      : payment.offlineOrigin && payment.referenceId === null;
  }
  return false;
}

function remainderPaymentMatches(
  payment: OrderDetail["payments"][number] | undefined,
  method: PaymentMethod,
  amountFen: number,
): boolean {
  return (
    payment !== undefined &&
    payment.method === method &&
    payment.amountFen === amountFen &&
    paymentStatusMatchesMethod(method, payment.status) &&
    (payment.memberId === undefined || payment.memberId === null) &&
    (payment.referenceId === undefined || payment.referenceId === null)
  );
}

function isExpectedCheckoutResult(
  value: unknown,
  sessionId: string,
  method: PaymentMethod,
  expected: CheckoutExpectedResult,
  member?: CheckoutMemberInput,
): value is CheckoutResult {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const hasMemberDebit = Object.hasOwn(record, "memberDebit");
  if (
    Object.keys(record).length !== (hasMemberDebit ? 4 : 3) ||
    !["order", "table", "receipt", ...(hasMemberDebit ? ["memberDebit"] : [])].every((key) =>
      Object.hasOwn(record, key),
    ) ||
    !isOrderDetail(record.order) ||
    !isTableSnapshot(record.table) ||
    typeof record.receipt !== "object" ||
    record.receipt === null ||
    Array.isArray(record.receipt)
  ) {
    return false;
  }
  const order = record.order;
  const table = record.table;
  const receipt = record.receipt as Record<string, unknown>;
  const memberDebit =
    hasMemberDebit && isMemberDebitState(record.memberDebit) ? record.memberDebit : undefined;
  if (hasMemberDebit && memberDebit === undefined) return false;
  const baseline = expected.baselineOrder;
  const mixedMemberBalanceFen = member?.memberBalanceFen;
  const expectedMemberDebitAmountFen = member ? (mixedMemberBalanceFen ?? baseline.totalFen) : null;
  const appendedPaymentCount =
    baseline.totalFen === 0 ? 0 : mixedMemberBalanceFen === undefined ? 1 : 2;
  if (
    baseline.status !== "OPEN" ||
    baseline.sessionId !== sessionId ||
    order.id !== baseline.id ||
    orderNumberIdentity(order) !== orderNumberIdentity(baseline) ||
    order.sessionId !== sessionId ||
    order.tableId !== baseline.tableId ||
    order.tableNumber !== baseline.tableNumber ||
    order.businessDate !== baseline.businessDate ||
    order.status !== "SETTLED" ||
    order.billingState !== "ENDED" ||
    order.endedAt === null ||
    order.startedAt !== baseline.startedAt ||
    order.tableFeeFen !== baseline.tableFeeFen ||
    order.productTotalFen !== baseline.productTotalFen ||
    order.coachServiceTotalFen !== baseline.coachServiceTotalFen ||
    order.totalFen !== baseline.totalFen ||
    order.paidFen !== baseline.totalFen ||
    order.refundedFen !== baseline.refundedFen ||
    !jsonEqual(order.priceSnapshot, baseline.priceSnapshot) ||
    !jsonEqual(order.priceSnapshots, baseline.priceSnapshots) ||
    !jsonEqual(order.items, baseline.items) ||
    !jsonEqual(order.coachServiceItems, baseline.coachServiceItems) ||
    !jsonEqual(order.groupBuyFulfillments, baseline.groupBuyFulfillments) ||
    !jsonEqual(order.refunds, baseline.refunds) ||
    order.payments.length !== baseline.payments.length + appendedPaymentCount ||
    !jsonEqual(order.payments.slice(0, baseline.payments.length), baseline.payments) ||
    table.tenantId !== expected.tenantId ||
    table.storeId !== expected.storeId ||
    table.tableId !== baseline.tableId ||
    table.tableNumber !== baseline.tableNumber ||
    table.state !== "AWAITING_CLEANING" ||
    table.sessionId !== null ||
    table.sessionStartedAt !== null ||
    table.billingState !== "ENDED" ||
    Object.keys(receipt).length !== 3 ||
    !["effectId", "status", "evidence"].every((key) => Object.hasOwn(receipt, key)) ||
    typeof receipt.effectId !== "string" ||
    receipt.effectId.length < 1 ||
    receipt.status !== "QUEUED" ||
    (receipt.evidence !== "MOCK" && receipt.evidence !== "REAL_HARDWARE")
  ) {
    return false;
  }
  if (
    (expectedMemberDebitAmountFen === null && memberDebit !== undefined) ||
    (expectedMemberDebitAmountFen !== null &&
      (memberDebit === undefined || memberDebit.amountFen !== expectedMemberDebitAmountFen))
  ) {
    return false;
  }
  if (baseline.totalFen === 0) return order.offlineOrigin === baseline.offlineOrigin;
  const appendedPayments = order.payments.slice(baseline.payments.length);
  const appendedTotalFen = appendedPayments.reduce(
    (total, payment) => total + payment.amountFen,
    0,
  );
  if (!Number.isSafeInteger(appendedTotalFen) || appendedTotalFen !== baseline.totalFen)
    return false;
  if (mixedMemberBalanceFen !== undefined) {
    if (
      !member ||
      expected.memberId !== member.memberId ||
      memberDebit?.status !== "CONFIRMED_CLOUD"
    ) {
      return false;
    }
    if (
      order.offlineOrigin !==
      (baseline.offlineOrigin || appendedPayments[0]?.offlineOrigin === true)
    ) {
      return false;
    }
    return (
      memberPaymentMatchesDebit(
        appendedPayments[0],
        member.memberId,
        mixedMemberBalanceFen,
        memberDebit,
      ) &&
      remainderPaymentMatches(
        appendedPayments[1],
        method,
        baseline.totalFen - mixedMemberBalanceFen,
      )
    );
  }
  const payment = appendedPayments[0];
  if (method === "MEMBER_BALANCE") {
    return (
      expected.memberId !== null &&
      memberDebit !== undefined &&
      order.offlineOrigin === (baseline.offlineOrigin || payment?.offlineOrigin === true) &&
      memberPaymentMatchesDebit(payment, expected.memberId, baseline.totalFen, memberDebit)
    );
  }
  return (
    expected.memberId === null &&
    order.offlineOrigin === baseline.offlineOrigin &&
    remainderPaymentMatches(payment, method, baseline.totalFen)
  );
}

async function checkoutSessionStrict(
  sessionId: string,
  method: PaymentMethod,
  idempotencyKey: string,
  expected: CheckoutExpectedResult,
  member?: CheckoutMemberInput,
): Promise<CheckoutResult> {
  if (!checkoutRequestMatchesFrozenCommand(sessionId, method, idempotencyKey, expected, member)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "收款方式、会员、会员余额金额、应收基线或原请求号无法形成同一笔安全结账请求，系统没有发出请求",
      400,
    );
  }
  const result = await request<unknown>(`/v1/sessions/${sessionId}/checkout`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify({
      method,
      expectedTotalFen: expected.baselineOrder.totalFen,
      idempotencyKey,
      ...member,
    }),
  });
  if (!isExpectedCheckoutResult(result, sessionId, method, expected, member)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "收款结果无法安全确认；系统不会把账单、付款或会员扣款显示为成功，请使用原请求继续核对",
    );
  }
  return result;
}

function isFrontdeskCloseoutRequest(
  value: FrontdeskConfirmCleaningRequest | FrontdeskReleaseTableRequest,
): boolean {
  return (
    Object.keys(value).length === 4 &&
    /^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/u.test(value.idempotencyKey) &&
    Number.isSafeInteger(value.expectedTableRevision) &&
    value.expectedTableRevision >= 0 &&
    /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(value.expectedSessionId) &&
    Number.isSafeInteger(value.expectedAggregateVersion) &&
    value.expectedAggregateVersion >= 1
  );
}

async function executeTableCloseout(
  tableId: string,
  requestBody: FrontdeskConfirmCleaningRequest | FrontdeskReleaseTableRequest,
  action: "TABLE_CLEANING_CONFIRMED" | "TABLE_RELEASED",
): Promise<FrontdeskTableCloseoutReceipt> {
  if (
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(tableId) ||
    !isFrontdeskCloseoutRequest(requestBody)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "清洁或释放球台前看到的台局版本无法安全确认，请刷新球台后重试",
    );
  }
  const suffix = action === "TABLE_CLEANING_CONFIRMED" ? "cleaning/complete" : "release";
  const result = await request<unknown>(`/v1/tables/${tableId}/${suffix}`, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(requestBody),
  });
  if (!isFrontdeskTableCloseoutReceiptForRequest(result, requestBody, action, tableId)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "清洁或释放球台的结果无法安全确认；系统不会显示成功，请使用原请求继续核对",
    );
  }
  return result;
}

export async function completeTableCleaning(
  tableId: string,
  requestBody: FrontdeskConfirmCleaningRequest,
): Promise<FrontdeskTableCloseoutReceipt> {
  return executeTableCloseout(tableId, requestBody, "TABLE_CLEANING_CONFIRMED");
}

export async function releaseTable(
  tableId: string,
  requestBody: FrontdeskReleaseTableRequest,
): Promise<FrontdeskTableCloseoutReceipt> {
  return executeTableCloseout(tableId, requestBody, "TABLE_RELEASED");
}

export async function listOrders(
  options: {
    offlineOnly?: boolean;
    businessDate?: string;
    dateFrom?: string;
    dateTo?: string;
    orderQuery?: string;
    tableNumber?: string;
    memberSearch?: string;
    paymentMethod?: PaymentMethod | "";
  } = {},
): Promise<OrderHistoryReadModel[]> {
  const query = new URLSearchParams();
  if (options.offlineOnly) query.set("offlineOnly", "true");
  if (options.businessDate) query.set("businessDate", options.businessDate);
  if (options.dateFrom) query.set("dateFrom", options.dateFrom);
  if (options.dateTo) query.set("dateTo", options.dateTo);
  if (options.orderQuery) query.set("orderQuery", options.orderQuery);
  if (options.tableNumber) query.set("tableNumber", options.tableNumber);
  if (options.memberSearch) query.set("memberSearch", options.memberSearch);
  if (options.paymentMethod) query.set("paymentMethod", options.paymentMethod);
  const result = await request<unknown>(
    `/v1/orders${query.size > 0 ? `?${query.toString()}` : ""}`,
    { cache: "no-store" },
  );
  if (!isOrderHistoryReadModelList(result)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "订单金额或退款明细无法安全确认，请缩小日期范围后刷新",
    );
  }
  return result;
}

export interface OrderStrongReportExpectedScope {
  tenantId: string;
  storeId: string;
}

function canonicalOrderStrongReportDate(value: string | null): boolean {
  if (value === null) return true;
  if (!/^\d{4}-\d{2}-\d{2}$/u.test(value)) return false;
  const milliseconds = Date.parse(`${value}T00:00:00.000Z`);
  return (
    Number.isFinite(milliseconds) && new Date(milliseconds).toISOString().slice(0, 10) === value
  );
}

function normalizeOrderStrongReportFilter(
  options: OrderStrongReportFilter,
): OrderStrongReportFilter {
  const normalized = {
    offlineOnly: options.offlineOnly,
    dateFrom: options.dateFrom,
    dateTo: options.dateTo,
    orderQuery: options.orderQuery.trim(),
    tableNumber: options.tableNumber.trim(),
    memberSearch: options.memberSearch.trim(),
    productQuery: options.productQuery.trim(),
    paymentMethod: options.paymentMethod,
    openingMethod: options.openingMethod,
    shiftId: options.shiftId === null ? null : options.shiftId.trim(),
  };
  if (
    typeof normalized.offlineOnly !== "boolean" ||
    !canonicalOrderStrongReportDate(normalized.dateFrom) ||
    !canonicalOrderStrongReportDate(normalized.dateTo) ||
    (normalized.dateFrom !== null &&
      normalized.dateTo !== null &&
      normalized.dateFrom > normalized.dateTo) ||
    normalized.orderQuery.length > 128 ||
    normalized.tableNumber.length > 32 ||
    normalized.memberSearch.length > 80 ||
    normalized.productQuery.length > 80 ||
    (normalized.paymentMethod !== null &&
      !new Set<PaymentMethod>(["CASH", "STATIC_WECHAT", "STATIC_ALIPAY", "MEMBER_BALANCE"]).has(
        normalized.paymentMethod,
      )) ||
    (normalized.openingMethod !== null &&
      !ORDER_STRONG_REPORT_OPENING_METHODS.includes(normalized.openingMethod)) ||
    (normalized.shiftId !== null &&
      (normalized.shiftId.length < 1 || normalized.shiftId.length > 128))
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "订单强报表的筛选条件不正确，系统没有读取或下载报表",
      400,
    );
  }
  return normalized;
}

function orderStrongReportQuery(filters: OrderStrongReportFilter): string {
  const query = new URLSearchParams();
  if (filters.offlineOnly) query.set("offlineOnly", "true");
  if (filters.dateFrom) query.set("dateFrom", filters.dateFrom);
  if (filters.dateTo) query.set("dateTo", filters.dateTo);
  if (filters.orderQuery) query.set("orderQuery", filters.orderQuery);
  if (filters.tableNumber) query.set("tableNumber", filters.tableNumber);
  if (filters.memberSearch) query.set("memberSearch", filters.memberSearch);
  if (filters.productQuery) query.set("productQuery", filters.productQuery);
  if (filters.paymentMethod) query.set("paymentMethod", filters.paymentMethod);
  if (filters.openingMethod) query.set("openingMethod", filters.openingMethod);
  if (filters.shiftId) query.set("shiftId", filters.shiftId);
  return query.toString();
}

function orderStrongReportInvalid(): ApiRequestError {
  return new ApiRequestError(
    "GATEWAY_RESPONSE_INVALID",
    "订单强报表无法安全确认，旧报表和金额已隐藏，请重新读取",
  );
}

async function orderStrongReportCsvSha256(csv: string): Promise<string> {
  if (!globalThis.crypto?.subtle || typeof globalThis.crypto.subtle.digest !== "function") {
    throw orderStrongReportInvalid();
  }
  try {
    const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(csv));
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join(
      "",
    );
  } catch {
    throw orderStrongReportInvalid();
  }
}

export async function getOrderStrongReport(
  options: OrderStrongReportFilter,
  expectedScope: OrderStrongReportExpectedScope,
): Promise<OrderStrongReportReadModel> {
  if (
    expectedScope.tenantId.length < 1 ||
    expectedScope.tenantId.length > 128 ||
    expectedScope.tenantId.trim() !== expectedScope.tenantId ||
    expectedScope.storeId.length < 1 ||
    expectedScope.storeId.length > 128 ||
    expectedScope.storeId.trim() !== expectedScope.storeId
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "当前门店身份不正确，系统没有读取或下载订单强报表",
      400,
    );
  }
  const filters = normalizeOrderStrongReportFilter(options);
  const query = orderStrongReportQuery(filters);
  const result = await request<unknown>(`/v1/orders/report${query ? `?${query}` : ""}`, {
    cache: "no-store",
  });
  if (
    !isOrderStrongReportReadModel(result, {
      tenantId: expectedScope.tenantId,
      storeId: expectedScope.storeId,
      filters,
    })
  ) {
    throw orderStrongReportInvalid();
  }
  if ((await orderStrongReportCsvSha256(result.csv)) !== result.contentSha256) {
    throw orderStrongReportInvalid();
  }
  return result;
}

function manualReviewListFilterIsCanonical(value: unknown): value is ManualReviewListFilter {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  if (
    Object.keys(record).length !== 2 ||
    record.category !== "MEMBER_RECEIVABLE" ||
    typeof record.businessDate !== "string" ||
    !/^\d{4}-\d{2}-\d{2}$/u.test(record.businessDate)
  ) {
    return false;
  }
  const milliseconds = Date.parse(`${record.businessDate}T00:00:00.000Z`);
  return (
    Number.isFinite(milliseconds) &&
    new Date(milliseconds).toISOString().slice(0, 10) === record.businessDate
  );
}

function isLegacyUnfilteredManualReviewQueryContext(value: unknown): boolean {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const queryKey = record.queryKey;
  return (
    "client" in record &&
    "meta" in record &&
    record.signal instanceof AbortSignal &&
    Array.isArray(queryKey) &&
    queryKey[0] === "manual-review"
  );
}

export function listManualReview(): Promise<ManualReviewListReadModel>;
export function listManualReview(
  filter: ManualReviewListFilter,
): Promise<ManualReviewListReadModel>;
export async function listManualReview(
  filterOrContext?: unknown,
): Promise<ManualReviewListReadModel> {
  const filter = manualReviewListFilterIsCanonical(filterOrContext)
    ? filterOrContext
    : filterOrContext === undefined || isLegacyUnfilteredManualReviewQueryContext(filterOrContext)
      ? undefined
      : null;
  if (filter === null) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "待人工确认筛选条件不正确，系统没有读取其他门店或营业日的数据",
      400,
    );
  }
  const query = filter
    ? `?${new URLSearchParams({
        category: filter.category,
        businessDate: filter.businessDate,
      }).toString()}`
    : "";
  const value = await request<unknown>(`/v1/manual-review${query}`, { cache: "no-store" });
  if (!isManualReviewListReadModel(value, filter ?? null)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "待人工确认事项返回内容无法安全确认");
  }
  return value;
}

function manualReviewResolutionWorkItemIdIsSafe(workItemId: string): boolean {
  return (
    workItemId === workItemId.trim() && /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(workItemId)
  );
}

function manualReviewResolutionPreviewMatchesRequest(
  value: unknown,
  workItemId: string,
  input: PreviewManualReviewResolutionRequest,
): value is ManualReviewResolutionPreviewReadModel {
  return (
    isManualReviewResolutionPreviewReadModel(value) &&
    value.workItemId === workItemId &&
    value.category === input.category &&
    value.resolutionCode === input.resolutionCode &&
    value.note === input.note
  );
}

function manualReviewResolutionApprovalMatchesCommand(
  value: unknown,
  input: CreateManualReviewResolutionApprovalCommand,
): value is ApprovalRequestReadModel {
  if (!isApprovalRequestReadModel(value)) return false;
  const snapshot = value.snapshot;
  return (
    snapshot.kind === "MANUAL_REVIEW_RESOLUTION" &&
    snapshot.workItemId === input.workItemId &&
    snapshot.category === input.category &&
    snapshot.resolutionCode === input.resolutionCode &&
    snapshot.note === input.note &&
    snapshot.sourceReferenceSha256 === input.sourceReferenceSha256 &&
    snapshot.businessFactSha256 === input.businessFactSha256 &&
    snapshot.commandSha256 === input.commandSha256 &&
    value.policy.resource === "MANUAL_REVIEW" &&
    value.policy.action === "RESOLVE" &&
    value.policy.requirement === "MANAGER_OR_OWNER" &&
    value.policy.effect === "MANAGER_OR_OWNER_APPROVAL"
  );
}

const manualReviewResolutionDefiniteNoEffectCodes = new Set([
  "AUTH_REQUIRED",
  "AUTHORIZATION_DEFAULT_DENY",
  "AUTHORIZATION_FACTS_NOT_TRUSTED",
  "CSRF_REJECTED",
  "MOBILE_SESSION_ACTIVATION_REQUIRED",
  "NATIVE_APP_VERSION_INVALID",
  "NATIVE_APP_VERSION_MISMATCH",
  "NATIVE_APP_VERSION_REQUIRED",
  "NATIVE_SECURE_SESSION_UNAVAILABLE",
  "NATIVE_SERVER_UPDATE_REQUIRED",
  "NATIVE_UPDATE_REQUIRED",
  "OFFLINE_AUTHORITY_UNAVAILABLE",
  "ONLINE_SERVICE_REQUIRED",
  "ORIGIN_REJECTED",
  "REQUEST_VALIDATION_FAILED",
]);

export function manualReviewResolutionOutcomeIsUnknown(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return true;
  if (manualReviewResolutionDefiniteNoEffectCodes.has(error.code)) return false;
  if (
    [
      "MANUAL_REVIEW_RESOLUTION_PREVIEW_RESULT_UNKNOWN",
      "MANUAL_REVIEW_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
      "MANUAL_REVIEW_RESOLUTION_RECOVERY_AMBIGUOUS",
      "GATEWAY_UNREACHABLE",
      "GATEWAY_RESPONSE_INVALID",
      "OPERATOR_IDENTITY_CHANGED",
    ].includes(error.code)
  ) {
    return true;
  }
  if (error.statusCode === 408 || error.statusCode === 429) return true;
  if (error.statusCode !== undefined && error.statusCode >= 400 && error.statusCode <= 499) {
    return false;
  }
  return error.statusCode === undefined || error.statusCode >= 500;
}

export async function previewManualReviewResolution(
  workItemId: string,
  requestSnapshot: PreviewManualReviewResolutionRequest,
): Promise<ManualReviewResolutionPreviewReadModel> {
  const input = structuredClone(requestSnapshot);
  if (
    !manualReviewResolutionWorkItemIdIsSafe(workItemId) ||
    !isPreviewManualReviewResolutionRequest(input)
  ) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "待复核事项、处理方式或说明不完整，请检查后重试",
      400,
    );
  }
  try {
    const value = await request<unknown>(
      `/v1/manual-review/${encodeURIComponent(workItemId)}/resolution-previews`,
      { method: "POST", cache: "no-store", body: JSON.stringify(input) },
    );
    if (!manualReviewResolutionPreviewMatchesRequest(value, workItemId, input)) {
      throw new ApiRequestError(
        "MANUAL_REVIEW_RESOLUTION_PREVIEW_RESULT_UNKNOWN",
        "处理预览与当前待复核事项无法安全对应，请勿提交审批",
      );
    }
    return value;
  } catch (error) {
    if (!manualReviewResolutionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "MANUAL_REVIEW_RESOLUTION_PREVIEW_RESULT_UNKNOWN",
      "处理预览暂时无法确认，请保留当前选择并重新检查",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function createManualReviewResolutionApproval(
  requestSnapshot: CreateManualReviewResolutionApprovalCommand,
): Promise<ApprovalRequestReadModel> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateManualReviewResolutionApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "待复核事项审批请求不完整，请重新生成处理预览",
      400,
    );
  }
  let receiptAccepted = false;
  try {
    const value = await request<unknown>(
      `/v1/manual-review/${encodeURIComponent(input.workItemId)}/resolution-approvals`,
      { method: "POST", cache: "no-store", body: JSON.stringify(input) },
    );
    if (!manualReviewResolutionApprovalMatchesCommand(value, input)) {
      throw new ApiRequestError(
        "MANUAL_REVIEW_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
        "待复核事项审批申请无法与原处理请求对应，系统继续保留原请求",
      );
    }
    receiptAccepted = true;
    const authoritative = await getApproval(value.approvalId);
    if (!manualReviewResolutionApprovalMatchesCommand(authoritative, input)) {
      throw new ApiRequestError(
        "MANUAL_REVIEW_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
        "权威审批记录与原待复核事项不一致，系统继续保留原请求",
      );
    }
    return authoritative;
  } catch (error) {
    if (!receiptAccepted && !manualReviewResolutionOutcomeIsUnknown(error)) throw error;
    throw new ApiRequestError(
      "MANUAL_REVIEW_RESOLUTION_APPROVAL_RESULT_UNKNOWN",
      "待复核事项审批结果暂时无法确认，请勿另建一笔处理",
      error instanceof ApiRequestError ? error.statusCode : undefined,
    );
  }
}

export async function findManualReviewResolutionApprovalForRecovery(
  requestSnapshot: CreateManualReviewResolutionApprovalCommand,
): Promise<ApprovalRequestReadModel | null> {
  const input = structuredClone(requestSnapshot);
  if (!isCreateManualReviewResolutionApprovalCommand(input)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "原待复核事项审批请求不完整，无法安全查询后续状态",
      400,
    );
  }
  const [mine, history] = await Promise.all([listApprovals("MINE"), listApprovals("HISTORY")]);
  const candidateIds = new Set(
    [...mine.items, ...history.items]
      .filter((item) => item.summary.kind === "MANUAL_REVIEW_RESOLUTION")
      .map((item) => item.approvalId),
  );
  const candidates = await Promise.all(
    [...candidateIds].map((approvalId) => getApproval(approvalId)),
  );
  const matches = candidates.filter((approval) =>
    manualReviewResolutionApprovalMatchesCommand(approval, input),
  );
  if (matches.length > 1) {
    throw new ApiRequestError(
      "MANUAL_REVIEW_RESOLUTION_RECOVERY_AMBIGUOUS",
      "查到多笔相同待复核事项的审批记录，系统不会自动解除恢复锁，请人工核对",
    );
  }
  return matches[0] ?? null;
}

export async function getManualReviewSummary(): Promise<ManualReviewSummaryReadModel> {
  const value = await request<unknown>("/v1/manual-review/summary", { cache: "no-store" });
  if (!isManualReviewSummaryReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "待人工确认事项数量无法安全确认");
  }
  return value;
}

async function readReconciliationSummary(
  businessDate?: string,
  headers?: Record<string, string>,
): Promise<ReconciliationSummary> {
  const suffix = businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : "";
  const value = await request<unknown>(`/v1/reconciliation/summary${suffix}`, {
    cache: "no-store",
    ...(headers ? { headers } : {}),
  });
  if (
    !isReconciliationSummaryReadModel(value) ||
    (businessDate !== undefined && value.businessDate !== businessDate)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "营业日对账金额无法安全确认，页面已停止显示，请刷新后重试",
    );
  }
  return value;
}

export function getReconciliationSummary(businessDate?: string): Promise<ReconciliationSummary> {
  return readReconciliationSummary(businessDate);
}

const ownerHeaders = { "x-demo-role": "OWNER", "x-actor-id": "owner_demo" };

export async function getSystemStatus(): Promise<SystemStatusReadModel> {
  const value = await request<unknown>("/v1/system/status", { cache: "no-store" });
  if (!isSystemStatusReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "系统状态返回内容无法安全确认");
  }
  return value;
}

export async function getBusinessAuditTimeline(
  expectedScope: Pick<OperatorIdentity, "tenantId" | "storeId">,
): Promise<BusinessAuditTimelineReadModel> {
  const value = await request<unknown>("/v1/system/audit-timeline", { cache: "no-store" });
  if (
    !isBusinessAuditTimelineReadModel(value) ||
    value.tenantId !== expectedScope.tenantId ||
    value.storeId !== expectedScope.storeId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "门店经营操作记录无法安全确认，页面已停止显示",
    );
  }
  return value;
}

export function getBusinessAuditTimelineCsv(): Promise<string> {
  return requestText("/v1/system/audit-timeline.csv");
}

export function getOperatingConfiguration(): Promise<OperatingConfigurationBundle> {
  return request<unknown>("/v1/operating-configuration", { cache: "no-store" }).then((value) => {
    if (!isOperatingConfigurationBundle(value)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "门店经营配置返回内容无法安全确认");
    }
    return value;
  });
}

export function previewOperatingConfiguration(
  input: OperatingConfigurationPreviewRequest,
): Promise<OperatingConfigurationPreviewResult> {
  return request<unknown>("/v1/operating-configuration/preview", {
    method: "POST",
    body: JSON.stringify(input),
  }).then((value) => {
    if (!isOperatingConfigurationPreviewResult(value)) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "门店经营配置检查结果无法安全确认");
    }
    return value;
  });
}

export function applyOperatingConfiguration(
  input: OperatingConfigurationApplyRequest,
): Promise<OperatingConfigurationApplyResult> {
  const requestSnapshot = structuredClone(input);
  const actorId = operatorHeaders["x-actor-id"];
  return request<unknown>("/v1/operating-configuration/apply", {
    method: "POST",
    body: JSON.stringify(requestSnapshot),
    // Cloud applies the versioned configuration and regenerates the offline snapshot atomically.
    // Keep the browser deadline longer than the Gateway-to-Cloud 30 second deadline so a slow
    // apply is reported by the server instead of being mislabelled as a disconnected Gateway.
    signal: AbortSignal.timeout(35_000),
  }).then((value) => {
    if (
      !isOperatingConfigurationApplyResult(value) ||
      !value.configuration.initialized ||
      value.configuration.configurationVersion !==
        requestSnapshot.expectedConfigurationVersion + 1 ||
      value.configuration.updatedBy !== actorId ||
      !operatingConfigurationDraftsEqual(value.configuration.draft, requestSnapshot.draft)
    ) {
      throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "门店经营配置保存结果无法安全确认");
    }
    return value;
  });
}

export async function getDeviceAdapterStatus(): Promise<DeviceIncidentStatusReadModel> {
  const value = await request<unknown>("/v1/devices/status", { cache: "no-store" });
  if (!isDeviceIncidentStatusReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "设备异常状态返回内容无法安全确认");
  }
  return value;
}

export async function resolveDeviceIncidentManually(
  incidentId: string,
  input: DeviceIncidentManualResolutionRequest,
): Promise<DeviceIncidentManualResolutionResult> {
  if (!isDeviceIncidentManualResolutionRequest(input)) {
    throw new ApiRequestError("CLIENT_REQUEST_INVALID", "设备异常处理说明不完整，系统没有提交确认");
  }
  const value = await request<unknown>(
    `/v1/devices/incidents/${encodeURIComponent(incidentId)}/manual-resolution`,
    { method: "POST", body: JSON.stringify(input), cache: "no-store" },
  );
  if (!isDeviceIncidentManualResolutionResult(value) || value.incidentId !== incidentId) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "设备异常处理结果无法安全确认");
  }
  return value;
}

export async function listTableKiosks(): Promise<TableKioskManagementReadModel[]> {
  const value = await request<unknown>("/v1/device-management/table-kiosks", {
    cache: "no-store",
  });
  if (!isTableKioskManagementReadModelList(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "桌边屏状态返回内容无法安全确认");
  }
  return value;
}

export async function createKioskPairing(
  tableNodeId: string,
  expectedComponentId: string,
  idempotencyKey: string,
): Promise<CreateKioskPairingResult> {
  const normalizedExpectedComponentId = expectedComponentId.trim();
  const value = await request<unknown>(
    `/v1/device-management/table-kiosks/${encodeURIComponent(tableNodeId)}/kiosk-pairings`,
    {
      method: "POST",
      body: JSON.stringify({ expectedComponentId: normalizedExpectedComponentId, idempotencyKey }),
    },
  );
  if (
    !isCreateKioskPairingResult(value) ||
    value.tableNodeId !== tableNodeId ||
    value.expectedComponentId !== normalizedExpectedComponentId
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "桌边屏配对结果无法安全确认");
  }
  return value;
}

export async function revokeKioskBinding(
  tableNodeId: string,
  expectedBindingVersion: number,
  reason: string,
  idempotencyKey: string,
  secondaryAuthorization: string,
): Promise<TableKioskManagementReadModel> {
  const value = await request<unknown>(
    `/v1/device-management/table-kiosks/${encodeURIComponent(tableNodeId)}/revoke`,
    {
      method: "POST",
      headers: secondaryAuthorizationHeaders(secondaryAuthorization),
      body: JSON.stringify({ reason, idempotencyKey, expectedBindingVersion }),
    },
  );
  const result = [value];
  if (!isTableKioskManagementReadModelList(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "桌边屏停用结果无法安全确认");
  }
  const [record] = result;
  if (!record) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "桌边屏停用结果无法安全确认");
  }
  if (
    record.tableNodeId !== tableNodeId ||
    record.bindingVersion !== expectedBindingVersion ||
    record.bindingStatus !== "REVOKED"
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "桌边屏停用结果无法安全确认");
  }
  return record;
}

export async function reprintReceipt(
  orderId: string,
  idempotencyKey: string,
): Promise<ReceiptReprintResult> {
  const value = await request<unknown>(
    `/v1/orders/${encodeURIComponent(orderId)}/receipt/reprint`,
    {
      method: "POST",
      body: JSON.stringify({ idempotencyKey }),
    },
  );
  if (!isReceiptReprintResult(value) || value.orderId !== orderId) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "小票补打结果无法安全确认");
  }
  return value;
}

export async function getDiagnosticBundle(): Promise<string> {
  const value = await request<unknown>("/v1/system/diagnostics");
  if (!isDiagnosticBundleReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "脱敏诊断文件内容无法安全确认");
  }
  return `${JSON.stringify(value satisfies DiagnosticBundleReadModel, null, 2)}\n`;
}

export async function getSupportAccessWorkspace(): Promise<SupportAccessWorkspace> {
  const value = await request<unknown>("/v1/support-access/grants", { cache: "no-store" });
  if (!isSupportAccessWorkspace(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "技术支持授权列表无法安全确认");
  }
  return value;
}

export async function createSupportAccessGrant(
  command: CreateSupportAccessGrantRequest,
): Promise<SupportAccessMutationResult> {
  const value = await request<unknown>("/v1/support-access/grants", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  if (
    !isSupportAccessMutationResult(value) ||
    value.operation !== "CREATE" ||
    value.idempotencyKey !== command.idempotencyKey
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "技术支持授权创建回执与本次操作不一致，请保留原授权码和请求号",
    );
  }
  return value;
}

export async function revokeSupportAccessGrant(
  grantId: string,
  command: RevokeSupportAccessGrantRequest,
): Promise<SupportAccessMutationResult> {
  const value = await request<unknown>(
    `/v1/support-access/grants/${encodeURIComponent(grantId)}/revoke`,
    { method: "POST", cache: "no-store", body: JSON.stringify(command) },
  );
  if (
    !isSupportAccessMutationResult(value) ||
    value.operation !== "REVOKE" ||
    value.idempotencyKey !== command.idempotencyKey ||
    value.grant.grantId !== grantId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "技术支持授权撤销回执与本次操作不一致，请保留原请求号",
    );
  }
  return value;
}

export async function recoverSupportAccessMutation(
  operationType: "CREATE" | "REVOKE",
  idempotencyKey: string,
): Promise<SupportAccessMutationResult> {
  const value = await request<unknown>(
    `/v1/support-access/by-request/${operationType}/${encodeURIComponent(idempotencyKey)}`,
    { cache: "no-store" },
  );
  if (
    !isSupportAccessMutationResult(value) ||
    value.operation !== operationType ||
    value.idempotencyKey !== idempotencyKey
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "技术支持授权历史回执与原请求号不一致");
  }
  return value;
}

export function supportAccessOutcomeIsUnknown(error: unknown): boolean {
  return (
    error instanceof ApiRequestError &&
    new Set(["GATEWAY_UNREACHABLE", "GATEWAY_RESPONSE_INVALID", "REQUEST_TIMEOUT"]).has(error.code)
  );
}

export function generateSupportAccessToken(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const encoded = btoa(String.fromCharCode(...bytes))
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replace(/=+$/u, "");
  return `bsp_${encoded}`;
}

export async function getSupportDiagnosticBundle(
  accessToken: string,
): Promise<DiagnosticBundleReadModel> {
  const timeout = new AbortController();
  const timeoutId = globalThis.setTimeout(() => timeout.abort(), 8_000);
  try {
    let response: Response;
    try {
      response = await fetch(`${gatewayUrl}/v1/support-access/diagnostics`, {
        method: "GET",
        cache: "no-store",
        credentials: "omit",
        headers: { "x-support-access-token": accessToken.trim() },
        signal: timeout.signal,
      });
    } catch {
      throw new ApiRequestError("GATEWAY_UNREACHABLE", "门店技术支持入口暂时无法连接");
    }
    let value: unknown;
    try {
      value = await response.json();
    } catch {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "门店技术支持入口返回内容无法安全确认",
        response.status,
      );
    }
    if (!response.ok) {
      const error = value as { code?: string; message?: string };
      throw new ApiRequestError(
        error.code ?? "REQUEST_FAILED",
        error.message ?? "技术支持授权没有通过",
        response.status,
      );
    }
    if (!isDiagnosticBundleReadModel(value)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "脱敏诊断内容无法安全确认，页面没有展示未知数据",
      );
    }
    return value;
  } finally {
    globalThis.clearTimeout(timeoutId);
  }
}

export function getOrdersCsv(businessDate?: string): Promise<string> {
  const suffix = businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : "";
  return requestText(`/v1/system/export/orders.csv${suffix}`, { headers: ownerHeaders });
}

export function getProductCatalogTemplate(): Promise<string> {
  return requestText("/v1/system/import/products/template.csv", { headers: ownerHeaders });
}

export async function previewProductCatalog(csv: string): Promise<ProductCatalogPreviewResult> {
  const value = await request<unknown>("/v1/system/import/products/preview", {
    method: "POST",
    headers: ownerHeaders,
    cache: "no-store",
    body: JSON.stringify({ csv }),
  });
  if (!isProductCatalogPreviewResult(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "商品导入预览内容无法安全确认");
  }
  return value;
}

function isProductCatalogImportResultForCommand(
  value: unknown,
  command: ProductCatalogImportCommand,
): value is ProductCatalogImportResult {
  if (value === null || typeof value !== "object" || Array.isArray(value)) return false;
  const record = value as Record<string, unknown>;
  const expectedKeys = [
    "idempotencyKey",
    "imported",
    "unchanged",
    "configurationVersion",
    "appliedAt",
    "evidence",
  ] as const;
  if (
    Object.keys(record).length !== expectedKeys.length ||
    expectedKeys.some((key) => !Object.hasOwn(record, key)) ||
    record.idempotencyKey !== command.idempotencyKey ||
    !Number.isSafeInteger(record.imported) ||
    (record.imported as number) < 0 ||
    !Number.isSafeInteger(record.unchanged) ||
    (record.unchanged as number) < 0 ||
    (record.imported as number) + (record.unchanged as number) !== command.rowCount ||
    !Number.isSafeInteger(record.configurationVersion) ||
    record.configurationVersion !==
      command.expectedConfigurationVersion + ((record.imported as number) > 0 ? 1 : 0) ||
    typeof record.appliedAt !== "string" ||
    !Number.isFinite(Date.parse(record.appliedAt)) ||
    new Date(Date.parse(record.appliedAt)).toISOString() !== record.appliedAt ||
    record.evidence !== "SIMULATED"
  ) {
    return false;
  }
  return true;
}

export async function importProductCatalog(
  command: ProductCatalogImportCommand,
): Promise<ProductCatalogImportResult> {
  const requestSnapshot = { ...command };
  try {
    const result = await request<unknown>("/v1/system/import/products", {
      method: "POST",
      headers: ownerHeaders,
      cache: "no-store",
      body: JSON.stringify({
        csv: requestSnapshot.csv,
        idempotencyKey: requestSnapshot.idempotencyKey,
        expectedConfigurationVersion: requestSnapshot.expectedConfigurationVersion,
        previewFingerprint: requestSnapshot.previewFingerprint,
      }),
    });
    if (!isProductCatalogImportResultForCommand(result, requestSnapshot)) {
      throw new ApiRequestError(
        "PRODUCT_CATALOG_IMPORT_RESULT_UNKNOWN",
        "商品导入可能已经完成，但返回结果无法与原文件安全核对",
      );
    }
    return result;
  } catch (error) {
    if (error instanceof ApiRequestError && error.code === "OPERATOR_IDENTITY_CHANGED") {
      throw error;
    }
    if (productCatalogImportOutcomeIsUnknown(error)) {
      throw new ApiRequestError(
        "PRODUCT_CATALOG_IMPORT_RESULT_UNKNOWN",
        "商品导入可能已经完成，但页面尚未确认。请保留原文件并使用同一次请求安全重试",
        error instanceof ApiRequestError ? error.statusCode : undefined,
      );
    }
    throw error;
  }
}

export async function importProductCatalogWithProductSaveGuard(
  productSaveIdentityKey: string,
  command: ProductCatalogImportCommand,
): Promise<ProductCatalogImportResult> {
  if (readProductSaveRecovery(productSaveIdentityKey).status !== "NONE") {
    throw new ApiRequestError(
      "PRODUCT_SAVE_RESULT_UNKNOWN",
      "商品资料保存结果尚未确认，批量应用已暂停；请先回到商品库存页面处理原请求",
    );
  }
  return await importProductCatalog(command);
}

export function getOwnerReconciliationSummary(
  businessDate?: string,
): Promise<ReconciliationSummary> {
  return readReconciliationSummary(businessDate, ownerHeaders);
}

export async function getOwnerBusinessSummary(
  businessDate?: string,
): Promise<OwnerBusinessSummary> {
  const suffix = businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : "";
  const value = await request<unknown>(`/v1/owner/business-summary${suffix}`, {
    cache: "no-store",
    headers: ownerHeaders,
  });
  if (
    !isOwnerBusinessSummaryReadModel(value) ||
    (businessDate !== undefined && value.businessDate !== businessDate)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "老板经营摘要金额无法安全确认，页面已停止显示，请刷新后重试",
    );
  }
  return value;
}

export type StoreClosingCommand =
  | StoreStartClosingCommand
  | StoreAcknowledgeClosingLegacyCommand
  | StoreCompleteClosingCommand;

function storeClosingBusinessDateIsValid(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/u.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(Date.UTC(year ?? 0, (month ?? 0) - 1, day));
  return (
    date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && date.getUTCDate() === day
  );
}

function storeClosingCommandIsValid(
  action: StoreClosingAction,
  command: StoreClosingCommand,
): boolean {
  if (command === null || typeof command !== "object" || Array.isArray(command)) return false;
  const record = command as unknown as Record<string, unknown>;
  const keys = [
    "businessDate",
    "expectedVersion",
    "closingSummarySha256",
    "note",
    "idempotencyKey",
  ] as const;
  const minimumVersion = action === "START_CLOSING" ? 1 : 2;
  const minimumNoteLength = action === "ACKNOWLEDGE_LEGACY" ? 2 : 0;
  return (
    Object.keys(record).length === keys.length &&
    keys.every((key) => Object.hasOwn(record, key)) &&
    typeof command.businessDate === "string" &&
    storeClosingBusinessDateIsValid(command.businessDate) &&
    Number.isSafeInteger(command.expectedVersion) &&
    command.expectedVersion >= minimumVersion &&
    command.expectedVersion <= 2_147_483_646 &&
    typeof command.closingSummarySha256 === "string" &&
    /^[a-f0-9]{64}$/u.test(command.closingSummarySha256) &&
    typeof command.note === "string" &&
    [...command.note].length >= minimumNoteLength &&
    [...command.note].length <= 500 &&
    command.note === command.note.trim() &&
    typeof command.idempotencyKey === "string" &&
    command.idempotencyKey.length >= 8 &&
    command.idempotencyKey.length <= 128 &&
    command.idempotencyKey === command.idempotencyKey.trim()
  );
}

function storeClosingResultMatchesCommand(
  value: unknown,
  action: StoreClosingAction,
  command: StoreClosingCommand,
  expectedScope: { tenantId: string; storeId: string; actorId: string },
): value is StoreOperatingDayRecord {
  if (
    !isStoreOperatingDayRecord(value) ||
    value.tenantId !== expectedScope.tenantId ||
    value.storeId !== expectedScope.storeId ||
    value.businessDate !== command.businessDate ||
    value.version !== command.expectedVersion + 1 ||
    value.closing === undefined
  ) {
    return false;
  }
  if (action === "START_CLOSING") {
    return (
      value.status === "CLOSING" &&
      value.closing.startedBy === expectedScope.actorId &&
      value.closing.note === command.note &&
      value.closing.requestId === command.idempotencyKey &&
      value.closing.legacyAcknowledgement === null &&
      value.closing.completion === null
    );
  }
  if (action === "ACKNOWLEDGE_LEGACY") {
    return (
      value.status === "CLOSING" &&
      value.closing.legacyAcknowledgement?.acknowledgedBy === expectedScope.actorId &&
      value.closing.legacyAcknowledgement.note === command.note &&
      value.closing.legacyAcknowledgement.requestId === command.idempotencyKey &&
      value.closing.completion === null
    );
  }
  return (
    value.status === "CLOSED" &&
    value.closing.completion?.closedBy === expectedScope.actorId &&
    value.closing.completion.note === command.note &&
    value.closing.completion.requestId === command.idempotencyKey &&
    value.closing.completion.closingSummarySha256 === command.closingSummarySha256
  );
}

export async function getStoreClosingReadiness(
  signal?: AbortSignal,
): Promise<StoreClosingReadiness> {
  const expectedTenantId = operatorRequestScope.tenantId;
  const expectedStoreId = operatorRequestScope.storeId;
  const value = await request<unknown>("/v1/store-closing/readiness", {
    cache: "no-store",
    signal: signal ?? null,
  });
  if (
    !isStoreClosingReadiness(value) ||
    value.tenantId !== expectedTenantId ||
    value.storeId !== expectedStoreId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "闭店检查结果无法安全确认，页面不会允许闭店操作",
      502,
    );
  }
  return value;
}

async function submitStoreClosingCommand(
  action: StoreClosingAction,
  command: StoreClosingCommand,
  path: string,
): Promise<StoreOperatingDayRecord> {
  if (!storeClosingCommandIsValid(action, command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "闭店原请求不完整，系统没有发出请求",
      400,
    );
  }
  const expectedScope = operatorRequestScope;
  const value = await request<unknown>(path, {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  if (!storeClosingResultMatchesCommand(value, action, command, expectedScope)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "闭店结果与原营业日、版本、摘要或请求编号不一致，页面继续锁定原请求",
      502,
    );
  }
  return value;
}

export function startStoreClosing(
  command: StoreStartClosingCommand,
): Promise<StoreOperatingDayRecord> {
  return submitStoreClosingCommand("START_CLOSING", command, "/v1/store-closing/start");
}

export function acknowledgeStoreClosingLegacy(
  command: StoreAcknowledgeClosingLegacyCommand,
): Promise<StoreOperatingDayRecord> {
  return submitStoreClosingCommand(
    "ACKNOWLEDGE_LEGACY",
    command,
    "/v1/store-closing/acknowledge-legacy",
  );
}

export function completeStoreClosing(
  command: StoreCompleteClosingCommand,
): Promise<StoreOperatingDayRecord> {
  return submitStoreClosingCommand("COMPLETE_CLOSING", command, "/v1/store-closing/complete");
}

export async function getStoreClosingByRequest(
  action: StoreClosingAction,
  command: StoreClosingCommand,
  signal?: AbortSignal,
): Promise<StoreOperatingDayRecord | null> {
  if (!storeClosingCommandIsValid(action, command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本机保存的闭店原请求不完整，系统没有查询或重放",
      400,
    );
  }
  const expectedScope = operatorRequestScope;
  const query = new URLSearchParams({ action, businessDate: command.businessDate });
  try {
    const value = await request<unknown>(
      `/v1/store-closing/by-request/${encodeURIComponent(command.idempotencyKey)}?${query.toString()}`,
      { cache: "no-store", signal: signal ?? null },
    );
    if (!storeClosingResultMatchesCommand(value, action, command, expectedScope)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "闭店查询结果与原营业日、版本、摘要或请求编号不一致，页面继续锁定",
        502,
      );
    }
    return value;
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "STORE_CLOSING_REQUEST_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

function storeOpenCommandIsValid(command: StoreOpenCommand): boolean {
  if (command === null || typeof command !== "object" || Array.isArray(command)) return false;
  const commandRecord = command as unknown as Record<string, unknown>;
  const commandKeys = [
    "businessDate",
    "readinessSha256",
    "operatingConfigurationVersion",
    "offlineConfirmed",
    "note",
    "idempotencyKey",
  ] as const;
  return (
    Object.keys(commandRecord).length === commandKeys.length &&
    commandKeys.every((key) => Object.hasOwn(commandRecord, key)) &&
    typeof command.businessDate === "string" &&
    /^\d{4}-\d{2}-\d{2}$/u.test(command.businessDate) &&
    typeof command.readinessSha256 === "string" &&
    /^[a-f0-9]{64}$/u.test(command.readinessSha256) &&
    Number.isSafeInteger(command.operatingConfigurationVersion) &&
    command.operatingConfigurationVersion >= 1 &&
    command.operatingConfigurationVersion <= 2_147_483_647 &&
    typeof command.offlineConfirmed === "boolean" &&
    typeof command.note === "string" &&
    [...command.note].length <= 500 &&
    command.note === command.note.trim() &&
    typeof command.idempotencyKey === "string" &&
    command.idempotencyKey.length >= 8 &&
    command.idempotencyKey.length <= 128 &&
    command.idempotencyKey === command.idempotencyKey.trim()
  );
}

function storeOperatingDayMatchesCommand(
  value: unknown,
  command: StoreOpenCommand,
  expectedScope: { tenantId: string; storeId: string; actorId: string },
): value is StoreOperatingDayRecord {
  return (
    isStoreOperatingDayRecord(value) &&
    value.tenantId === expectedScope.tenantId &&
    value.storeId === expectedScope.storeId &&
    value.businessDate === command.businessDate &&
    value.status === "OPEN" &&
    value.openingMode === (command.offlineConfirmed ? "LIMITED_OFFLINE" : "ONLINE") &&
    value.openedBy === expectedScope.actorId &&
    value.openingNote === command.note &&
    value.operatingConfigurationVersion === command.operatingConfigurationVersion &&
    value.openingRequestId === command.idempotencyKey
  );
}

export async function getStoreOpeningReadiness(
  signal?: AbortSignal,
): Promise<StoreOpeningReadiness> {
  const expectedTenantId = operatorRequestScope.tenantId;
  const expectedStoreId = operatorRequestScope.storeId;
  const value = await request<unknown>("/v1/store-opening/readiness", {
    cache: "no-store",
    signal: signal ?? null,
  });
  if (
    !isStoreOpeningReadiness(value) ||
    value.tenantId !== expectedTenantId ||
    value.storeId !== expectedStoreId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "开店检查结果无法安全确认，页面不会允许开店",
      502,
    );
  }
  return value;
}

export async function openStoreOperatingDay(
  command: StoreOpenCommand,
): Promise<StoreOperatingDayRecord> {
  if (!storeOpenCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "开店原请求不完整，系统没有发出开店请求",
      400,
    );
  }
  const expectedScope = operatorRequestScope;
  const value = await request<unknown>("/v1/store-opening", {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  if (!storeOperatingDayMatchesCommand(value, command, expectedScope)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "开店结果与本次营业日、配置版本或原请求不一致，页面继续保留原请求",
      502,
    );
  }
  return value;
}

export async function getStoreOperatingDayByRequest(
  command: StoreOpenCommand,
  signal?: AbortSignal,
): Promise<StoreOperatingDayRecord | null> {
  if (!storeOpenCommandIsValid(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "本机保存的开店原请求不完整，系统没有查询或重试",
      400,
    );
  }
  const expectedScope = operatorRequestScope;
  const query = new URLSearchParams({ businessDate: command.businessDate });
  try {
    const value = await request<unknown>(
      `/v1/store-opening/by-request/${encodeURIComponent(command.idempotencyKey)}?${query.toString()}`,
      { cache: "no-store", signal: signal ?? null },
    );
    if (!storeOperatingDayMatchesCommand(value, command, expectedScope)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "开店查询结果与原营业日、配置版本或请求编号不一致，页面继续锁定",
        502,
      );
    }
    return value;
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "STORE_OPERATING_DAY_REQUEST_RESULT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export async function listCashShifts(): Promise<CashShiftRecord[]> {
  const result = await request<unknown>("/v1/cash-shifts", { cache: "no-store" });
  if (!isCashShiftRecordList(result)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "班次记录无法安全确认，请刷新页面后重试");
  }
  return result;
}

export async function startCashShift(
  openingCashFen: number,
  note: string,
  idempotencyKey: string,
  expectedActorId: string,
): Promise<CashShiftRecord> {
  const normalizedNote = note.trim();
  const result = await request<unknown>("/v1/cash-shifts/start", {
    method: "POST",
    body: JSON.stringify({ openingCashFen, note: normalizedNote, idempotencyKey }),
  });
  const startedEvent = isCashShiftRecord(result) ? result.timeline[0] : undefined;
  if (
    !isCashShiftRecord(result) ||
    result.status !== "OPEN" ||
    result.openedBy !== expectedActorId ||
    result.openingCashFen !== openingCashFen ||
    result.startNote !== normalizedNote ||
    result.cashReceiptsFen !== 0 ||
    result.cashRefundsFen !== 0 ||
    result.cashInFen !== 0 ||
    result.cashOutFen !== 0 ||
    result.expectedCashFen !== openingCashFen ||
    result.countedCashFen !== null ||
    result.cashDifferenceFen !== null ||
    result.exceptionNote !== "" ||
    result.openTables.length !== 0 ||
    result.inventoryDifferences.length !== 0 ||
    result.handoverSubmittedBy !== null ||
    result.handoverSubmittedByDisplayName !== null ||
    result.handoverSubmittedAt !== null ||
    result.receivedBy !== null ||
    result.receivedByDisplayName !== null ||
    result.receivedAt !== null ||
    result.receiveNote !== "" ||
    result.version !== 1 ||
    result.timeline.length !== 1 ||
    startedEvent?.type !== "STARTED" ||
    startedEvent.actorId !== expectedActorId ||
    startedEvent.actorDisplayName !== result.openedByDisplayName ||
    startedEvent.occurredAt !== result.startedAt ||
    startedEvent.note !== normalizedNote
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "开班结果无法安全确认，请先刷新班次记录，再按原内容重试",
    );
  }
  return result;
}

export async function listCashShiftCashMovements(
  shiftId: string,
): Promise<CashShiftCashMovementListReadModel> {
  const expectedScope = { ...operatorRequestScope };
  const result = await request<unknown>(
    `/v1/cash-shifts/${encodeURIComponent(shiftId)}/cash-movements`,
    { cache: "no-store" },
  );
  if (
    !isCashShiftCashMovementListReadModel(result) ||
    result.tenantId !== expectedScope.tenantId ||
    result.storeId !== expectedScope.storeId ||
    result.shiftId !== shiftId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "本班现金出入记录与当前门店或班次不一致，页面已停止显示整份账目",
      502,
    );
  }
  return result;
}

function cashShiftCashMovementMatchesCommand(
  value: unknown,
  shiftId: string,
  command: RecordCashShiftCashMovementCommand,
): value is CashShiftCashMovementRecord {
  return (
    isCashShiftCashMovementRecord(value) &&
    value.shiftId === shiftId &&
    value.shiftVersion === command.expectedShiftVersion + 1 &&
    value.direction === command.direction &&
    value.amountFen === command.amountFen &&
    value.purpose === command.purpose.trim()
  );
}

export async function getCashShiftCashMovementByRequest(
  shiftId: string,
  command: RecordCashShiftCashMovementCommand,
): Promise<CashShiftCashMovementRecord | null> {
  try {
    const result = await request<unknown>(
      `/v1/cash-shifts/${encodeURIComponent(shiftId)}/cash-movements/by-request/${encodeURIComponent(command.idempotencyKey)}`,
      { cache: "no-store" },
    );
    if (!cashShiftCashMovementMatchesCommand(result, shiftId, command)) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "现金出入查询结果与原班次、金额或用途不一致，页面继续锁定原请求",
        502,
      );
    }
    return result;
  } catch (error) {
    if (
      error instanceof ApiRequestError &&
      error.statusCode === 404 &&
      error.code === "CASH_SHIFT_CASH_MOVEMENT_NOT_FOUND"
    ) {
      return null;
    }
    throw error;
  }
}

export async function recordCashShiftCashMovement(
  shiftId: string,
  command: RecordCashShiftCashMovementCommand,
): Promise<CashShiftCashMovementRecord> {
  const result = await request<unknown>(
    `/v1/cash-shifts/${encodeURIComponent(shiftId)}/cash-movements`,
    {
      method: "POST",
      cache: "no-store",
      body: JSON.stringify(command),
    },
  );
  if (!cashShiftCashMovementMatchesCommand(result, shiftId, command)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "现金出入结果与本次班次、金额或用途不一致，页面已保留原请求等待核对",
      502,
    );
  }
  return result;
}

function sameCashShiftDifferenceAssessment(
  left: CashShiftHandoverPreviewReadModel["assessment"],
  right: CashShiftHandoverPreviewReadModel["assessment"],
): boolean {
  return (
    left.expectedCashFen === right.expectedCashFen &&
    left.countedCashFen === right.countedCashFen &&
    left.cashDifferenceFen === right.cashDifferenceFen &&
    left.absoluteDifferenceFen === right.absoluteDifferenceFen &&
    left.differenceRateBasisPointsCeiling === right.differenceRateBasisPointsCeiling &&
    left.tier === right.tier &&
    left.approvalRequirement === right.approvalRequirement &&
    left.managerNotificationRequired === right.managerNotificationRequired
  );
}

export async function previewCashShiftHandover(
  shiftId: string,
  input: PreviewCashShiftHandoverRequest,
  expectedActorId: string,
): Promise<CashShiftHandoverPreviewReadModel> {
  const result = await request<unknown>(
    `/v1/cash-shifts/${encodeURIComponent(shiftId)}/handover-preview`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  if (
    !isCashShiftHandoverPreviewReadModel(result) ||
    result.shiftId !== shiftId ||
    result.assessment.countedCashFen !== input.countedCashFen ||
    result.handoverActor.accountId !== expectedActorId ||
    result.handoverNote !== input.handoverNote ||
    result.substituteReason !== input.substituteReason ||
    (result.handoverMode === "OPENING_CASHIER" &&
      (result.openedBy.accountId !== expectedActorId || result.substituteReason !== null)) ||
    (result.handoverMode === "MANAGER_SUBSTITUTE" &&
      (result.openedBy.accountId === expectedActorId || result.substituteReason === null))
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "交班预览与本次清点内容不一致，系统没有开放提交；请重新读取班次后再试",
    );
  }
  return result;
}

export async function submitCashShiftHandoverV1(
  shiftId: string,
  command: SubmitCashShiftHandoverCommand,
  expectedActorId: string,
  preview: CashShiftHandoverPreviewReadModel,
): Promise<CashShiftHandoverSubmissionResult> {
  if (
    preview.shiftId !== shiftId ||
    preview.shiftVersion !== command.expectedShiftVersion ||
    preview.assessment.countedCashFen !== command.countedCashFen ||
    preview.handoverNote !== command.handoverNote ||
    preview.substituteReason !== command.substituteReason ||
    preview.previewSha256 !== command.previewSha256 ||
    preview.handoverActor.accountId !== expectedActorId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "本页交班预览已变化，系统没有提交；请重新预览后核对",
    );
  }
  const result = await request<unknown>(`/v1/cash-shifts/${encodeURIComponent(shiftId)}/handover`, {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isCashShiftHandoverSubmissionResult(result) ||
    result.shiftId !== shiftId ||
    result.shiftVersion !== command.expectedShiftVersion + 1 ||
    result.handoverActor.accountId !== expectedActorId ||
    result.handoverMode !== preview.handoverMode ||
    result.handoverNote !== command.handoverNote ||
    result.substituteReason !== command.substituteReason ||
    !sameCashShiftDifferenceAssessment(result.assessment, preview.assessment)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "交班结果无法与已确认预览对应，请保留原请求并刷新交接记录",
    );
  }
  return result;
}

export async function getCashShiftHandoverWorkflow(
  shiftId: string,
): Promise<CashShiftHandoverWorkflowReadModel> {
  const result = await request<unknown>(
    `/v1/cash-shifts/${encodeURIComponent(shiftId)}/handover-workflow`,
    { cache: "no-store" },
  );
  if (!isCashShiftHandoverWorkflowReadModel(result) || result.shiftId !== shiftId) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "交接进度无法安全确认，请刷新班次后重试");
  }
  return result;
}

export async function receiveCashShiftHandoverV1(
  shiftId: string,
  command: ReceiveCashShiftHandoverCommand,
  expectedActorId: string,
  workflow: CashShiftHandoverWorkflowReadModel,
): Promise<CashShiftHandoverReceiveResult> {
  if (
    workflow.shiftId !== shiftId ||
    workflow.workflowStatus !== "WAITING_RECEIVER" ||
    workflow.shiftVersion !== command.expectedHandoverVersion ||
    workflow.receiver !== null ||
    workflow.handoverActor.accountId === expectedActorId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "本页交接进度已经变化，系统没有确认接班；请刷新后重新核对",
    );
  }
  const result = await request<unknown>(`/v1/cash-shifts/${encodeURIComponent(shiftId)}/receive`, {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isCashShiftHandoverReceiveResult(result) ||
    result.shiftId !== shiftId ||
    result.shiftVersion !== command.expectedHandoverVersion + 1 ||
    result.receiver.accountId !== expectedActorId ||
    result.receiver.accountId === workflow.handoverActor.accountId ||
    result.receiveNote !== command.receiveNote ||
    result.substituteReason !== command.substituteReason ||
    !sameCashShiftDifferenceAssessment(result.assessment, workflow.assessment)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "接班结果无法与已核对的交接事实对应，请保留原请求并刷新交接记录",
    );
  }
  return result;
}

export async function submitCashShiftHandover(
  shiftId: string,
  countedCashFen: number,
  exceptionNote: string,
  idempotencyKey: string,
  expectedActorId: string,
): Promise<never> {
  void shiftId;
  void countedCashFen;
  void exceptionNote;
  void idempotencyKey;
  void expectedActorId;
  throw new ApiRequestError(
    "CASH_SHIFT_HANDOVER_CONTRACT_RETIRED",
    "旧版交班入口已停用；请从交接班页面先查看逐分差异和处理结果，再确认提交",
    410,
  );
}

export async function confirmCashShiftHandover(
  shiftId: string,
  note: string,
  idempotencyKey: string,
  expectedActorId: string,
  expectedHandover: CashShiftRecord,
): Promise<never> {
  void shiftId;
  void note;
  void idempotencyKey;
  void expectedActorId;
  void expectedHandover;
  throw new ApiRequestError(
    "CASH_SHIFT_RECEIVE_CONTRACT_RETIRED",
    "旧版接班入口已停用；请从交接班页面核对冻结金额、责任人和审批要求后确认接班",
    410,
  );
}

export async function getServiceRouting(): Promise<ServiceRoutingConfigurationReadModel> {
  const value = await request<unknown>("/v1/service-routing", { cache: "no-store" });
  if (!isServiceRoutingConfigurationReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "现场职责设置返回内容无法安全确认");
  }
  return value;
}

export async function updateServiceRouting(
  command: UpdateServiceRoutingConfigurationCommand,
): Promise<ServiceRoutingConfigurationReadModel> {
  if (!isUpdateServiceRoutingConfigurationCommand(command)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "现场职责设置有误，请重新核对");
  }
  const value = await request<unknown>("/v1/service-routing", {
    method: "PUT",
    body: JSON.stringify(command),
  });
  if (
    !isServiceRoutingConfigurationReadModel(value) ||
    value.configVersion !== command.expectedConfigVersion + 1 ||
    value.primaryRole !== command.primaryRole ||
    JSON.stringify(value.copiedRoles) !== JSON.stringify(command.copiedRoles) ||
    value.serviceSlaMinutes !== command.serviceSlaMinutes ||
    value.checkoutSlaMinutes !== command.checkoutSlaMinutes ||
    value.ownerEscalationDelayMinutes !== command.ownerEscalationDelayMinutes ||
    value.allowCashierTemporaryDuty !== command.allowCashierTemporaryDuty
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "现场职责设置保存结果无法安全确认，请使用原请求查询或重试",
    );
  }
  return value;
}

export async function getServiceDuty(): Promise<ServiceDutyReadModel> {
  const value = await request<unknown>("/v1/service-duty", { cache: "no-store" });
  if (!isServiceDutyReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "现场服务职责状态无法安全确认");
  }
  return value;
}

export async function assumeServiceDuty(
  command: AssumeServiceDutyCommand,
): Promise<ServiceDutyReadModel> {
  if (!isAssumeServiceDutyCommand(command)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "临时承担服务职责的请求有误");
  }
  const value = await request<unknown>("/v1/service-duty/assume", {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isServiceDutyReadModel(value) ||
    value.dutyVersion !== command.expectedDutyVersion + 1 ||
    value.configuration.configVersion !== command.expectedConfigVersion ||
    value.status !== "ACTIVE" ||
    value.currentAssignee?.isCurrentActor !== true
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "临时承担服务职责的结果无法安全确认，请使用原请求查询或重试",
    );
  }
  return value;
}

export async function releaseServiceDuty(
  command: ReleaseServiceDutyCommand,
): Promise<ServiceDutyReadModel> {
  if (!isReleaseServiceDutyCommand(command)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "退出临时服务职责的请求有误");
  }
  const value = await request<unknown>("/v1/service-duty/release", {
    method: "POST",
    body: JSON.stringify(command),
  });
  if (
    !isServiceDutyReadModel(value) ||
    value.dutyVersion !== command.expectedDutyVersion + 1 ||
    value.status !== "INACTIVE"
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "退出临时服务职责的结果无法安全确认，请使用原请求查询或重试",
    );
  }
  return value;
}

function kioskProductReservationTransitionIsValid(
  command: KioskProductReservationTransitionCommand | CancelKioskProductReservationCommand,
  cancel: boolean,
): boolean {
  const keys = Object.keys(command);
  const expectedKeys = cancel
    ? ["reservationId", "expectedReservationVersion", "idempotencyKey", "reason"]
    : ["reservationId", "expectedReservationVersion", "idempotencyKey"];
  if (keys.length !== expectedKeys.length || !expectedKeys.every((key) => keys.includes(key))) {
    return false;
  }
  if (
    typeof command.reservationId !== "string" ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/.test(command.reservationId) ||
    typeof command.expectedReservationVersion !== "number" ||
    !Number.isSafeInteger(command.expectedReservationVersion) ||
    command.expectedReservationVersion < 1 ||
    typeof command.idempotencyKey !== "string" ||
    command.idempotencyKey.length < 8 ||
    command.idempotencyKey.length > 128
  ) {
    return false;
  }
  return (
    !cancel ||
    ("reason" in command &&
      [...command.reason.trim()].length >= 1 &&
      [...command.reason.trim()].length <= 300)
  );
}

function kioskProductReservationResultMatches(
  value: unknown,
  command: KioskProductReservationTransitionCommand | CancelKioskProductReservationCommand,
  state: "ACKNOWLEDGED" | "CANCELLED",
): value is KioskProductReservationReadModel {
  return (
    isKioskProductReservationReadModel(value) &&
    value.reservationId === command.reservationId &&
    value.reservationVersion === command.expectedReservationVersion + 1 &&
    value.state === state
  );
}

export async function acknowledgeKioskProductOrder(
  command: KioskProductReservationTransitionCommand,
): Promise<KioskProductReservationReadModel> {
  if (!kioskProductReservationTransitionIsValid(command, false)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "接单请求已过期，请刷新现场工作台");
  }
  const value = await request<unknown>(
    `/v1/service-duty/kiosk-product-orders/${encodeURIComponent(command.reservationId)}/acknowledge`,
    { method: "POST", body: JSON.stringify(command) },
  );
  if (!kioskProductReservationResultMatches(value, command, "ACKNOWLEDGED")) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "接单结果无法安全确认，系统已保留原请求；请勿重新接单",
    );
  }
  return value;
}

export async function deliverKioskProductOrder(
  command: KioskProductReservationTransitionCommand,
): Promise<DeliverKioskProductReservationReceipt> {
  if (!kioskProductReservationTransitionIsValid(command, false)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "送达请求已过期，请刷新现场工作台");
  }
  const value = await request<unknown>(
    `/v1/service-duty/kiosk-product-orders/${encodeURIComponent(command.reservationId)}/deliver`,
    { method: "POST", body: JSON.stringify(command) },
  );
  if (
    !isDeliverKioskProductReservationReceipt(value) ||
    value.reservation.reservationId !== command.reservationId ||
    value.reservation.reservationVersion !== command.expectedReservationVersion + 1
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "送达结果无法安全确认，商品可能已经加入账单并扣减库存；请使用原请求恢复",
    );
  }
  return value;
}

export async function cancelKioskProductOrder(
  command: CancelKioskProductReservationCommand,
): Promise<KioskProductReservationReadModel> {
  if (!kioskProductReservationTransitionIsValid(command, true)) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "请填写拒绝原因后再释放商品预留");
  }
  const value = await request<unknown>(
    `/v1/service-duty/kiosk-product-orders/${encodeURIComponent(command.reservationId)}/cancel`,
    { method: "POST", body: JSON.stringify(command) },
  );
  if (!kioskProductReservationResultMatches(value, command, "CANCELLED")) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "拒绝结果无法安全确认，系统已保留原请求；请勿重复释放预留",
    );
  }
  return value;
}

export async function listServiceWorkItems(): Promise<ServiceWorkItemListReadModel> {
  const value = await request<unknown>("/v1/service-work-items", { cache: "no-store" });
  if (!isServiceWorkItemListReadModel(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "现场工作项返回内容无法安全确认");
  }
  return value;
}

export async function completeTableCleaningWorkItem(
  command: CompleteTableCleaningWorkItemCommand,
): Promise<TableCleaningWorkItemCompletionReceipt> {
  if (!isCompleteTableCleaningWorkItemCommand(command)) {
    throw new ApiRequestError(
      "REQUEST_VALIDATION_FAILED",
      "清洁事项与当前球台状态不一致，请刷新工作中心后重试",
    );
  }
  const value = await request<unknown>(
    `/v1/service-work-items/${encodeURIComponent(command.workItemId)}/table-cleaning/complete`,
    { method: "POST", body: JSON.stringify(command) },
  );
  if (!isTableCleaningWorkItemCompletionReceiptForCommand(value, command)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "清洁结果无法安全确认，系统已保留原请求；请勿再次新建操作",
    );
  }
  return value;
}

export async function getServiceRequestTransferOptions(
  eventId: string,
): Promise<ServiceRequestTransferOptionsReadModel> {
  const value = await request<unknown>(
    `/v1/service-requests/${encodeURIComponent(eventId)}/transfer-options`,
    { cache: "no-store" },
  );
  if (!isServiceRequestTransferOptionsReadModel(value) || value.eventId !== eventId) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "可转交人员与当前待办不一致，已停止操作");
  }
  return value;
}

export async function transferServiceRequest(
  eventId: string,
  command: TransferServiceRequestCommand,
): Promise<ServiceRequestTransferReceipt> {
  if (!isTransferServiceRequestCommand(command) || command.reason !== command.reason.trim()) {
    throw new ApiRequestError("REQUEST_VALIDATION_FAILED", "请填写转交原因并重新选择接手人");
  }
  const value = await request<unknown>(
    `/v1/service-requests/${encodeURIComponent(eventId)}/transfer`,
    { method: "POST", body: JSON.stringify(command) },
  );
  if (
    !isServiceRequestTransferReceipt(value) ||
    value.eventId !== eventId ||
    value.workItemVersion !== command.expectedWorkItemVersion + 1 ||
    value.targetRole !== command.targetRole ||
    value.targetCandidateId !== command.targetCandidateId ||
    value.reason !== command.reason
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "转交结果无法安全确认，请使用原请求查询或重试",
    );
  }
  return value;
}

export async function listServiceRequests(): Promise<ServiceRequestReadModel[]> {
  const value = await request<unknown>("/v1/service-requests", { cache: "no-store" });
  if (!isActiveServiceRequestReadModelList(value)) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "服务待办返回内容无法安全确认");
  }
  return value;
}

export type ServiceRequestHistoryPageBoundary = Readonly<{
  requestedCursor: string | null;
  nextCursor: string | null;
  eventIds: readonly string[];
  previous: ServiceRequestHistoryPageBoundary | null;
}>;

export type ValidatedServiceRequestHistoryPage = ServiceRequestHistoryPage &
  Readonly<{ boundary: ServiceRequestHistoryPageBoundary }>;

function validateServiceRequestHistoryPageSequence(
  value: ServiceRequestHistoryPage,
  cursor: string | undefined,
  previous: ServiceRequestHistoryPageBoundary | null,
): ServiceRequestHistoryPageBoundary {
  for (let page = previous; page !== null; page = page.previous) {
    if (value.nextCursor !== null && page.requestedCursor === value.nextCursor) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "服务待办历史翻页顺序异常，已保留此前确认的记录",
      );
    }
    if (value.items.some((item) => page.eventIds.includes(item.eventId))) {
      throw new ApiRequestError(
        "GATEWAY_RESPONSE_INVALID",
        "服务待办历史出现重复记录，已保留此前确认的记录",
      );
    }
  }
  return Object.freeze({
    requestedCursor: cursor ?? null,
    nextCursor: value.nextCursor,
    eventIds: Object.freeze(value.items.map((item) => item.eventId)),
    previous,
  });
}

export function listServiceRequestHistory(cursor?: string): Promise<ServiceRequestHistoryPage>;
export function listServiceRequestHistory(
  cursor: string | undefined,
  previous: ServiceRequestHistoryPageBoundary | null,
): Promise<ValidatedServiceRequestHistoryPage>;
export async function listServiceRequestHistory(
  cursor?: string,
  previous?: ServiceRequestHistoryPageBoundary | null,
): Promise<ServiceRequestHistoryPage | ValidatedServiceRequestHistoryPage> {
  const query = new URLSearchParams({ limit: "50" });
  if (cursor !== undefined) query.set("cursor", cursor);
  const value = await request<unknown>(`/v1/service-requests/history?${query.toString()}`, {
    cache: "no-store",
  });
  if (
    !isServiceRequestHistoryPage(value) ||
    (value.nextCursor !== null && value.nextCursor === cursor)
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "服务待办历史返回内容无法安全确认");
  }
  if (previous === undefined) return value;
  return {
    ...value,
    boundary: validateServiceRequestHistoryPageSequence(value, cursor, previous),
  };
}

function validatedServiceRequestTransitionResponse(
  value: unknown,
  expectedEventId: string,
  expectedStatus: "ACKNOWLEDGED" | "COMPLETED",
  expectedAssignment: {
    assignedActorDisplayName: string | null;
    assignedToCurrentActor: boolean;
  },
): ServiceRequestReadModel {
  const candidate = [value];
  if (
    !isServiceRequestReadModelList(candidate) ||
    candidate[0]?.eventId !== expectedEventId ||
    candidate[0]?.status !== expectedStatus ||
    candidate[0]?.assignedActorDisplayName !== expectedAssignment.assignedActorDisplayName ||
    candidate[0]?.assignedToCurrentActor !== expectedAssignment.assignedToCurrentActor
  ) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "服务待办操作结果无法安全确认");
  }
  const [result] = candidate;
  if (!result) {
    throw new ApiRequestError("GATEWAY_RESPONSE_INVALID", "服务待办操作结果无法安全确认");
  }
  return result;
}

export async function acknowledgeServiceRequest(
  eventId: string,
  idempotencyKey: string,
  expectedAssignment: {
    assignedActorDisplayName: string | null;
    assignedToCurrentActor: boolean;
  },
): Promise<ServiceRequestReadModel> {
  const value = await request<unknown>(`/v1/service-requests/${eventId}/acknowledge`, {
    method: "POST",
    body: JSON.stringify({ idempotencyKey }),
  });
  return validatedServiceRequestTransitionResponse(
    value,
    eventId,
    "ACKNOWLEDGED",
    expectedAssignment,
  );
}

export async function completeServiceRequest(
  eventId: string,
  idempotencyKey: string,
  expectedAssignment: {
    assignedActorDisplayName: string | null;
    assignedToCurrentActor: boolean;
  },
): Promise<ServiceRequestReadModel> {
  const value = await request<unknown>(`/v1/service-requests/${eventId}/complete`, {
    method: "POST",
    body: JSON.stringify({ idempotencyKey }),
  });
  return validatedServiceRequestTransitionResponse(value, eventId, "COMPLETED", expectedAssignment);
}

export async function listStorePackages(includeDisabled = false): Promise<StorePackageRecord[]> {
  const query = new URLSearchParams();
  if (includeDisabled) query.set("includeDisabled", "true");
  const suffix = query.size > 0 ? `?${query.toString()}` : "";
  const value = await request<unknown>(`/v1/store-packages${suffix}`, { cache: "no-store" });
  if (
    !Array.isArray(value) ||
    value.length > 500 ||
    !value.every(isStorePackageRecord) ||
    (!includeDisabled && value.some((record) => !record.enabled)) ||
    new Set(value.map((record) => record.id)).size !== value.length
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "门店套餐目录无法安全确认，页面不会显示不完整内容",
    );
  }
  return value;
}

export async function upsertStorePackage(
  packageId: string,
  command: StorePackageUpsertRequest,
): Promise<StorePackageRecord> {
  const value = await request<unknown>(`/v1/store-packages/${encodeURIComponent(packageId)}`, {
    method: "PUT",
    cache: "no-store",
    body: JSON.stringify(command),
  });
  if (
    !isStorePackageRecord(value) ||
    value.id !== packageId ||
    value.name !== command.name ||
    JSON.stringify(value.components) !== JSON.stringify(command.components) ||
    value.listPriceFen !== command.listPriceFen ||
    value.salePriceFen !== command.salePriceFen ||
    value.enabled !== command.enabled ||
    value.version !== command.expectedVersion + 1
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "套餐保存结果与本次填写内容不一致，请保留原请求号并刷新核对",
    );
  }
  return value;
}

function isStorePackageAddResult(value: unknown): value is StorePackageOrderItemAddResult {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const candidate = value as Partial<StorePackageOrderItemAddResult>;
  if (!isOrderDetailReadModel(candidate.order) || !isStorePackageOrderItem(candidate.packageItem)) {
    return false;
  }
  return (
    candidate.packageItem.status === "ACTIVE" &&
    candidate.packageItem.orderId === candidate.order.id &&
    candidate.packageItem.sessionId === candidate.order.sessionId &&
    candidate.order.packageItems?.some(
      (item) => JSON.stringify(item) === JSON.stringify(candidate.packageItem),
    ) === true
  );
}

function isStorePackageReturnResult(value: unknown): value is StorePackageOrderItemReturnResult {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const candidate = value as Partial<StorePackageOrderItemReturnResult>;
  if (
    !isOrderDetailReadModel(candidate.order) ||
    !isStorePackageOrderItem(candidate.packageItem) ||
    !isStorePackageOrderItemReturnRecord(candidate.returnRecord)
  ) {
    return false;
  }
  return (
    candidate.packageItem.status === "RETURNED" &&
    candidate.returnRecord.packageItemId === candidate.packageItem.id &&
    candidate.returnRecord.orderId === candidate.order.id &&
    candidate.order.packageItems?.some(
      (item) => JSON.stringify(item) === JSON.stringify(candidate.packageItem),
    ) === true
  );
}

export async function addStorePackageOrderItem(
  sessionId: string,
  command: {
    packageId: string;
    expectedPackageVersion: number;
    expectedOrderVersion: number;
    idempotencyKey: string;
  },
): Promise<StorePackageOrderItemAddResult> {
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/package-items`,
    { method: "POST", cache: "no-store", body: JSON.stringify(command) },
  );
  if (!isStorePackageAddResult(value) || value.packageItem.packageId !== command.packageId) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "套餐加单结果无法安全确认；页面不会把应收或库存变化显示为成功",
    );
  }
  return value;
}

export async function getStorePackageAddResult(
  sessionId: string,
  idempotencyKey: string,
): Promise<StorePackageOrderItemAddResult> {
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/package-items/by-request/${encodeURIComponent(idempotencyKey)}`,
    { cache: "no-store" },
  );
  if (!isStorePackageAddResult(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "原套餐加单结果无法安全确认，请保留原请求号继续核对",
    );
  }
  return value;
}

export async function cancelUnpaidStorePackageOrderItem(
  sessionId: string,
  packageItemId: string,
  command: {
    expectedOrderVersion: number;
    reason: string;
    idempotencyKey: string;
  },
): Promise<StorePackageOrderItemReturnResult> {
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/package-items/${encodeURIComponent(packageItemId)}/cancel`,
    { method: "POST", cache: "no-store", body: JSON.stringify(command) },
  );
  if (
    !isStorePackageReturnResult(value) ||
    value.packageItem.id !== packageItemId ||
    value.returnRecord.returnMode !== "UNPAID_CANCEL"
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "套餐撤销结果无法安全确认；页面不会把应收或库存恢复显示为成功",
    );
  }
  return value;
}

export async function getStorePackageReturnResult(
  sessionId: string,
  idempotencyKey: string,
): Promise<StorePackageOrderItemReturnResult> {
  const value = await request<unknown>(
    `/v1/sessions/${encodeURIComponent(sessionId)}/package-items/returns/by-request/${encodeURIComponent(idempotencyKey)}`,
    { cache: "no-store" },
  );
  if (!isStorePackageReturnResult(value)) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "原套餐撤销结果无法安全确认，请保留原请求号继续核对",
    );
  }
  return value;
}

export async function getWorkforcePayrollWorkspace(
  viewer: "SELF" | "MANAGEMENT",
  month: string,
): Promise<WorkforcePayrollWorkspace> {
  const endpoint = viewer === "SELF" ? "self" : "manage";
  const value = await request<unknown>(
    `/v1/workforce/payroll/${endpoint}?${new URLSearchParams({ month }).toString()}`,
    { cache: "no-store" },
  );
  if (
    !isWorkforcePayrollWorkspace(value) ||
    value.viewer !== viewer ||
    value.month !== month ||
    value.tenantId !== operatorRequestScope.tenantId ||
    value.storeId !== operatorRequestScope.storeId
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "工资单列表无法与当前门店和月份安全对应，页面不会显示不完整金额",
    );
  }
  return value;
}

function workforcePayrollOperationPath(command: WorkforcePayrollOperationCommand): string {
  if (command.operationType === "CREATE") return "/v1/workforce/payroll";
  const payslipId = encodeURIComponent(command.payslipId);
  return {
    REVISE: `/v1/workforce/payroll/${payslipId}/revise`,
    REVIEW: `/v1/workforce/payroll/${payslipId}/review`,
    RESPOND: `/v1/workforce/payroll/${payslipId}/respond`,
    LOCK: `/v1/workforce/payroll/${payslipId}/lock`,
    RECORD_PAYMENT: `/v1/workforce/payroll/${payslipId}/payment`,
  }[command.operationType];
}

function canonicalWorkforcePayrollCommandJson(value: unknown): string {
  if (value === null || typeof value !== "object") return JSON.stringify(value) ?? "undefined";
  if (Array.isArray(value)) {
    return `[${value.map((item) => canonicalWorkforcePayrollCommandJson(item)).join(",")}]`;
  }
  const record = value as Record<string, unknown>;
  return `{${Object.keys(record)
    .sort()
    .map((key) => `${JSON.stringify(key)}:${canonicalWorkforcePayrollCommandJson(record[key])}`)
    .join(",")}}`;
}

export function workforcePayrollCommandMatches(
  returned: WorkforcePayrollOperationCommand,
  sent: WorkforcePayrollOperationCommand,
): boolean {
  return (
    canonicalWorkforcePayrollCommandJson(returned) === canonicalWorkforcePayrollCommandJson(sent)
  );
}

function checkedWorkforcePayrollResult(
  value: unknown,
  command: WorkforcePayrollOperationCommand,
): WorkforcePayrollOperationResult {
  if (
    !isWorkforcePayrollOperationResult(value) ||
    !workforcePayrollCommandMatches(value.command, command) ||
    (command.payslipId !== null && value.payslip.payslipId !== command.payslipId)
  ) {
    throw new ApiRequestError(
      "GATEWAY_RESPONSE_INVALID",
      "工资操作回执与本次员工、月份、金额或步骤不一致，请保留操作号并刷新核对",
    );
  }
  return value;
}

export async function executeWorkforcePayrollOperation(
  command: WorkforcePayrollOperationCommand,
): Promise<WorkforcePayrollOperationResult> {
  const value = await request<unknown>(workforcePayrollOperationPath(command), {
    method: "POST",
    cache: "no-store",
    body: JSON.stringify(command.request),
  });
  return checkedWorkforcePayrollResult(value, command);
}

export async function recoverWorkforcePayrollOperation(
  command: WorkforcePayrollOperationCommand,
): Promise<WorkforcePayrollOperationResult> {
  const value = await request<unknown>(
    `/v1/workforce/payroll/by-request/${command.operationType}/${encodeURIComponent(command.request.idempotencyKey)}`,
    { cache: "no-store" },
  );
  return checkedWorkforcePayrollResult(value, command);
}
